import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf enum ConnectionError.Reason
 */
export var ConnectionError_Reason;
(function (ConnectionError_Reason) {
    /**
     * @generated from protobuf enum value: REASON_UNSPECIFIED = 0;
     */
    ConnectionError_Reason[ConnectionError_Reason["REASON_UNSPECIFIED"] = 0] = "REASON_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: UNAUTHORIZED = 1;
     */
    ConnectionError_Reason[ConnectionError_Reason["UNAUTHORIZED"] = 1] = "UNAUTHORIZED";
    /**
     * @generated from protobuf enum value: INVALID_AUTH = 2;
     */
    ConnectionError_Reason[ConnectionError_Reason["INVALID_AUTH"] = 2] = "INVALID_AUTH";
    /**
     * @generated from protobuf enum value: SESSION_REVOKED = 3;
     */
    ConnectionError_Reason[ConnectionError_Reason["SESSION_REVOKED"] = 3] = "SESSION_REVOKED";
})(ConnectionError_Reason || (ConnectionError_Reason = {}));
/**
 * @generated from protobuf enum BotAvatar.Kind
 */
export var BotAvatar_Kind;
(function (BotAvatar_Kind) {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    BotAvatar_Kind[BotAvatar_Kind["KIND_UNSPECIFIED"] = 0] = "KIND_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CODEX_ATLAS = 1;
     */
    BotAvatar_Kind[BotAvatar_Kind["CODEX_ATLAS"] = 1] = "CODEX_ATLAS";
})(BotAvatar_Kind || (BotAvatar_Kind = {}));
/**
 * @generated from protobuf enum BotPresenceState.Kind
 */
export var BotPresenceState_Kind;
(function (BotPresenceState_Kind) {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["KIND_UNSPECIFIED"] = 0] = "KIND_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: HIDDEN = 1;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["HIDDEN"] = 1] = "HIDDEN";
    /**
     * @generated from protobuf enum value: IDLE = 2;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["IDLE"] = 2] = "IDLE";
    /**
     * @generated from protobuf enum value: HAPPY = 3;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["HAPPY"] = 3] = "HAPPY";
    /**
     * @generated from protobuf enum value: WAVING = 4;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["WAVING"] = 4] = "WAVING";
    /**
     * @generated from protobuf enum value: JUMPING = 5;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["JUMPING"] = 5] = "JUMPING";
    /**
     * @generated from protobuf enum value: FAILED = 6;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["FAILED"] = 6] = "FAILED";
    /**
     * @generated from protobuf enum value: WAITING = 7;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["WAITING"] = 7] = "WAITING";
    /**
     * @generated from protobuf enum value: RUNNING = 8;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["RUNNING"] = 8] = "RUNNING";
    /**
     * @generated from protobuf enum value: REVIEW = 9;
     */
    BotPresenceState_Kind[BotPresenceState_Kind["REVIEW"] = 9] = "REVIEW";
})(BotPresenceState_Kind || (BotPresenceState_Kind = {}));
/**
 * @generated from protobuf enum MessageSubthread.Kind
 */
export var MessageSubthread_Kind;
(function (MessageSubthread_Kind) {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    MessageSubthread_Kind[MessageSubthread_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: KIND_REPLY = 1;
     */
    MessageSubthread_Kind[MessageSubthread_Kind["REPLY"] = 1] = "REPLY";
    /**
     * @generated from protobuf enum value: KIND_SUBTHREAD = 2;
     */
    MessageSubthread_Kind[MessageSubthread_Kind["SUBTHREAD"] = 2] = "SUBTHREAD";
})(MessageSubthread_Kind || (MessageSubthread_Kind = {}));
/**
 * @generated from protobuf enum BlockList.Kind
 */
export var BlockList_Kind;
(function (BlockList_Kind) {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    BlockList_Kind[BlockList_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: KIND_UNORDERED = 1;
     */
    BlockList_Kind[BlockList_Kind["UNORDERED"] = 1] = "UNORDERED";
    /**
     * @generated from protobuf enum value: KIND_ORDERED = 2;
     */
    BlockList_Kind[BlockList_Kind["ORDERED"] = 2] = "ORDERED";
})(BlockList_Kind || (BlockList_Kind = {}));
/**
 * @generated from protobuf enum BlockDisclosure.Kind
 */
export var BlockDisclosure_Kind;
(function (BlockDisclosure_Kind) {
    /**
     * @generated from protobuf enum value: KIND_DEFAULT = 0;
     */
    BlockDisclosure_Kind[BlockDisclosure_Kind["DEFAULT"] = 0] = "DEFAULT";
    /**
     * @generated from protobuf enum value: KIND_PROGRESS = 1;
     */
    BlockDisclosure_Kind[BlockDisclosure_Kind["PROGRESS"] = 1] = "PROGRESS";
})(BlockDisclosure_Kind || (BlockDisclosure_Kind = {}));
/**
 * @generated from protobuf enum BlockDisclosure.ActivityKind
 */
export var BlockDisclosure_ActivityKind;
(function (BlockDisclosure_ActivityKind) {
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_UNSPECIFIED = 0;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_REASONING = 1;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["REASONING"] = 1] = "REASONING";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_EXPLORE = 2;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["EXPLORE"] = 2] = "EXPLORE";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_READ = 3;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["READ"] = 3] = "READ";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_SEARCH = 4;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["SEARCH"] = 4] = "SEARCH";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_EDIT = 5;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["EDIT"] = 5] = "EDIT";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_DELETE = 6;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["DELETE"] = 6] = "DELETE";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_MOVE = 7;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["MOVE"] = 7] = "MOVE";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_COMMAND = 8;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["COMMAND"] = 8] = "COMMAND";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_WEB = 9;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["WEB"] = 9] = "WEB";
    /**
     * @generated from protobuf enum value: ACTIVITY_KIND_TOOL = 10;
     */
    BlockDisclosure_ActivityKind[BlockDisclosure_ActivityKind["TOOL"] = 10] = "TOOL";
})(BlockDisclosure_ActivityKind || (BlockDisclosure_ActivityKind = {}));
/**
 * @generated from protobuf enum BlockTable.Alignment
 */
export var BlockTable_Alignment;
(function (BlockTable_Alignment) {
    /**
     * @generated from protobuf enum value: ALIGNMENT_UNSPECIFIED = 0;
     */
    BlockTable_Alignment[BlockTable_Alignment["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: ALIGNMENT_LEFT = 1;
     */
    BlockTable_Alignment[BlockTable_Alignment["LEFT"] = 1] = "LEFT";
    /**
     * @generated from protobuf enum value: ALIGNMENT_CENTER = 2;
     */
    BlockTable_Alignment[BlockTable_Alignment["CENTER"] = 2] = "CENTER";
    /**
     * @generated from protobuf enum value: ALIGNMENT_RIGHT = 3;
     */
    BlockTable_Alignment[BlockTable_Alignment["RIGHT"] = 3] = "RIGHT";
})(BlockTable_Alignment || (BlockTable_Alignment = {}));
/**
 * @generated from protobuf enum MessageEntity.Type
 */
export var MessageEntity_Type;
(function (MessageEntity_Type) {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    MessageEntity_Type[MessageEntity_Type["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: TYPE_MENTION = 1;
     */
    MessageEntity_Type[MessageEntity_Type["MENTION"] = 1] = "MENTION";
    /**
     * @generated from protobuf enum value: TYPE_URL = 2;
     */
    MessageEntity_Type[MessageEntity_Type["URL"] = 2] = "URL";
    /**
     * @generated from protobuf enum value: TYPE_TEXT_URL = 3;
     */
    MessageEntity_Type[MessageEntity_Type["TEXT_URL"] = 3] = "TEXT_URL";
    /**
     * @generated from protobuf enum value: TYPE_EMAIL = 4;
     */
    MessageEntity_Type[MessageEntity_Type["EMAIL"] = 4] = "EMAIL";
    /**
     * @generated from protobuf enum value: TYPE_BOLD = 5;
     */
    MessageEntity_Type[MessageEntity_Type["BOLD"] = 5] = "BOLD";
    /**
     * @generated from protobuf enum value: TYPE_ITALIC = 6;
     */
    MessageEntity_Type[MessageEntity_Type["ITALIC"] = 6] = "ITALIC";
    /**
     * @generated from protobuf enum value: TYPE_USERNAME_MENTION = 7;
     */
    MessageEntity_Type[MessageEntity_Type["USERNAME_MENTION"] = 7] = "USERNAME_MENTION";
    /**
     * @generated from protobuf enum value: TYPE_CODE = 8;
     */
    MessageEntity_Type[MessageEntity_Type["CODE"] = 8] = "CODE";
    /**
     * @generated from protobuf enum value: TYPE_PRE = 9;
     */
    MessageEntity_Type[MessageEntity_Type["PRE"] = 9] = "PRE";
    /**
     * @generated from protobuf enum value: TYPE_PHONE_NUMBER = 10;
     */
    MessageEntity_Type[MessageEntity_Type["PHONE_NUMBER"] = 10] = "PHONE_NUMBER";
    /**
     * @generated from protobuf enum value: TYPE_THREAD = 11;
     */
    MessageEntity_Type[MessageEntity_Type["THREAD"] = 11] = "THREAD";
    /**
     * @generated from protobuf enum value: TYPE_THREAD_TITLE = 12;
     */
    MessageEntity_Type[MessageEntity_Type["THREAD_TITLE"] = 12] = "THREAD_TITLE";
    /**
     * @generated from protobuf enum value: TYPE_BOT_COMMAND = 13;
     */
    MessageEntity_Type[MessageEntity_Type["BOT_COMMAND"] = 13] = "BOT_COMMAND";
    /**
     * @generated from protobuf enum value: TYPE_GROUP_MENTION = 14;
     */
    MessageEntity_Type[MessageEntity_Type["GROUP_MENTION"] = 14] = "GROUP_MENTION";
    /**
     * Range-only styles. Unknown values preserve visible text on older clients.
     *
     * @generated from protobuf enum value: TYPE_UNDERLINE = 15;
     */
    MessageEntity_Type[MessageEntity_Type["UNDERLINE"] = 15] = "UNDERLINE";
    /**
     * @generated from protobuf enum value: TYPE_STRIKETHROUGH = 16;
     */
    MessageEntity_Type[MessageEntity_Type["STRIKETHROUGH"] = 16] = "STRIKETHROUGH";
    /**
     * @generated from protobuf enum value: TYPE_HIGHLIGHT = 17;
     */
    MessageEntity_Type[MessageEntity_Type["HIGHLIGHT"] = 17] = "HIGHLIGHT";
    /**
     * Opaque TeX source range; Markdown must not be parsed inside the formula.
     *
     * @generated from protobuf enum value: TYPE_MATH = 18;
     */
    MessageEntity_Type[MessageEntity_Type["MATH"] = 18] = "MATH";
})(MessageEntity_Type || (MessageEntity_Type = {}));
/**
 * @generated from protobuf enum Member.Role
 */
export var Member_Role;
(function (Member_Role) {
    /**
     * @generated from protobuf enum value: OWNER = 0;
     */
    Member_Role[Member_Role["OWNER"] = 0] = "OWNER";
    /**
     * @generated from protobuf enum value: ADMIN = 1;
     */
    Member_Role[Member_Role["ADMIN"] = 1] = "ADMIN";
    /**
     * @generated from protobuf enum value: MEMBER = 2;
     */
    Member_Role[Member_Role["MEMBER"] = 2] = "MEMBER";
})(Member_Role || (Member_Role = {}));
/**
 * Compatibility summary of the preview media.
 *
 * @generated from protobuf enum UrlPreview.MediaType
 */
export var UrlPreview_MediaType;
(function (UrlPreview_MediaType) {
    /**
     * No typed preview media was detected.
     *
     * @generated from protobuf enum value: MEDIA_TYPE_UNSPECIFIED = 0;
     */
    UrlPreview_MediaType[UrlPreview_MediaType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Metadata explicitly identifies this link as an article.
     *
     * @generated from protobuf enum value: MEDIA_TYPE_ARTICLE = 1;
     */
    UrlPreview_MediaType[UrlPreview_MediaType["ARTICLE"] = 1] = "ARTICLE";
    /**
     * The preview's primary media is an image.
     *
     * @generated from protobuf enum value: MEDIA_TYPE_IMAGE = 2;
     */
    UrlPreview_MediaType[UrlPreview_MediaType["IMAGE"] = 2] = "IMAGE";
    /**
     * The preview's primary media is a video or video player.
     *
     * @generated from protobuf enum value: MEDIA_TYPE_VIDEO = 3;
     */
    UrlPreview_MediaType[UrlPreview_MediaType["VIDEO"] = 3] = "VIDEO";
    /**
     * The preview's primary media is a document or downloadable file.
     *
     * @generated from protobuf enum value: MEDIA_TYPE_DOCUMENT = 4;
     */
    UrlPreview_MediaType[UrlPreview_MediaType["DOCUMENT"] = 4] = "DOCUMENT";
    /**
     * The preview's primary media is a provider embed.
     *
     * @generated from protobuf enum value: MEDIA_TYPE_EMBED = 5;
     */
    UrlPreview_MediaType[UrlPreview_MediaType["EMBED"] = 5] = "EMBED";
})(UrlPreview_MediaType || (UrlPreview_MediaType = {}));
/**
 * @generated from protobuf enum MessageAttachmentExternalTask.Status
 */
export var MessageAttachmentExternalTask_Status;
(function (MessageAttachmentExternalTask_Status) {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    MessageAttachmentExternalTask_Status[MessageAttachmentExternalTask_Status["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: STATUS_BACKLOG = 1;
     */
    MessageAttachmentExternalTask_Status[MessageAttachmentExternalTask_Status["BACKLOG"] = 1] = "BACKLOG";
    /**
     * @generated from protobuf enum value: STATUS_TODO = 2;
     */
    MessageAttachmentExternalTask_Status[MessageAttachmentExternalTask_Status["TODO"] = 2] = "TODO";
    /**
     * @generated from protobuf enum value: STATUS_IN_PROGRESS = 3;
     */
    MessageAttachmentExternalTask_Status[MessageAttachmentExternalTask_Status["IN_PROGRESS"] = 3] = "IN_PROGRESS";
    /**
     * @generated from protobuf enum value: STATUS_DONE = 4;
     */
    MessageAttachmentExternalTask_Status[MessageAttachmentExternalTask_Status["DONE"] = 4] = "DONE";
    /**
     * @generated from protobuf enum value: STATUS_CANCELLED = 5;
     */
    MessageAttachmentExternalTask_Status[MessageAttachmentExternalTask_Status["CANCELLED"] = 5] = "CANCELLED";
})(MessageAttachmentExternalTask_Status || (MessageAttachmentExternalTask_Status = {}));
/**
 * @generated from protobuf enum Photo.Format
 */
export var Photo_Format;
(function (Photo_Format) {
    /**
     * @generated from protobuf enum value: FORMAT_UNSPECIFIED = 0;
     */
    Photo_Format[Photo_Format["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: FORMAT_JPEG = 1;
     */
    Photo_Format[Photo_Format["JPEG"] = 1] = "JPEG";
    /**
     * @generated from protobuf enum value: FORMAT_PNG = 2;
     */
    Photo_Format[Photo_Format["PNG"] = 2] = "PNG";
})(Photo_Format || (Photo_Format = {}));
/**
 * Type of error
 *
 * @generated from protobuf enum RpcError.Code
 */
export var RpcError_Code;
(function (RpcError_Code) {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    RpcError_Code[RpcError_Code["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from protobuf enum value: BAD_REQUEST = 1;
     */
    RpcError_Code[RpcError_Code["BAD_REQUEST"] = 1] = "BAD_REQUEST";
    /**
     * @generated from protobuf enum value: UNAUTHENTICATED = 2;
     */
    RpcError_Code[RpcError_Code["UNAUTHENTICATED"] = 2] = "UNAUTHENTICATED";
    /**
     * @generated from protobuf enum value: RATE_LIMIT = 3;
     */
    RpcError_Code[RpcError_Code["RATE_LIMIT"] = 3] = "RATE_LIMIT";
    /**
     * @generated from protobuf enum value: INTERNAL_ERROR = 4;
     */
    RpcError_Code[RpcError_Code["INTERNAL_ERROR"] = 4] = "INTERNAL_ERROR";
    /**
     * @generated from protobuf enum value: PEER_ID_INVALID = 5;
     */
    RpcError_Code[RpcError_Code["PEER_ID_INVALID"] = 5] = "PEER_ID_INVALID";
    /**
     * @generated from protobuf enum value: MESSAGE_ID_INVALID = 6;
     */
    RpcError_Code[RpcError_Code["MESSAGE_ID_INVALID"] = 6] = "MESSAGE_ID_INVALID";
    /**
     * @generated from protobuf enum value: USER_ID_INVALID = 7;
     */
    RpcError_Code[RpcError_Code["USER_ID_INVALID"] = 7] = "USER_ID_INVALID";
    /**
     * @generated from protobuf enum value: USER_ALREADY_MEMBER = 8;
     */
    RpcError_Code[RpcError_Code["USER_ALREADY_MEMBER"] = 8] = "USER_ALREADY_MEMBER";
    /**
     * @generated from protobuf enum value: SPACE_ID_INVALID = 9;
     */
    RpcError_Code[RpcError_Code["SPACE_ID_INVALID"] = 9] = "SPACE_ID_INVALID";
    /**
     * @generated from protobuf enum value: CHAT_ID_INVALID = 10;
     */
    RpcError_Code[RpcError_Code["CHAT_ID_INVALID"] = 10] = "CHAT_ID_INVALID";
    /**
     * @generated from protobuf enum value: EMAIL_INVALID = 11;
     */
    RpcError_Code[RpcError_Code["EMAIL_INVALID"] = 11] = "EMAIL_INVALID";
    /**
     * @generated from protobuf enum value: PHONE_NUMBER_INVALID = 12;
     */
    RpcError_Code[RpcError_Code["PHONE_NUMBER_INVALID"] = 12] = "PHONE_NUMBER_INVALID";
    /**
     * @generated from protobuf enum value: SPACE_ADMIN_REQUIRED = 13;
     */
    RpcError_Code[RpcError_Code["SPACE_ADMIN_REQUIRED"] = 13] = "SPACE_ADMIN_REQUIRED";
    /**
     * @generated from protobuf enum value: SPACE_OWNER_REQUIRED = 14;
     */
    RpcError_Code[RpcError_Code["SPACE_OWNER_REQUIRED"] = 14] = "SPACE_OWNER_REQUIRED";
    /**
     * @generated from protobuf enum value: USERNAME_INVALID = 15;
     */
    RpcError_Code[RpcError_Code["USERNAME_INVALID"] = 15] = "USERNAME_INVALID";
    /**
     * @generated from protobuf enum value: USERNAME_TAKEN = 16;
     */
    RpcError_Code[RpcError_Code["USERNAME_TAKEN"] = 16] = "USERNAME_TAKEN";
    /**
     * @generated from protobuf enum value: FIRST_NAME_INVALID = 17;
     */
    RpcError_Code[RpcError_Code["FIRST_NAME_INVALID"] = 17] = "FIRST_NAME_INVALID";
    /**
     * @generated from protobuf enum value: URL_PREVIEW_UNAVAILABLE = 18;
     */
    RpcError_Code[RpcError_Code["URL_PREVIEW_UNAVAILABLE"] = 18] = "URL_PREVIEW_UNAVAILABLE";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_IMMUTABLE = 19;
     */
    RpcError_Code[RpcError_Code["AGENT_SESSION_MESSAGE_IMMUTABLE"] = 19] = "AGENT_SESSION_MESSAGE_IMMUTABLE";
    /**
     * @generated from protobuf enum value: SPACE_INVITE_INVALID = 20;
     */
    RpcError_Code[RpcError_Code["SPACE_INVITE_INVALID"] = 20] = "SPACE_INVITE_INVALID";
})(RpcError_Code || (RpcError_Code = {}));
/**
 * @generated from protobuf enum SyncSkippedSequence.Reason
 */
export var SyncSkippedSequence_Reason;
(function (SyncSkippedSequence_Reason) {
    /**
     * @generated from protobuf enum value: REASON_UNSPECIFIED = 0;
     */
    SyncSkippedSequence_Reason[SyncSkippedSequence_Reason["REASON_UNSPECIFIED"] = 0] = "REASON_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: IRRELEVANT_TO_BUCKET = 1;
     */
    SyncSkippedSequence_Reason[SyncSkippedSequence_Reason["IRRELEVANT_TO_BUCKET"] = 1] = "IRRELEVANT_TO_BUCKET";
    /**
     * @generated from protobuf enum value: SNAPSHOT_REPAIR_REQUIRED = 2;
     */
    SyncSkippedSequence_Reason[SyncSkippedSequence_Reason["SNAPSHOT_REPAIR_REQUIRED"] = 2] = "SNAPSHOT_REPAIR_REQUIRED";
})(SyncSkippedSequence_Reason || (SyncSkippedSequence_Reason = {}));
/**
 * @generated from protobuf enum GetUpdatesResult.ResultType
 */
export var GetUpdatesResult_ResultType;
(function (GetUpdatesResult_ResultType) {
    /**
     * @generated from protobuf enum value: RESULT_TYPE_UNSPECIFIED = 0;
     */
    GetUpdatesResult_ResultType[GetUpdatesResult_ResultType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: RESULT_TYPE_EMPTY = 1;
     */
    GetUpdatesResult_ResultType[GetUpdatesResult_ResultType["EMPTY"] = 1] = "EMPTY";
    /**
     * @generated from protobuf enum value: RESULT_TYPE_SLICE = 2;
     */
    GetUpdatesResult_ResultType[GetUpdatesResult_ResultType["SLICE"] = 2] = "SLICE";
    /**
     * @generated from protobuf enum value: RESULT_TYPE_TOO_LONG = 3;
     */
    GetUpdatesResult_ResultType[GetUpdatesResult_ResultType["TOO_LONG"] = 3] = "TOO_LONG";
})(GetUpdatesResult_ResultType || (GetUpdatesResult_ResultType = {}));
/**
 * @generated from protobuf enum NotificationSettings.Mode
 */
export var NotificationSettings_Mode;
(function (NotificationSettings_Mode) {
    /**
     * @generated from protobuf enum value: MODE_UNSPECIFIED = 0;
     */
    NotificationSettings_Mode[NotificationSettings_Mode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: MODE_ALL = 1;
     */
    NotificationSettings_Mode[NotificationSettings_Mode["ALL"] = 1] = "ALL";
    /**
     * @generated from protobuf enum value: MODE_NONE = 2;
     */
    NotificationSettings_Mode[NotificationSettings_Mode["NONE"] = 2] = "NONE";
    /**
     * @generated from protobuf enum value: MODE_MENTIONS = 3;
     */
    NotificationSettings_Mode[NotificationSettings_Mode["MENTIONS"] = 3] = "MENTIONS";
    /**
     * @generated from protobuf enum value: MODE_IMPORTANT_ONLY = 4;
     */
    NotificationSettings_Mode[NotificationSettings_Mode["IMPORTANT_ONLY"] = 4] = "IMPORTANT_ONLY";
    /**
     * @generated from protobuf enum value: MODE_ONLY_MENTIONS = 5;
     */
    NotificationSettings_Mode[NotificationSettings_Mode["ONLY_MENTIONS"] = 5] = "ONLY_MENTIONS";
})(NotificationSettings_Mode || (NotificationSettings_Mode = {}));
/**
 * @generated from protobuf enum DialogNotificationSettings.Mode
 */
export var DialogNotificationSettings_Mode;
(function (DialogNotificationSettings_Mode) {
    /**
     * @generated from protobuf enum value: MODE_UNSPECIFIED = 0;
     */
    DialogNotificationSettings_Mode[DialogNotificationSettings_Mode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: MODE_ALL = 1;
     */
    DialogNotificationSettings_Mode[DialogNotificationSettings_Mode["ALL"] = 1] = "ALL";
    /**
     * @generated from protobuf enum value: MODE_MENTIONS = 2;
     */
    DialogNotificationSettings_Mode[DialogNotificationSettings_Mode["MENTIONS"] = 2] = "MENTIONS";
    /**
     * @generated from protobuf enum value: MODE_NONE = 3;
     */
    DialogNotificationSettings_Mode[DialogNotificationSettings_Mode["NONE"] = 3] = "NONE";
})(DialogNotificationSettings_Mode || (DialogNotificationSettings_Mode = {}));
/**
 * @generated from protobuf enum PushContentEncryptionKey.Algorithm
 */
export var PushContentEncryptionKey_Algorithm;
(function (PushContentEncryptionKey_Algorithm) {
    /**
     * @generated from protobuf enum value: ALGORITHM_UNSPECIFIED = 0;
     */
    PushContentEncryptionKey_Algorithm[PushContentEncryptionKey_Algorithm["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: ALGORITHM_X25519_HKDF_SHA256_AES256_GCM = 1;
     */
    PushContentEncryptionKey_Algorithm[PushContentEncryptionKey_Algorithm["X25519_HKDF_SHA256_AES256_GCM"] = 1] = "X25519_HKDF_SHA256_AES256_GCM";
})(PushContentEncryptionKey_Algorithm || (PushContentEncryptionKey_Algorithm = {}));
/**
 * @generated from protobuf enum GetChatTranscriptInput.Mode
 */
export var GetChatTranscriptInput_Mode;
(function (GetChatTranscriptInput_Mode) {
    /**
     * @generated from protobuf enum value: MODE_UNSPECIFIED = 0;
     */
    GetChatTranscriptInput_Mode[GetChatTranscriptInput_Mode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: MODE_HUMAN_READABLE = 1;
     */
    GetChatTranscriptInput_Mode[GetChatTranscriptInput_Mode["HUMAN_READABLE"] = 1] = "HUMAN_READABLE";
})(GetChatTranscriptInput_Mode || (GetChatTranscriptInput_Mode = {}));
/**
 * @generated from protobuf enum GetChatTranscriptInput.Length
 */
export var GetChatTranscriptInput_Length;
(function (GetChatTranscriptInput_Length) {
    /**
     * @generated from protobuf enum value: LENGTH_UNSPECIFIED = 0;
     */
    GetChatTranscriptInput_Length[GetChatTranscriptInput_Length["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: LENGTH_CONCISE = 1;
     */
    GetChatTranscriptInput_Length[GetChatTranscriptInput_Length["CONCISE"] = 1] = "CONCISE";
})(GetChatTranscriptInput_Length || (GetChatTranscriptInput_Length = {}));
/**
 * @generated from protobuf enum GetChatTranscriptInput.Media
 */
export var GetChatTranscriptInput_Media;
(function (GetChatTranscriptInput_Media) {
    /**
     * @generated from protobuf enum value: MEDIA_UNSPECIFIED = 0;
     */
    GetChatTranscriptInput_Media[GetChatTranscriptInput_Media["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: MEDIA_INCLUDED = 1;
     */
    GetChatTranscriptInput_Media[GetChatTranscriptInput_Media["INCLUDED"] = 1] = "INCLUDED";
    /**
     * @generated from protobuf enum value: MEDIA_EXCLUDED = 2;
     */
    GetChatTranscriptInput_Media[GetChatTranscriptInput_Media["EXCLUDED"] = 2] = "EXCLUDED";
})(GetChatTranscriptInput_Media || (GetChatTranscriptInput_Media = {}));
/**
 * @generated from protobuf enum GetChatTranscriptResult.StopReason
 */
export var GetChatTranscriptResult_StopReason;
(function (GetChatTranscriptResult_StopReason) {
    /**
     * @generated from protobuf enum value: STOP_REASON_UNSPECIFIED = 0;
     */
    GetChatTranscriptResult_StopReason[GetChatTranscriptResult_StopReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: STOP_REASON_COMPLETE = 1;
     */
    GetChatTranscriptResult_StopReason[GetChatTranscriptResult_StopReason["COMPLETE"] = 1] = "COMPLETE";
    /**
     * @generated from protobuf enum value: STOP_REASON_MESSAGE_LIMIT = 2;
     */
    GetChatTranscriptResult_StopReason[GetChatTranscriptResult_StopReason["MESSAGE_LIMIT"] = 2] = "MESSAGE_LIMIT";
    /**
     * @generated from protobuf enum value: STOP_REASON_OUTPUT_LIMIT = 3;
     */
    GetChatTranscriptResult_StopReason[GetChatTranscriptResult_StopReason["OUTPUT_LIMIT"] = 3] = "OUTPUT_LIMIT";
})(GetChatTranscriptResult_StopReason || (GetChatTranscriptResult_StopReason = {}));
/**
 * @generated from protobuf enum UpdateNewMessageNotification.Reason
 */
export var UpdateNewMessageNotification_Reason;
(function (UpdateNewMessageNotification_Reason) {
    /**
     * @generated from protobuf enum value: REASON_UNSPECIFIED = 0;
     */
    UpdateNewMessageNotification_Reason[UpdateNewMessageNotification_Reason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: REASON_MENTION = 1;
     */
    UpdateNewMessageNotification_Reason[UpdateNewMessageNotification_Reason["MENTION"] = 1] = "MENTION";
    /**
     * @generated from protobuf enum value: REASON_IMPORTANT = 2;
     */
    UpdateNewMessageNotification_Reason[UpdateNewMessageNotification_Reason["IMPORTANT"] = 2] = "IMPORTANT";
})(UpdateNewMessageNotification_Reason || (UpdateNewMessageNotification_Reason = {}));
/**
 * @generated from protobuf enum UpdateComposeAction.ComposeAction
 */
export var UpdateComposeAction_ComposeAction;
(function (UpdateComposeAction_ComposeAction) {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    UpdateComposeAction_ComposeAction[UpdateComposeAction_ComposeAction["NONE"] = 0] = "NONE";
    /**
     * @generated from protobuf enum value: TYPING = 1;
     */
    UpdateComposeAction_ComposeAction[UpdateComposeAction_ComposeAction["TYPING"] = 1] = "TYPING";
    /**
     * @generated from protobuf enum value: UPLOADING_PHOTO = 2;
     */
    UpdateComposeAction_ComposeAction[UpdateComposeAction_ComposeAction["UPLOADING_PHOTO"] = 2] = "UPLOADING_PHOTO";
    /**
     * @generated from protobuf enum value: UPLOADING_DOCUMENT = 3;
     */
    UpdateComposeAction_ComposeAction[UpdateComposeAction_ComposeAction["UPLOADING_DOCUMENT"] = 3] = "UPLOADING_DOCUMENT";
    /**
     * @generated from protobuf enum value: UPLOADING_VIDEO = 4;
     */
    UpdateComposeAction_ComposeAction[UpdateComposeAction_ComposeAction["UPLOADING_VIDEO"] = 4] = "UPLOADING_VIDEO";
    /**
     * @generated from protobuf enum value: RECORDING_VOICE = 5;
     */
    UpdateComposeAction_ComposeAction[UpdateComposeAction_ComposeAction["RECORDING_VOICE"] = 5] = "RECORDING_VOICE";
})(UpdateComposeAction_ComposeAction || (UpdateComposeAction_ComposeAction = {}));
/**
 * @generated from protobuf enum UserStatus.Status
 */
export var UserStatus_Status;
(function (UserStatus_Status) {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UserStatus_Status[UserStatus_Status["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from protobuf enum value: ONLINE = 1;
     */
    UserStatus_Status[UserStatus_Status["ONLINE"] = 1] = "ONLINE";
    /**
     * @generated from protobuf enum value: OFFLINE = 2;
     */
    UserStatus_Status[UserStatus_Status["OFFLINE"] = 2] = "OFFLINE";
})(UserStatus_Status || (UserStatus_Status = {}));
/**
 * @generated from protobuf enum BotCapability.Kind
 */
export var BotCapability_Kind;
(function (BotCapability_Kind) {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    BotCapability_Kind[BotCapability_Kind["KIND_UNSPECIFIED"] = 0] = "KIND_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CHAT_SETTINGS = 1;
     */
    BotCapability_Kind[BotCapability_Kind["CHAT_SETTINGS"] = 1] = "CHAT_SETTINGS";
    /**
     * @generated from protobuf enum value: AGENT_CONFIGURATION = 2;
     */
    BotCapability_Kind[BotCapability_Kind["AGENT_CONFIGURATION"] = 2] = "AGENT_CONFIGURATION";
})(BotCapability_Kind || (BotCapability_Kind = {}));
/**
 * @generated from protobuf enum BotChatSettingsInfo.Tone
 */
export var BotChatSettingsInfo_Tone;
(function (BotChatSettingsInfo_Tone) {
    /**
     * @generated from protobuf enum value: TONE_UNSPECIFIED = 0;
     */
    BotChatSettingsInfo_Tone[BotChatSettingsInfo_Tone["TONE_UNSPECIFIED"] = 0] = "TONE_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: NEUTRAL = 1;
     */
    BotChatSettingsInfo_Tone[BotChatSettingsInfo_Tone["NEUTRAL"] = 1] = "NEUTRAL";
    /**
     * @generated from protobuf enum value: SUCCESS = 2;
     */
    BotChatSettingsInfo_Tone[BotChatSettingsInfo_Tone["SUCCESS"] = 2] = "SUCCESS";
    /**
     * @generated from protobuf enum value: WARNING = 3;
     */
    BotChatSettingsInfo_Tone[BotChatSettingsInfo_Tone["WARNING"] = 3] = "WARNING";
    /**
     * @generated from protobuf enum value: ERROR = 4;
     */
    BotChatSettingsInfo_Tone[BotChatSettingsInfo_Tone["ERROR"] = 4] = "ERROR";
})(BotChatSettingsInfo_Tone || (BotChatSettingsInfo_Tone = {}));
/**
 * @generated from protobuf enum BotChatSettingsProblem.Code
 */
export var BotChatSettingsProblem_Code;
(function (BotChatSettingsProblem_Code) {
    /**
     * @generated from protobuf enum value: CODE_UNSPECIFIED = 0;
     */
    BotChatSettingsProblem_Code[BotChatSettingsProblem_Code["CODE_UNSPECIFIED"] = 0] = "CODE_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: UNAVAILABLE = 1;
     */
    BotChatSettingsProblem_Code[BotChatSettingsProblem_Code["UNAVAILABLE"] = 1] = "UNAVAILABLE";
    /**
     * @generated from protobuf enum value: INVALID_VALUE = 2;
     */
    BotChatSettingsProblem_Code[BotChatSettingsProblem_Code["INVALID_VALUE"] = 2] = "INVALID_VALUE";
    /**
     * @generated from protobuf enum value: STALE = 3;
     */
    BotChatSettingsProblem_Code[BotChatSettingsProblem_Code["STALE"] = 3] = "STALE";
    /**
     * @generated from protobuf enum value: FAILED = 4;
     */
    BotChatSettingsProblem_Code[BotChatSettingsProblem_Code["FAILED"] = 4] = "FAILED";
    /**
     * Generated by Inline when a capable bot has no reachable connection or
     * does not answer in time.
     *
     * @generated from protobuf enum value: UNREACHABLE = 5;
     */
    BotChatSettingsProblem_Code[BotChatSettingsProblem_Code["UNREACHABLE"] = 5] = "UNREACHABLE";
})(BotChatSettingsProblem_Code || (BotChatSettingsProblem_Code = {}));
/**
 * @generated from protobuf enum AuthBeginResult.Delivery
 */
export var AuthBeginResult_Delivery;
(function (AuthBeginResult_Delivery) {
    /**
     * @generated from protobuf enum value: DELIVERY_UNSPECIFIED = 0;
     */
    AuthBeginResult_Delivery[AuthBeginResult_Delivery["DELIVERY_UNSPECIFIED"] = 0] = "DELIVERY_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: EMAIL = 1;
     */
    AuthBeginResult_Delivery[AuthBeginResult_Delivery["EMAIL"] = 1] = "EMAIL";
    /**
     * @generated from protobuf enum value: SMS = 2;
     */
    AuthBeginResult_Delivery[AuthBeginResult_Delivery["SMS"] = 2] = "SMS";
})(AuthBeginResult_Delivery || (AuthBeginResult_Delivery = {}));
/**
 * @generated from protobuf enum UploadFailure.Code
 */
export var UploadFailure_Code;
(function (UploadFailure_Code) {
    /**
     * @generated from protobuf enum value: UPLOAD_FAILURE_CODE_UNSPECIFIED = 0;
     */
    UploadFailure_Code[UploadFailure_Code["UPLOAD_FAILURE_CODE_UNSPECIFIED"] = 0] = "UPLOAD_FAILURE_CODE_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: UPLOAD_FAILURE_INTEGRITY = 1;
     */
    UploadFailure_Code[UploadFailure_Code["UPLOAD_FAILURE_INTEGRITY"] = 1] = "UPLOAD_FAILURE_INTEGRITY";
    /**
     * @generated from protobuf enum value: UPLOAD_FAILURE_INVALID_MEDIA = 2;
     */
    UploadFailure_Code[UploadFailure_Code["UPLOAD_FAILURE_INVALID_MEDIA"] = 2] = "UPLOAD_FAILURE_INVALID_MEDIA";
    /**
     * @generated from protobuf enum value: UPLOAD_FAILURE_PROCESSING = 3;
     */
    UploadFailure_Code[UploadFailure_Code["UPLOAD_FAILURE_PROCESSING"] = 3] = "UPLOAD_FAILURE_PROCESSING";
    /**
     * @generated from protobuf enum value: UPLOAD_FAILURE_STORAGE = 4;
     */
    UploadFailure_Code[UploadFailure_Code["UPLOAD_FAILURE_STORAGE"] = 4] = "UPLOAD_FAILURE_STORAGE";
})(UploadFailure_Code || (UploadFailure_Code = {}));
/**
 * @generated from protobuf enum DialogFollowMode
 */
export var DialogFollowMode;
(function (DialogFollowMode) {
    /**
     * Default relevance mode: mentions/replies and server heuristics may surface the thread.
     *
     * @generated from protobuf enum value: DIALOG_FOLLOW_MODE_UNSPECIFIED = 0;
     */
    DialogFollowMode[DialogFollowMode["DIALOG_FOLLOW_MODE_UNSPECIFIED"] = 0] = "DIALOG_FOLLOW_MODE_UNSPECIFIED";
    /**
     * Explicitly follow the thread; normal thread activity should surface it.
     *
     * @generated from protobuf enum value: FOLLOWING = 1;
     */
    DialogFollowMode[DialogFollowMode["FOLLOWING"] = 1] = "FOLLOWING";
    /**
     * Explicit opt-out; server auto-follow heuristics must not flip this back to following.
     * Mentions/replies may still surface the thread through normal relevance behavior.
     *
     * @generated from protobuf enum value: UNFOLLOWED = 2;
     */
    DialogFollowMode[DialogFollowMode["UNFOLLOWED"] = 2] = "UNFOLLOWED";
})(DialogFollowMode || (DialogFollowMode = {}));
/**
 * Agent providers that implement Inline's session continuity contract. The
 * numeric values are stored by the server; additions must be append-only.
 *
 * @generated from protobuf enum AgentSessionProvider
 */
export var AgentSessionProvider;
(function (AgentSessionProvider) {
    /**
     * @generated from protobuf enum value: AGENT_SESSION_PROVIDER_UNSPECIFIED = 0;
     */
    AgentSessionProvider[AgentSessionProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_PROVIDER_CODEX = 1;
     */
    AgentSessionProvider[AgentSessionProvider["CODEX"] = 1] = "CODEX";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_PROVIDER_CODEX_CLOUD = 2;
     */
    AgentSessionProvider[AgentSessionProvider["CODEX_CLOUD"] = 2] = "CODEX_CLOUD";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_PROVIDER_CLAUDE = 3;
     */
    AgentSessionProvider[AgentSessionProvider["CLAUDE"] = 3] = "CLAUDE";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_PROVIDER_OPEN_CODE = 4;
     */
    AgentSessionProvider[AgentSessionProvider["OPEN_CODE"] = 4] = "OPEN_CODE";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_PROVIDER_AMP = 5;
     */
    AgentSessionProvider[AgentSessionProvider["AMP"] = 5] = "AMP";
})(AgentSessionProvider || (AgentSessionProvider = {}));
/**
 * @generated from protobuf enum AgentSessionMessageRole
 */
export var AgentSessionMessageRole;
(function (AgentSessionMessageRole) {
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_ROLE_UNSPECIFIED = 0;
     */
    AgentSessionMessageRole[AgentSessionMessageRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_ROLE_USER = 1;
     */
    AgentSessionMessageRole[AgentSessionMessageRole["USER"] = 1] = "USER";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_ROLE_ASSISTANT = 2;
     */
    AgentSessionMessageRole[AgentSessionMessageRole["ASSISTANT"] = 2] = "ASSISTANT";
})(AgentSessionMessageRole || (AgentSessionMessageRole = {}));
/**
 * @generated from protobuf enum AgentSessionMessageRelation
 */
export var AgentSessionMessageRelation;
(function (AgentSessionMessageRelation) {
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_RELATION_UNSPECIFIED = 0;
     */
    AgentSessionMessageRelation[AgentSessionMessageRelation["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * The provider owns this projected Inline row.
     *
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_RELATION_IMPORTED = 1;
     */
    AgentSessionMessageRelation[AgentSessionMessageRelation["IMPORTED"] = 1] = "IMPORTED";
    /**
     * An existing Inline-authored row is linked to its provider echo.
     *
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_RELATION_LINKED = 2;
     */
    AgentSessionMessageRelation[AgentSessionMessageRelation["LINKED"] = 2] = "LINKED";
})(AgentSessionMessageRelation || (AgentSessionMessageRelation = {}));
/**
 * @generated from protobuf enum MessageSendMode
 */
export var MessageSendMode;
(function (MessageSendMode) {
    /**
     * @generated from protobuf enum value: MODE_UNSPECIFIED = 0;
     */
    MessageSendMode[MessageSendMode["MODE_UNSPECIFIED"] = 0] = "MODE_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: MODE_SILENT = 1;
     */
    MessageSendMode[MessageSendMode["MODE_SILENT"] = 1] = "MODE_SILENT";
})(MessageSendMode || (MessageSendMode = {}));
/**
 * @generated from protobuf enum ConnectAgentSessionState
 */
export var ConnectAgentSessionState;
(function (ConnectAgentSessionState) {
    /**
     * @generated from protobuf enum value: CONNECT_AGENT_SESSION_STATE_UNSPECIFIED = 0;
     */
    ConnectAgentSessionState[ConnectAgentSessionState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CONNECT_AGENT_SESSION_STATE_CREATED = 1;
     */
    ConnectAgentSessionState[ConnectAgentSessionState["CREATED"] = 1] = "CREATED";
    /**
     * @generated from protobuf enum value: CONNECT_AGENT_SESSION_STATE_ALREADY_CONNECTED = 2;
     */
    ConnectAgentSessionState[ConnectAgentSessionState["ALREADY_CONNECTED"] = 2] = "ALREADY_CONNECTED";
    /**
     * @generated from protobuf enum value: CONNECT_AGENT_SESSION_STATE_CONNECTED_ELSEWHERE = 3;
     */
    ConnectAgentSessionState[ConnectAgentSessionState["CONNECTED_ELSEWHERE"] = 3] = "CONNECTED_ELSEWHERE";
})(ConnectAgentSessionState || (ConnectAgentSessionState = {}));
/**
 * @generated from protobuf enum AgentSessionSyncMode
 */
export var AgentSessionSyncMode;
(function (AgentSessionSyncMode) {
    /**
     * @generated from protobuf enum value: AGENT_SESSION_SYNC_MODE_UNSPECIFIED = 0;
     */
    AgentSessionSyncMode[AgentSessionSyncMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Historical repair: visible in realtime but not counted as unread or pushed.
     *
     * @generated from protobuf enum value: AGENT_SESSION_SYNC_MODE_HISTORY = 1;
     */
    AgentSessionSyncMode[AgentSessionSyncMode["HISTORY"] = 1] = "HISTORY";
    /**
     * Current provider output: normal realtime visibility and unread semantics.
     *
     * @generated from protobuf enum value: AGENT_SESSION_SYNC_MODE_LIVE = 2;
     */
    AgentSessionSyncMode[AgentSessionSyncMode["LIVE"] = 2] = "LIVE";
})(AgentSessionSyncMode || (AgentSessionSyncMode = {}));
/**
 * @generated from protobuf enum AgentSessionMessageSyncState
 */
export var AgentSessionMessageSyncState;
(function (AgentSessionMessageSyncState) {
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_UNSPECIFIED = 0;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_CREATED = 1;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["CREATED"] = 1] = "CREATED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_EDITED = 2;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["EDITED"] = 2] = "EDITED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_LINKED = 3;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["LINKED"] = 3] = "LINKED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_UNCHANGED = 4;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["UNCHANGED"] = 4] = "UNCHANGED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_STALE = 5;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["STALE"] = 5] = "STALE";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_TOMBSTONED = 6;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["TOMBSTONED"] = 6] = "TOMBSTONED";
    /**
     * @generated from protobuf enum value: AGENT_SESSION_MESSAGE_SYNC_STATE_CONFLICT = 7;
     */
    AgentSessionMessageSyncState[AgentSessionMessageSyncState["CONFLICT"] = 7] = "CONFLICT";
})(AgentSessionMessageSyncState || (AgentSessionMessageSyncState = {}));
/**
 * @generated from protobuf enum Method
 */
export var Method;
(function (Method) {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    Method[Method["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: GET_ME = 1;
     */
    Method[Method["GET_ME"] = 1] = "GET_ME";
    /**
     * @generated from protobuf enum value: SEND_MESSAGE = 2;
     */
    Method[Method["SEND_MESSAGE"] = 2] = "SEND_MESSAGE";
    /**
     * @generated from protobuf enum value: GET_PEER_PHOTO = 3;
     */
    Method[Method["GET_PEER_PHOTO"] = 3] = "GET_PEER_PHOTO";
    /**
     * @generated from protobuf enum value: DELETE_MESSAGES = 4;
     */
    Method[Method["DELETE_MESSAGES"] = 4] = "DELETE_MESSAGES";
    /**
     * @generated from protobuf enum value: GET_CHAT_HISTORY = 5;
     */
    Method[Method["GET_CHAT_HISTORY"] = 5] = "GET_CHAT_HISTORY";
    /**
     * @generated from protobuf enum value: ADD_REACTION = 6;
     */
    Method[Method["ADD_REACTION"] = 6] = "ADD_REACTION";
    /**
     * @generated from protobuf enum value: DELETE_REACTION = 7;
     */
    Method[Method["DELETE_REACTION"] = 7] = "DELETE_REACTION";
    /**
     * @generated from protobuf enum value: EDIT_MESSAGE = 8;
     */
    Method[Method["EDIT_MESSAGE"] = 8] = "EDIT_MESSAGE";
    /**
     * @generated from protobuf enum value: CREATE_CHAT = 9;
     */
    Method[Method["CREATE_CHAT"] = 9] = "CREATE_CHAT";
    /**
     * @generated from protobuf enum value: GET_SPACE_MEMBERS = 10;
     */
    Method[Method["GET_SPACE_MEMBERS"] = 10] = "GET_SPACE_MEMBERS";
    /**
     * @generated from protobuf enum value: DELETE_CHAT = 11;
     */
    Method[Method["DELETE_CHAT"] = 11] = "DELETE_CHAT";
    /**
     * @generated from protobuf enum value: INVITE_TO_SPACE = 12;
     */
    Method[Method["INVITE_TO_SPACE"] = 12] = "INVITE_TO_SPACE";
    /**
     * @generated from protobuf enum value: GET_CHAT_PARTICIPANTS = 13;
     */
    Method[Method["GET_CHAT_PARTICIPANTS"] = 13] = "GET_CHAT_PARTICIPANTS";
    /**
     * @generated from protobuf enum value: ADD_CHAT_PARTICIPANT = 14;
     */
    Method[Method["ADD_CHAT_PARTICIPANT"] = 14] = "ADD_CHAT_PARTICIPANT";
    /**
     * @generated from protobuf enum value: REMOVE_CHAT_PARTICIPANT = 15;
     */
    Method[Method["REMOVE_CHAT_PARTICIPANT"] = 15] = "REMOVE_CHAT_PARTICIPANT";
    /**
     * @generated from protobuf enum value: TRANSLATE_MESSAGES = 16;
     */
    Method[Method["TRANSLATE_MESSAGES"] = 16] = "TRANSLATE_MESSAGES";
    /**
     * @generated from protobuf enum value: GET_CHATS = 17;
     */
    Method[Method["GET_CHATS"] = 17] = "GET_CHATS";
    /**
     * @generated from protobuf enum value: UPDATE_USER_SETTINGS = 18;
     */
    Method[Method["UPDATE_USER_SETTINGS"] = 18] = "UPDATE_USER_SETTINGS";
    /**
     * @generated from protobuf enum value: GET_USER_SETTINGS = 19;
     */
    Method[Method["GET_USER_SETTINGS"] = 19] = "GET_USER_SETTINGS";
    /**
     * @generated from protobuf enum value: SEND_COMPOSE_ACTION = 20;
     */
    Method[Method["SEND_COMPOSE_ACTION"] = 20] = "SEND_COMPOSE_ACTION";
    /**
     * @generated from protobuf enum value: CREATE_BOT = 21;
     */
    Method[Method["CREATE_BOT"] = 21] = "CREATE_BOT";
    /**
     * @generated from protobuf enum value: DELETE_MEMBER = 22;
     */
    Method[Method["DELETE_MEMBER"] = 22] = "DELETE_MEMBER";
    /**
     * @generated from protobuf enum value: MARK_AS_UNREAD = 23;
     */
    Method[Method["MARK_AS_UNREAD"] = 23] = "MARK_AS_UNREAD";
    /**
     * @generated from protobuf enum value: GET_UPDATES_STATE = 24;
     */
    Method[Method["GET_UPDATES_STATE"] = 24] = "GET_UPDATES_STATE";
    /**
     * @generated from protobuf enum value: GET_CHAT = 25;
     */
    Method[Method["GET_CHAT"] = 25] = "GET_CHAT";
    /**
     * @generated from protobuf enum value: GET_UPDATES = 26;
     */
    Method[Method["GET_UPDATES"] = 26] = "GET_UPDATES";
    /**
     * @generated from protobuf enum value: UPDATE_MEMBER_ACCESS = 27;
     */
    Method[Method["UPDATE_MEMBER_ACCESS"] = 27] = "UPDATE_MEMBER_ACCESS";
    /**
     * @generated from protobuf enum value: SEARCH_MESSAGES = 28;
     */
    Method[Method["SEARCH_MESSAGES"] = 28] = "SEARCH_MESSAGES";
    /**
     * @generated from protobuf enum value: FORWARD_MESSAGES = 29;
     */
    Method[Method["FORWARD_MESSAGES"] = 29] = "FORWARD_MESSAGES";
    /**
     * @generated from protobuf enum value: UPDATE_CHAT_VISIBILITY = 30;
     */
    Method[Method["UPDATE_CHAT_VISIBILITY"] = 30] = "UPDATE_CHAT_VISIBILITY";
    /**
     * @generated from protobuf enum value: PIN_MESSAGE = 31;
     */
    Method[Method["PIN_MESSAGE"] = 31] = "PIN_MESSAGE";
    /**
     * @generated from protobuf enum value: UPDATE_CHAT_INFO = 32;
     */
    Method[Method["UPDATE_CHAT_INFO"] = 32] = "UPDATE_CHAT_INFO";
    /**
     * @generated from protobuf enum value: LIST_BOTS = 33;
     */
    Method[Method["LIST_BOTS"] = 33] = "LIST_BOTS";
    /**
     * @generated from protobuf enum value: REVEAL_BOT_TOKEN = 34;
     */
    Method[Method["REVEAL_BOT_TOKEN"] = 34] = "REVEAL_BOT_TOKEN";
    /**
     * @generated from protobuf enum value: MOVE_THREAD = 35;
     */
    Method[Method["MOVE_THREAD"] = 35] = "MOVE_THREAD";
    /**
     * @generated from protobuf enum value: ROTATE_BOT_TOKEN = 36;
     */
    Method[Method["ROTATE_BOT_TOKEN"] = 36] = "ROTATE_BOT_TOKEN";
    /**
     * @generated from protobuf enum value: UPDATE_BOT_PROFILE = 37;
     */
    Method[Method["UPDATE_BOT_PROFILE"] = 37] = "UPDATE_BOT_PROFILE";
    /**
     * @generated from protobuf enum value: GET_MESSAGES = 38;
     */
    Method[Method["GET_MESSAGES"] = 38] = "GET_MESSAGES";
    /**
     * @generated from protobuf enum value: UPDATE_DIALOG_NOTIFICATION_SETTINGS = 39;
     */
    Method[Method["UPDATE_DIALOG_NOTIFICATION_SETTINGS"] = 39] = "UPDATE_DIALOG_NOTIFICATION_SETTINGS";
    /**
     * @generated from protobuf enum value: READ_MESSAGES = 40;
     */
    Method[Method["READ_MESSAGES"] = 40] = "READ_MESSAGES";
    /**
     * @generated from protobuf enum value: REGISTER_DEVICE = 41;
     */
    Method[Method["REGISTER_DEVICE"] = 41] = "REGISTER_DEVICE";
    /**
     * @generated from protobuf enum value: CREATE_SUBTHREAD = 42;
     */
    Method[Method["CREATE_SUBTHREAD"] = 42] = "CREATE_SUBTHREAD";
    /**
     * @generated from protobuf enum value: GET_BOT_COMMANDS = 43;
     */
    Method[Method["GET_BOT_COMMANDS"] = 43] = "GET_BOT_COMMANDS";
    /**
     * @generated from protobuf enum value: SET_BOT_COMMANDS = 44;
     */
    Method[Method["SET_BOT_COMMANDS"] = 44] = "SET_BOT_COMMANDS";
    /**
     * @generated from protobuf enum value: GET_PEER_BOT_COMMANDS = 45;
     */
    Method[Method["GET_PEER_BOT_COMMANDS"] = 45] = "GET_PEER_BOT_COMMANDS";
    /**
     * @generated from protobuf enum value: SHOW_IN_CHAT_LIST = 46;
     */
    Method[Method["SHOW_IN_CHAT_LIST"] = 46] = "SHOW_IN_CHAT_LIST";
    /**
     * @generated from protobuf enum value: RESERVE_CHAT_IDS = 47;
     */
    Method[Method["RESERVE_CHAT_IDS"] = 47] = "RESERVE_CHAT_IDS";
    /**
     * @generated from protobuf enum value: INVOKE_MESSAGE_ACTION = 48;
     */
    Method[Method["INVOKE_MESSAGE_ACTION"] = 48] = "INVOKE_MESSAGE_ACTION";
    /**
     * @generated from protobuf enum value: ANSWER_MESSAGE_ACTION = 49;
     */
    Method[Method["ANSWER_MESSAGE_ACTION"] = 49] = "ANSWER_MESSAGE_ACTION";
    /**
     * @generated from protobuf enum value: REVOKE_SESSION = 50;
     */
    Method[Method["REVOKE_SESSION"] = 50] = "REVOKE_SESSION";
    /**
     * @generated from protobuf enum value: UPDATE_DIALOG_OPEN = 51;
     */
    Method[Method["UPDATE_DIALOG_OPEN"] = 51] = "UPDATE_DIALOG_OPEN";
    /**
     * @generated from protobuf enum value: UPDATE_DIALOG_ORDER = 52;
     */
    Method[Method["UPDATE_DIALOG_ORDER"] = 52] = "UPDATE_DIALOG_ORDER";
    /**
     * @generated from protobuf enum value: CLEAR_CHAT_HISTORY = 53;
     */
    Method[Method["CLEAR_CHAT_HISTORY"] = 53] = "CLEAR_CHAT_HISTORY";
    /**
     * @generated from protobuf enum value: DELETE_BOT = 54;
     */
    Method[Method["DELETE_BOT"] = 54] = "DELETE_BOT";
    /**
     * @generated from protobuf enum value: DELETE_MESSAGE_ATTACHMENT = 55;
     */
    Method[Method["DELETE_MESSAGE_ATTACHMENT"] = 55] = "DELETE_MESSAGE_ATTACHMENT";
    /**
     * @generated from protobuf enum value: SET_BOT_AVATAR = 56;
     */
    Method[Method["SET_BOT_AVATAR"] = 56] = "SET_BOT_AVATAR";
    /**
     * @generated from protobuf enum value: CLEAR_BOT_AVATAR = 57;
     */
    Method[Method["CLEAR_BOT_AVATAR"] = 57] = "CLEAR_BOT_AVATAR";
    /**
     * @generated from protobuf enum value: GET_BOT_PRESENCE = 58;
     */
    Method[Method["GET_BOT_PRESENCE"] = 58] = "GET_BOT_PRESENCE";
    /**
     * @generated from protobuf enum value: SET_BOT_PRESENCE_STATE = 59;
     */
    Method[Method["SET_BOT_PRESENCE_STATE"] = 59] = "SET_BOT_PRESENCE_STATE";
    /**
     * @generated from protobuf enum value: UPDATE_DIALOG_FOLLOW_MODE = 60;
     */
    Method[Method["UPDATE_DIALOG_FOLLOW_MODE"] = 60] = "UPDATE_DIALOG_FOLLOW_MODE";
    /**
     * @generated from protobuf enum value: GET_SESSIONS = 61;
     */
    Method[Method["GET_SESSIONS"] = 61] = "GET_SESSIONS";
    /**
     * @generated from protobuf enum value: CHECK_USERNAME = 62;
     */
    Method[Method["CHECK_USERNAME"] = 62] = "CHECK_USERNAME";
    /**
     * @generated from protobuf enum value: CHANGE_USERNAME = 63;
     */
    Method[Method["CHANGE_USERNAME"] = 63] = "CHANGE_USERNAME";
    /**
     * @generated from protobuf enum value: UPDATE_PROFILE = 64;
     */
    Method[Method["UPDATE_PROFILE"] = 64] = "UPDATE_PROFILE";
    /**
     * @generated from protobuf enum value: GET_SPACE_URL_PREVIEW_EXCLUSIONS = 65;
     */
    Method[Method["GET_SPACE_URL_PREVIEW_EXCLUSIONS"] = 65] = "GET_SPACE_URL_PREVIEW_EXCLUSIONS";
    /**
     * @generated from protobuf enum value: ADD_SPACE_URL_PREVIEW_EXCLUSION = 66;
     */
    Method[Method["ADD_SPACE_URL_PREVIEW_EXCLUSION"] = 66] = "ADD_SPACE_URL_PREVIEW_EXCLUSION";
    /**
     * @generated from protobuf enum value: REMOVE_SPACE_URL_PREVIEW_EXCLUSION = 67;
     */
    Method[Method["REMOVE_SPACE_URL_PREVIEW_EXCLUSION"] = 67] = "REMOVE_SPACE_URL_PREVIEW_EXCLUSION";
    /**
     * @generated from protobuf enum value: GET_USER_GROUPS = 68;
     */
    Method[Method["GET_USER_GROUPS"] = 68] = "GET_USER_GROUPS";
    /**
     * @generated from protobuf enum value: CREATE_USER_GROUP = 69;
     */
    Method[Method["CREATE_USER_GROUP"] = 69] = "CREATE_USER_GROUP";
    /**
     * @generated from protobuf enum value: UPDATE_USER_GROUP = 70;
     */
    Method[Method["UPDATE_USER_GROUP"] = 70] = "UPDATE_USER_GROUP";
    /**
     * @generated from protobuf enum value: DELETE_USER_GROUP = 71;
     */
    Method[Method["DELETE_USER_GROUP"] = 71] = "DELETE_USER_GROUP";
    /**
     * @generated from protobuf enum value: GET_SPACE_SETTINGS = 72;
     */
    Method[Method["GET_SPACE_SETTINGS"] = 72] = "GET_SPACE_SETTINGS";
    /**
     * @generated from protobuf enum value: TOGGLE_SPACE_GRID = 73;
     */
    Method[Method["TOGGLE_SPACE_GRID"] = 73] = "TOGGLE_SPACE_GRID";
    /**
     * @generated from protobuf enum value: GET_THREAD_REFERENCES = 74;
     */
    Method[Method["GET_THREAD_REFERENCES"] = 74] = "GET_THREAD_REFERENCES";
    /**
     * @generated from protobuf enum value: GET_THREAD_SUBTHREADS = 75;
     */
    Method[Method["GET_THREAD_SUBTHREADS"] = 75] = "GET_THREAD_SUBTHREADS";
    /**
     * @generated from protobuf enum value: GET_PEER_BOTS = 76;
     */
    Method[Method["GET_PEER_BOTS"] = 76] = "GET_PEER_BOTS";
    /**
     * @generated from protobuf enum value: GET_MY_BOT_CAPABILITIES = 77;
     */
    Method[Method["GET_MY_BOT_CAPABILITIES"] = 77] = "GET_MY_BOT_CAPABILITIES";
    /**
     * @generated from protobuf enum value: SET_MY_BOT_CAPABILITIES = 78;
     */
    Method[Method["SET_MY_BOT_CAPABILITIES"] = 78] = "SET_MY_BOT_CAPABILITIES";
    /**
     * @generated from protobuf enum value: REQUEST_BOT_CHAT_SETTINGS = 79;
     */
    Method[Method["REQUEST_BOT_CHAT_SETTINGS"] = 79] = "REQUEST_BOT_CHAT_SETTINGS";
    /**
     * @generated from protobuf enum value: INVOKE_BOT_CHAT_SETTINGS_ITEM = 80;
     */
    Method[Method["INVOKE_BOT_CHAT_SETTINGS_ITEM"] = 80] = "INVOKE_BOT_CHAT_SETTINGS_ITEM";
    /**
     * @generated from protobuf enum value: ANSWER_BOT_CHAT_SETTINGS = 81;
     */
    Method[Method["ANSWER_BOT_CHAT_SETTINGS"] = 81] = "ANSWER_BOT_CHAT_SETTINGS";
    /**
     * @generated from protobuf enum value: GET_GRID = 83;
     */
    Method[Method["GET_GRID"] = 83] = "GET_GRID";
    /**
     * @generated from protobuf enum value: CREATE_GRID_ROOM = 84;
     */
    Method[Method["CREATE_GRID_ROOM"] = 84] = "CREATE_GRID_ROOM";
    /**
     * @generated from protobuf enum value: JOIN_GRID_ROOM = 85;
     */
    Method[Method["JOIN_GRID_ROOM"] = 85] = "JOIN_GRID_ROOM";
    /**
     * @generated from protobuf enum value: LEAVE_GRID_ROOM = 86;
     */
    Method[Method["LEAVE_GRID_ROOM"] = 86] = "LEAVE_GRID_ROOM";
    /**
     * @generated from protobuf enum value: SET_GRID_ROOM_TITLE = 87;
     */
    Method[Method["SET_GRID_ROOM_TITLE"] = 87] = "SET_GRID_ROOM_TITLE";
    /**
     * @generated from protobuf enum value: SET_GRID_ROOM_LOCKED = 88;
     */
    Method[Method["SET_GRID_ROOM_LOCKED"] = 88] = "SET_GRID_ROOM_LOCKED";
    /**
     * @generated from protobuf enum value: DELETE_GRID_ROOM = 89;
     */
    Method[Method["DELETE_GRID_ROOM"] = 89] = "DELETE_GRID_ROOM";
    /**
     * @generated from protobuf enum value: PREPARE_GRID_CONNECTION = 90;
     */
    Method[Method["PREPARE_GRID_CONNECTION"] = 90] = "PREPARE_GRID_CONNECTION";
    /**
     * @generated from protobuf enum value: SET_GRID_AVATAR_MICROPHONE_ENABLED = 91;
     */
    Method[Method["SET_GRID_AVATAR_MICROPHONE_ENABLED"] = 91] = "SET_GRID_AVATAR_MICROPHONE_ENABLED";
    /**
     * @generated from protobuf enum value: GET_GRID_HOME = 92;
     */
    Method[Method["GET_GRID_HOME"] = 92] = "GET_GRID_HOME";
    /**
     * @generated from protobuf enum value: CREATE_CLI_SESSION = 93;
     */
    Method[Method["CREATE_CLI_SESSION"] = 93] = "CREATE_CLI_SESSION";
    /**
     * @generated from protobuf enum value: SET_PROFILE_PHOTO = 94;
     */
    Method[Method["SET_PROFILE_PHOTO"] = 94] = "SET_PROFILE_PHOTO";
    /**
     * @generated from protobuf enum value: GET_EXTERNAL_PROFILE_PHOTO = 95;
     */
    Method[Method["GET_EXTERNAL_PROFILE_PHOTO"] = 95] = "GET_EXTERNAL_PROFILE_PHOTO";
    /**
     * @generated from protobuf enum value: GET_CHAT_TRANSCRIPT = 96;
     */
    Method[Method["GET_CHAT_TRANSCRIPT"] = 96] = "GET_CHAT_TRANSCRIPT";
    /**
     * @generated from protobuf enum value: SEARCH_EXTERNAL_RESOURCES = 97;
     */
    Method[Method["SEARCH_EXTERNAL_RESOURCES"] = 97] = "SEARCH_EXTERNAL_RESOURCES";
    /**
     * @generated from protobuf enum value: JOIN_PUBLIC_SPACE = 98;
     */
    Method[Method["JOIN_PUBLIC_SPACE"] = 98] = "JOIN_PUBLIC_SPACE";
    /**
     * @generated from protobuf enum value: COLLAPSE_HISTORY = 99;
     */
    Method[Method["COLLAPSE_HISTORY"] = 99] = "COLLAPSE_HISTORY";
    /**
     * @generated from protobuf enum value: LIST_CONNECTORS = 100;
     */
    Method[Method["LIST_CONNECTORS"] = 100] = "LIST_CONNECTORS";
    /**
     * @generated from protobuf enum value: PREPARE_CONNECTOR_OAUTH = 101;
     */
    Method[Method["PREPARE_CONNECTOR_OAUTH"] = 101] = "PREPARE_CONNECTOR_OAUTH";
    /**
     * @generated from protobuf enum value: DISCONNECT_CONNECTOR = 102;
     */
    Method[Method["DISCONNECT_CONNECTOR"] = 102] = "DISCONNECT_CONNECTOR";
    /**
     * @generated from protobuf enum value: SEARCH_USERS = 103;
     */
    Method[Method["SEARCH_USERS"] = 103] = "SEARCH_USERS";
    /**
     * @generated from protobuf enum value: INVITE_TO_INLINE = 104;
     */
    Method[Method["INVITE_TO_INLINE"] = 104] = "INVITE_TO_INLINE";
    /**
     * @generated from protobuf enum value: RESOLVE_URL_PREVIEW = 105;
     */
    Method[Method["RESOLVE_URL_PREVIEW"] = 105] = "RESOLVE_URL_PREVIEW";
    /**
     * @generated from protobuf enum value: CREATE_BOT_AGENT = 106;
     */
    Method[Method["CREATE_BOT_AGENT"] = 106] = "CREATE_BOT_AGENT";
    /**
     * @generated from protobuf enum value: GET_BOT_AGENT = 107;
     */
    Method[Method["GET_BOT_AGENT"] = 107] = "GET_BOT_AGENT";
    /**
     * @generated from protobuf enum value: LIST_BOT_AGENTS = 108;
     */
    Method[Method["LIST_BOT_AGENTS"] = 108] = "LIST_BOT_AGENTS";
    /**
     * @generated from protobuf enum value: CREATE_SPACE = 109;
     */
    Method[Method["CREATE_SPACE"] = 109] = "CREATE_SPACE";
    /**
     * @generated from protobuf enum value: DELETE_SPACE = 110;
     */
    Method[Method["DELETE_SPACE"] = 110] = "DELETE_SPACE";
    /**
     * @generated from protobuf enum value: LEAVE_SPACE = 111;
     */
    Method[Method["LEAVE_SPACE"] = 111] = "LEAVE_SPACE";
    /**
     * @generated from protobuf enum value: GET_CONNECTOR_CONFIG = 112;
     */
    Method[Method["GET_CONNECTOR_CONFIG"] = 112] = "GET_CONNECTOR_CONFIG";
    /**
     * @generated from protobuf enum value: SET_CONNECTOR_CONFIG = 113;
     */
    Method[Method["SET_CONNECTOR_CONFIG"] = 113] = "SET_CONNECTOR_CONFIG";
    /**
     * @generated from protobuf enum value: CREATE_EXTERNAL_TASK = 114;
     */
    Method[Method["CREATE_EXTERNAL_TASK"] = 114] = "CREATE_EXTERNAL_TASK";
    /**
     * @generated from protobuf enum value: UNREGISTER_DEVICE = 115;
     */
    Method[Method["UNREGISTER_DEVICE"] = 115] = "UNREGISTER_DEVICE";
    /**
     * @generated from protobuf enum value: LOG_OUT = 116;
     */
    Method[Method["LOG_OUT"] = 116] = "LOG_OUT";
    /**
     * @generated from protobuf enum value: CREATE_UPLOAD = 117;
     */
    Method[Method["CREATE_UPLOAD"] = 117] = "CREATE_UPLOAD";
    /**
     * @generated from protobuf enum value: SAVE_UPLOAD_PART = 118;
     */
    Method[Method["SAVE_UPLOAD_PART"] = 118] = "SAVE_UPLOAD_PART";
    /**
     * @generated from protobuf enum value: GET_UPLOAD_STATE = 119;
     */
    Method[Method["GET_UPLOAD_STATE"] = 119] = "GET_UPLOAD_STATE";
    /**
     * @generated from protobuf enum value: FINISH_UPLOAD = 120;
     */
    Method[Method["FINISH_UPLOAD"] = 120] = "FINISH_UPLOAD";
    /**
     * @generated from protobuf enum value: CANCEL_UPLOAD = 121;
     */
    Method[Method["CANCEL_UPLOAD"] = 121] = "CANCEL_UPLOAD";
    /**
     * @generated from protobuf enum value: UPDATE_SESSION = 122;
     */
    Method[Method["UPDATE_SESSION"] = 122] = "UPDATE_SESSION";
    /**
     * @generated from protobuf enum value: UPDATE_DIALOG_ARCHIVED = 123;
     */
    Method[Method["UPDATE_DIALOG_ARCHIVED"] = 123] = "UPDATE_DIALOG_ARCHIVED";
    /**
     * @generated from protobuf enum value: CREATE_DIALOG_FOLDER = 124;
     */
    Method[Method["CREATE_DIALOG_FOLDER"] = 124] = "CREATE_DIALOG_FOLDER";
    /**
     * @generated from protobuf enum value: UPDATE_DIALOG_FOLDER = 125;
     */
    Method[Method["UPDATE_DIALOG_FOLDER"] = 125] = "UPDATE_DIALOG_FOLDER";
    /**
     * @generated from protobuf enum value: DELETE_DIALOG_FOLDER = 126;
     */
    Method[Method["DELETE_DIALOG_FOLDER"] = 126] = "DELETE_DIALOG_FOLDER";
    /**
     * @generated from protobuf enum value: GET_SPACE = 127;
     */
    Method[Method["GET_SPACE"] = 127] = "GET_SPACE";
    /**
     * @generated from protobuf enum value: CONNECT_AGENT_SESSION = 128;
     */
    Method[Method["CONNECT_AGENT_SESSION"] = 128] = "CONNECT_AGENT_SESSION";
    /**
     * @generated from protobuf enum value: SYNC_AGENT_SESSION_MESSAGES = 129;
     */
    Method[Method["SYNC_AGENT_SESSION_MESSAGES"] = 129] = "SYNC_AGENT_SESSION_MESSAGES";
    /**
     * @generated from protobuf enum value: GET_AGENT_SESSION = 130;
     */
    Method[Method["GET_AGENT_SESSION"] = 130] = "GET_AGENT_SESSION";
    /**
     * @generated from protobuf enum value: UPDATE_BOT_AGENT = 131;
     */
    Method[Method["UPDATE_BOT_AGENT"] = 131] = "UPDATE_BOT_AGENT";
    /**
     * @generated from protobuf enum value: DELETE_BOT_AGENT = 132;
     */
    Method[Method["DELETE_BOT_AGENT"] = 132] = "DELETE_BOT_AGENT";
    /**
     * @generated from protobuf enum value: JOIN_SPACE_BY_INVITE_TOKEN = 133;
     */
    Method[Method["JOIN_SPACE_BY_INVITE_TOKEN"] = 133] = "JOIN_SPACE_BY_INVITE_TOKEN";
    /**
     * @generated from protobuf enum value: GET_SPACE_INVITE_LINK = 134;
     */
    Method[Method["GET_SPACE_INVITE_LINK"] = 134] = "GET_SPACE_INVITE_LINK";
    /**
     * @generated from protobuf enum value: SET_SPACE_INVITE_LINK_ENABLED = 135;
     */
    Method[Method["SET_SPACE_INVITE_LINK_ENABLED"] = 135] = "SET_SPACE_INVITE_LINK_ENABLED";
    /**
     * @generated from protobuf enum value: GET_FILE_PART = 136;
     */
    Method[Method["GET_FILE_PART"] = 136] = "GET_FILE_PART";
    /**
     * @generated from protobuf enum value: ACKNOWLEDGE_MESSAGES = 137;
     */
    Method[Method["ACKNOWLEDGE_MESSAGES"] = 137] = "ACKNOWLEDGE_MESSAGES";
    /**
     * @generated from protobuf enum value: GET_USERS = 138;
     */
    Method[Method["GET_USERS"] = 138] = "GET_USERS";
    /**
     * @generated from protobuf enum value: GET_BOT_SKILLS = 139;
     */
    Method[Method["GET_BOT_SKILLS"] = 139] = "GET_BOT_SKILLS";
    /**
     * @generated from protobuf enum value: GET_BOT_CONFIGURATION_CATALOG = 140;
     */
    Method[Method["GET_BOT_CONFIGURATION_CATALOG"] = 140] = "GET_BOT_CONFIGURATION_CATALOG";
})(Method || (Method = {}));
/**
 * @generated from protobuf enum GridConnectionUnavailableReason
 */
export var GridConnectionUnavailableReason;
(function (GridConnectionUnavailableReason) {
    /**
     * @generated from protobuf enum value: GRID_CONNECTION_UNAVAILABLE_REASON_UNSPECIFIED = 0;
     */
    GridConnectionUnavailableReason[GridConnectionUnavailableReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: GRID_CONNECTION_UNAVAILABLE_REASON_NOT_ACTIVE = 1;
     */
    GridConnectionUnavailableReason[GridConnectionUnavailableReason["NOT_ACTIVE"] = 1] = "NOT_ACTIVE";
    /**
     * @generated from protobuf enum value: GRID_CONNECTION_UNAVAILABLE_REASON_PROVIDER_UNAVAILABLE = 2;
     */
    GridConnectionUnavailableReason[GridConnectionUnavailableReason["PROVIDER_UNAVAILABLE"] = 2] = "PROVIDER_UNAVAILABLE";
})(GridConnectionUnavailableReason || (GridConnectionUnavailableReason = {}));
/**
 * @generated from protobuf enum UsernameAvailability
 */
export var UsernameAvailability;
(function (UsernameAvailability) {
    /**
     * @generated from protobuf enum value: USERNAME_AVAILABILITY_UNSPECIFIED = 0;
     */
    UsernameAvailability[UsernameAvailability["USERNAME_AVAILABILITY_UNSPECIFIED"] = 0] = "USERNAME_AVAILABILITY_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: USERNAME_AVAILABLE = 1;
     */
    UsernameAvailability[UsernameAvailability["USERNAME_AVAILABLE"] = 1] = "USERNAME_AVAILABLE";
    /**
     * @generated from protobuf enum value: USERNAME_CURRENT = 2;
     */
    UsernameAvailability[UsernameAvailability["USERNAME_CURRENT"] = 2] = "USERNAME_CURRENT";
    /**
     * @generated from protobuf enum value: USERNAME_TAKEN = 3;
     */
    UsernameAvailability[UsernameAvailability["USERNAME_TAKEN"] = 3] = "USERNAME_TAKEN";
    /**
     * @generated from protobuf enum value: USERNAME_RESERVED = 4;
     */
    UsernameAvailability[UsernameAvailability["USERNAME_RESERVED"] = 4] = "USERNAME_RESERVED";
    /**
     * @generated from protobuf enum value: USERNAME_INVALID = 5;
     */
    UsernameAvailability[UsernameAvailability["USERNAME_INVALID"] = 5] = "USERNAME_INVALID";
})(UsernameAvailability || (UsernameAvailability = {}));
/**
 * @generated from protobuf enum ExternalProfileProvider
 */
export var ExternalProfileProvider;
(function (ExternalProfileProvider) {
    /**
     * @generated from protobuf enum value: EXTERNAL_PROFILE_PROVIDER_UNSPECIFIED = 0;
     */
    ExternalProfileProvider[ExternalProfileProvider["EXTERNAL_PROFILE_PROVIDER_UNSPECIFIED"] = 0] = "EXTERNAL_PROFILE_PROVIDER_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: EXTERNAL_PROFILE_PROVIDER_X = 1;
     */
    ExternalProfileProvider[ExternalProfileProvider["EXTERNAL_PROFILE_PROVIDER_X"] = 1] = "EXTERNAL_PROFILE_PROVIDER_X";
})(ExternalProfileProvider || (ExternalProfileProvider = {}));
/**
 * @generated from protobuf enum ExternalProfilePhotoStatus
 */
export var ExternalProfilePhotoStatus;
(function (ExternalProfilePhotoStatus) {
    /**
     * @generated from protobuf enum value: EXTERNAL_PROFILE_PHOTO_STATUS_UNSPECIFIED = 0;
     */
    ExternalProfilePhotoStatus[ExternalProfilePhotoStatus["EXTERNAL_PROFILE_PHOTO_STATUS_UNSPECIFIED"] = 0] = "EXTERNAL_PROFILE_PHOTO_STATUS_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: EXTERNAL_PROFILE_PHOTO_FOUND = 1;
     */
    ExternalProfilePhotoStatus[ExternalProfilePhotoStatus["EXTERNAL_PROFILE_PHOTO_FOUND"] = 1] = "EXTERNAL_PROFILE_PHOTO_FOUND";
    /**
     * @generated from protobuf enum value: EXTERNAL_PROFILE_PHOTO_NOT_FOUND = 2;
     */
    ExternalProfilePhotoStatus[ExternalProfilePhotoStatus["EXTERNAL_PROFILE_PHOTO_NOT_FOUND"] = 2] = "EXTERNAL_PROFILE_PHOTO_NOT_FOUND";
    /**
     * @generated from protobuf enum value: EXTERNAL_PROFILE_PHOTO_UNAVAILABLE = 3;
     */
    ExternalProfilePhotoStatus[ExternalProfilePhotoStatus["EXTERNAL_PROFILE_PHOTO_UNAVAILABLE"] = 3] = "EXTERNAL_PROFILE_PHOTO_UNAVAILABLE";
})(ExternalProfilePhotoStatus || (ExternalProfilePhotoStatus = {}));
/**
 * @generated from protobuf enum PushNotificationProvider
 */
export var PushNotificationProvider;
(function (PushNotificationProvider) {
    /**
     * @generated from protobuf enum value: PUSH_NOTIFICATION_PROVIDER_UNSPECIFIED = 0;
     */
    PushNotificationProvider[PushNotificationProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PUSH_NOTIFICATION_PROVIDER_APNS = 1;
     */
    PushNotificationProvider[PushNotificationProvider["APNS"] = 1] = "APNS";
    /**
     * @generated from protobuf enum value: PUSH_NOTIFICATION_PROVIDER_EXPO_ANDROID = 2;
     */
    PushNotificationProvider[PushNotificationProvider["EXPO_ANDROID"] = 2] = "EXPO_ANDROID";
})(PushNotificationProvider || (PushNotificationProvider = {}));
/**
 * @generated from protobuf enum DeleteDialogFolderDisposition
 */
export var DeleteDialogFolderDisposition;
(function (DeleteDialogFolderDisposition) {
    /**
     * @generated from protobuf enum value: DELETE_DIALOG_FOLDER_DISPOSITION_UNSPECIFIED = 0;
     */
    DeleteDialogFolderDisposition[DeleteDialogFolderDisposition["DELETE_DIALOG_FOLDER_DISPOSITION_UNSPECIFIED"] = 0] = "DELETE_DIALOG_FOLDER_DISPOSITION_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CLOSE_DIALOGS = 1;
     */
    DeleteDialogFolderDisposition[DeleteDialogFolderDisposition["CLOSE_DIALOGS"] = 1] = "CLOSE_DIALOGS";
    /**
     * @generated from protobuf enum value: KEEP_DIALOGS = 2;
     */
    DeleteDialogFolderDisposition[DeleteDialogFolderDisposition["KEEP_DIALOGS"] = 2] = "KEEP_DIALOGS";
})(DeleteDialogFolderDisposition || (DeleteDialogFolderDisposition = {}));
/**
 * @generated from protobuf enum GetChatHistoryMode
 */
export var GetChatHistoryMode;
(function (GetChatHistoryMode) {
    /**
     * @generated from protobuf enum value: HISTORY_MODE_UNSPECIFIED = 0;
     */
    GetChatHistoryMode[GetChatHistoryMode["HISTORY_MODE_UNSPECIFIED"] = 0] = "HISTORY_MODE_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: HISTORY_MODE_LATEST = 1;
     */
    GetChatHistoryMode[GetChatHistoryMode["HISTORY_MODE_LATEST"] = 1] = "HISTORY_MODE_LATEST";
    /**
     * @generated from protobuf enum value: HISTORY_MODE_OLDER = 2;
     */
    GetChatHistoryMode[GetChatHistoryMode["HISTORY_MODE_OLDER"] = 2] = "HISTORY_MODE_OLDER";
    /**
     * @generated from protobuf enum value: HISTORY_MODE_NEWER = 3;
     */
    GetChatHistoryMode[GetChatHistoryMode["HISTORY_MODE_NEWER"] = 3] = "HISTORY_MODE_NEWER";
    /**
     * @generated from protobuf enum value: HISTORY_MODE_AROUND = 4;
     */
    GetChatHistoryMode[GetChatHistoryMode["HISTORY_MODE_AROUND"] = 4] = "HISTORY_MODE_AROUND";
})(GetChatHistoryMode || (GetChatHistoryMode = {}));
/**
 * @generated from protobuf enum ThreadReferenceKind
 */
export var ThreadReferenceKind;
(function (ThreadReferenceKind) {
    /**
     * @generated from protobuf enum value: THREAD_REFERENCE_KIND_UNSPECIFIED = 0;
     */
    ThreadReferenceKind[ThreadReferenceKind["THREAD_REFERENCE_KIND_UNSPECIFIED"] = 0] = "THREAD_REFERENCE_KIND_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: THREAD_LINK = 1;
     */
    ThreadReferenceKind[ThreadReferenceKind["THREAD_LINK"] = 1] = "THREAD_LINK";
    /**
     * @generated from protobuf enum value: REPLY_THREAD = 2;
     */
    ThreadReferenceKind[ThreadReferenceKind["REPLY_THREAD"] = 2] = "REPLY_THREAD";
})(ThreadReferenceKind || (ThreadReferenceKind = {}));
/**
 * @generated from protobuf enum SearchMessagesFilter
 */
export var SearchMessagesFilter;
(function (SearchMessagesFilter) {
    /**
     * @generated from protobuf enum value: FILTER_UNSPECIFIED = 0;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_UNSPECIFIED"] = 0] = "FILTER_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: FILTER_PHOTOS = 1;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_PHOTOS"] = 1] = "FILTER_PHOTOS";
    /**
     * @generated from protobuf enum value: FILTER_VIDEOS = 2;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_VIDEOS"] = 2] = "FILTER_VIDEOS";
    /**
     * @generated from protobuf enum value: FILTER_PHOTO_VIDEO = 3;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_PHOTO_VIDEO"] = 3] = "FILTER_PHOTO_VIDEO";
    /**
     * @generated from protobuf enum value: FILTER_DOCUMENTS = 4;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_DOCUMENTS"] = 4] = "FILTER_DOCUMENTS";
    /**
     * @generated from protobuf enum value: FILTER_LINKS = 5;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_LINKS"] = 5] = "FILTER_LINKS";
    /**
     * @generated from protobuf enum value: FILTER_VOICE_MEMOS = 6;
     */
    SearchMessagesFilter[SearchMessagesFilter["FILTER_VOICE_MEMOS"] = 6] = "FILTER_VOICE_MEMOS";
})(SearchMessagesFilter || (SearchMessagesFilter = {}));
/**
 * @generated from protobuf enum ExternalResourceProvider
 */
export var ExternalResourceProvider;
(function (ExternalResourceProvider) {
    /**
     * @generated from protobuf enum value: EXTERNAL_RESOURCE_PROVIDER_UNSPECIFIED = 0;
     */
    ExternalResourceProvider[ExternalResourceProvider["EXTERNAL_RESOURCE_PROVIDER_UNSPECIFIED"] = 0] = "EXTERNAL_RESOURCE_PROVIDER_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: NOTION = 1;
     */
    ExternalResourceProvider[ExternalResourceProvider["NOTION"] = 1] = "NOTION";
    /**
     * @generated from protobuf enum value: LINEAR = 2;
     */
    ExternalResourceProvider[ExternalResourceProvider["LINEAR"] = 2] = "LINEAR";
    /**
     * @generated from protobuf enum value: GITHUB = 3;
     */
    ExternalResourceProvider[ExternalResourceProvider["GITHUB"] = 3] = "GITHUB";
})(ExternalResourceProvider || (ExternalResourceProvider = {}));
/**
 * @generated from protobuf enum ExternalResourceKind
 */
export var ExternalResourceKind;
(function (ExternalResourceKind) {
    /**
     * @generated from protobuf enum value: EXTERNAL_RESOURCE_KIND_UNSPECIFIED = 0;
     */
    ExternalResourceKind[ExternalResourceKind["EXTERNAL_RESOURCE_KIND_UNSPECIFIED"] = 0] = "EXTERNAL_RESOURCE_KIND_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PAGE = 1;
     */
    ExternalResourceKind[ExternalResourceKind["PAGE"] = 1] = "PAGE";
    /**
     * @generated from protobuf enum value: DATABASE = 2;
     */
    ExternalResourceKind[ExternalResourceKind["DATABASE"] = 2] = "DATABASE";
    /**
     * @generated from protobuf enum value: ISSUE = 3;
     */
    ExternalResourceKind[ExternalResourceKind["ISSUE"] = 3] = "ISSUE";
    /**
     * @generated from protobuf enum value: PULL_REQUEST = 4;
     */
    ExternalResourceKind[ExternalResourceKind["PULL_REQUEST"] = 4] = "PULL_REQUEST";
    /**
     * @generated from protobuf enum value: REPOSITORY = 5;
     */
    ExternalResourceKind[ExternalResourceKind["REPOSITORY"] = 5] = "REPOSITORY";
    /**
     * @generated from protobuf enum value: OTHER = 6;
     */
    ExternalResourceKind[ExternalResourceKind["OTHER"] = 6] = "OTHER";
})(ExternalResourceKind || (ExternalResourceKind = {}));
/**
 * @generated from protobuf enum ConnectorProvider
 */
export var ConnectorProvider;
(function (ConnectorProvider) {
    /**
     * @generated from protobuf enum value: CONNECTOR_PROVIDER_UNSPECIFIED = 0;
     */
    ConnectorProvider[ConnectorProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CONNECTOR_PROVIDER_NOTION = 1;
     */
    ConnectorProvider[ConnectorProvider["NOTION"] = 1] = "NOTION";
    /**
     * @generated from protobuf enum value: CONNECTOR_PROVIDER_LINEAR = 2;
     */
    ConnectorProvider[ConnectorProvider["LINEAR"] = 2] = "LINEAR";
    /**
     * @generated from protobuf enum value: CONNECTOR_PROVIDER_GITHUB = 3;
     */
    ConnectorProvider[ConnectorProvider["GITHUB"] = 3] = "GITHUB";
})(ConnectorProvider || (ConnectorProvider = {}));
/**
 * @generated from protobuf enum HttpUploadKind
 */
export var HttpUploadKind;
(function (HttpUploadKind) {
    /**
     * @generated from protobuf enum value: HTTP_UPLOAD_KIND_UNSPECIFIED = 0;
     */
    HttpUploadKind[HttpUploadKind["HTTP_UPLOAD_KIND_UNSPECIFIED"] = 0] = "HTTP_UPLOAD_KIND_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PHOTO = 1;
     */
    HttpUploadKind[HttpUploadKind["PHOTO"] = 1] = "PHOTO";
    /**
     * @generated from protobuf enum value: VIDEO = 2;
     */
    HttpUploadKind[HttpUploadKind["VIDEO"] = 2] = "VIDEO";
    /**
     * @generated from protobuf enum value: DOCUMENT = 3;
     */
    HttpUploadKind[HttpUploadKind["DOCUMENT"] = 3] = "DOCUMENT";
    /**
     * @generated from protobuf enum value: VOICE = 4;
     */
    HttpUploadKind[HttpUploadKind["VOICE"] = 4] = "VOICE";
})(HttpUploadKind || (HttpUploadKind = {}));
// --- Native resumable uploads ---
// These are ordinary RpcCall methods and may be carried by Realtime V2 or V3.
/**
 * @generated from protobuf enum UploadKind
 */
export var UploadKind;
(function (UploadKind) {
    /**
     * @generated from protobuf enum value: UPLOAD_KIND_UNSPECIFIED = 0;
     */
    UploadKind[UploadKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: UPLOAD_KIND_PHOTO = 1;
     */
    UploadKind[UploadKind["PHOTO"] = 1] = "PHOTO";
    /**
     * @generated from protobuf enum value: UPLOAD_KIND_VIDEO = 2;
     */
    UploadKind[UploadKind["VIDEO"] = 2] = "VIDEO";
    /**
     * @generated from protobuf enum value: UPLOAD_KIND_DOCUMENT = 3;
     */
    UploadKind[UploadKind["DOCUMENT"] = 3] = "DOCUMENT";
    /**
     * @generated from protobuf enum value: UPLOAD_KIND_VOICE = 4;
     */
    UploadKind[UploadKind["VOICE"] = 4] = "VOICE";
})(UploadKind || (UploadKind = {}));
/**
 * @generated from protobuf enum UploadStatus
 */
export var UploadStatus;
(function (UploadStatus) {
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_UNSPECIFIED = 0;
     */
    UploadStatus[UploadStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_UPLOADING = 1;
     */
    UploadStatus[UploadStatus["UPLOADING"] = 1] = "UPLOADING";
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_PROCESSING = 2;
     */
    UploadStatus[UploadStatus["PROCESSING"] = 2] = "PROCESSING";
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_COMPLETE = 3;
     */
    UploadStatus[UploadStatus["COMPLETE"] = 3] = "COMPLETE";
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_FAILED = 4;
     */
    UploadStatus[UploadStatus["FAILED"] = 4] = "FAILED";
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_CANCELED = 5;
     */
    UploadStatus[UploadStatus["CANCELED"] = 5] = "CANCELED";
    /**
     * @generated from protobuf enum value: UPLOAD_STATUS_EXPIRED = 6;
     */
    UploadStatus[UploadStatus["EXPIRED"] = 6] = "EXPIRED";
})(UploadStatus || (UploadStatus = {}));
// @generated message type with reflection information, may provide speed optimized methods
class ClientMessage$Type extends MessageType {
    constructor() {
        super("ClientMessage", [
            { no: 1, name: "id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "seq", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "connection_init", kind: "message", oneof: "body", T: () => ConnectionInit },
            { no: 5, name: "rpc_call", kind: "message", oneof: "body", T: () => RpcCall },
            { no: 6, name: "ack", kind: "message", oneof: "body", T: () => Ack },
            { no: 7, name: "ping", kind: "message", oneof: "body", T: () => Ping }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.seq = 0;
        message.body = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 id */ 1:
                    message.id = reader.uint64().toBigInt();
                    break;
                case /* uint32 seq */ 2:
                    message.seq = reader.uint32();
                    break;
                case /* ConnectionInit connection_init */ 4:
                    message.body = {
                        oneofKind: "connectionInit",
                        connectionInit: ConnectionInit.internalBinaryRead(reader, reader.uint32(), options, message.body.connectionInit)
                    };
                    break;
                case /* RpcCall rpc_call */ 5:
                    message.body = {
                        oneofKind: "rpcCall",
                        rpcCall: RpcCall.internalBinaryRead(reader, reader.uint32(), options, message.body.rpcCall)
                    };
                    break;
                case /* Ack ack */ 6:
                    message.body = {
                        oneofKind: "ack",
                        ack: Ack.internalBinaryRead(reader, reader.uint32(), options, message.body.ack)
                    };
                    break;
                case /* Ping ping */ 7:
                    message.body = {
                        oneofKind: "ping",
                        ping: Ping.internalBinaryRead(reader, reader.uint32(), options, message.body.ping)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.id);
        /* uint32 seq = 2; */
        if (message.seq !== 0)
            writer.tag(2, WireType.Varint).uint32(message.seq);
        /* ConnectionInit connection_init = 4; */
        if (message.body.oneofKind === "connectionInit")
            ConnectionInit.internalBinaryWrite(message.body.connectionInit, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* RpcCall rpc_call = 5; */
        if (message.body.oneofKind === "rpcCall")
            RpcCall.internalBinaryWrite(message.body.rpcCall, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* Ack ack = 6; */
        if (message.body.oneofKind === "ack")
            Ack.internalBinaryWrite(message.body.ack, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* Ping ping = 7; */
        if (message.body.oneofKind === "ping")
            Ping.internalBinaryWrite(message.body.ping, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClientMessage
 */
export const ClientMessage = new ClientMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectionInit$Type extends MessageType {
    constructor() {
        super("ConnectionInit", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "build_number", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "layer", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "client_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "os_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "device_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "device_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "client_type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "time_zone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* optional int32 build_number */ 2:
                    message.buildNumber = reader.int32();
                    break;
                case /* optional uint32 layer */ 3:
                    message.layer = reader.uint32();
                    break;
                case /* optional string client_version */ 4:
                    message.clientVersion = reader.string();
                    break;
                case /* optional string os_version */ 5:
                    message.osVersion = reader.string();
                    break;
                case /* optional string device_id */ 6:
                    message.deviceId = reader.string();
                    break;
                case /* optional string device_name */ 7:
                    message.deviceName = reader.string();
                    break;
                case /* optional string client_type */ 8:
                    message.clientType = reader.string();
                    break;
                case /* optional string time_zone */ 9:
                    message.timeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* optional int32 build_number = 2; */
        if (message.buildNumber !== undefined)
            writer.tag(2, WireType.Varint).int32(message.buildNumber);
        /* optional uint32 layer = 3; */
        if (message.layer !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.layer);
        /* optional string client_version = 4; */
        if (message.clientVersion !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.clientVersion);
        /* optional string os_version = 5; */
        if (message.osVersion !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.osVersion);
        /* optional string device_id = 6; */
        if (message.deviceId !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.deviceId);
        /* optional string device_name = 7; */
        if (message.deviceName !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.deviceName);
        /* optional string client_type = 8; */
        if (message.clientType !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.clientType);
        /* optional string time_zone = 9; */
        if (message.timeZone !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.timeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectionInit
 */
export const ConnectionInit = new ConnectionInit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerProtocolMessage$Type extends MessageType {
    constructor() {
        super("ServerProtocolMessage", [
            { no: 1, name: "id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "connection_open", kind: "message", oneof: "body", T: () => ConnectionOpen },
            { no: 5, name: "rpc_result", kind: "message", oneof: "body", T: () => RpcResult },
            { no: 6, name: "rpc_error", kind: "message", oneof: "body", T: () => RpcError },
            { no: 7, name: "message", kind: "message", oneof: "body", T: () => ServerMessage },
            { no: 8, name: "ack", kind: "message", oneof: "body", T: () => Ack },
            { no: 9, name: "pong", kind: "message", oneof: "body", T: () => Pong },
            { no: 10, name: "connection_error", kind: "message", oneof: "body", T: () => ConnectionError }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.body = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 id */ 1:
                    message.id = reader.uint64().toBigInt();
                    break;
                case /* ConnectionOpen connection_open */ 4:
                    message.body = {
                        oneofKind: "connectionOpen",
                        connectionOpen: ConnectionOpen.internalBinaryRead(reader, reader.uint32(), options, message.body.connectionOpen)
                    };
                    break;
                case /* RpcResult rpc_result */ 5:
                    message.body = {
                        oneofKind: "rpcResult",
                        rpcResult: RpcResult.internalBinaryRead(reader, reader.uint32(), options, message.body.rpcResult)
                    };
                    break;
                case /* RpcError rpc_error */ 6:
                    message.body = {
                        oneofKind: "rpcError",
                        rpcError: RpcError.internalBinaryRead(reader, reader.uint32(), options, message.body.rpcError)
                    };
                    break;
                case /* ServerMessage message */ 7:
                    message.body = {
                        oneofKind: "message",
                        message: ServerMessage.internalBinaryRead(reader, reader.uint32(), options, message.body.message)
                    };
                    break;
                case /* Ack ack */ 8:
                    message.body = {
                        oneofKind: "ack",
                        ack: Ack.internalBinaryRead(reader, reader.uint32(), options, message.body.ack)
                    };
                    break;
                case /* Pong pong */ 9:
                    message.body = {
                        oneofKind: "pong",
                        pong: Pong.internalBinaryRead(reader, reader.uint32(), options, message.body.pong)
                    };
                    break;
                case /* ConnectionError connection_error */ 10:
                    message.body = {
                        oneofKind: "connectionError",
                        connectionError: ConnectionError.internalBinaryRead(reader, reader.uint32(), options, message.body.connectionError)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.id);
        /* ConnectionOpen connection_open = 4; */
        if (message.body.oneofKind === "connectionOpen")
            ConnectionOpen.internalBinaryWrite(message.body.connectionOpen, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* RpcResult rpc_result = 5; */
        if (message.body.oneofKind === "rpcResult")
            RpcResult.internalBinaryWrite(message.body.rpcResult, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* RpcError rpc_error = 6; */
        if (message.body.oneofKind === "rpcError")
            RpcError.internalBinaryWrite(message.body.rpcError, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ServerMessage message = 7; */
        if (message.body.oneofKind === "message")
            ServerMessage.internalBinaryWrite(message.body.message, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* Ack ack = 8; */
        if (message.body.oneofKind === "ack")
            Ack.internalBinaryWrite(message.body.ack, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* Pong pong = 9; */
        if (message.body.oneofKind === "pong")
            Pong.internalBinaryWrite(message.body.pong, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ConnectionError connection_error = 10; */
        if (message.body.oneofKind === "connectionError")
            ConnectionError.internalBinaryWrite(message.body.connectionError, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ServerProtocolMessage
 */
export const ServerProtocolMessage = new ServerProtocolMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerMessage$Type extends MessageType {
    constructor() {
        super("ServerMessage", [
            { no: 4, name: "update", kind: "message", oneof: "payload", T: () => UpdatesPayload },
            { no: 5, name: "grid", kind: "message", oneof: "payload", T: () => GridEvent },
            { no: 6, name: "bot", kind: "message", oneof: "payload", T: () => BotEvent }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UpdatesPayload update */ 4:
                    message.payload = {
                        oneofKind: "update",
                        update: UpdatesPayload.internalBinaryRead(reader, reader.uint32(), options, message.payload.update)
                    };
                    break;
                case /* GridEvent grid */ 5:
                    message.payload = {
                        oneofKind: "grid",
                        grid: GridEvent.internalBinaryRead(reader, reader.uint32(), options, message.payload.grid)
                    };
                    break;
                case /* BotEvent bot */ 6:
                    message.payload = {
                        oneofKind: "bot",
                        bot: BotEvent.internalBinaryRead(reader, reader.uint32(), options, message.payload.bot)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UpdatesPayload update = 4; */
        if (message.payload.oneofKind === "update")
            UpdatesPayload.internalBinaryWrite(message.payload.update, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* GridEvent grid = 5; */
        if (message.payload.oneofKind === "grid")
            GridEvent.internalBinaryWrite(message.payload.grid, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* BotEvent bot = 6; */
        if (message.payload.oneofKind === "bot")
            BotEvent.internalBinaryWrite(message.payload.bot, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ServerMessage
 */
export const ServerMessage = new ServerMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotEvent$Type extends MessageType {
    constructor() {
        super("BotEvent", [
            { no: 1, name: "chat_settings_requested", kind: "message", oneof: "event", T: () => BotChatSettingsRequested },
            { no: 2, name: "chat_settings_item_invoked", kind: "message", oneof: "event", T: () => BotChatSettingsItemInvoked }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.event = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotChatSettingsRequested chat_settings_requested */ 1:
                    message.event = {
                        oneofKind: "chatSettingsRequested",
                        chatSettingsRequested: BotChatSettingsRequested.internalBinaryRead(reader, reader.uint32(), options, message.event.chatSettingsRequested)
                    };
                    break;
                case /* BotChatSettingsItemInvoked chat_settings_item_invoked */ 2:
                    message.event = {
                        oneofKind: "chatSettingsItemInvoked",
                        chatSettingsItemInvoked: BotChatSettingsItemInvoked.internalBinaryRead(reader, reader.uint32(), options, message.event.chatSettingsItemInvoked)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotChatSettingsRequested chat_settings_requested = 1; */
        if (message.event.oneofKind === "chatSettingsRequested")
            BotChatSettingsRequested.internalBinaryWrite(message.event.chatSettingsRequested, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BotChatSettingsItemInvoked chat_settings_item_invoked = 2; */
        if (message.event.oneofKind === "chatSettingsItemInvoked")
            BotChatSettingsItemInvoked.internalBinaryWrite(message.event.chatSettingsItemInvoked, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotEvent
 */
export const BotEvent = new BotEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatesPayload$Type extends MessageType {
    constructor() {
        super("UpdatesPayload", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdatesPayload
 */
export const UpdatesPayload = new UpdatesPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Ack$Type extends MessageType {
    constructor() {
        super("Ack", [
            { no: 1, name: "msg_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.msgId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 msg_id */ 1:
                    message.msgId = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 msg_id = 1; */
        if (message.msgId !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.msgId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Ack
 */
export const Ack = new Ack$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectionOpen$Type extends MessageType {
    constructor() {
        super("ConnectionOpen", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectionOpen
 */
export const ConnectionOpen = new ConnectionOpen$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectionError$Type extends MessageType {
    constructor() {
        super("ConnectionError", [
            { no: 1, name: "reason", kind: "enum", T: () => ["ConnectionError.Reason", ConnectionError_Reason] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reason = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectionError.Reason reason */ 1:
                    message.reason = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectionError.Reason reason = 1; */
        if (message.reason !== 0)
            writer.tag(1, WireType.Varint).int32(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectionError
 */
export const ConnectionError = new ConnectionError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Ping$Type extends MessageType {
    constructor() {
        super("Ping", [
            { no: 1, name: "nonce", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.nonce = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 nonce */ 1:
                    message.nonce = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 nonce = 1; */
        if (message.nonce !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.nonce);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Ping
 */
export const Ping = new Ping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pong$Type extends MessageType {
    constructor() {
        super("Pong", [
            { no: 1, name: "nonce", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.nonce = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 nonce */ 1:
                    message.nonce = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 nonce = 1; */
        if (message.nonce !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.nonce);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Pong
 */
export const Pong = new Pong$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputPeer$Type extends MessageType {
    constructor() {
        super("InputPeer", [
            { no: 2, name: "self", kind: "message", oneof: "type", T: () => InputPeerSelf },
            { no: 3, name: "chat", kind: "message", oneof: "type", T: () => InputPeerChat },
            { no: 4, name: "user", kind: "message", oneof: "type", T: () => InputPeerUser }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeerSelf self */ 2:
                    message.type = {
                        oneofKind: "self",
                        self: InputPeerSelf.internalBinaryRead(reader, reader.uint32(), options, message.type.self)
                    };
                    break;
                case /* InputPeerChat chat */ 3:
                    message.type = {
                        oneofKind: "chat",
                        chat: InputPeerChat.internalBinaryRead(reader, reader.uint32(), options, message.type.chat)
                    };
                    break;
                case /* InputPeerUser user */ 4:
                    message.type = {
                        oneofKind: "user",
                        user: InputPeerUser.internalBinaryRead(reader, reader.uint32(), options, message.type.user)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeerSelf self = 2; */
        if (message.type.oneofKind === "self")
            InputPeerSelf.internalBinaryWrite(message.type.self, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* InputPeerChat chat = 3; */
        if (message.type.oneofKind === "chat")
            InputPeerChat.internalBinaryWrite(message.type.chat, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* InputPeerUser user = 4; */
        if (message.type.oneofKind === "user")
            InputPeerUser.internalBinaryWrite(message.type.user, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputPeer
 */
export const InputPeer = new InputPeer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputPeerSelf$Type extends MessageType {
    constructor() {
        super("InputPeerSelf", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputPeerSelf
 */
export const InputPeerSelf = new InputPeerSelf$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputPeerChat$Type extends MessageType {
    constructor() {
        super("InputPeerChat", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputPeerChat
 */
export const InputPeerChat = new InputPeerChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputPeerUser$Type extends MessageType {
    constructor() {
        super("InputPeerUser", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputPeerUser
 */
export const InputPeerUser = new InputPeerUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Peer$Type extends MessageType {
    constructor() {
        super("Peer", [
            { no: 2, name: "chat", kind: "message", oneof: "type", T: () => PeerChat },
            { no: 3, name: "user", kind: "message", oneof: "type", T: () => PeerUser }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* PeerChat chat */ 2:
                    message.type = {
                        oneofKind: "chat",
                        chat: PeerChat.internalBinaryRead(reader, reader.uint32(), options, message.type.chat)
                    };
                    break;
                case /* PeerUser user */ 3:
                    message.type = {
                        oneofKind: "user",
                        user: PeerUser.internalBinaryRead(reader, reader.uint32(), options, message.type.user)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* PeerChat chat = 2; */
        if (message.type.oneofKind === "chat")
            PeerChat.internalBinaryWrite(message.type.chat, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* PeerUser user = 3; */
        if (message.type.oneofKind === "user")
            PeerUser.internalBinaryWrite(message.type.user, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Peer
 */
export const Peer = new Peer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerChat$Type extends MessageType {
    constructor() {
        super("PeerChat", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PeerChat
 */
export const PeerChat = new PeerChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerUser$Type extends MessageType {
    constructor() {
        super("PeerUser", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PeerUser
 */
export const PeerUser = new PeerUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputScope$Type extends MessageType {
    constructor() {
        super("InputScope", [
            { no: 1, name: "user", kind: "message", oneof: "type", T: () => InputScopeUser },
            { no: 2, name: "space", kind: "message", oneof: "type", T: () => InputScopeSpace }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputScopeUser user */ 1:
                    message.type = {
                        oneofKind: "user",
                        user: InputScopeUser.internalBinaryRead(reader, reader.uint32(), options, message.type.user)
                    };
                    break;
                case /* InputScopeSpace space */ 2:
                    message.type = {
                        oneofKind: "space",
                        space: InputScopeSpace.internalBinaryRead(reader, reader.uint32(), options, message.type.space)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputScopeUser user = 1; */
        if (message.type.oneofKind === "user")
            InputScopeUser.internalBinaryWrite(message.type.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* InputScopeSpace space = 2; */
        if (message.type.oneofKind === "space")
            InputScopeSpace.internalBinaryWrite(message.type.space, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputScope
 */
export const InputScope = new InputScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputScopeUser$Type extends MessageType {
    constructor() {
        super("InputScopeUser", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputScopeUser
 */
export const InputScopeUser = new InputScopeUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputScopeSpace$Type extends MessageType {
    constructor() {
        super("InputScopeSpace", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputScopeSpace
 */
export const InputScopeSpace = new InputScopeSpace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Scope$Type extends MessageType {
    constructor() {
        super("Scope", [
            { no: 1, name: "user", kind: "message", oneof: "type", T: () => ScopeUser },
            { no: 2, name: "space", kind: "message", oneof: "type", T: () => ScopeSpace }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ScopeUser user */ 1:
                    message.type = {
                        oneofKind: "user",
                        user: ScopeUser.internalBinaryRead(reader, reader.uint32(), options, message.type.user)
                    };
                    break;
                case /* ScopeSpace space */ 2:
                    message.type = {
                        oneofKind: "space",
                        space: ScopeSpace.internalBinaryRead(reader, reader.uint32(), options, message.type.space)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ScopeUser user = 1; */
        if (message.type.oneofKind === "user")
            ScopeUser.internalBinaryWrite(message.type.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ScopeSpace space = 2; */
        if (message.type.oneofKind === "space")
            ScopeSpace.internalBinaryWrite(message.type.space, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Scope
 */
export const Scope = new Scope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScopeUser$Type extends MessageType {
    constructor() {
        super("ScopeUser", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScopeUser
 */
export const ScopeUser = new ScopeUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScopeSpace$Type extends MessageType {
    constructor() {
        super("ScopeSpace", [
            { no: 1, name: "space", kind: "message", T: () => Space }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Space space */ 1:
                    message.space = Space.internalBinaryRead(reader, reader.uint32(), options, message.space);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Space space = 1; */
        if (message.space)
            Space.internalBinaryWrite(message.space, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScopeSpace
 */
export const ScopeSpace = new ScopeSpace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotAvatar$Type extends MessageType {
    constructor() {
        super("BotAvatar", [
            { no: 1, name: "kind", kind: "enum", T: () => ["BotAvatar.Kind", BotAvatar_Kind] },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cdn_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotAvatar.Kind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* optional string cdn_url */ 4:
                    message.cdnUrl = reader.string();
                    break;
                case /* optional string file_unique_id */ 5:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotAvatar.Kind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* optional string cdn_url = 4; */
        if (message.cdnUrl !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.cdnUrl);
        /* optional string file_unique_id = 5; */
        if (message.fileUniqueId !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotAvatar
 */
export const BotAvatar = new BotAvatar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotPresenceState$Type extends MessageType {
    constructor() {
        super("BotPresenceState", [
            { no: 1, name: "kind", kind: "enum", T: () => ["BotPresenceState.Kind", BotPresenceState_Kind] },
            { no: 2, name: "comment", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotPresenceState.Kind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* optional string comment */ 2:
                    message.comment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotPresenceState.Kind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* optional string comment = 2; */
        if (message.comment !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.comment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotPresenceState
 */
export const BotPresenceState = new BotPresenceState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType {
    constructor() {
        super("User", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "first_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "username", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "phone_number", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "email", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "min", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "status", kind: "message", T: () => UserStatus },
            { no: 9, name: "profile_photo", kind: "message", T: () => UserProfilePhoto },
            { no: 11, name: "pending_setup", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "time_zone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "bot", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "bot_avatar", kind: "message", T: () => BotAvatar },
            { no: 15, name: "bio", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* optional string first_name */ 2:
                    message.firstName = reader.string();
                    break;
                case /* optional string last_name */ 3:
                    message.lastName = reader.string();
                    break;
                case /* optional string username */ 4:
                    message.username = reader.string();
                    break;
                case /* optional string phone_number */ 5:
                    message.phoneNumber = reader.string();
                    break;
                case /* optional string email */ 6:
                    message.email = reader.string();
                    break;
                case /* optional bool min */ 7:
                    message.min = reader.bool();
                    break;
                case /* optional UserStatus status */ 8:
                    message.status = UserStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* optional UserProfilePhoto profile_photo */ 9:
                    message.profilePhoto = UserProfilePhoto.internalBinaryRead(reader, reader.uint32(), options, message.profilePhoto);
                    break;
                case /* optional bool pending_setup */ 11:
                    message.pendingSetup = reader.bool();
                    break;
                case /* optional string time_zone */ 12:
                    message.timeZone = reader.string();
                    break;
                case /* optional bool bot */ 13:
                    message.bot = reader.bool();
                    break;
                case /* optional BotAvatar bot_avatar */ 14:
                    message.botAvatar = BotAvatar.internalBinaryRead(reader, reader.uint32(), options, message.botAvatar);
                    break;
                case /* optional string bio */ 15:
                    message.bio = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* optional string first_name = 2; */
        if (message.firstName !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.firstName);
        /* optional string last_name = 3; */
        if (message.lastName !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.lastName);
        /* optional string username = 4; */
        if (message.username !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.username);
        /* optional string phone_number = 5; */
        if (message.phoneNumber !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.phoneNumber);
        /* optional string email = 6; */
        if (message.email !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.email);
        /* optional bool min = 7; */
        if (message.min !== undefined)
            writer.tag(7, WireType.Varint).bool(message.min);
        /* optional UserStatus status = 8; */
        if (message.status)
            UserStatus.internalBinaryWrite(message.status, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional UserProfilePhoto profile_photo = 9; */
        if (message.profilePhoto)
            UserProfilePhoto.internalBinaryWrite(message.profilePhoto, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional bool pending_setup = 11; */
        if (message.pendingSetup !== undefined)
            writer.tag(11, WireType.Varint).bool(message.pendingSetup);
        /* optional string time_zone = 12; */
        if (message.timeZone !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.timeZone);
        /* optional bool bot = 13; */
        if (message.bot !== undefined)
            writer.tag(13, WireType.Varint).bool(message.bot);
        /* optional BotAvatar bot_avatar = 14; */
        if (message.botAvatar)
            BotAvatar.internalBinaryWrite(message.botAvatar, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* optional string bio = 15; */
        if (message.bio !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.bio);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message User
 */
export const User = new User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProfilePhoto$Type extends MessageType {
    constructor() {
        super("UserProfilePhoto", [
            { no: 1, name: "photo_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "stripped_thumb", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "cdn_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 photo_id */ 1:
                    message.photoId = reader.int64().toBigInt();
                    break;
                case /* optional bytes stripped_thumb */ 2:
                    message.strippedThumb = reader.bytes();
                    break;
                case /* optional string cdn_url */ 3:
                    message.cdnUrl = reader.string();
                    break;
                case /* optional string file_unique_id */ 4:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 photo_id = 1; */
        if (message.photoId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.photoId);
        /* optional bytes stripped_thumb = 2; */
        if (message.strippedThumb !== undefined)
            writer.tag(2, WireType.LengthDelimited).bytes(message.strippedThumb);
        /* optional string cdn_url = 3; */
        if (message.cdnUrl !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.cdnUrl);
        /* optional string file_unique_id = 4; */
        if (message.fileUniqueId !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserProfilePhoto
 */
export const UserProfilePhoto = new UserProfilePhoto$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Dialog$Type extends MessageType {
    constructor() {
        super("Dialog", [
            { no: 1, name: "peer", kind: "message", T: () => Peer },
            { no: 2, name: "space_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "archived", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "pinned", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "read_max_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "unread_count", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "chat_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "unread_mark", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "notification_settings", kind: "message", T: () => DialogNotificationSettings },
            { no: 10, name: "sidebar_visible", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "chat_list_hidden", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "open", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "opened_date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 14, name: "order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "pinned_order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "follow_mode", kind: "enum", opt: true, T: () => ["DialogFollowMode", DialogFollowMode] },
            { no: 17, name: "collapsed_max_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 18, name: "folder_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer */ 1:
                    message.peer = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peer);
                    break;
                case /* optional int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* optional bool archived */ 3:
                    message.archived = reader.bool();
                    break;
                case /* optional bool pinned */ 4:
                    message.pinned = reader.bool();
                    break;
                case /* optional int64 read_max_id */ 5:
                    message.readMaxId = reader.int64().toBigInt();
                    break;
                case /* optional int32 unread_count */ 6:
                    message.unreadCount = reader.int32();
                    break;
                case /* optional int64 chat_id */ 7:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional bool unread_mark */ 8:
                    message.unreadMark = reader.bool();
                    break;
                case /* optional DialogNotificationSettings notification_settings */ 9:
                    message.notificationSettings = DialogNotificationSettings.internalBinaryRead(reader, reader.uint32(), options, message.notificationSettings);
                    break;
                case /* optional bool sidebar_visible = 10 [deprecated = true];*/ 10:
                    message.sidebarVisible = reader.bool();
                    break;
                case /* optional bool chat_list_hidden */ 13:
                    message.chatListHidden = reader.bool();
                    break;
                case /* optional bool open */ 11:
                    message.open = reader.bool();
                    break;
                case /* optional int64 opened_date */ 12:
                    message.openedDate = reader.int64().toBigInt();
                    break;
                case /* optional string order */ 14:
                    message.order = reader.string();
                    break;
                case /* optional string pinned_order */ 15:
                    message.pinnedOrder = reader.string();
                    break;
                case /* optional DialogFollowMode follow_mode */ 16:
                    message.followMode = reader.int32();
                    break;
                case /* optional int64 collapsed_max_id */ 17:
                    message.collapsedMaxId = reader.int64().toBigInt();
                    break;
                case /* optional int64 folder_id */ 18:
                    message.folderId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer = 1; */
        if (message.peer)
            Peer.internalBinaryWrite(message.peer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 space_id = 2; */
        if (message.spaceId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        /* optional bool archived = 3; */
        if (message.archived !== undefined)
            writer.tag(3, WireType.Varint).bool(message.archived);
        /* optional bool pinned = 4; */
        if (message.pinned !== undefined)
            writer.tag(4, WireType.Varint).bool(message.pinned);
        /* optional int64 read_max_id = 5; */
        if (message.readMaxId !== undefined)
            writer.tag(5, WireType.Varint).int64(message.readMaxId);
        /* optional int32 unread_count = 6; */
        if (message.unreadCount !== undefined)
            writer.tag(6, WireType.Varint).int32(message.unreadCount);
        /* optional int64 chat_id = 7; */
        if (message.chatId !== undefined)
            writer.tag(7, WireType.Varint).int64(message.chatId);
        /* optional bool unread_mark = 8; */
        if (message.unreadMark !== undefined)
            writer.tag(8, WireType.Varint).bool(message.unreadMark);
        /* optional DialogNotificationSettings notification_settings = 9; */
        if (message.notificationSettings)
            DialogNotificationSettings.internalBinaryWrite(message.notificationSettings, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional bool sidebar_visible = 10 [deprecated = true]; */
        if (message.sidebarVisible !== undefined)
            writer.tag(10, WireType.Varint).bool(message.sidebarVisible);
        /* optional bool chat_list_hidden = 13; */
        if (message.chatListHidden !== undefined)
            writer.tag(13, WireType.Varint).bool(message.chatListHidden);
        /* optional bool open = 11; */
        if (message.open !== undefined)
            writer.tag(11, WireType.Varint).bool(message.open);
        /* optional int64 opened_date = 12; */
        if (message.openedDate !== undefined)
            writer.tag(12, WireType.Varint).int64(message.openedDate);
        /* optional string order = 14; */
        if (message.order !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.order);
        /* optional string pinned_order = 15; */
        if (message.pinnedOrder !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.pinnedOrder);
        /* optional DialogFollowMode follow_mode = 16; */
        if (message.followMode !== undefined)
            writer.tag(16, WireType.Varint).int32(message.followMode);
        /* optional int64 collapsed_max_id = 17; */
        if (message.collapsedMaxId !== undefined)
            writer.tag(17, WireType.Varint).int64(message.collapsedMaxId);
        /* optional int64 folder_id = 18; */
        if (message.folderId !== undefined)
            writer.tag(18, WireType.Varint).int64(message.folderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Dialog
 */
export const Dialog = new Dialog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DialogFolder$Type extends MessageType {
    constructor() {
        super("DialogFolder", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "order", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "pinned_order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.order = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* optional string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string order */ 3:
                    message.order = reader.string();
                    break;
                case /* optional string emoji */ 4:
                    message.emoji = reader.string();
                    break;
                case /* optional string pinned_order */ 5:
                    message.pinnedOrder = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* optional string title = 2; */
        if (message.title !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string order = 3; */
        if (message.order !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.order);
        /* optional string emoji = 4; */
        if (message.emoji !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.emoji);
        /* optional string pinned_order = 5; */
        if (message.pinnedOrder !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.pinnedOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DialogFolder
 */
export const DialogFolder = new DialogFolder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatPermissions$Type extends MessageType {
    constructor() {
        super("ChatPermissions", [
            { no: 1, name: "can_update_info", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.canUpdateInfo = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool can_update_info */ 1:
                    message.canUpdateInfo = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool can_update_info = 1; */
        if (message.canUpdateInfo !== false)
            writer.tag(1, WireType.Varint).bool(message.canUpdateInfo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChatPermissions
 */
export const ChatPermissions = new ChatPermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentThreadContext$Type extends MessageType {
    constructor() {
        super("AgentThreadContext", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "agent_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "configuration", kind: "message", T: () => AgentThreadConfiguration }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* optional int64 agent_id */ 2:
                    message.agentId = reader.int64().toBigInt();
                    break;
                case /* optional AgentThreadConfiguration configuration */ 3:
                    message.configuration = AgentThreadConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* optional int64 agent_id = 2; */
        if (message.agentId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.agentId);
        /* optional AgentThreadConfiguration configuration = 3; */
        if (message.configuration)
            AgentThreadConfiguration.internalBinaryWrite(message.configuration, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentThreadContext
 */
export const AgentThreadContext = new AgentThreadContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentThreadConfiguration$Type extends MessageType {
    constructor() {
        super("AgentThreadConfiguration", [
            { no: 1, name: "project_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reasoning_effort_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string project_id */ 1:
                    message.projectId = reader.string();
                    break;
                case /* optional string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                case /* optional string reasoning_effort_id */ 3:
                    message.reasoningEffortId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string project_id = 1; */
        if (message.projectId !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.projectId);
        /* optional string model_id = 2; */
        if (message.modelId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        /* optional string reasoning_effort_id = 3; */
        if (message.reasoningEffortId !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.reasoningEffortId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentThreadConfiguration
 */
export const AgentThreadConfiguration = new AgentThreadConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Chat$Type extends MessageType {
    constructor() {
        super("Chat", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "space_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_public", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "last_msg_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "peer_id", kind: "message", T: () => Peer },
            { no: 9, name: "date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "created_by", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "parent_chat_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "parent_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 13, name: "untitled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "number", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "permissions", kind: "message", T: () => ChatPermissions },
            { no: 16, name: "seq", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "acknowledgements", kind: "message", T: () => ChatAcknowledgements },
            { no: 18, name: "agent_context", kind: "message", T: () => AgentThreadContext }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.title = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* optional int64 space_id */ 3:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* optional string description */ 4:
                    message.description = reader.string();
                    break;
                case /* optional string emoji */ 5:
                    message.emoji = reader.string();
                    break;
                case /* optional bool is_public */ 6:
                    message.isPublic = reader.bool();
                    break;
                case /* optional int64 last_msg_id */ 7:
                    message.lastMsgId = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 8:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional int64 date */ 9:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional int64 created_by */ 10:
                    message.createdBy = reader.int64().toBigInt();
                    break;
                case /* optional int64 parent_chat_id */ 11:
                    message.parentChatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 parent_message_id */ 12:
                    message.parentMessageId = reader.int64().toBigInt();
                    break;
                case /* optional bool untitled */ 13:
                    message.untitled = reader.bool();
                    break;
                case /* optional int32 number */ 14:
                    message.number = reader.int32();
                    break;
                case /* optional ChatPermissions permissions */ 15:
                    message.permissions = ChatPermissions.internalBinaryRead(reader, reader.uint32(), options, message.permissions);
                    break;
                case /* optional int32 seq */ 16:
                    message.seq = reader.int32();
                    break;
                case /* optional ChatAcknowledgements acknowledgements */ 17:
                    message.acknowledgements = ChatAcknowledgements.internalBinaryRead(reader, reader.uint32(), options, message.acknowledgements);
                    break;
                case /* optional AgentThreadContext agent_context */ 18:
                    message.agentContext = AgentThreadContext.internalBinaryRead(reader, reader.uint32(), options, message.agentContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* optional int64 space_id = 3; */
        if (message.spaceId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.spaceId);
        /* optional string description = 4; */
        if (message.description !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* optional string emoji = 5; */
        if (message.emoji !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.emoji);
        /* optional bool is_public = 6; */
        if (message.isPublic !== undefined)
            writer.tag(6, WireType.Varint).bool(message.isPublic);
        /* optional int64 last_msg_id = 7; */
        if (message.lastMsgId !== undefined)
            writer.tag(7, WireType.Varint).int64(message.lastMsgId);
        /* Peer peer_id = 8; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 date = 9; */
        if (message.date !== undefined)
            writer.tag(9, WireType.Varint).int64(message.date);
        /* optional int64 created_by = 10; */
        if (message.createdBy !== undefined)
            writer.tag(10, WireType.Varint).int64(message.createdBy);
        /* optional int64 parent_chat_id = 11; */
        if (message.parentChatId !== undefined)
            writer.tag(11, WireType.Varint).int64(message.parentChatId);
        /* optional int64 parent_message_id = 12; */
        if (message.parentMessageId !== undefined)
            writer.tag(12, WireType.Varint).int64(message.parentMessageId);
        /* optional bool untitled = 13; */
        if (message.untitled !== undefined)
            writer.tag(13, WireType.Varint).bool(message.untitled);
        /* optional int32 number = 14; */
        if (message.number !== undefined)
            writer.tag(14, WireType.Varint).int32(message.number);
        /* optional ChatPermissions permissions = 15; */
        if (message.permissions)
            ChatPermissions.internalBinaryWrite(message.permissions, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 seq = 16; */
        if (message.seq !== undefined)
            writer.tag(16, WireType.Varint).int32(message.seq);
        /* optional ChatAcknowledgements acknowledgements = 17; */
        if (message.acknowledgements)
            ChatAcknowledgements.internalBinaryWrite(message.acknowledgements, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* optional AgentThreadContext agent_context = 18; */
        if (message.agentContext)
            AgentThreadContext.internalBinaryWrite(message.agentContext, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Chat
 */
export const Chat = new Chat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageReplies$Type extends MessageType {
    constructor() {
        super("MessageReplies", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "reply_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "has_unread", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "recent_replier_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.replyCount = 0;
        message.hasUnread = false;
        message.recentReplierUserIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int32 reply_count */ 2:
                    message.replyCount = reader.int32();
                    break;
                case /* bool has_unread */ 3:
                    message.hasUnread = reader.bool();
                    break;
                case /* repeated int64 recent_replier_user_ids */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.recentReplierUserIds.push(reader.int64().toBigInt());
                    else
                        message.recentReplierUserIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* int32 reply_count = 2; */
        if (message.replyCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.replyCount);
        /* bool has_unread = 3; */
        if (message.hasUnread !== false)
            writer.tag(3, WireType.Varint).bool(message.hasUnread);
        /* repeated int64 recent_replier_user_ids = 4; */
        if (message.recentReplierUserIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.recentReplierUserIds.length; i++)
                writer.int64(message.recentReplierUserIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageReplies
 */
export const MessageReplies = new MessageReplies$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageSubthread$Type extends MessageType {
    constructor() {
        super("MessageSubthread", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["MessageSubthread.Kind", MessageSubthread_Kind, "KIND_"] },
            { no: 3, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "has_unread", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "recent_author_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.kind = 0;
        message.messageCount = 0;
        message.hasUnread = false;
        message.recentAuthorUserIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* MessageSubthread.Kind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* optional string title */ 3:
                    message.title = reader.string();
                    break;
                case /* int32 message_count */ 4:
                    message.messageCount = reader.int32();
                    break;
                case /* bool has_unread */ 5:
                    message.hasUnread = reader.bool();
                    break;
                case /* repeated int64 recent_author_user_ids */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.recentAuthorUserIds.push(reader.int64().toBigInt());
                    else
                        message.recentAuthorUserIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* MessageSubthread.Kind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* optional string title = 3; */
        if (message.title !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* int32 message_count = 4; */
        if (message.messageCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.messageCount);
        /* bool has_unread = 5; */
        if (message.hasUnread !== false)
            writer.tag(5, WireType.Varint).bool(message.hasUnread);
        /* repeated int64 recent_author_user_ids = 6; */
        if (message.recentAuthorUserIds.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.recentAuthorUserIds.length; i++)
                writer.int64(message.recentAuthorUserIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageSubthread
 */
export const MessageSubthread = new MessageSubthread$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageActions$Type extends MessageType {
    constructor() {
        super("MessageActions", [
            { no: 1, name: "rows", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MessageActionRow }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.rows = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MessageActionRow rows */ 1:
                    message.rows.push(MessageActionRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MessageActionRow rows = 1; */
        for (let i = 0; i < message.rows.length; i++)
            MessageActionRow.internalBinaryWrite(message.rows[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageActions
 */
export const MessageActions = new MessageActions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageActionRow$Type extends MessageType {
    constructor() {
        super("MessageActionRow", [
            { no: 1, name: "actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MessageAction }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.actions = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MessageAction actions */ 1:
                    message.actions.push(MessageAction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MessageAction actions = 1; */
        for (let i = 0; i < message.actions.length; i++)
            MessageAction.internalBinaryWrite(message.actions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageActionRow
 */
export const MessageActionRow = new MessageActionRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageAction$Type extends MessageType {
    constructor() {
        super("MessageAction", [
            { no: 1, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "callback", kind: "message", oneof: "action", T: () => MessageActionCallback },
            { no: 4, name: "copy_text", kind: "message", oneof: "action", T: () => MessageActionCopyText }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.actionId = "";
        message.text = "";
        message.action = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string action_id */ 1:
                    message.actionId = reader.string();
                    break;
                case /* string text */ 2:
                    message.text = reader.string();
                    break;
                case /* MessageActionCallback callback */ 3:
                    message.action = {
                        oneofKind: "callback",
                        callback: MessageActionCallback.internalBinaryRead(reader, reader.uint32(), options, message.action.callback)
                    };
                    break;
                case /* MessageActionCopyText copy_text */ 4:
                    message.action = {
                        oneofKind: "copyText",
                        copyText: MessageActionCopyText.internalBinaryRead(reader, reader.uint32(), options, message.action.copyText)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string action_id = 1; */
        if (message.actionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actionId);
        /* string text = 2; */
        if (message.text !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.text);
        /* MessageActionCallback callback = 3; */
        if (message.action.oneofKind === "callback")
            MessageActionCallback.internalBinaryWrite(message.action.callback, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* MessageActionCopyText copy_text = 4; */
        if (message.action.oneofKind === "copyText")
            MessageActionCopyText.internalBinaryWrite(message.action.copyText, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageAction
 */
export const MessageAction = new MessageAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageActionCallback$Type extends MessageType {
    constructor() {
        super("MessageActionCallback", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageActionCallback
 */
export const MessageActionCallback = new MessageActionCallback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageActionCopyText$Type extends MessageType {
    constructor() {
        super("MessageActionCopyText", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageActionCopyText
 */
export const MessageActionCopyText = new MessageActionCopyText$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageActionResponseUi$Type extends MessageType {
    constructor() {
        super("MessageActionResponseUi", [
            { no: 1, name: "toast", kind: "message", oneof: "kind", T: () => MessageActionToast }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* MessageActionToast toast */ 1:
                    message.kind = {
                        oneofKind: "toast",
                        toast: MessageActionToast.internalBinaryRead(reader, reader.uint32(), options, message.kind.toast)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* MessageActionToast toast = 1; */
        if (message.kind.oneofKind === "toast")
            MessageActionToast.internalBinaryWrite(message.kind.toast, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageActionResponseUi
 */
export const MessageActionResponseUi = new MessageActionResponseUi$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageActionToast$Type extends MessageType {
    constructor() {
        super("MessageActionToast", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageActionToast
 */
export const MessageActionToast = new MessageActionToast$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageService$Type extends MessageType {
    constructor() {
        super("MessageService", [
            { no: 1, name: "thread_backlink", kind: "message", oneof: "event", T: () => MessageServiceThreadBacklink },
            { no: 2, name: "pinned_message", kind: "message", oneof: "event", T: () => MessageServicePinnedMessage }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.event = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* MessageServiceThreadBacklink thread_backlink */ 1:
                    message.event = {
                        oneofKind: "threadBacklink",
                        threadBacklink: MessageServiceThreadBacklink.internalBinaryRead(reader, reader.uint32(), options, message.event.threadBacklink)
                    };
                    break;
                case /* MessageServicePinnedMessage pinned_message */ 2:
                    message.event = {
                        oneofKind: "pinnedMessage",
                        pinnedMessage: MessageServicePinnedMessage.internalBinaryRead(reader, reader.uint32(), options, message.event.pinnedMessage)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* MessageServiceThreadBacklink thread_backlink = 1; */
        if (message.event.oneofKind === "threadBacklink")
            MessageServiceThreadBacklink.internalBinaryWrite(message.event.threadBacklink, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* MessageServicePinnedMessage pinned_message = 2; */
        if (message.event.oneofKind === "pinnedMessage")
            MessageServicePinnedMessage.internalBinaryWrite(message.event.pinnedMessage, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageService
 */
export const MessageService = new MessageService$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageServiceThreadBacklink$Type extends MessageType {
    constructor() {
        super("MessageServiceThreadBacklink", [
            { no: 1, name: "source_chat_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "source_title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 source_chat_id */ 1:
                    message.sourceChatId = reader.int64().toBigInt();
                    break;
                case /* optional string source_title */ 2:
                    message.sourceTitle = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 source_chat_id = 1; */
        if (message.sourceChatId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.sourceChatId);
        /* optional string source_title = 2; */
        if (message.sourceTitle !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.sourceTitle);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageServiceThreadBacklink
 */
export const MessageServiceThreadBacklink = new MessageServiceThreadBacklink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageServicePinnedMessage$Type extends MessageType {
    constructor() {
        super("MessageServicePinnedMessage", [
            { no: 1, name: "message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 message_id */ 1:
                    message.messageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 message_id = 1; */
        if (message.messageId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.messageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageServicePinnedMessage
 */
export const MessageServicePinnedMessage = new MessageServicePinnedMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockContent$Type extends MessageType {
    constructor() {
        super("BlockContent", [
            { no: 1, name: "blocks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Block }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.blocks = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Block blocks */ 1:
                    message.blocks.push(Block.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Block blocks = 1; */
        for (let i = 0; i < message.blocks.length; i++)
            Block.internalBinaryWrite(message.blocks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockContent
 */
export const BlockContent = new BlockContent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockText$Type extends MessageType {
    constructor() {
        super("BlockText", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "length", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "is_rtl", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.offset = 0n;
        message.length = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* int64 length */ 2:
                    message.length = reader.int64().toBigInt();
                    break;
                case /* optional bool is_rtl */ 3:
                    message.isRtl = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* int64 length = 2; */
        if (message.length !== 0n)
            writer.tag(2, WireType.Varint).int64(message.length);
        /* optional bool is_rtl = 3; */
        if (message.isRtl !== undefined)
            writer.tag(3, WireType.Varint).bool(message.isRtl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockText
 */
export const BlockText = new BlockText$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Block$Type extends MessageType {
    constructor() {
        super("Block", [
            { no: 1, name: "paragraph", kind: "message", oneof: "kind", T: () => BlockText },
            { no: 2, name: "heading", kind: "message", oneof: "kind", T: () => BlockHeading },
            { no: 3, name: "code", kind: "message", oneof: "kind", T: () => BlockCode },
            { no: 4, name: "list", kind: "message", oneof: "kind", T: () => BlockList },
            { no: 5, name: "separator", kind: "message", oneof: "kind", T: () => BlockSeparator },
            { no: 6, name: "image", kind: "message", oneof: "kind", T: () => BlockImage },
            { no: 7, name: "album", kind: "message", oneof: "kind", T: () => BlockAlbum },
            { no: 8, name: "disclosure", kind: "message", oneof: "kind", T: () => BlockDisclosure },
            { no: 9, name: "footer", kind: "message", oneof: "kind", T: () => BlockText },
            { no: 10, name: "quote", kind: "message", oneof: "kind", T: () => BlockQuote },
            { no: 11, name: "table", kind: "message", oneof: "kind", T: () => BlockTable },
            { no: 12, name: "math", kind: "message", oneof: "kind", T: () => BlockText }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BlockText paragraph */ 1:
                    message.kind = {
                        oneofKind: "paragraph",
                        paragraph: BlockText.internalBinaryRead(reader, reader.uint32(), options, message.kind.paragraph)
                    };
                    break;
                case /* BlockHeading heading */ 2:
                    message.kind = {
                        oneofKind: "heading",
                        heading: BlockHeading.internalBinaryRead(reader, reader.uint32(), options, message.kind.heading)
                    };
                    break;
                case /* BlockCode code */ 3:
                    message.kind = {
                        oneofKind: "code",
                        code: BlockCode.internalBinaryRead(reader, reader.uint32(), options, message.kind.code)
                    };
                    break;
                case /* BlockList list */ 4:
                    message.kind = {
                        oneofKind: "list",
                        list: BlockList.internalBinaryRead(reader, reader.uint32(), options, message.kind.list)
                    };
                    break;
                case /* BlockSeparator separator */ 5:
                    message.kind = {
                        oneofKind: "separator",
                        separator: BlockSeparator.internalBinaryRead(reader, reader.uint32(), options, message.kind.separator)
                    };
                    break;
                case /* BlockImage image */ 6:
                    message.kind = {
                        oneofKind: "image",
                        image: BlockImage.internalBinaryRead(reader, reader.uint32(), options, message.kind.image)
                    };
                    break;
                case /* BlockAlbum album */ 7:
                    message.kind = {
                        oneofKind: "album",
                        album: BlockAlbum.internalBinaryRead(reader, reader.uint32(), options, message.kind.album)
                    };
                    break;
                case /* BlockDisclosure disclosure */ 8:
                    message.kind = {
                        oneofKind: "disclosure",
                        disclosure: BlockDisclosure.internalBinaryRead(reader, reader.uint32(), options, message.kind.disclosure)
                    };
                    break;
                case /* BlockText footer */ 9:
                    message.kind = {
                        oneofKind: "footer",
                        footer: BlockText.internalBinaryRead(reader, reader.uint32(), options, message.kind.footer)
                    };
                    break;
                case /* BlockQuote quote */ 10:
                    message.kind = {
                        oneofKind: "quote",
                        quote: BlockQuote.internalBinaryRead(reader, reader.uint32(), options, message.kind.quote)
                    };
                    break;
                case /* BlockTable table */ 11:
                    message.kind = {
                        oneofKind: "table",
                        table: BlockTable.internalBinaryRead(reader, reader.uint32(), options, message.kind.table)
                    };
                    break;
                case /* BlockText math */ 12:
                    message.kind = {
                        oneofKind: "math",
                        math: BlockText.internalBinaryRead(reader, reader.uint32(), options, message.kind.math)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BlockText paragraph = 1; */
        if (message.kind.oneofKind === "paragraph")
            BlockText.internalBinaryWrite(message.kind.paragraph, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BlockHeading heading = 2; */
        if (message.kind.oneofKind === "heading")
            BlockHeading.internalBinaryWrite(message.kind.heading, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* BlockCode code = 3; */
        if (message.kind.oneofKind === "code")
            BlockCode.internalBinaryWrite(message.kind.code, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* BlockList list = 4; */
        if (message.kind.oneofKind === "list")
            BlockList.internalBinaryWrite(message.kind.list, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* BlockSeparator separator = 5; */
        if (message.kind.oneofKind === "separator")
            BlockSeparator.internalBinaryWrite(message.kind.separator, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* BlockImage image = 6; */
        if (message.kind.oneofKind === "image")
            BlockImage.internalBinaryWrite(message.kind.image, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* BlockAlbum album = 7; */
        if (message.kind.oneofKind === "album")
            BlockAlbum.internalBinaryWrite(message.kind.album, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* BlockDisclosure disclosure = 8; */
        if (message.kind.oneofKind === "disclosure")
            BlockDisclosure.internalBinaryWrite(message.kind.disclosure, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* BlockText footer = 9; */
        if (message.kind.oneofKind === "footer")
            BlockText.internalBinaryWrite(message.kind.footer, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* BlockQuote quote = 10; */
        if (message.kind.oneofKind === "quote")
            BlockQuote.internalBinaryWrite(message.kind.quote, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* BlockTable table = 11; */
        if (message.kind.oneofKind === "table")
            BlockTable.internalBinaryWrite(message.kind.table, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* BlockText math = 12; */
        if (message.kind.oneofKind === "math")
            BlockText.internalBinaryWrite(message.kind.math, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Block
 */
export const Block = new Block$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockHeading$Type extends MessageType {
    constructor() {
        super("BlockHeading", [
            { no: 1, name: "text", kind: "message", T: () => BlockText },
            { no: 2, name: "level", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.level = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BlockText text */ 1:
                    message.text = BlockText.internalBinaryRead(reader, reader.uint32(), options, message.text);
                    break;
                case /* uint32 level */ 2:
                    message.level = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BlockText text = 1; */
        if (message.text)
            BlockText.internalBinaryWrite(message.text, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 level = 2; */
        if (message.level !== 0)
            writer.tag(2, WireType.Varint).uint32(message.level);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockHeading
 */
export const BlockHeading = new BlockHeading$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockCode$Type extends MessageType {
    constructor() {
        super("BlockCode", [
            { no: 1, name: "text", kind: "message", T: () => BlockText },
            { no: 2, name: "language", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BlockText text */ 1:
                    message.text = BlockText.internalBinaryRead(reader, reader.uint32(), options, message.text);
                    break;
                case /* optional string language */ 2:
                    message.language = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BlockText text = 1; */
        if (message.text)
            BlockText.internalBinaryWrite(message.text, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string language = 2; */
        if (message.language !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.language);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockCode
 */
export const BlockCode = new BlockCode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockList$Type extends MessageType {
    constructor() {
        super("BlockList", [
            { no: 1, name: "kind", kind: "enum", T: () => ["BlockList.Kind", BlockList_Kind, "KIND_"] },
            { no: 2, name: "start", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BlockListItem },
            { no: 4, name: "is_rtl", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BlockList.Kind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* optional int64 start */ 2:
                    message.start = reader.int64().toBigInt();
                    break;
                case /* repeated BlockListItem items */ 3:
                    message.items.push(BlockListItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool is_rtl */ 4:
                    message.isRtl = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BlockList.Kind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* optional int64 start = 2; */
        if (message.start !== undefined)
            writer.tag(2, WireType.Varint).int64(message.start);
        /* repeated BlockListItem items = 3; */
        for (let i = 0; i < message.items.length; i++)
            BlockListItem.internalBinaryWrite(message.items[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional bool is_rtl = 4; */
        if (message.isRtl !== undefined)
            writer.tag(4, WireType.Varint).bool(message.isRtl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockList
 */
export const BlockList = new BlockList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockListItem$Type extends MessageType {
    constructor() {
        super("BlockListItem", [
            { no: 1, name: "children", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Block },
            { no: 2, name: "checked", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.children = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Block children */ 1:
                    message.children.push(Block.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool checked */ 2:
                    message.checked = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Block children = 1; */
        for (let i = 0; i < message.children.length; i++)
            Block.internalBinaryWrite(message.children[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional bool checked = 2; */
        if (message.checked !== undefined)
            writer.tag(2, WireType.Varint).bool(message.checked);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockListItem
 */
export const BlockListItem = new BlockListItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockSeparator$Type extends MessageType {
    constructor() {
        super("BlockSeparator", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockSeparator
 */
export const BlockSeparator = new BlockSeparator$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockImageDimensions$Type extends MessageType {
    constructor() {
        super("BlockImageDimensions", [
            { no: 1, name: "width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "height", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.width = 0;
        message.height = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 width */ 1:
                    message.width = reader.uint32();
                    break;
                case /* uint32 height */ 2:
                    message.height = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint32 width = 1; */
        if (message.width !== 0)
            writer.tag(1, WireType.Varint).uint32(message.width);
        /* uint32 height = 2; */
        if (message.height !== 0)
            writer.tag(2, WireType.Varint).uint32(message.height);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockImageDimensions
 */
export const BlockImageDimensions = new BlockImageDimensions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockImagePending$Type extends MessageType {
    constructor() {
        super("BlockImagePending", [
            { no: 1, name: "dimensions", kind: "message", T: () => BlockImageDimensions },
            { no: 2, name: "stripped_thumbnail", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional BlockImageDimensions dimensions */ 1:
                    message.dimensions = BlockImageDimensions.internalBinaryRead(reader, reader.uint32(), options, message.dimensions);
                    break;
                case /* optional bytes stripped_thumbnail */ 2:
                    message.strippedThumbnail = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional BlockImageDimensions dimensions = 1; */
        if (message.dimensions)
            BlockImageDimensions.internalBinaryWrite(message.dimensions, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional bytes stripped_thumbnail = 2; */
        if (message.strippedThumbnail !== undefined)
            writer.tag(2, WireType.LengthDelimited).bytes(message.strippedThumbnail);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockImagePending
 */
export const BlockImagePending = new BlockImagePending$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockImageUnavailable$Type extends MessageType {
    constructor() {
        super("BlockImageUnavailable", [
            { no: 1, name: "dimensions", kind: "message", T: () => BlockImageDimensions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional BlockImageDimensions dimensions */ 1:
                    message.dimensions = BlockImageDimensions.internalBinaryRead(reader, reader.uint32(), options, message.dimensions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional BlockImageDimensions dimensions = 1; */
        if (message.dimensions)
            BlockImageDimensions.internalBinaryWrite(message.dimensions, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockImageUnavailable
 */
export const BlockImageUnavailable = new BlockImageUnavailable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockImage$Type extends MessageType {
    constructor() {
        super("BlockImage", [
            { no: 1, name: "alt", kind: "message", T: () => BlockText },
            { no: 2, name: "pending", kind: "message", oneof: "state", T: () => BlockImagePending },
            { no: 3, name: "ready", kind: "message", oneof: "state", T: () => Photo },
            { no: 4, name: "unavailable", kind: "message", oneof: "state", T: () => BlockImageUnavailable }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BlockText alt */ 1:
                    message.alt = BlockText.internalBinaryRead(reader, reader.uint32(), options, message.alt);
                    break;
                case /* BlockImagePending pending */ 2:
                    message.state = {
                        oneofKind: "pending",
                        pending: BlockImagePending.internalBinaryRead(reader, reader.uint32(), options, message.state.pending)
                    };
                    break;
                case /* Photo ready */ 3:
                    message.state = {
                        oneofKind: "ready",
                        ready: Photo.internalBinaryRead(reader, reader.uint32(), options, message.state.ready)
                    };
                    break;
                case /* BlockImageUnavailable unavailable */ 4:
                    message.state = {
                        oneofKind: "unavailable",
                        unavailable: BlockImageUnavailable.internalBinaryRead(reader, reader.uint32(), options, message.state.unavailable)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BlockText alt = 1; */
        if (message.alt)
            BlockText.internalBinaryWrite(message.alt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BlockImagePending pending = 2; */
        if (message.state.oneofKind === "pending")
            BlockImagePending.internalBinaryWrite(message.state.pending, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Photo ready = 3; */
        if (message.state.oneofKind === "ready")
            Photo.internalBinaryWrite(message.state.ready, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* BlockImageUnavailable unavailable = 4; */
        if (message.state.oneofKind === "unavailable")
            BlockImageUnavailable.internalBinaryWrite(message.state.unavailable, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockImage
 */
export const BlockImage = new BlockImage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockAlbum$Type extends MessageType {
    constructor() {
        super("BlockAlbum", [
            { no: 1, name: "images", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BlockImage }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.images = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BlockImage images */ 1:
                    message.images.push(BlockImage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BlockImage images = 1; */
        for (let i = 0; i < message.images.length; i++)
            BlockImage.internalBinaryWrite(message.images[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockAlbum
 */
export const BlockAlbum = new BlockAlbum$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockDisclosure$Type extends MessageType {
    constructor() {
        super("BlockDisclosure", [
            { no: 1, name: "summary", kind: "message", T: () => BlockText },
            { no: 2, name: "kind", kind: "enum", T: () => ["BlockDisclosure.Kind", BlockDisclosure_Kind, "KIND_"] },
            { no: 3, name: "initially_open", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "children", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Block },
            { no: 5, name: "is_rtl", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "activity_kind", kind: "enum", T: () => ["BlockDisclosure.ActivityKind", BlockDisclosure_ActivityKind, "ACTIVITY_KIND_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        message.children = [];
        message.activityKind = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BlockText summary */ 1:
                    message.summary = BlockText.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                case /* BlockDisclosure.Kind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* optional bool initially_open */ 3:
                    message.initiallyOpen = reader.bool();
                    break;
                case /* repeated Block children */ 4:
                    message.children.push(Block.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool is_rtl */ 5:
                    message.isRtl = reader.bool();
                    break;
                case /* BlockDisclosure.ActivityKind activity_kind */ 6:
                    message.activityKind = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BlockText summary = 1; */
        if (message.summary)
            BlockText.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BlockDisclosure.Kind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* optional bool initially_open = 3; */
        if (message.initiallyOpen !== undefined)
            writer.tag(3, WireType.Varint).bool(message.initiallyOpen);
        /* repeated Block children = 4; */
        for (let i = 0; i < message.children.length; i++)
            Block.internalBinaryWrite(message.children[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional bool is_rtl = 5; */
        if (message.isRtl !== undefined)
            writer.tag(5, WireType.Varint).bool(message.isRtl);
        /* BlockDisclosure.ActivityKind activity_kind = 6; */
        if (message.activityKind !== 0)
            writer.tag(6, WireType.Varint).int32(message.activityKind);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockDisclosure
 */
export const BlockDisclosure = new BlockDisclosure$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockQuote$Type extends MessageType {
    constructor() {
        super("BlockQuote", [
            { no: 1, name: "children", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Block },
            { no: 2, name: "is_rtl", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.children = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Block children */ 1:
                    message.children.push(Block.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool is_rtl */ 2:
                    message.isRtl = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Block children = 1; */
        for (let i = 0; i < message.children.length; i++)
            Block.internalBinaryWrite(message.children[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional bool is_rtl = 2; */
        if (message.isRtl !== undefined)
            writer.tag(2, WireType.Varint).bool(message.isRtl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockQuote
 */
export const BlockQuote = new BlockQuote$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockTable$Type extends MessageType {
    constructor() {
        super("BlockTable", [
            { no: 1, name: "rows", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BlockTableRow },
            { no: 2, name: "alignments", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["BlockTable.Alignment", BlockTable_Alignment, "ALIGNMENT_"] },
            { no: 3, name: "is_rtl", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.rows = [];
        message.alignments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BlockTableRow rows */ 1:
                    message.rows.push(BlockTableRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated BlockTable.Alignment alignments */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.alignments.push(reader.int32());
                    else
                        message.alignments.push(reader.int32());
                    break;
                case /* optional bool is_rtl */ 3:
                    message.isRtl = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BlockTableRow rows = 1; */
        for (let i = 0; i < message.rows.length; i++)
            BlockTableRow.internalBinaryWrite(message.rows[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated BlockTable.Alignment alignments = 2; */
        if (message.alignments.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.alignments.length; i++)
                writer.int32(message.alignments[i]);
            writer.join();
        }
        /* optional bool is_rtl = 3; */
        if (message.isRtl !== undefined)
            writer.tag(3, WireType.Varint).bool(message.isRtl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockTable
 */
export const BlockTable = new BlockTable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockTableRow$Type extends MessageType {
    constructor() {
        super("BlockTableRow", [
            { no: 1, name: "cells", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BlockText }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.cells = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BlockText cells */ 1:
                    message.cells.push(BlockText.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BlockText cells = 1; */
        for (let i = 0; i < message.cells.length; i++)
            BlockText.internalBinaryWrite(message.cells[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BlockTableRow
 */
export const BlockTableRow = new BlockTableRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType {
    constructor() {
        super("Message", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "from_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "peer_id", kind: "message", T: () => Peer },
            { no: 4, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "out", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "mentioned", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "reply_to_msg_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "media", kind: "message", T: () => MessageMedia },
            { no: 11, name: "edit_date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "grouped_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 13, name: "attachments", kind: "message", T: () => MessageAttachments },
            { no: 14, name: "reactions", kind: "message", T: () => MessageReactions },
            { no: 15, name: "is_sticker", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6000, name: "has_link", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "entities", kind: "message", T: () => MessageEntities },
            { no: 17, name: "send_mode", kind: "enum", opt: true, T: () => ["MessageSendMode", MessageSendMode] },
            { no: 18, name: "fwd_from", kind: "message", T: () => MessageFwdHeader },
            { no: 19, name: "replies", kind: "message", T: () => MessageReplies },
            { no: 20, name: "actions", kind: "message", T: () => MessageActions },
            { no: 21, name: "rev", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 22, name: "service_message", kind: "message", T: () => MessageService },
            { no: 23, name: "block_content", kind: "message", T: () => BlockContent },
            { no: 24, name: "agent_session", kind: "message", T: () => AgentSessionMessageInfo },
            { no: 25, name: "subthread", kind: "message", T: () => MessageSubthread }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.fromId = 0n;
        message.chatId = 0n;
        message.out = false;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 from_id */ 2:
                    message.fromId = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 3:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 chat_id */ 4:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional string message */ 5:
                    message.message = reader.string();
                    break;
                case /* bool out */ 6:
                    message.out = reader.bool();
                    break;
                case /* int64 date */ 7:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional bool mentioned */ 8:
                    message.mentioned = reader.bool();
                    break;
                case /* optional int64 reply_to_msg_id */ 9:
                    message.replyToMsgId = reader.int64().toBigInt();
                    break;
                case /* optional MessageMedia media */ 10:
                    message.media = MessageMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* optional int64 edit_date */ 11:
                    message.editDate = reader.int64().toBigInt();
                    break;
                case /* optional int64 grouped_id */ 12:
                    message.groupedId = reader.int64().toBigInt();
                    break;
                case /* optional MessageAttachments attachments */ 13:
                    message.attachments = MessageAttachments.internalBinaryRead(reader, reader.uint32(), options, message.attachments);
                    break;
                case /* optional MessageReactions reactions */ 14:
                    message.reactions = MessageReactions.internalBinaryRead(reader, reader.uint32(), options, message.reactions);
                    break;
                case /* optional bool is_sticker */ 15:
                    message.isSticker = reader.bool();
                    break;
                case /* optional bool has_link */ 6000:
                    message.hasLink = reader.bool();
                    break;
                case /* optional MessageEntities entities */ 16:
                    message.entities = MessageEntities.internalBinaryRead(reader, reader.uint32(), options, message.entities);
                    break;
                case /* optional MessageSendMode send_mode */ 17:
                    message.sendMode = reader.int32();
                    break;
                case /* optional MessageFwdHeader fwd_from */ 18:
                    message.fwdFrom = MessageFwdHeader.internalBinaryRead(reader, reader.uint32(), options, message.fwdFrom);
                    break;
                case /* optional MessageReplies replies */ 19:
                    message.replies = MessageReplies.internalBinaryRead(reader, reader.uint32(), options, message.replies);
                    break;
                case /* optional MessageActions actions */ 20:
                    message.actions = MessageActions.internalBinaryRead(reader, reader.uint32(), options, message.actions);
                    break;
                case /* optional int64 rev */ 21:
                    message.rev = reader.int64().toBigInt();
                    break;
                case /* optional MessageService service_message */ 22:
                    message.serviceMessage = MessageService.internalBinaryRead(reader, reader.uint32(), options, message.serviceMessage);
                    break;
                case /* optional BlockContent block_content */ 23:
                    message.blockContent = BlockContent.internalBinaryRead(reader, reader.uint32(), options, message.blockContent);
                    break;
                case /* optional AgentSessionMessageInfo agent_session */ 24:
                    message.agentSession = AgentSessionMessageInfo.internalBinaryRead(reader, reader.uint32(), options, message.agentSession);
                    break;
                case /* optional MessageSubthread subthread */ 25:
                    message.subthread = MessageSubthread.internalBinaryRead(reader, reader.uint32(), options, message.subthread);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 from_id = 2; */
        if (message.fromId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.fromId);
        /* Peer peer_id = 3; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 chat_id = 4; */
        if (message.chatId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.chatId);
        /* optional string message = 5; */
        if (message.message !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.message);
        /* bool out = 6; */
        if (message.out !== false)
            writer.tag(6, WireType.Varint).bool(message.out);
        /* int64 date = 7; */
        if (message.date !== 0n)
            writer.tag(7, WireType.Varint).int64(message.date);
        /* optional bool mentioned = 8; */
        if (message.mentioned !== undefined)
            writer.tag(8, WireType.Varint).bool(message.mentioned);
        /* optional int64 reply_to_msg_id = 9; */
        if (message.replyToMsgId !== undefined)
            writer.tag(9, WireType.Varint).int64(message.replyToMsgId);
        /* optional MessageMedia media = 10; */
        if (message.media)
            MessageMedia.internalBinaryWrite(message.media, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 edit_date = 11; */
        if (message.editDate !== undefined)
            writer.tag(11, WireType.Varint).int64(message.editDate);
        /* optional int64 grouped_id = 12; */
        if (message.groupedId !== undefined)
            writer.tag(12, WireType.Varint).int64(message.groupedId);
        /* optional MessageAttachments attachments = 13; */
        if (message.attachments)
            MessageAttachments.internalBinaryWrite(message.attachments, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional MessageReactions reactions = 14; */
        if (message.reactions)
            MessageReactions.internalBinaryWrite(message.reactions, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* optional bool is_sticker = 15; */
        if (message.isSticker !== undefined)
            writer.tag(15, WireType.Varint).bool(message.isSticker);
        /* optional bool has_link = 6000; */
        if (message.hasLink !== undefined)
            writer.tag(6000, WireType.Varint).bool(message.hasLink);
        /* optional MessageEntities entities = 16; */
        if (message.entities)
            MessageEntities.internalBinaryWrite(message.entities, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* optional MessageSendMode send_mode = 17; */
        if (message.sendMode !== undefined)
            writer.tag(17, WireType.Varint).int32(message.sendMode);
        /* optional MessageFwdHeader fwd_from = 18; */
        if (message.fwdFrom)
            MessageFwdHeader.internalBinaryWrite(message.fwdFrom, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* optional MessageReplies replies = 19; */
        if (message.replies)
            MessageReplies.internalBinaryWrite(message.replies, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* optional MessageActions actions = 20; */
        if (message.actions)
            MessageActions.internalBinaryWrite(message.actions, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 rev = 21; */
        if (message.rev !== undefined)
            writer.tag(21, WireType.Varint).int64(message.rev);
        /* optional MessageService service_message = 22; */
        if (message.serviceMessage)
            MessageService.internalBinaryWrite(message.serviceMessage, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* optional BlockContent block_content = 23; */
        if (message.blockContent)
            BlockContent.internalBinaryWrite(message.blockContent, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* optional AgentSessionMessageInfo agent_session = 24; */
        if (message.agentSession)
            AgentSessionMessageInfo.internalBinaryWrite(message.agentSession, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* optional MessageSubthread subthread = 25; */
        if (message.subthread)
            MessageSubthread.internalBinaryWrite(message.subthread, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSessionMessageInfo$Type extends MessageType {
    constructor() {
        super("AgentSessionMessageInfo", [
            { no: 1, name: "agent_session_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "provider", kind: "enum", T: () => ["AgentSessionProvider", AgentSessionProvider, "AGENT_SESSION_PROVIDER_"] },
            { no: 3, name: "role", kind: "enum", T: () => ["AgentSessionMessageRole", AgentSessionMessageRole, "AGENT_SESSION_MESSAGE_ROLE_"] },
            { no: 4, name: "relation", kind: "enum", T: () => ["AgentSessionMessageRelation", AgentSessionMessageRelation, "AGENT_SESSION_MESSAGE_RELATION_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agentSessionId = 0n;
        message.provider = 0;
        message.role = 0;
        message.relation = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 agent_session_id */ 1:
                    message.agentSessionId = reader.int64().toBigInt();
                    break;
                case /* AgentSessionProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                case /* AgentSessionMessageRole role */ 3:
                    message.role = reader.int32();
                    break;
                case /* AgentSessionMessageRelation relation */ 4:
                    message.relation = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 agent_session_id = 1; */
        if (message.agentSessionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.agentSessionId);
        /* AgentSessionProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        /* AgentSessionMessageRole role = 3; */
        if (message.role !== 0)
            writer.tag(3, WireType.Varint).int32(message.role);
        /* AgentSessionMessageRelation relation = 4; */
        if (message.relation !== 0)
            writer.tag(4, WireType.Varint).int32(message.relation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSessionMessageInfo
 */
export const AgentSessionMessageInfo = new AgentSessionMessageInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageFwdHeader$Type extends MessageType {
    constructor() {
        super("MessageFwdHeader", [
            { no: 1, name: "from_peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "from_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "from_message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fromId = 0n;
        message.fromMessageId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer from_peer_id */ 1:
                    message.fromPeerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.fromPeerId);
                    break;
                case /* int64 from_id */ 2:
                    message.fromId = reader.int64().toBigInt();
                    break;
                case /* int64 from_message_id */ 3:
                    message.fromMessageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer from_peer_id = 1; */
        if (message.fromPeerId)
            Peer.internalBinaryWrite(message.fromPeerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 from_id = 2; */
        if (message.fromId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.fromId);
        /* int64 from_message_id = 3; */
        if (message.fromMessageId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.fromMessageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageFwdHeader
 */
export const MessageFwdHeader = new MessageFwdHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntities$Type extends MessageType {
    constructor() {
        super("MessageEntities", [
            { no: 1, name: "entities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MessageEntity }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.entities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MessageEntity entities */ 1:
                    message.entities.push(MessageEntity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MessageEntity entities = 1; */
        for (let i = 0; i < message.entities.length; i++)
            MessageEntity.internalBinaryWrite(message.entities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntities
 */
export const MessageEntities = new MessageEntities$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity$Type extends MessageType {
    constructor() {
        super("MessageEntity", [
            { no: 1, name: "type", kind: "enum", T: () => ["MessageEntity.Type", MessageEntity_Type, "TYPE_"] },
            { no: 2, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "length", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "mention", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityMention },
            { no: 5, name: "text_url", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityTextUrl },
            { no: 6, name: "pre", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityPre },
            { no: 7, name: "thread", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityThread },
            { no: 8, name: "thread_title", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityThreadTitle },
            { no: 9, name: "group_mention", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityGroupMention },
            { no: 10, name: "bot_command", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityBotCommand },
            { no: 11, name: "math", kind: "message", oneof: "entity", T: () => MessageEntity_MessageEntityMath }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = 0;
        message.offset = 0n;
        message.length = 0n;
        message.entity = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* MessageEntity.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* int64 offset */ 2:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* int64 length */ 3:
                    message.length = reader.int64().toBigInt();
                    break;
                case /* MessageEntity.MessageEntityMention mention */ 4:
                    message.entity = {
                        oneofKind: "mention",
                        mention: MessageEntity_MessageEntityMention.internalBinaryRead(reader, reader.uint32(), options, message.entity.mention)
                    };
                    break;
                case /* MessageEntity.MessageEntityTextUrl text_url */ 5:
                    message.entity = {
                        oneofKind: "textUrl",
                        textUrl: MessageEntity_MessageEntityTextUrl.internalBinaryRead(reader, reader.uint32(), options, message.entity.textUrl)
                    };
                    break;
                case /* MessageEntity.MessageEntityPre pre */ 6:
                    message.entity = {
                        oneofKind: "pre",
                        pre: MessageEntity_MessageEntityPre.internalBinaryRead(reader, reader.uint32(), options, message.entity.pre)
                    };
                    break;
                case /* MessageEntity.MessageEntityThread thread */ 7:
                    message.entity = {
                        oneofKind: "thread",
                        thread: MessageEntity_MessageEntityThread.internalBinaryRead(reader, reader.uint32(), options, message.entity.thread)
                    };
                    break;
                case /* MessageEntity.MessageEntityThreadTitle thread_title */ 8:
                    message.entity = {
                        oneofKind: "threadTitle",
                        threadTitle: MessageEntity_MessageEntityThreadTitle.internalBinaryRead(reader, reader.uint32(), options, message.entity.threadTitle)
                    };
                    break;
                case /* MessageEntity.MessageEntityGroupMention group_mention */ 9:
                    message.entity = {
                        oneofKind: "groupMention",
                        groupMention: MessageEntity_MessageEntityGroupMention.internalBinaryRead(reader, reader.uint32(), options, message.entity.groupMention)
                    };
                    break;
                case /* MessageEntity.MessageEntityBotCommand bot_command */ 10:
                    message.entity = {
                        oneofKind: "botCommand",
                        botCommand: MessageEntity_MessageEntityBotCommand.internalBinaryRead(reader, reader.uint32(), options, message.entity.botCommand)
                    };
                    break;
                case /* MessageEntity.MessageEntityMath math */ 11:
                    message.entity = {
                        oneofKind: "math",
                        math: MessageEntity_MessageEntityMath.internalBinaryRead(reader, reader.uint32(), options, message.entity.math)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* MessageEntity.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* int64 offset = 2; */
        if (message.offset !== 0n)
            writer.tag(2, WireType.Varint).int64(message.offset);
        /* int64 length = 3; */
        if (message.length !== 0n)
            writer.tag(3, WireType.Varint).int64(message.length);
        /* MessageEntity.MessageEntityMention mention = 4; */
        if (message.entity.oneofKind === "mention")
            MessageEntity_MessageEntityMention.internalBinaryWrite(message.entity.mention, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityTextUrl text_url = 5; */
        if (message.entity.oneofKind === "textUrl")
            MessageEntity_MessageEntityTextUrl.internalBinaryWrite(message.entity.textUrl, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityPre pre = 6; */
        if (message.entity.oneofKind === "pre")
            MessageEntity_MessageEntityPre.internalBinaryWrite(message.entity.pre, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityThread thread = 7; */
        if (message.entity.oneofKind === "thread")
            MessageEntity_MessageEntityThread.internalBinaryWrite(message.entity.thread, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityThreadTitle thread_title = 8; */
        if (message.entity.oneofKind === "threadTitle")
            MessageEntity_MessageEntityThreadTitle.internalBinaryWrite(message.entity.threadTitle, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityGroupMention group_mention = 9; */
        if (message.entity.oneofKind === "groupMention")
            MessageEntity_MessageEntityGroupMention.internalBinaryWrite(message.entity.groupMention, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityBotCommand bot_command = 10; */
        if (message.entity.oneofKind === "botCommand")
            MessageEntity_MessageEntityBotCommand.internalBinaryWrite(message.entity.botCommand, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* MessageEntity.MessageEntityMath math = 11; */
        if (message.entity.oneofKind === "math")
            MessageEntity_MessageEntityMath.internalBinaryWrite(message.entity.math, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity
 */
export const MessageEntity = new MessageEntity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityMention$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityMention", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "agent_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* optional int64 agent_id */ 2:
                    message.agentId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        /* optional int64 agent_id = 2; */
        if (message.agentId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.agentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityMention
 */
export const MessageEntity_MessageEntityMention = new MessageEntity_MessageEntityMention$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityGroupMention$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityGroupMention", [
            { no: 1, name: "group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groupId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 group_id */ 1:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 group_id = 1; */
        if (message.groupId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityGroupMention
 */
export const MessageEntity_MessageEntityGroupMention = new MessageEntity_MessageEntityGroupMention$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityTextUrl$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityTextUrl", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityTextUrl
 */
export const MessageEntity_MessageEntityTextUrl = new MessageEntity_MessageEntityTextUrl$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityPre$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityPre", [
            { no: 1, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.language = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string language */ 1:
                    message.language = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string language = 1; */
        if (message.language !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.language);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityPre
 */
export const MessageEntity_MessageEntityPre = new MessageEntity_MessageEntityPre$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityThread$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityThread", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityThread
 */
export const MessageEntity_MessageEntityThread = new MessageEntity_MessageEntityThread$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityThreadTitle$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityThreadTitle", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.title = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityThreadTitle
 */
export const MessageEntity_MessageEntityThreadTitle = new MessageEntity_MessageEntityThreadTitle$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityBotCommand$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityBotCommand", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityBotCommand
 */
export const MessageEntity_MessageEntityBotCommand = new MessageEntity_MessageEntityBotCommand$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageEntity_MessageEntityMath$Type extends MessageType {
    constructor() {
        super("MessageEntity.MessageEntityMath", [
            { no: 1, name: "display", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.display = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool display */ 1:
                    message.display = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool display = 1; */
        if (message.display !== false)
            writer.tag(1, WireType.Varint).bool(message.display);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageEntity.MessageEntityMath
 */
export const MessageEntity_MessageEntityMath = new MessageEntity_MessageEntityMath$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageReactions$Type extends MessageType {
    constructor() {
        super("MessageReactions", [
            { no: 1, name: "reactions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Reaction }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reactions = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Reaction reactions */ 1:
                    message.reactions.push(Reaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Reaction reactions = 1; */
        for (let i = 0; i < message.reactions.length; i++)
            Reaction.internalBinaryWrite(message.reactions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageReactions
 */
export const MessageReactions = new MessageReactions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Reaction$Type extends MessageType {
    constructor() {
        super("Reaction", [
            { no: 1, name: "emoji", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.emoji = "";
        message.userId = 0n;
        message.messageId = 0n;
        message.chatId = 0n;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string emoji */ 1:
                    message.emoji = reader.string();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* int64 message_id */ 3:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* int64 chat_id */ 4:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 5:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string emoji = 1; */
        if (message.emoji !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.emoji);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* int64 message_id = 3; */
        if (message.messageId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.messageId);
        /* int64 chat_id = 4; */
        if (message.chatId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.chatId);
        /* int64 date = 5; */
        if (message.date !== 0n)
            writer.tag(5, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Reaction
 */
export const Reaction = new Reaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Member$Type extends MessageType {
    constructor() {
        super("Member", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "role", kind: "enum", opt: true, T: () => ["Member.Role", Member_Role] },
            { no: 5, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "can_access_public_chats", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.spaceId = 0n;
        message.userId = 0n;
        message.date = 0n;
        message.canAccessPublicChats = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 3:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* optional Member.Role role */ 4:
                    message.role = reader.int32();
                    break;
                case /* int64 date */ 5:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* bool can_access_public_chats */ 6:
                    message.canAccessPublicChats = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 space_id = 2; */
        if (message.spaceId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        /* int64 user_id = 3; */
        if (message.userId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.userId);
        /* optional Member.Role role = 4; */
        if (message.role !== undefined)
            writer.tag(4, WireType.Varint).int32(message.role);
        /* int64 date = 5; */
        if (message.date !== 0n)
            writer.tag(5, WireType.Varint).int64(message.date);
        /* bool can_access_public_chats = 6; */
        if (message.canAccessPublicChats !== false)
            writer.tag(6, WireType.Varint).bool(message.canAccessPublicChats);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Member
 */
export const Member = new Member$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Space$Type extends MessageType {
    constructor() {
        super("Space", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "creator", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "is_public", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "handle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "seq", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.name = "";
        message.creator = false;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool creator */ 3:
                    message.creator = reader.bool();
                    break;
                case /* int64 date */ 4:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional bool is_public */ 5:
                    message.isPublic = reader.bool();
                    break;
                case /* optional string handle */ 6:
                    message.handle = reader.string();
                    break;
                case /* optional int32 seq */ 7:
                    message.seq = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool creator = 3; */
        if (message.creator !== false)
            writer.tag(3, WireType.Varint).bool(message.creator);
        /* int64 date = 4; */
        if (message.date !== 0n)
            writer.tag(4, WireType.Varint).int64(message.date);
        /* optional bool is_public = 5; */
        if (message.isPublic !== undefined)
            writer.tag(5, WireType.Varint).bool(message.isPublic);
        /* optional string handle = 6; */
        if (message.handle !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.handle);
        /* optional int32 seq = 7; */
        if (message.seq !== undefined)
            writer.tag(7, WireType.Varint).int32(message.seq);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Space
 */
export const Space = new Space$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceInput$Type extends MessageType {
    constructor() {
        super("GetSpaceInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceInput
 */
export const GetSpaceInput = new GetSpaceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceResult$Type extends MessageType {
    constructor() {
        super("GetSpaceResult", [
            { no: 1, name: "space", kind: "message", T: () => Space },
            { no: 2, name: "membership", kind: "message", T: () => Member },
            { no: 3, name: "settings", kind: "message", T: () => SpaceSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Space space */ 1:
                    message.space = Space.internalBinaryRead(reader, reader.uint32(), options, message.space);
                    break;
                case /* Member membership */ 2:
                    message.membership = Member.internalBinaryRead(reader, reader.uint32(), options, message.membership);
                    break;
                case /* SpaceSettings settings */ 3:
                    message.settings = SpaceSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Space space = 1; */
        if (message.space)
            Space.internalBinaryWrite(message.space, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Member membership = 2; */
        if (message.membership)
            Member.internalBinaryWrite(message.membership, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* SpaceSettings settings = 3; */
        if (message.settings)
            SpaceSettings.internalBinaryWrite(message.settings, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceResult
 */
export const GetSpaceResult = new GetSpaceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSession$Type extends MessageType {
    constructor() {
        super("AgentSession", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => Peer },
            { no: 3, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "provider", kind: "enum", T: () => ["AgentSessionProvider", AgentSessionProvider, "AGENT_SESSION_PROVIDER_"] },
            { no: 5, name: "status_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "parent_chat_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.botUserId = 0n;
        message.provider = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 2:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 bot_user_id */ 3:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* AgentSessionProvider provider */ 4:
                    message.provider = reader.int32();
                    break;
                case /* optional int64 status_message_id */ 5:
                    message.statusMessageId = reader.int64().toBigInt();
                    break;
                case /* optional int64 parent_chat_id */ 6:
                    message.parentChatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* Peer peer_id = 2; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int64 bot_user_id = 3; */
        if (message.botUserId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.botUserId);
        /* AgentSessionProvider provider = 4; */
        if (message.provider !== 0)
            writer.tag(4, WireType.Varint).int32(message.provider);
        /* optional int64 status_message_id = 5; */
        if (message.statusMessageId !== undefined)
            writer.tag(5, WireType.Varint).int64(message.statusMessageId);
        /* optional int64 parent_chat_id = 6; */
        if (message.parentChatId !== undefined)
            writer.tag(6, WireType.Varint).int64(message.parentChatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSession
 */
export const AgentSession = new AgentSession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectAgentSessionInput$Type extends MessageType {
    constructor() {
        super("ConnectAgentSessionInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "provider", kind: "enum", T: () => ["AgentSessionProvider", AgentSessionProvider, "AGENT_SESSION_PROVIDER_"] },
            { no: 4, name: "instance_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "session_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "project_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.provider = 0;
        message.instanceRef = "";
        message.sessionRef = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 bot_user_id */ 2:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* AgentSessionProvider provider */ 3:
                    message.provider = reader.int32();
                    break;
                case /* string instance_ref */ 4:
                    message.instanceRef = reader.string();
                    break;
                case /* string session_ref */ 5:
                    message.sessionRef = reader.string();
                    break;
                case /* optional string project_ref */ 6:
                    message.projectRef = reader.string();
                    break;
                case /* optional int64 status_message_id */ 7:
                    message.statusMessageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 bot_user_id = 2; */
        if (message.botUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.botUserId);
        /* AgentSessionProvider provider = 3; */
        if (message.provider !== 0)
            writer.tag(3, WireType.Varint).int32(message.provider);
        /* string instance_ref = 4; */
        if (message.instanceRef !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.instanceRef);
        /* string session_ref = 5; */
        if (message.sessionRef !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sessionRef);
        /* optional string project_ref = 6; */
        if (message.projectRef !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.projectRef);
        /* optional int64 status_message_id = 7; */
        if (message.statusMessageId !== undefined)
            writer.tag(7, WireType.Varint).int64(message.statusMessageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectAgentSessionInput
 */
export const ConnectAgentSessionInput = new ConnectAgentSessionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectAgentSessionResult$Type extends MessageType {
    constructor() {
        super("ConnectAgentSessionResult", [
            { no: 1, name: "agent_session", kind: "message", T: () => AgentSession },
            { no: 2, name: "state", kind: "enum", T: () => ["ConnectAgentSessionState", ConnectAgentSessionState, "CONNECT_AGENT_SESSION_STATE_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AgentSession agent_session */ 1:
                    message.agentSession = AgentSession.internalBinaryRead(reader, reader.uint32(), options, message.agentSession);
                    break;
                case /* ConnectAgentSessionState state */ 2:
                    message.state = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AgentSession agent_session = 1; */
        if (message.agentSession)
            AgentSession.internalBinaryWrite(message.agentSession, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ConnectAgentSessionState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectAgentSessionResult
 */
export const ConnectAgentSessionResult = new ConnectAgentSessionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSessionConnection$Type extends MessageType {
    constructor() {
        super("AgentSessionConnection", [
            { no: 1, name: "agent_session", kind: "message", T: () => AgentSession },
            { no: 2, name: "instance_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "session_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "project_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.instanceRef = "";
        message.sessionRef = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AgentSession agent_session */ 1:
                    message.agentSession = AgentSession.internalBinaryRead(reader, reader.uint32(), options, message.agentSession);
                    break;
                case /* string instance_ref */ 2:
                    message.instanceRef = reader.string();
                    break;
                case /* string session_ref */ 3:
                    message.sessionRef = reader.string();
                    break;
                case /* optional string project_ref */ 4:
                    message.projectRef = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AgentSession agent_session = 1; */
        if (message.agentSession)
            AgentSession.internalBinaryWrite(message.agentSession, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string instance_ref = 2; */
        if (message.instanceRef !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.instanceRef);
        /* string session_ref = 3; */
        if (message.sessionRef !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionRef);
        /* optional string project_ref = 4; */
        if (message.projectRef !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.projectRef);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSessionConnection
 */
export const AgentSessionConnection = new AgentSessionConnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgentSessionInput$Type extends MessageType {
    constructor() {
        super("GetAgentSessionInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 bot_user_id */ 2:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 bot_user_id = 2; */
        if (message.botUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAgentSessionInput
 */
export const GetAgentSessionInput = new GetAgentSessionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgentSessionResult$Type extends MessageType {
    constructor() {
        super("GetAgentSessionResult", [
            { no: 1, name: "connection", kind: "message", T: () => AgentSessionConnection }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional AgentSessionConnection connection */ 1:
                    message.connection = AgentSessionConnection.internalBinaryRead(reader, reader.uint32(), options, message.connection);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional AgentSessionConnection connection = 1; */
        if (message.connection)
            AgentSessionConnection.internalBinaryWrite(message.connection, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAgentSessionResult
 */
export const GetAgentSessionResult = new GetAgentSessionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSessionMessageUpsert$Type extends MessageType {
    constructor() {
        super("AgentSessionMessageUpsert", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entities", kind: "message", T: () => MessageEntities },
            { no: 3, name: "assistant_random_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                case /* optional MessageEntities entities */ 2:
                    message.entities = MessageEntities.internalBinaryRead(reader, reader.uint32(), options, message.entities);
                    break;
                case /* optional int64 assistant_random_id */ 3:
                    message.assistantRandomId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        /* optional MessageEntities entities = 2; */
        if (message.entities)
            MessageEntities.internalBinaryWrite(message.entities, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 assistant_random_id = 3; */
        if (message.assistantRandomId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.assistantRandomId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSessionMessageUpsert
 */
export const AgentSessionMessageUpsert = new AgentSessionMessageUpsert$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSessionMessageLink$Type extends MessageType {
    constructor() {
        super("AgentSessionMessageLink", [
            { no: 1, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 message_id */ 1:
                    message.messageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 message_id = 1; */
        if (message.messageId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.messageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSessionMessageLink
 */
export const AgentSessionMessageLink = new AgentSessionMessageLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSessionMessageSync$Type extends MessageType {
    constructor() {
        super("AgentSessionMessageSync", [
            { no: 1, name: "role", kind: "enum", T: () => ["AgentSessionMessageRole", AgentSessionMessageRole, "AGENT_SESSION_MESSAGE_ROLE_"] },
            { no: 2, name: "item_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "correlation_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "source_date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "revision_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "base_revision_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "complete", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "upsert", kind: "message", oneof: "operation", T: () => AgentSessionMessageUpsert },
            { no: 9, name: "link", kind: "message", oneof: "operation", T: () => AgentSessionMessageLink }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.role = 0;
        message.complete = false;
        message.operation = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AgentSessionMessageRole role */ 1:
                    message.role = reader.int32();
                    break;
                case /* optional string item_ref */ 2:
                    message.itemRef = reader.string();
                    break;
                case /* optional string correlation_ref */ 3:
                    message.correlationRef = reader.string();
                    break;
                case /* optional int64 source_date */ 4:
                    message.sourceDate = reader.int64().toBigInt();
                    break;
                case /* optional string revision_ref */ 5:
                    message.revisionRef = reader.string();
                    break;
                case /* optional string base_revision_ref */ 6:
                    message.baseRevisionRef = reader.string();
                    break;
                case /* bool complete */ 7:
                    message.complete = reader.bool();
                    break;
                case /* AgentSessionMessageUpsert upsert */ 8:
                    message.operation = {
                        oneofKind: "upsert",
                        upsert: AgentSessionMessageUpsert.internalBinaryRead(reader, reader.uint32(), options, message.operation.upsert)
                    };
                    break;
                case /* AgentSessionMessageLink link */ 9:
                    message.operation = {
                        oneofKind: "link",
                        link: AgentSessionMessageLink.internalBinaryRead(reader, reader.uint32(), options, message.operation.link)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AgentSessionMessageRole role = 1; */
        if (message.role !== 0)
            writer.tag(1, WireType.Varint).int32(message.role);
        /* optional string item_ref = 2; */
        if (message.itemRef !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.itemRef);
        /* optional string correlation_ref = 3; */
        if (message.correlationRef !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.correlationRef);
        /* optional int64 source_date = 4; */
        if (message.sourceDate !== undefined)
            writer.tag(4, WireType.Varint).int64(message.sourceDate);
        /* optional string revision_ref = 5; */
        if (message.revisionRef !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.revisionRef);
        /* optional string base_revision_ref = 6; */
        if (message.baseRevisionRef !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.baseRevisionRef);
        /* bool complete = 7; */
        if (message.complete !== false)
            writer.tag(7, WireType.Varint).bool(message.complete);
        /* AgentSessionMessageUpsert upsert = 8; */
        if (message.operation.oneofKind === "upsert")
            AgentSessionMessageUpsert.internalBinaryWrite(message.operation.upsert, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* AgentSessionMessageLink link = 9; */
        if (message.operation.oneofKind === "link")
            AgentSessionMessageLink.internalBinaryWrite(message.operation.link, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSessionMessageSync
 */
export const AgentSessionMessageSync = new AgentSessionMessageSync$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncAgentSessionMessagesInput$Type extends MessageType {
    constructor() {
        super("SyncAgentSessionMessagesInput", [
            { no: 1, name: "agent_session_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "mode", kind: "enum", T: () => ["AgentSessionSyncMode", AgentSessionSyncMode, "AGENT_SESSION_SYNC_MODE_"] },
            { no: 3, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentSessionMessageSync }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agentSessionId = 0n;
        message.mode = 0;
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 agent_session_id */ 1:
                    message.agentSessionId = reader.int64().toBigInt();
                    break;
                case /* AgentSessionSyncMode mode */ 2:
                    message.mode = reader.int32();
                    break;
                case /* repeated AgentSessionMessageSync messages */ 3:
                    message.messages.push(AgentSessionMessageSync.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 agent_session_id = 1; */
        if (message.agentSessionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.agentSessionId);
        /* AgentSessionSyncMode mode = 2; */
        if (message.mode !== 0)
            writer.tag(2, WireType.Varint).int32(message.mode);
        /* repeated AgentSessionMessageSync messages = 3; */
        for (let i = 0; i < message.messages.length; i++)
            AgentSessionMessageSync.internalBinaryWrite(message.messages[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncAgentSessionMessagesInput
 */
export const SyncAgentSessionMessagesInput = new SyncAgentSessionMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentSessionMessageSyncResult$Type extends MessageType {
    constructor() {
        super("AgentSessionMessageSyncResult", [
            { no: 1, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["AgentSessionMessageSyncState", AgentSessionMessageSyncState, "AGENT_SESSION_MESSAGE_SYNC_STATE_"] },
            { no: 3, name: "message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "current_revision_ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.index = 0;
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 index */ 1:
                    message.index = reader.int32();
                    break;
                case /* AgentSessionMessageSyncState state */ 2:
                    message.state = reader.int32();
                    break;
                case /* optional int64 message_id */ 3:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* optional string current_revision_ref */ 4:
                    message.currentRevisionRef = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 index = 1; */
        if (message.index !== 0)
            writer.tag(1, WireType.Varint).int32(message.index);
        /* AgentSessionMessageSyncState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        /* optional int64 message_id = 3; */
        if (message.messageId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.messageId);
        /* optional string current_revision_ref = 4; */
        if (message.currentRevisionRef !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.currentRevisionRef);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentSessionMessageSyncResult
 */
export const AgentSessionMessageSyncResult = new AgentSessionMessageSyncResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncAgentSessionMessagesResult$Type extends MessageType {
    constructor() {
        super("SyncAgentSessionMessagesResult", [
            { no: 1, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentSessionMessageSyncResult }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AgentSessionMessageSyncResult messages */ 1:
                    message.messages.push(AgentSessionMessageSyncResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AgentSessionMessageSyncResult messages = 1; */
        for (let i = 0; i < message.messages.length; i++)
            AgentSessionMessageSyncResult.internalBinaryWrite(message.messages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncAgentSessionMessagesResult
 */
export const SyncAgentSessionMessagesResult = new SyncAgentSessionMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinPublicSpaceInput$Type extends MessageType {
    constructor() {
        super("JoinPublicSpaceInput", [
            { no: 1, name: "handle", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.handle = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string handle */ 1:
                    message.handle = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string handle = 1; */
        if (message.handle !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.handle);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JoinPublicSpaceInput
 */
export const JoinPublicSpaceInput = new JoinPublicSpaceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinPublicSpaceResult$Type extends MessageType {
    constructor() {
        super("JoinPublicSpaceResult", [
            { no: 1, name: "space", kind: "message", T: () => Space },
            { no: 2, name: "member", kind: "message", T: () => Member },
            { no: 3, name: "already_member", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.alreadyMember = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Space space */ 1:
                    message.space = Space.internalBinaryRead(reader, reader.uint32(), options, message.space);
                    break;
                case /* Member member */ 2:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                case /* bool already_member */ 3:
                    message.alreadyMember = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Space space = 1; */
        if (message.space)
            Space.internalBinaryWrite(message.space, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Member member = 2; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool already_member = 3; */
        if (message.alreadyMember !== false)
            writer.tag(3, WireType.Varint).bool(message.alreadyMember);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JoinPublicSpaceResult
 */
export const JoinPublicSpaceResult = new JoinPublicSpaceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpaceInviteLink$Type extends MessageType {
    constructor() {
        super("SpaceInviteLink", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expires_at", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                case /* optional int64 expires_at */ 2:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        /* optional int64 expires_at = 2; */
        if (message.expiresAt !== undefined)
            writer.tag(2, WireType.Varint).int64(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpaceInviteLink
 */
export const SpaceInviteLink = new SpaceInviteLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinSpaceByInviteTokenInput$Type extends MessageType {
    constructor() {
        super("JoinSpaceByInviteTokenInput", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JoinSpaceByInviteTokenInput
 */
export const JoinSpaceByInviteTokenInput = new JoinSpaceByInviteTokenInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinSpaceByInviteTokenResult$Type extends MessageType {
    constructor() {
        super("JoinSpaceByInviteTokenResult", [
            { no: 1, name: "space", kind: "message", T: () => Space },
            { no: 2, name: "member", kind: "message", T: () => Member },
            { no: 3, name: "already_member", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.alreadyMember = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Space space */ 1:
                    message.space = Space.internalBinaryRead(reader, reader.uint32(), options, message.space);
                    break;
                case /* Member member */ 2:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                case /* bool already_member */ 3:
                    message.alreadyMember = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Space space = 1; */
        if (message.space)
            Space.internalBinaryWrite(message.space, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Member member = 2; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool already_member = 3; */
        if (message.alreadyMember !== false)
            writer.tag(3, WireType.Varint).bool(message.alreadyMember);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JoinSpaceByInviteTokenResult
 */
export const JoinSpaceByInviteTokenResult = new JoinSpaceByInviteTokenResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceInviteLinkInput$Type extends MessageType {
    constructor() {
        super("GetSpaceInviteLinkInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceInviteLinkInput
 */
export const GetSpaceInviteLinkInput = new GetSpaceInviteLinkInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceInviteLinkResult$Type extends MessageType {
    constructor() {
        super("GetSpaceInviteLinkResult", [
            { no: 1, name: "link", kind: "message", T: () => SpaceInviteLink }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional SpaceInviteLink link */ 1:
                    message.link = SpaceInviteLink.internalBinaryRead(reader, reader.uint32(), options, message.link);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional SpaceInviteLink link = 1; */
        if (message.link)
            SpaceInviteLink.internalBinaryWrite(message.link, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceInviteLinkResult
 */
export const GetSpaceInviteLinkResult = new GetSpaceInviteLinkResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetSpaceInviteLinkEnabledInput$Type extends MessageType {
    constructor() {
        super("SetSpaceInviteLinkEnabledInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetSpaceInviteLinkEnabledInput
 */
export const SetSpaceInviteLinkEnabledInput = new SetSpaceInviteLinkEnabledInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetSpaceInviteLinkEnabledResult$Type extends MessageType {
    constructor() {
        super("SetSpaceInviteLinkEnabledResult", [
            { no: 1, name: "link", kind: "message", T: () => SpaceInviteLink }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional SpaceInviteLink link */ 1:
                    message.link = SpaceInviteLink.internalBinaryRead(reader, reader.uint32(), options, message.link);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional SpaceInviteLink link = 1; */
        if (message.link)
            SpaceInviteLink.internalBinaryWrite(message.link, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetSpaceInviteLinkEnabledResult
 */
export const SetSpaceInviteLinkEnabledResult = new SetSpaceInviteLinkEnabledResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserGroup$Type extends MessageType {
    constructor() {
        super("UserGroup", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "member_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "current_user_is_member", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.spaceId = 0n;
        message.name = "";
        message.memberCount = 0;
        message.userIds = [];
        message.currentUserIsMember = false;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* optional string description */ 4:
                    message.description = reader.string();
                    break;
                case /* int32 member_count */ 5:
                    message.memberCount = reader.int32();
                    break;
                case /* repeated int64 user_ids */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userIds.push(reader.int64().toBigInt());
                    else
                        message.userIds.push(reader.int64().toBigInt());
                    break;
                case /* bool current_user_is_member */ 7:
                    message.currentUserIsMember = reader.bool();
                    break;
                case /* int64 date */ 8:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 space_id = 2; */
        if (message.spaceId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* optional string description = 4; */
        if (message.description !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* int32 member_count = 5; */
        if (message.memberCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.memberCount);
        /* repeated int64 user_ids = 6; */
        if (message.userIds.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userIds.length; i++)
                writer.int64(message.userIds[i]);
            writer.join();
        }
        /* bool current_user_is_member = 7; */
        if (message.currentUserIsMember !== false)
            writer.tag(7, WireType.Varint).bool(message.currentUserIsMember);
        /* int64 date = 8; */
        if (message.date !== 0n)
            writer.tag(8, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserGroup
 */
export const UserGroup = new UserGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddReactionInput$Type extends MessageType {
    constructor() {
        super("AddReactionInput", [
            { no: 1, name: "emoji", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.emoji = "";
        message.messageId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string emoji */ 1:
                    message.emoji = reader.string();
                    break;
                case /* int64 message_id */ 2:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* InputPeer peer_id */ 3:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string emoji = 1; */
        if (message.emoji !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.emoji);
        /* int64 message_id = 2; */
        if (message.messageId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.messageId);
        /* InputPeer peer_id = 3; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddReactionInput
 */
export const AddReactionInput = new AddReactionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddReactionResult$Type extends MessageType {
    constructor() {
        super("AddReactionResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddReactionResult
 */
export const AddReactionResult = new AddReactionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReactionInput$Type extends MessageType {
    constructor() {
        super("DeleteReactionInput", [
            { no: 1, name: "emoji", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 3, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.emoji = "";
        message.messageId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string emoji */ 1:
                    message.emoji = reader.string();
                    break;
                case /* InputPeer peer_id */ 2:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 message_id */ 3:
                    message.messageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string emoji = 1; */
        if (message.emoji !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.emoji);
        /* InputPeer peer_id = 2; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int64 message_id = 3; */
        if (message.messageId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.messageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteReactionInput
 */
export const DeleteReactionInput = new DeleteReactionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReactionResult$Type extends MessageType {
    constructor() {
        super("DeleteReactionResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteReactionResult
 */
export const DeleteReactionResult = new DeleteReactionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageAttachments$Type extends MessageType {
    constructor() {
        super("MessageAttachments", [
            { no: 1, name: "attachments", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MessageAttachment }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.attachments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MessageAttachment attachments */ 1:
                    message.attachments.push(MessageAttachment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MessageAttachment attachments = 1; */
        for (let i = 0; i < message.attachments.length; i++)
            MessageAttachment.internalBinaryWrite(message.attachments[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageAttachments
 */
export const MessageAttachments = new MessageAttachments$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageAttachment$Type extends MessageType {
    constructor() {
        super("MessageAttachment", [
            { no: 4, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "external_task", kind: "message", oneof: "attachment", T: () => MessageAttachmentExternalTask },
            { no: 3, name: "url_preview", kind: "message", oneof: "attachment", T: () => UrlPreview }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.attachment = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 4:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* MessageAttachmentExternalTask external_task */ 2:
                    message.attachment = {
                        oneofKind: "externalTask",
                        externalTask: MessageAttachmentExternalTask.internalBinaryRead(reader, reader.uint32(), options, message.attachment.externalTask)
                    };
                    break;
                case /* UrlPreview url_preview */ 3:
                    message.attachment = {
                        oneofKind: "urlPreview",
                        urlPreview: UrlPreview.internalBinaryRead(reader, reader.uint32(), options, message.attachment.urlPreview)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 4; */
        if (message.id !== 0n)
            writer.tag(4, WireType.Varint).int64(message.id);
        /* MessageAttachmentExternalTask external_task = 2; */
        if (message.attachment.oneofKind === "externalTask")
            MessageAttachmentExternalTask.internalBinaryWrite(message.attachment.externalTask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* UrlPreview url_preview = 3; */
        if (message.attachment.oneofKind === "urlPreview")
            UrlPreview.internalBinaryWrite(message.attachment.urlPreview, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageAttachment
 */
export const MessageAttachment = new MessageAttachment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UrlPreview$Type extends MessageType {
    constructor() {
        super("UrlPreview", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "site_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "photo", kind: "message", T: () => Photo },
            { no: 7, name: "duration", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "media_type", kind: "enum", opt: true, T: () => ["UrlPreview.MediaType", UrlPreview_MediaType, "MEDIA_TYPE_"] },
            { no: 9, name: "display_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "provider", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "author", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "media", kind: "message", T: () => UrlPreviewMedia },
            { no: 13, name: "layout", kind: "message", T: () => UrlPreviewLayout },
            { no: 14, name: "author_photo", kind: "message", T: () => Photo },
            { no: 15, name: "icon_emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* optional string url */ 2:
                    message.url = reader.string();
                    break;
                case /* optional string site_name */ 3:
                    message.siteName = reader.string();
                    break;
                case /* optional string title */ 4:
                    message.title = reader.string();
                    break;
                case /* optional string description */ 5:
                    message.description = reader.string();
                    break;
                case /* optional Photo photo */ 6:
                    message.photo = Photo.internalBinaryRead(reader, reader.uint32(), options, message.photo);
                    break;
                case /* optional int64 duration */ 7:
                    message.duration = reader.int64().toBigInt();
                    break;
                case /* optional UrlPreview.MediaType media_type */ 8:
                    message.mediaType = reader.int32();
                    break;
                case /* optional string display_url */ 9:
                    message.displayUrl = reader.string();
                    break;
                case /* optional string provider */ 10:
                    message.provider = reader.string();
                    break;
                case /* optional string author */ 11:
                    message.author = reader.string();
                    break;
                case /* optional UrlPreviewMedia media */ 12:
                    message.media = UrlPreviewMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* optional UrlPreviewLayout layout */ 13:
                    message.layout = UrlPreviewLayout.internalBinaryRead(reader, reader.uint32(), options, message.layout);
                    break;
                case /* optional Photo author_photo */ 14:
                    message.authorPhoto = Photo.internalBinaryRead(reader, reader.uint32(), options, message.authorPhoto);
                    break;
                case /* optional string icon_emoji */ 15:
                    message.iconEmoji = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* optional string url = 2; */
        if (message.url !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* optional string site_name = 3; */
        if (message.siteName !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.siteName);
        /* optional string title = 4; */
        if (message.title !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* optional string description = 5; */
        if (message.description !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* optional Photo photo = 6; */
        if (message.photo)
            Photo.internalBinaryWrite(message.photo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 duration = 7; */
        if (message.duration !== undefined)
            writer.tag(7, WireType.Varint).int64(message.duration);
        /* optional UrlPreview.MediaType media_type = 8; */
        if (message.mediaType !== undefined)
            writer.tag(8, WireType.Varint).int32(message.mediaType);
        /* optional string display_url = 9; */
        if (message.displayUrl !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.displayUrl);
        /* optional string provider = 10; */
        if (message.provider !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.provider);
        /* optional string author = 11; */
        if (message.author !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.author);
        /* optional UrlPreviewMedia media = 12; */
        if (message.media)
            UrlPreviewMedia.internalBinaryWrite(message.media, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* optional UrlPreviewLayout layout = 13; */
        if (message.layout)
            UrlPreviewLayout.internalBinaryWrite(message.layout, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional Photo author_photo = 14; */
        if (message.authorPhoto)
            Photo.internalBinaryWrite(message.authorPhoto, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* optional string icon_emoji = 15; */
        if (message.iconEmoji !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.iconEmoji);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UrlPreview
 */
export const UrlPreview = new UrlPreview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UrlPreviewMedia$Type extends MessageType {
    constructor() {
        super("UrlPreviewMedia", [
            { no: 1, name: "photo", kind: "message", oneof: "media", T: () => Photo },
            { no: 2, name: "video", kind: "message", oneof: "media", T: () => Video },
            { no: 3, name: "document", kind: "message", oneof: "media", T: () => Document },
            { no: 4, name: "external_video", kind: "message", oneof: "media", T: () => UrlPreviewExternalVideo },
            { no: 5, name: "embed", kind: "message", oneof: "media", T: () => UrlPreviewEmbed }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.media = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Photo photo */ 1:
                    message.media = {
                        oneofKind: "photo",
                        photo: Photo.internalBinaryRead(reader, reader.uint32(), options, message.media.photo)
                    };
                    break;
                case /* Video video */ 2:
                    message.media = {
                        oneofKind: "video",
                        video: Video.internalBinaryRead(reader, reader.uint32(), options, message.media.video)
                    };
                    break;
                case /* Document document */ 3:
                    message.media = {
                        oneofKind: "document",
                        document: Document.internalBinaryRead(reader, reader.uint32(), options, message.media.document)
                    };
                    break;
                case /* UrlPreviewExternalVideo external_video */ 4:
                    message.media = {
                        oneofKind: "externalVideo",
                        externalVideo: UrlPreviewExternalVideo.internalBinaryRead(reader, reader.uint32(), options, message.media.externalVideo)
                    };
                    break;
                case /* UrlPreviewEmbed embed */ 5:
                    message.media = {
                        oneofKind: "embed",
                        embed: UrlPreviewEmbed.internalBinaryRead(reader, reader.uint32(), options, message.media.embed)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Photo photo = 1; */
        if (message.media.oneofKind === "photo")
            Photo.internalBinaryWrite(message.media.photo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Video video = 2; */
        if (message.media.oneofKind === "video")
            Video.internalBinaryWrite(message.media.video, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Document document = 3; */
        if (message.media.oneofKind === "document")
            Document.internalBinaryWrite(message.media.document, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* UrlPreviewExternalVideo external_video = 4; */
        if (message.media.oneofKind === "externalVideo")
            UrlPreviewExternalVideo.internalBinaryWrite(message.media.externalVideo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* UrlPreviewEmbed embed = 5; */
        if (message.media.oneofKind === "embed")
            UrlPreviewEmbed.internalBinaryWrite(message.media.embed, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UrlPreviewMedia
 */
export const UrlPreviewMedia = new UrlPreviewMedia$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UrlPreviewExternalVideo$Type extends MessageType {
    constructor() {
        super("UrlPreviewExternalVideo", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mime_type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "w", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "h", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "duration", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                case /* optional string mime_type */ 2:
                    message.mimeType = reader.string();
                    break;
                case /* optional int32 w */ 3:
                    message.w = reader.int32();
                    break;
                case /* optional int32 h */ 4:
                    message.h = reader.int32();
                    break;
                case /* optional int32 duration */ 5:
                    message.duration = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        /* optional string mime_type = 2; */
        if (message.mimeType !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.mimeType);
        /* optional int32 w = 3; */
        if (message.w !== undefined)
            writer.tag(3, WireType.Varint).int32(message.w);
        /* optional int32 h = 4; */
        if (message.h !== undefined)
            writer.tag(4, WireType.Varint).int32(message.h);
        /* optional int32 duration = 5; */
        if (message.duration !== undefined)
            writer.tag(5, WireType.Varint).int32(message.duration);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UrlPreviewExternalVideo
 */
export const UrlPreviewExternalVideo = new UrlPreviewExternalVideo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UrlPreviewEmbed$Type extends MessageType {
    constructor() {
        super("UrlPreviewEmbed", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "w", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "h", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "duration", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                case /* optional string type */ 2:
                    message.type = reader.string();
                    break;
                case /* optional int32 w */ 3:
                    message.w = reader.int32();
                    break;
                case /* optional int32 h */ 4:
                    message.h = reader.int32();
                    break;
                case /* optional int32 duration */ 5:
                    message.duration = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        /* optional string type = 2; */
        if (message.type !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* optional int32 w = 3; */
        if (message.w !== undefined)
            writer.tag(3, WireType.Varint).int32(message.w);
        /* optional int32 h = 4; */
        if (message.h !== undefined)
            writer.tag(4, WireType.Varint).int32(message.h);
        /* optional int32 duration = 5; */
        if (message.duration !== undefined)
            writer.tag(5, WireType.Varint).int32(message.duration);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UrlPreviewEmbed
 */
export const UrlPreviewEmbed = new UrlPreviewEmbed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UrlPreviewLayout$Type extends MessageType {
    constructor() {
        super("UrlPreviewLayout", [
            { no: 1, name: "has_large_media", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "show_large_media", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.hasLargeMedia = false;
        message.showLargeMedia = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_large_media */ 1:
                    message.hasLargeMedia = reader.bool();
                    break;
                case /* bool show_large_media */ 2:
                    message.showLargeMedia = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool has_large_media = 1; */
        if (message.hasLargeMedia !== false)
            writer.tag(1, WireType.Varint).bool(message.hasLargeMedia);
        /* bool show_large_media = 2; */
        if (message.showLargeMedia !== false)
            writer.tag(2, WireType.Varint).bool(message.showLargeMedia);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UrlPreviewLayout
 */
export const UrlPreviewLayout = new UrlPreviewLayout$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageAttachmentExternalTask$Type extends MessageType {
    constructor() {
        super("MessageAttachmentExternalTask", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "application", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["MessageAttachmentExternalTask.Status", MessageAttachmentExternalTask_Status, "STATUS_"] },
            { no: 6, name: "assigned_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.taskId = "";
        message.application = "";
        message.title = "";
        message.status = 0;
        message.assignedUserId = 0n;
        message.url = "";
        message.number = "";
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string task_id */ 2:
                    message.taskId = reader.string();
                    break;
                case /* string application */ 3:
                    message.application = reader.string();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* MessageAttachmentExternalTask.Status status */ 5:
                    message.status = reader.int32();
                    break;
                case /* int64 assigned_user_id */ 6:
                    message.assignedUserId = reader.int64().toBigInt();
                    break;
                case /* string url */ 7:
                    message.url = reader.string();
                    break;
                case /* string number */ 8:
                    message.number = reader.string();
                    break;
                case /* int64 date */ 9:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string task_id = 2; */
        if (message.taskId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.taskId);
        /* string application = 3; */
        if (message.application !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.application);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* MessageAttachmentExternalTask.Status status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* int64 assigned_user_id = 6; */
        if (message.assignedUserId !== 0n)
            writer.tag(6, WireType.Varint).int64(message.assignedUserId);
        /* string url = 7; */
        if (message.url !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.url);
        /* string number = 8; */
        if (message.number !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.number);
        /* int64 date = 9; */
        if (message.date !== 0n)
            writer.tag(9, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageAttachmentExternalTask
 */
export const MessageAttachmentExternalTask = new MessageAttachmentExternalTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageMedia$Type extends MessageType {
    constructor() {
        super("MessageMedia", [
            { no: 1, name: "photo", kind: "message", oneof: "media", T: () => MessagePhoto },
            { no: 2, name: "video", kind: "message", oneof: "media", T: () => MessageVideo },
            { no: 3, name: "document", kind: "message", oneof: "media", T: () => MessageDocument },
            { no: 4, name: "nudge", kind: "message", oneof: "media", T: () => MessageNudge },
            { no: 5, name: "voice", kind: "message", oneof: "media", T: () => MessageVoice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.media = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* MessagePhoto photo */ 1:
                    message.media = {
                        oneofKind: "photo",
                        photo: MessagePhoto.internalBinaryRead(reader, reader.uint32(), options, message.media.photo)
                    };
                    break;
                case /* MessageVideo video */ 2:
                    message.media = {
                        oneofKind: "video",
                        video: MessageVideo.internalBinaryRead(reader, reader.uint32(), options, message.media.video)
                    };
                    break;
                case /* MessageDocument document */ 3:
                    message.media = {
                        oneofKind: "document",
                        document: MessageDocument.internalBinaryRead(reader, reader.uint32(), options, message.media.document)
                    };
                    break;
                case /* MessageNudge nudge */ 4:
                    message.media = {
                        oneofKind: "nudge",
                        nudge: MessageNudge.internalBinaryRead(reader, reader.uint32(), options, message.media.nudge)
                    };
                    break;
                case /* MessageVoice voice */ 5:
                    message.media = {
                        oneofKind: "voice",
                        voice: MessageVoice.internalBinaryRead(reader, reader.uint32(), options, message.media.voice)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* MessagePhoto photo = 1; */
        if (message.media.oneofKind === "photo")
            MessagePhoto.internalBinaryWrite(message.media.photo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* MessageVideo video = 2; */
        if (message.media.oneofKind === "video")
            MessageVideo.internalBinaryWrite(message.media.video, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* MessageDocument document = 3; */
        if (message.media.oneofKind === "document")
            MessageDocument.internalBinaryWrite(message.media.document, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* MessageNudge nudge = 4; */
        if (message.media.oneofKind === "nudge")
            MessageNudge.internalBinaryWrite(message.media.nudge, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* MessageVoice voice = 5; */
        if (message.media.oneofKind === "voice")
            MessageVoice.internalBinaryWrite(message.media.voice, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageMedia
 */
export const MessageMedia = new MessageMedia$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessagePhoto$Type extends MessageType {
    constructor() {
        super("MessagePhoto", [
            { no: 1, name: "photo", kind: "message", T: () => Photo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Photo photo */ 1:
                    message.photo = Photo.internalBinaryRead(reader, reader.uint32(), options, message.photo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Photo photo = 1; */
        if (message.photo)
            Photo.internalBinaryWrite(message.photo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessagePhoto
 */
export const MessagePhoto = new MessagePhoto$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageVideo$Type extends MessageType {
    constructor() {
        super("MessageVideo", [
            { no: 1, name: "video", kind: "message", T: () => Video }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Video video */ 1:
                    message.video = Video.internalBinaryRead(reader, reader.uint32(), options, message.video);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Video video = 1; */
        if (message.video)
            Video.internalBinaryWrite(message.video, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageVideo
 */
export const MessageVideo = new MessageVideo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageDocument$Type extends MessageType {
    constructor() {
        super("MessageDocument", [
            { no: 1, name: "document", kind: "message", T: () => Document }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Document document */ 1:
                    message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Document document = 1; */
        if (message.document)
            Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageDocument
 */
export const MessageDocument = new MessageDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageVoice$Type extends MessageType {
    constructor() {
        super("MessageVoice", [
            { no: 1, name: "voice", kind: "message", T: () => Voice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Voice voice */ 1:
                    message.voice = Voice.internalBinaryRead(reader, reader.uint32(), options, message.voice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Voice voice = 1; */
        if (message.voice)
            Voice.internalBinaryWrite(message.voice, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageVoice
 */
export const MessageVoice = new MessageVoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageNudge$Type extends MessageType {
    constructor() {
        super("MessageNudge", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageNudge
 */
export const MessageNudge = new MessageNudge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Video$Type extends MessageType {
    constructor() {
        super("Video", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "w", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "h", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "duration", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "photo", kind: "message", T: () => Photo },
            { no: 8, name: "cdn_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "is_animated", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "has_audio", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.date = 0n;
        message.w = 0;
        message.h = 0;
        message.duration = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* int32 w */ 3:
                    message.w = reader.int32();
                    break;
                case /* int32 h */ 4:
                    message.h = reader.int32();
                    break;
                case /* int32 duration */ 5:
                    message.duration = reader.int32();
                    break;
                case /* int32 size */ 6:
                    message.size = reader.int32();
                    break;
                case /* optional Photo photo */ 7:
                    message.photo = Photo.internalBinaryRead(reader, reader.uint32(), options, message.photo);
                    break;
                case /* optional string cdn_url */ 8:
                    message.cdnUrl = reader.string();
                    break;
                case /* optional bool is_animated */ 9:
                    message.isAnimated = reader.bool();
                    break;
                case /* optional bool has_audio */ 10:
                    message.hasAudio = reader.bool();
                    break;
                case /* optional string file_unique_id */ 100:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 date = 2; */
        if (message.date !== 0n)
            writer.tag(2, WireType.Varint).int64(message.date);
        /* int32 w = 3; */
        if (message.w !== 0)
            writer.tag(3, WireType.Varint).int32(message.w);
        /* int32 h = 4; */
        if (message.h !== 0)
            writer.tag(4, WireType.Varint).int32(message.h);
        /* int32 duration = 5; */
        if (message.duration !== 0)
            writer.tag(5, WireType.Varint).int32(message.duration);
        /* int32 size = 6; */
        if (message.size !== 0)
            writer.tag(6, WireType.Varint).int32(message.size);
        /* optional Photo photo = 7; */
        if (message.photo)
            Photo.internalBinaryWrite(message.photo, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional string cdn_url = 8; */
        if (message.cdnUrl !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.cdnUrl);
        /* optional bool is_animated = 9; */
        if (message.isAnimated !== undefined)
            writer.tag(9, WireType.Varint).bool(message.isAnimated);
        /* optional bool has_audio = 10; */
        if (message.hasAudio !== undefined)
            writer.tag(10, WireType.Varint).bool(message.hasAudio);
        /* optional string file_unique_id = 100; */
        if (message.fileUniqueId !== undefined)
            writer.tag(100, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Video
 */
export const Video = new Video$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Document$Type extends MessageType {
    constructor() {
        super("Document", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "cdn_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "photo", kind: "message", T: () => Photo },
            { no: 100, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.fileName = "";
        message.mimeType = "";
        message.size = 0;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string file_name */ 2:
                    message.fileName = reader.string();
                    break;
                case /* string mime_type */ 3:
                    message.mimeType = reader.string();
                    break;
                case /* int32 size */ 4:
                    message.size = reader.int32();
                    break;
                case /* optional string cdn_url */ 5:
                    message.cdnUrl = reader.string();
                    break;
                case /* int64 date */ 6:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional Photo photo */ 7:
                    message.photo = Photo.internalBinaryRead(reader, reader.uint32(), options, message.photo);
                    break;
                case /* optional string file_unique_id */ 100:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string file_name = 2; */
        if (message.fileName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fileName);
        /* string mime_type = 3; */
        if (message.mimeType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.mimeType);
        /* int32 size = 4; */
        if (message.size !== 0)
            writer.tag(4, WireType.Varint).int32(message.size);
        /* optional string cdn_url = 5; */
        if (message.cdnUrl !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.cdnUrl);
        /* int64 date = 6; */
        if (message.date !== 0n)
            writer.tag(6, WireType.Varint).int64(message.date);
        /* optional Photo photo = 7; */
        if (message.photo)
            Photo.internalBinaryWrite(message.photo, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional string file_unique_id = 100; */
        if (message.fileUniqueId !== undefined)
            writer.tag(100, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Document
 */
export const Document = new Document$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Voice$Type extends MessageType {
    constructor() {
        super("Voice", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "duration", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "cdn_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "waveform", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 100, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.date = 0n;
        message.duration = 0;
        message.size = 0;
        message.mimeType = "";
        message.waveform = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* int32 duration */ 3:
                    message.duration = reader.int32();
                    break;
                case /* int32 size */ 4:
                    message.size = reader.int32();
                    break;
                case /* string mime_type */ 5:
                    message.mimeType = reader.string();
                    break;
                case /* optional string cdn_url */ 6:
                    message.cdnUrl = reader.string();
                    break;
                case /* bytes waveform */ 7:
                    message.waveform = reader.bytes();
                    break;
                case /* optional string file_unique_id */ 100:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 date = 2; */
        if (message.date !== 0n)
            writer.tag(2, WireType.Varint).int64(message.date);
        /* int32 duration = 3; */
        if (message.duration !== 0)
            writer.tag(3, WireType.Varint).int32(message.duration);
        /* int32 size = 4; */
        if (message.size !== 0)
            writer.tag(4, WireType.Varint).int32(message.size);
        /* string mime_type = 5; */
        if (message.mimeType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.mimeType);
        /* optional string cdn_url = 6; */
        if (message.cdnUrl !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.cdnUrl);
        /* bytes waveform = 7; */
        if (message.waveform.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.waveform);
        /* optional string file_unique_id = 100; */
        if (message.fileUniqueId !== undefined)
            writer.tag(100, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Voice
 */
export const Voice = new Voice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Photo$Type extends MessageType {
    constructor() {
        super("Photo", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "sizes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PhotoSize },
            { no: 4, name: "format", kind: "enum", T: () => ["Photo.Format", Photo_Format, "FORMAT_"] },
            { no: 100, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.date = 0n;
        message.sizes = [];
        message.format = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* repeated PhotoSize sizes */ 3:
                    message.sizes.push(PhotoSize.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* Photo.Format format */ 4:
                    message.format = reader.int32();
                    break;
                case /* optional string file_unique_id */ 100:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 date = 2; */
        if (message.date !== 0n)
            writer.tag(2, WireType.Varint).int64(message.date);
        /* repeated PhotoSize sizes = 3; */
        for (let i = 0; i < message.sizes.length; i++)
            PhotoSize.internalBinaryWrite(message.sizes[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* Photo.Format format = 4; */
        if (message.format !== 0)
            writer.tag(4, WireType.Varint).int32(message.format);
        /* optional string file_unique_id = 100; */
        if (message.fileUniqueId !== undefined)
            writer.tag(100, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Photo
 */
export const Photo = new Photo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PhotoSize$Type extends MessageType {
    constructor() {
        super("PhotoSize", [
            { no: 100, name: "file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "w", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "h", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "bytes", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 6, name: "cdn_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = "";
        message.w = 0;
        message.h = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string file_unique_id */ 100:
                    message.fileUniqueId = reader.string();
                    break;
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* int32 w */ 2:
                    message.w = reader.int32();
                    break;
                case /* int32 h */ 3:
                    message.h = reader.int32();
                    break;
                case /* int32 size */ 4:
                    message.size = reader.int32();
                    break;
                case /* optional bytes bytes */ 5:
                    message.bytes = reader.bytes();
                    break;
                case /* optional string cdn_url */ 6:
                    message.cdnUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string file_unique_id = 100; */
        if (message.fileUniqueId !== undefined)
            writer.tag(100, WireType.LengthDelimited).string(message.fileUniqueId);
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* int32 w = 2; */
        if (message.w !== 0)
            writer.tag(2, WireType.Varint).int32(message.w);
        /* int32 h = 3; */
        if (message.h !== 0)
            writer.tag(3, WireType.Varint).int32(message.h);
        /* int32 size = 4; */
        if (message.size !== 0)
            writer.tag(4, WireType.Varint).int32(message.size);
        /* optional bytes bytes = 5; */
        if (message.bytes !== undefined)
            writer.tag(5, WireType.LengthDelimited).bytes(message.bytes);
        /* optional string cdn_url = 6; */
        if (message.cdnUrl !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.cdnUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PhotoSize
 */
export const PhotoSize = new PhotoSize$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RpcError$Type extends MessageType {
    constructor() {
        super("RpcError", [
            { no: 1, name: "req_msg_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "error_code", kind: "enum", T: () => ["RpcError.Code", RpcError_Code] },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "code", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reqMsgId = 0n;
        message.errorCode = 0;
        message.message = "";
        message.code = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 req_msg_id */ 1:
                    message.reqMsgId = reader.uint64().toBigInt();
                    break;
                case /* RpcError.Code error_code */ 2:
                    message.errorCode = reader.int32();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* int32 code */ 4:
                    message.code = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 req_msg_id = 1; */
        if (message.reqMsgId !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.reqMsgId);
        /* RpcError.Code error_code = 2; */
        if (message.errorCode !== 0)
            writer.tag(2, WireType.Varint).int32(message.errorCode);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* int32 code = 4; */
        if (message.code !== 0)
            writer.tag(4, WireType.Varint).int32(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RpcError
 */
export const RpcError = new RpcError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RpcCall$Type extends MessageType {
    constructor() {
        super("RpcCall", [
            { no: 1, name: "method", kind: "enum", T: () => ["Method", Method] },
            { no: 2, name: "getMe", kind: "message", oneof: "input", T: () => GetMeInput },
            { no: 3, name: "getPeerPhoto", kind: "message", oneof: "input", T: () => GetPeerPhotoInput },
            { no: 4, name: "deleteMessages", kind: "message", oneof: "input", T: () => DeleteMessagesInput },
            { no: 5, name: "sendMessage", kind: "message", oneof: "input", T: () => SendMessageInput },
            { no: 6, name: "getChatHistory", kind: "message", oneof: "input", T: () => GetChatHistoryInput },
            { no: 7, name: "addReaction", kind: "message", oneof: "input", T: () => AddReactionInput },
            { no: 8, name: "deleteReaction", kind: "message", oneof: "input", T: () => DeleteReactionInput },
            { no: 9, name: "editMessage", kind: "message", oneof: "input", T: () => EditMessageInput },
            { no: 10, name: "createChat", kind: "message", oneof: "input", T: () => CreateChatInput },
            { no: 11, name: "getSpaceMembers", kind: "message", oneof: "input", T: () => GetSpaceMembersInput },
            { no: 12, name: "deleteChat", kind: "message", oneof: "input", T: () => DeleteChatInput },
            { no: 13, name: "inviteToSpace", kind: "message", oneof: "input", T: () => InviteToSpaceInput },
            { no: 14, name: "getChatParticipants", kind: "message", oneof: "input", T: () => GetChatParticipantsInput },
            { no: 15, name: "addChatParticipant", kind: "message", oneof: "input", T: () => AddChatParticipantInput },
            { no: 16, name: "removeChatParticipant", kind: "message", oneof: "input", T: () => RemoveChatParticipantInput },
            { no: 17, name: "translateMessages", kind: "message", oneof: "input", T: () => TranslateMessagesInput },
            { no: 18, name: "getChats", kind: "message", oneof: "input", T: () => GetChatsInput },
            { no: 19, name: "updateUserSettings", kind: "message", oneof: "input", T: () => UpdateUserSettingsInput },
            { no: 20, name: "getUserSettings", kind: "message", oneof: "input", T: () => GetUserSettingsInput },
            { no: 21, name: "sendComposeAction", kind: "message", oneof: "input", T: () => SendComposeActionInput },
            { no: 22, name: "createBot", kind: "message", oneof: "input", T: () => CreateBotInput },
            { no: 23, name: "deleteMember", kind: "message", oneof: "input", T: () => DeleteMemberInput },
            { no: 24, name: "markAsUnread", kind: "message", oneof: "input", T: () => MarkAsUnreadInput },
            { no: 25, name: "getUpdatesState", kind: "message", oneof: "input", T: () => GetUpdatesStateInput },
            { no: 26, name: "getChat", kind: "message", oneof: "input", T: () => GetChatInput },
            { no: 27, name: "getUpdates", kind: "message", oneof: "input", T: () => GetUpdatesInput },
            { no: 28, name: "updateMemberAccess", kind: "message", oneof: "input", T: () => UpdateMemberAccessInput },
            { no: 29, name: "searchMessages", kind: "message", oneof: "input", T: () => SearchMessagesInput },
            { no: 30, name: "forwardMessages", kind: "message", oneof: "input", T: () => ForwardMessagesInput },
            { no: 31, name: "updateChatVisibility", kind: "message", oneof: "input", T: () => UpdateChatVisibilityInput },
            { no: 32, name: "pinMessage", kind: "message", oneof: "input", T: () => PinMessageInput },
            { no: 33, name: "updateChatInfo", kind: "message", oneof: "input", T: () => UpdateChatInfoInput },
            { no: 34, name: "listBots", kind: "message", oneof: "input", T: () => ListBotsInput },
            { no: 35, name: "revealBotToken", kind: "message", oneof: "input", T: () => RevealBotTokenInput },
            { no: 36, name: "moveThread", kind: "message", oneof: "input", T: () => MoveThreadInput },
            { no: 37, name: "rotateBotToken", kind: "message", oneof: "input", T: () => RotateBotTokenInput },
            { no: 38, name: "updateBotProfile", kind: "message", oneof: "input", T: () => UpdateBotProfileInput },
            { no: 39, name: "getMessages", kind: "message", oneof: "input", T: () => GetMessagesInput },
            { no: 40, name: "updateDialogNotificationSettings", kind: "message", oneof: "input", T: () => UpdateDialogNotificationSettingsInput },
            { no: 41, name: "readMessages", kind: "message", oneof: "input", T: () => ReadMessagesInput },
            { no: 42, name: "registerDevice", kind: "message", oneof: "input", T: () => RegisterDeviceInput },
            { no: 43, name: "createSubthread", kind: "message", oneof: "input", T: () => CreateSubthreadInput },
            { no: 44, name: "getBotCommands", kind: "message", oneof: "input", T: () => GetBotCommandsInput },
            { no: 45, name: "setBotCommands", kind: "message", oneof: "input", T: () => SetBotCommandsInput },
            { no: 46, name: "getPeerBotCommands", kind: "message", oneof: "input", T: () => GetPeerBotCommandsInput },
            { no: 47, name: "showInChatList", kind: "message", oneof: "input", T: () => ShowInChatListInput },
            { no: 48, name: "reserveChatIds", kind: "message", oneof: "input", T: () => ReserveChatIdsInput },
            { no: 49, name: "invokeMessageAction", kind: "message", oneof: "input", T: () => InvokeMessageActionInput },
            { no: 50, name: "answerMessageAction", kind: "message", oneof: "input", T: () => AnswerMessageActionInput },
            { no: 51, name: "revokeSession", kind: "message", oneof: "input", T: () => RevokeSessionInput },
            { no: 52, name: "updateDialogOpen", kind: "message", oneof: "input", T: () => UpdateDialogOpenInput },
            { no: 53, name: "updateDialogOrder", kind: "message", oneof: "input", T: () => UpdateDialogOrderInput },
            { no: 54, name: "clearChatHistory", kind: "message", oneof: "input", T: () => ClearChatHistoryInput },
            { no: 55, name: "deleteBot", kind: "message", oneof: "input", T: () => DeleteBotInput },
            { no: 56, name: "deleteMessageAttachment", kind: "message", oneof: "input", T: () => DeleteMessageAttachmentInput },
            { no: 57, name: "setBotAvatar", kind: "message", oneof: "input", T: () => SetBotAvatarInput },
            { no: 58, name: "clearBotAvatar", kind: "message", oneof: "input", T: () => ClearBotAvatarInput },
            { no: 59, name: "getBotPresence", kind: "message", oneof: "input", T: () => GetBotPresenceInput },
            { no: 60, name: "setBotPresenceState", kind: "message", oneof: "input", T: () => SetBotPresenceStateInput },
            { no: 61, name: "updateDialogFollowMode", kind: "message", oneof: "input", T: () => UpdateDialogFollowModeInput },
            { no: 62, name: "getSessions", kind: "message", oneof: "input", T: () => GetSessionsInput },
            { no: 63, name: "checkUsername", kind: "message", oneof: "input", T: () => CheckUsernameInput },
            { no: 64, name: "changeUsername", kind: "message", oneof: "input", T: () => ChangeUsernameInput },
            { no: 65, name: "updateProfile", kind: "message", oneof: "input", T: () => UpdateProfileInput },
            { no: 66, name: "getSpaceUrlPreviewExclusions", kind: "message", oneof: "input", T: () => GetSpaceUrlPreviewExclusionsInput },
            { no: 67, name: "addSpaceUrlPreviewExclusion", kind: "message", oneof: "input", T: () => AddSpaceUrlPreviewExclusionInput },
            { no: 68, name: "removeSpaceUrlPreviewExclusion", kind: "message", oneof: "input", T: () => RemoveSpaceUrlPreviewExclusionInput },
            { no: 69, name: "getUserGroups", kind: "message", oneof: "input", T: () => GetUserGroupsInput },
            { no: 70, name: "createUserGroup", kind: "message", oneof: "input", T: () => CreateUserGroupInput },
            { no: 71, name: "updateUserGroup", kind: "message", oneof: "input", T: () => UpdateUserGroupInput },
            { no: 72, name: "deleteUserGroup", kind: "message", oneof: "input", T: () => DeleteUserGroupInput },
            { no: 73, name: "getSpaceSettings", kind: "message", oneof: "input", T: () => GetSpaceSettingsInput },
            { no: 74, name: "toggleSpaceGrid", kind: "message", oneof: "input", T: () => ToggleSpaceGridInput },
            { no: 75, name: "getThreadReferences", kind: "message", oneof: "input", T: () => GetThreadReferencesInput },
            { no: 76, name: "getThreadSubthreads", kind: "message", oneof: "input", T: () => GetThreadSubthreadsInput },
            { no: 77, name: "getPeerBots", kind: "message", oneof: "input", T: () => GetPeerBotsInput },
            { no: 78, name: "getMyBotCapabilities", kind: "message", oneof: "input", T: () => GetMyBotCapabilitiesInput },
            { no: 79, name: "setMyBotCapabilities", kind: "message", oneof: "input", T: () => SetMyBotCapabilitiesInput },
            { no: 80, name: "requestBotChatSettings", kind: "message", oneof: "input", T: () => RequestBotChatSettingsInput },
            { no: 81, name: "invokeBotChatSettingsItem", kind: "message", oneof: "input", T: () => InvokeBotChatSettingsItemInput },
            { no: 82, name: "answerBotChatSettings", kind: "message", oneof: "input", T: () => AnswerBotChatSettingsInput },
            { no: 84, name: "getGrid", kind: "message", oneof: "input", T: () => GetGridInput },
            { no: 85, name: "createGridRoom", kind: "message", oneof: "input", T: () => CreateGridRoomInput },
            { no: 86, name: "joinGridRoom", kind: "message", oneof: "input", T: () => JoinGridRoomInput },
            { no: 87, name: "leaveGridRoom", kind: "message", oneof: "input", T: () => LeaveGridRoomInput },
            { no: 88, name: "setGridRoomTitle", kind: "message", oneof: "input", T: () => SetGridRoomTitleInput },
            { no: 89, name: "setGridRoomLocked", kind: "message", oneof: "input", T: () => SetGridRoomLockedInput },
            { no: 90, name: "deleteGridRoom", kind: "message", oneof: "input", T: () => DeleteGridRoomInput },
            { no: 91, name: "prepareGridConnection", kind: "message", oneof: "input", T: () => PrepareGridConnectionInput },
            { no: 92, name: "setGridAvatarMicrophoneEnabled", kind: "message", oneof: "input", T: () => SetGridAvatarMicrophoneEnabledInput },
            { no: 93, name: "getGridHome", kind: "message", oneof: "input", T: () => GetGridHomeInput },
            { no: 94, name: "createCliSession", kind: "message", oneof: "input", T: () => CreateCliSessionInput },
            { no: 95, name: "setProfilePhoto", kind: "message", oneof: "input", T: () => SetProfilePhotoInput },
            { no: 96, name: "getExternalProfilePhoto", kind: "message", oneof: "input", T: () => GetExternalProfilePhotoInput },
            { no: 97, name: "getChatTranscript", kind: "message", oneof: "input", T: () => GetChatTranscriptInput },
            { no: 98, name: "searchExternalResources", kind: "message", oneof: "input", T: () => SearchExternalResourcesInput },
            { no: 99, name: "joinPublicSpace", kind: "message", oneof: "input", T: () => JoinPublicSpaceInput },
            { no: 100, name: "collapseHistory", kind: "message", oneof: "input", T: () => CollapseHistoryInput },
            { no: 101, name: "listConnectors", kind: "message", oneof: "input", T: () => ListConnectorsInput },
            { no: 102, name: "prepareConnectorOAuth", kind: "message", oneof: "input", T: () => PrepareConnectorOAuthInput },
            { no: 103, name: "disconnectConnector", kind: "message", oneof: "input", T: () => DisconnectConnectorInput },
            { no: 104, name: "searchUsers", kind: "message", oneof: "input", T: () => SearchUsersInput },
            { no: 105, name: "inviteToInline", kind: "message", oneof: "input", T: () => InviteToInlineInput },
            { no: 106, name: "resolveUrlPreview", kind: "message", oneof: "input", T: () => ResolveUrlPreviewInput },
            { no: 107, name: "createBotAgent", kind: "message", oneof: "input", T: () => CreateBotAgentInput },
            { no: 108, name: "getBotAgent", kind: "message", oneof: "input", T: () => GetBotAgentInput },
            { no: 109, name: "listBotAgents", kind: "message", oneof: "input", T: () => ListBotAgentsInput },
            { no: 110, name: "createSpace", kind: "message", oneof: "input", T: () => CreateSpaceInput },
            { no: 111, name: "deleteSpace", kind: "message", oneof: "input", T: () => DeleteSpaceInput },
            { no: 112, name: "leaveSpace", kind: "message", oneof: "input", T: () => LeaveSpaceInput },
            { no: 113, name: "getConnectorConfig", kind: "message", oneof: "input", T: () => GetConnectorConfigInput },
            { no: 114, name: "setConnectorConfig", kind: "message", oneof: "input", T: () => SetConnectorConfigInput },
            { no: 115, name: "createExternalTask", kind: "message", oneof: "input", T: () => CreateExternalTaskInput },
            { no: 116, name: "unregisterDevice", kind: "message", oneof: "input", T: () => UnregisterDeviceInput },
            { no: 117, name: "logOut", kind: "message", oneof: "input", T: () => LogOutInput },
            { no: 118, name: "createUpload", kind: "message", oneof: "input", T: () => CreateUploadInput },
            { no: 119, name: "saveUploadPart", kind: "message", oneof: "input", T: () => SaveUploadPartInput },
            { no: 120, name: "getUploadState", kind: "message", oneof: "input", T: () => GetUploadStateInput },
            { no: 121, name: "finishUpload", kind: "message", oneof: "input", T: () => FinishUploadInput },
            { no: 122, name: "cancelUpload", kind: "message", oneof: "input", T: () => CancelUploadInput },
            { no: 123, name: "updateSession", kind: "message", oneof: "input", T: () => UpdateSessionInput },
            { no: 124, name: "updateDialogArchived", kind: "message", oneof: "input", T: () => UpdateDialogArchivedInput },
            { no: 125, name: "createDialogFolder", kind: "message", oneof: "input", T: () => CreateDialogFolderInput },
            { no: 126, name: "updateDialogFolder", kind: "message", oneof: "input", T: () => UpdateDialogFolderInput },
            { no: 127, name: "deleteDialogFolder", kind: "message", oneof: "input", T: () => DeleteDialogFolderInput },
            { no: 128, name: "getSpace", kind: "message", oneof: "input", T: () => GetSpaceInput },
            { no: 129, name: "connectAgentSession", kind: "message", oneof: "input", T: () => ConnectAgentSessionInput },
            { no: 130, name: "syncAgentSessionMessages", kind: "message", oneof: "input", T: () => SyncAgentSessionMessagesInput },
            { no: 131, name: "getAgentSession", kind: "message", oneof: "input", T: () => GetAgentSessionInput },
            { no: 132, name: "updateBotAgent", kind: "message", oneof: "input", T: () => UpdateBotAgentInput },
            { no: 133, name: "deleteBotAgent", kind: "message", oneof: "input", T: () => DeleteBotAgentInput },
            { no: 134, name: "joinSpaceByInviteToken", kind: "message", oneof: "input", T: () => JoinSpaceByInviteTokenInput },
            { no: 135, name: "getSpaceInviteLink", kind: "message", oneof: "input", T: () => GetSpaceInviteLinkInput },
            { no: 136, name: "setSpaceInviteLinkEnabled", kind: "message", oneof: "input", T: () => SetSpaceInviteLinkEnabledInput },
            { no: 137, name: "getFilePart", kind: "message", oneof: "input", T: () => GetFilePartInput },
            { no: 138, name: "acknowledgeMessages", kind: "message", oneof: "input", T: () => AcknowledgeMessagesInput },
            { no: 139, name: "getUsers", kind: "message", oneof: "input", T: () => GetUsersInput },
            { no: 140, name: "getBotSkills", kind: "message", oneof: "input", T: () => GetBotSkillsInput },
            { no: 141, name: "getBotConfigurationCatalog", kind: "message", oneof: "input", T: () => GetBotConfigurationCatalogInput }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.method = 0;
        message.input = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Method method */ 1:
                    message.method = reader.int32();
                    break;
                case /* GetMeInput getMe */ 2:
                    message.input = {
                        oneofKind: "getMe",
                        getMe: GetMeInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getMe)
                    };
                    break;
                case /* GetPeerPhotoInput getPeerPhoto */ 3:
                    message.input = {
                        oneofKind: "getPeerPhoto",
                        getPeerPhoto: GetPeerPhotoInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getPeerPhoto)
                    };
                    break;
                case /* DeleteMessagesInput deleteMessages */ 4:
                    message.input = {
                        oneofKind: "deleteMessages",
                        deleteMessages: DeleteMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteMessages)
                    };
                    break;
                case /* SendMessageInput sendMessage */ 5:
                    message.input = {
                        oneofKind: "sendMessage",
                        sendMessage: SendMessageInput.internalBinaryRead(reader, reader.uint32(), options, message.input.sendMessage)
                    };
                    break;
                case /* GetChatHistoryInput getChatHistory */ 6:
                    message.input = {
                        oneofKind: "getChatHistory",
                        getChatHistory: GetChatHistoryInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getChatHistory)
                    };
                    break;
                case /* AddReactionInput addReaction */ 7:
                    message.input = {
                        oneofKind: "addReaction",
                        addReaction: AddReactionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.addReaction)
                    };
                    break;
                case /* DeleteReactionInput deleteReaction */ 8:
                    message.input = {
                        oneofKind: "deleteReaction",
                        deleteReaction: DeleteReactionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteReaction)
                    };
                    break;
                case /* EditMessageInput editMessage */ 9:
                    message.input = {
                        oneofKind: "editMessage",
                        editMessage: EditMessageInput.internalBinaryRead(reader, reader.uint32(), options, message.input.editMessage)
                    };
                    break;
                case /* CreateChatInput createChat */ 10:
                    message.input = {
                        oneofKind: "createChat",
                        createChat: CreateChatInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createChat)
                    };
                    break;
                case /* GetSpaceMembersInput getSpaceMembers */ 11:
                    message.input = {
                        oneofKind: "getSpaceMembers",
                        getSpaceMembers: GetSpaceMembersInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getSpaceMembers)
                    };
                    break;
                case /* DeleteChatInput deleteChat */ 12:
                    message.input = {
                        oneofKind: "deleteChat",
                        deleteChat: DeleteChatInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteChat)
                    };
                    break;
                case /* InviteToSpaceInput inviteToSpace */ 13:
                    message.input = {
                        oneofKind: "inviteToSpace",
                        inviteToSpace: InviteToSpaceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.inviteToSpace)
                    };
                    break;
                case /* GetChatParticipantsInput getChatParticipants */ 14:
                    message.input = {
                        oneofKind: "getChatParticipants",
                        getChatParticipants: GetChatParticipantsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getChatParticipants)
                    };
                    break;
                case /* AddChatParticipantInput addChatParticipant */ 15:
                    message.input = {
                        oneofKind: "addChatParticipant",
                        addChatParticipant: AddChatParticipantInput.internalBinaryRead(reader, reader.uint32(), options, message.input.addChatParticipant)
                    };
                    break;
                case /* RemoveChatParticipantInput removeChatParticipant */ 16:
                    message.input = {
                        oneofKind: "removeChatParticipant",
                        removeChatParticipant: RemoveChatParticipantInput.internalBinaryRead(reader, reader.uint32(), options, message.input.removeChatParticipant)
                    };
                    break;
                case /* TranslateMessagesInput translateMessages */ 17:
                    message.input = {
                        oneofKind: "translateMessages",
                        translateMessages: TranslateMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.translateMessages)
                    };
                    break;
                case /* GetChatsInput getChats */ 18:
                    message.input = {
                        oneofKind: "getChats",
                        getChats: GetChatsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getChats)
                    };
                    break;
                case /* UpdateUserSettingsInput updateUserSettings */ 19:
                    message.input = {
                        oneofKind: "updateUserSettings",
                        updateUserSettings: UpdateUserSettingsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateUserSettings)
                    };
                    break;
                case /* GetUserSettingsInput getUserSettings */ 20:
                    message.input = {
                        oneofKind: "getUserSettings",
                        getUserSettings: GetUserSettingsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getUserSettings)
                    };
                    break;
                case /* SendComposeActionInput sendComposeAction */ 21:
                    message.input = {
                        oneofKind: "sendComposeAction",
                        sendComposeAction: SendComposeActionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.sendComposeAction)
                    };
                    break;
                case /* CreateBotInput createBot */ 22:
                    message.input = {
                        oneofKind: "createBot",
                        createBot: CreateBotInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createBot)
                    };
                    break;
                case /* DeleteMemberInput deleteMember */ 23:
                    message.input = {
                        oneofKind: "deleteMember",
                        deleteMember: DeleteMemberInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteMember)
                    };
                    break;
                case /* MarkAsUnreadInput markAsUnread */ 24:
                    message.input = {
                        oneofKind: "markAsUnread",
                        markAsUnread: MarkAsUnreadInput.internalBinaryRead(reader, reader.uint32(), options, message.input.markAsUnread)
                    };
                    break;
                case /* GetUpdatesStateInput getUpdatesState */ 25:
                    message.input = {
                        oneofKind: "getUpdatesState",
                        getUpdatesState: GetUpdatesStateInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getUpdatesState)
                    };
                    break;
                case /* GetChatInput getChat */ 26:
                    message.input = {
                        oneofKind: "getChat",
                        getChat: GetChatInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getChat)
                    };
                    break;
                case /* GetUpdatesInput getUpdates */ 27:
                    message.input = {
                        oneofKind: "getUpdates",
                        getUpdates: GetUpdatesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getUpdates)
                    };
                    break;
                case /* UpdateMemberAccessInput updateMemberAccess */ 28:
                    message.input = {
                        oneofKind: "updateMemberAccess",
                        updateMemberAccess: UpdateMemberAccessInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateMemberAccess)
                    };
                    break;
                case /* SearchMessagesInput searchMessages */ 29:
                    message.input = {
                        oneofKind: "searchMessages",
                        searchMessages: SearchMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.searchMessages)
                    };
                    break;
                case /* ForwardMessagesInput forwardMessages */ 30:
                    message.input = {
                        oneofKind: "forwardMessages",
                        forwardMessages: ForwardMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.forwardMessages)
                    };
                    break;
                case /* UpdateChatVisibilityInput updateChatVisibility */ 31:
                    message.input = {
                        oneofKind: "updateChatVisibility",
                        updateChatVisibility: UpdateChatVisibilityInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateChatVisibility)
                    };
                    break;
                case /* PinMessageInput pinMessage */ 32:
                    message.input = {
                        oneofKind: "pinMessage",
                        pinMessage: PinMessageInput.internalBinaryRead(reader, reader.uint32(), options, message.input.pinMessage)
                    };
                    break;
                case /* UpdateChatInfoInput updateChatInfo */ 33:
                    message.input = {
                        oneofKind: "updateChatInfo",
                        updateChatInfo: UpdateChatInfoInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateChatInfo)
                    };
                    break;
                case /* ListBotsInput listBots */ 34:
                    message.input = {
                        oneofKind: "listBots",
                        listBots: ListBotsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.listBots)
                    };
                    break;
                case /* RevealBotTokenInput revealBotToken */ 35:
                    message.input = {
                        oneofKind: "revealBotToken",
                        revealBotToken: RevealBotTokenInput.internalBinaryRead(reader, reader.uint32(), options, message.input.revealBotToken)
                    };
                    break;
                case /* MoveThreadInput moveThread */ 36:
                    message.input = {
                        oneofKind: "moveThread",
                        moveThread: MoveThreadInput.internalBinaryRead(reader, reader.uint32(), options, message.input.moveThread)
                    };
                    break;
                case /* RotateBotTokenInput rotateBotToken */ 37:
                    message.input = {
                        oneofKind: "rotateBotToken",
                        rotateBotToken: RotateBotTokenInput.internalBinaryRead(reader, reader.uint32(), options, message.input.rotateBotToken)
                    };
                    break;
                case /* UpdateBotProfileInput updateBotProfile */ 38:
                    message.input = {
                        oneofKind: "updateBotProfile",
                        updateBotProfile: UpdateBotProfileInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateBotProfile)
                    };
                    break;
                case /* GetMessagesInput getMessages */ 39:
                    message.input = {
                        oneofKind: "getMessages",
                        getMessages: GetMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getMessages)
                    };
                    break;
                case /* UpdateDialogNotificationSettingsInput updateDialogNotificationSettings */ 40:
                    message.input = {
                        oneofKind: "updateDialogNotificationSettings",
                        updateDialogNotificationSettings: UpdateDialogNotificationSettingsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateDialogNotificationSettings)
                    };
                    break;
                case /* ReadMessagesInput readMessages */ 41:
                    message.input = {
                        oneofKind: "readMessages",
                        readMessages: ReadMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.readMessages)
                    };
                    break;
                case /* RegisterDeviceInput registerDevice */ 42:
                    message.input = {
                        oneofKind: "registerDevice",
                        registerDevice: RegisterDeviceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.registerDevice)
                    };
                    break;
                case /* CreateSubthreadInput createSubthread */ 43:
                    message.input = {
                        oneofKind: "createSubthread",
                        createSubthread: CreateSubthreadInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createSubthread)
                    };
                    break;
                case /* GetBotCommandsInput getBotCommands */ 44:
                    message.input = {
                        oneofKind: "getBotCommands",
                        getBotCommands: GetBotCommandsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getBotCommands)
                    };
                    break;
                case /* SetBotCommandsInput setBotCommands */ 45:
                    message.input = {
                        oneofKind: "setBotCommands",
                        setBotCommands: SetBotCommandsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setBotCommands)
                    };
                    break;
                case /* GetPeerBotCommandsInput getPeerBotCommands */ 46:
                    message.input = {
                        oneofKind: "getPeerBotCommands",
                        getPeerBotCommands: GetPeerBotCommandsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getPeerBotCommands)
                    };
                    break;
                case /* ShowInChatListInput showInChatList */ 47:
                    message.input = {
                        oneofKind: "showInChatList",
                        showInChatList: ShowInChatListInput.internalBinaryRead(reader, reader.uint32(), options, message.input.showInChatList)
                    };
                    break;
                case /* ReserveChatIdsInput reserveChatIds */ 48:
                    message.input = {
                        oneofKind: "reserveChatIds",
                        reserveChatIds: ReserveChatIdsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.reserveChatIds)
                    };
                    break;
                case /* InvokeMessageActionInput invokeMessageAction */ 49:
                    message.input = {
                        oneofKind: "invokeMessageAction",
                        invokeMessageAction: InvokeMessageActionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.invokeMessageAction)
                    };
                    break;
                case /* AnswerMessageActionInput answerMessageAction */ 50:
                    message.input = {
                        oneofKind: "answerMessageAction",
                        answerMessageAction: AnswerMessageActionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.answerMessageAction)
                    };
                    break;
                case /* RevokeSessionInput revokeSession */ 51:
                    message.input = {
                        oneofKind: "revokeSession",
                        revokeSession: RevokeSessionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.revokeSession)
                    };
                    break;
                case /* UpdateDialogOpenInput updateDialogOpen */ 52:
                    message.input = {
                        oneofKind: "updateDialogOpen",
                        updateDialogOpen: UpdateDialogOpenInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateDialogOpen)
                    };
                    break;
                case /* UpdateDialogOrderInput updateDialogOrder */ 53:
                    message.input = {
                        oneofKind: "updateDialogOrder",
                        updateDialogOrder: UpdateDialogOrderInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateDialogOrder)
                    };
                    break;
                case /* ClearChatHistoryInput clearChatHistory */ 54:
                    message.input = {
                        oneofKind: "clearChatHistory",
                        clearChatHistory: ClearChatHistoryInput.internalBinaryRead(reader, reader.uint32(), options, message.input.clearChatHistory)
                    };
                    break;
                case /* DeleteBotInput deleteBot */ 55:
                    message.input = {
                        oneofKind: "deleteBot",
                        deleteBot: DeleteBotInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteBot)
                    };
                    break;
                case /* DeleteMessageAttachmentInput deleteMessageAttachment */ 56:
                    message.input = {
                        oneofKind: "deleteMessageAttachment",
                        deleteMessageAttachment: DeleteMessageAttachmentInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteMessageAttachment)
                    };
                    break;
                case /* SetBotAvatarInput setBotAvatar */ 57:
                    message.input = {
                        oneofKind: "setBotAvatar",
                        setBotAvatar: SetBotAvatarInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setBotAvatar)
                    };
                    break;
                case /* ClearBotAvatarInput clearBotAvatar */ 58:
                    message.input = {
                        oneofKind: "clearBotAvatar",
                        clearBotAvatar: ClearBotAvatarInput.internalBinaryRead(reader, reader.uint32(), options, message.input.clearBotAvatar)
                    };
                    break;
                case /* GetBotPresenceInput getBotPresence */ 59:
                    message.input = {
                        oneofKind: "getBotPresence",
                        getBotPresence: GetBotPresenceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getBotPresence)
                    };
                    break;
                case /* SetBotPresenceStateInput setBotPresenceState */ 60:
                    message.input = {
                        oneofKind: "setBotPresenceState",
                        setBotPresenceState: SetBotPresenceStateInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setBotPresenceState)
                    };
                    break;
                case /* UpdateDialogFollowModeInput updateDialogFollowMode */ 61:
                    message.input = {
                        oneofKind: "updateDialogFollowMode",
                        updateDialogFollowMode: UpdateDialogFollowModeInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateDialogFollowMode)
                    };
                    break;
                case /* GetSessionsInput getSessions */ 62:
                    message.input = {
                        oneofKind: "getSessions",
                        getSessions: GetSessionsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getSessions)
                    };
                    break;
                case /* CheckUsernameInput checkUsername */ 63:
                    message.input = {
                        oneofKind: "checkUsername",
                        checkUsername: CheckUsernameInput.internalBinaryRead(reader, reader.uint32(), options, message.input.checkUsername)
                    };
                    break;
                case /* ChangeUsernameInput changeUsername */ 64:
                    message.input = {
                        oneofKind: "changeUsername",
                        changeUsername: ChangeUsernameInput.internalBinaryRead(reader, reader.uint32(), options, message.input.changeUsername)
                    };
                    break;
                case /* UpdateProfileInput updateProfile */ 65:
                    message.input = {
                        oneofKind: "updateProfile",
                        updateProfile: UpdateProfileInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateProfile)
                    };
                    break;
                case /* GetSpaceUrlPreviewExclusionsInput getSpaceUrlPreviewExclusions */ 66:
                    message.input = {
                        oneofKind: "getSpaceUrlPreviewExclusions",
                        getSpaceUrlPreviewExclusions: GetSpaceUrlPreviewExclusionsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getSpaceUrlPreviewExclusions)
                    };
                    break;
                case /* AddSpaceUrlPreviewExclusionInput addSpaceUrlPreviewExclusion */ 67:
                    message.input = {
                        oneofKind: "addSpaceUrlPreviewExclusion",
                        addSpaceUrlPreviewExclusion: AddSpaceUrlPreviewExclusionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.addSpaceUrlPreviewExclusion)
                    };
                    break;
                case /* RemoveSpaceUrlPreviewExclusionInput removeSpaceUrlPreviewExclusion */ 68:
                    message.input = {
                        oneofKind: "removeSpaceUrlPreviewExclusion",
                        removeSpaceUrlPreviewExclusion: RemoveSpaceUrlPreviewExclusionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.removeSpaceUrlPreviewExclusion)
                    };
                    break;
                case /* GetUserGroupsInput getUserGroups */ 69:
                    message.input = {
                        oneofKind: "getUserGroups",
                        getUserGroups: GetUserGroupsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getUserGroups)
                    };
                    break;
                case /* CreateUserGroupInput createUserGroup */ 70:
                    message.input = {
                        oneofKind: "createUserGroup",
                        createUserGroup: CreateUserGroupInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createUserGroup)
                    };
                    break;
                case /* UpdateUserGroupInput updateUserGroup */ 71:
                    message.input = {
                        oneofKind: "updateUserGroup",
                        updateUserGroup: UpdateUserGroupInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateUserGroup)
                    };
                    break;
                case /* DeleteUserGroupInput deleteUserGroup */ 72:
                    message.input = {
                        oneofKind: "deleteUserGroup",
                        deleteUserGroup: DeleteUserGroupInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteUserGroup)
                    };
                    break;
                case /* GetSpaceSettingsInput getSpaceSettings */ 73:
                    message.input = {
                        oneofKind: "getSpaceSettings",
                        getSpaceSettings: GetSpaceSettingsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getSpaceSettings)
                    };
                    break;
                case /* ToggleSpaceGridInput toggleSpaceGrid */ 74:
                    message.input = {
                        oneofKind: "toggleSpaceGrid",
                        toggleSpaceGrid: ToggleSpaceGridInput.internalBinaryRead(reader, reader.uint32(), options, message.input.toggleSpaceGrid)
                    };
                    break;
                case /* GetThreadReferencesInput getThreadReferences */ 75:
                    message.input = {
                        oneofKind: "getThreadReferences",
                        getThreadReferences: GetThreadReferencesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getThreadReferences)
                    };
                    break;
                case /* GetThreadSubthreadsInput getThreadSubthreads */ 76:
                    message.input = {
                        oneofKind: "getThreadSubthreads",
                        getThreadSubthreads: GetThreadSubthreadsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getThreadSubthreads)
                    };
                    break;
                case /* GetPeerBotsInput getPeerBots */ 77:
                    message.input = {
                        oneofKind: "getPeerBots",
                        getPeerBots: GetPeerBotsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getPeerBots)
                    };
                    break;
                case /* GetMyBotCapabilitiesInput getMyBotCapabilities */ 78:
                    message.input = {
                        oneofKind: "getMyBotCapabilities",
                        getMyBotCapabilities: GetMyBotCapabilitiesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getMyBotCapabilities)
                    };
                    break;
                case /* SetMyBotCapabilitiesInput setMyBotCapabilities */ 79:
                    message.input = {
                        oneofKind: "setMyBotCapabilities",
                        setMyBotCapabilities: SetMyBotCapabilitiesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setMyBotCapabilities)
                    };
                    break;
                case /* RequestBotChatSettingsInput requestBotChatSettings */ 80:
                    message.input = {
                        oneofKind: "requestBotChatSettings",
                        requestBotChatSettings: RequestBotChatSettingsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.requestBotChatSettings)
                    };
                    break;
                case /* InvokeBotChatSettingsItemInput invokeBotChatSettingsItem */ 81:
                    message.input = {
                        oneofKind: "invokeBotChatSettingsItem",
                        invokeBotChatSettingsItem: InvokeBotChatSettingsItemInput.internalBinaryRead(reader, reader.uint32(), options, message.input.invokeBotChatSettingsItem)
                    };
                    break;
                case /* AnswerBotChatSettingsInput answerBotChatSettings */ 82:
                    message.input = {
                        oneofKind: "answerBotChatSettings",
                        answerBotChatSettings: AnswerBotChatSettingsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.answerBotChatSettings)
                    };
                    break;
                case /* GetGridInput getGrid */ 84:
                    message.input = {
                        oneofKind: "getGrid",
                        getGrid: GetGridInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getGrid)
                    };
                    break;
                case /* CreateGridRoomInput createGridRoom */ 85:
                    message.input = {
                        oneofKind: "createGridRoom",
                        createGridRoom: CreateGridRoomInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createGridRoom)
                    };
                    break;
                case /* JoinGridRoomInput joinGridRoom */ 86:
                    message.input = {
                        oneofKind: "joinGridRoom",
                        joinGridRoom: JoinGridRoomInput.internalBinaryRead(reader, reader.uint32(), options, message.input.joinGridRoom)
                    };
                    break;
                case /* LeaveGridRoomInput leaveGridRoom */ 87:
                    message.input = {
                        oneofKind: "leaveGridRoom",
                        leaveGridRoom: LeaveGridRoomInput.internalBinaryRead(reader, reader.uint32(), options, message.input.leaveGridRoom)
                    };
                    break;
                case /* SetGridRoomTitleInput setGridRoomTitle */ 88:
                    message.input = {
                        oneofKind: "setGridRoomTitle",
                        setGridRoomTitle: SetGridRoomTitleInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setGridRoomTitle)
                    };
                    break;
                case /* SetGridRoomLockedInput setGridRoomLocked */ 89:
                    message.input = {
                        oneofKind: "setGridRoomLocked",
                        setGridRoomLocked: SetGridRoomLockedInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setGridRoomLocked)
                    };
                    break;
                case /* DeleteGridRoomInput deleteGridRoom */ 90:
                    message.input = {
                        oneofKind: "deleteGridRoom",
                        deleteGridRoom: DeleteGridRoomInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteGridRoom)
                    };
                    break;
                case /* PrepareGridConnectionInput prepareGridConnection */ 91:
                    message.input = {
                        oneofKind: "prepareGridConnection",
                        prepareGridConnection: PrepareGridConnectionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.prepareGridConnection)
                    };
                    break;
                case /* SetGridAvatarMicrophoneEnabledInput setGridAvatarMicrophoneEnabled */ 92:
                    message.input = {
                        oneofKind: "setGridAvatarMicrophoneEnabled",
                        setGridAvatarMicrophoneEnabled: SetGridAvatarMicrophoneEnabledInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setGridAvatarMicrophoneEnabled)
                    };
                    break;
                case /* GetGridHomeInput getGridHome */ 93:
                    message.input = {
                        oneofKind: "getGridHome",
                        getGridHome: GetGridHomeInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getGridHome)
                    };
                    break;
                case /* CreateCliSessionInput createCliSession */ 94:
                    message.input = {
                        oneofKind: "createCliSession",
                        createCliSession: CreateCliSessionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createCliSession)
                    };
                    break;
                case /* SetProfilePhotoInput setProfilePhoto */ 95:
                    message.input = {
                        oneofKind: "setProfilePhoto",
                        setProfilePhoto: SetProfilePhotoInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setProfilePhoto)
                    };
                    break;
                case /* GetExternalProfilePhotoInput getExternalProfilePhoto */ 96:
                    message.input = {
                        oneofKind: "getExternalProfilePhoto",
                        getExternalProfilePhoto: GetExternalProfilePhotoInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getExternalProfilePhoto)
                    };
                    break;
                case /* GetChatTranscriptInput getChatTranscript */ 97:
                    message.input = {
                        oneofKind: "getChatTranscript",
                        getChatTranscript: GetChatTranscriptInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getChatTranscript)
                    };
                    break;
                case /* SearchExternalResourcesInput searchExternalResources */ 98:
                    message.input = {
                        oneofKind: "searchExternalResources",
                        searchExternalResources: SearchExternalResourcesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.searchExternalResources)
                    };
                    break;
                case /* JoinPublicSpaceInput joinPublicSpace */ 99:
                    message.input = {
                        oneofKind: "joinPublicSpace",
                        joinPublicSpace: JoinPublicSpaceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.joinPublicSpace)
                    };
                    break;
                case /* CollapseHistoryInput collapseHistory */ 100:
                    message.input = {
                        oneofKind: "collapseHistory",
                        collapseHistory: CollapseHistoryInput.internalBinaryRead(reader, reader.uint32(), options, message.input.collapseHistory)
                    };
                    break;
                case /* ListConnectorsInput listConnectors */ 101:
                    message.input = {
                        oneofKind: "listConnectors",
                        listConnectors: ListConnectorsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.listConnectors)
                    };
                    break;
                case /* PrepareConnectorOAuthInput prepareConnectorOAuth */ 102:
                    message.input = {
                        oneofKind: "prepareConnectorOAuth",
                        prepareConnectorOAuth: PrepareConnectorOAuthInput.internalBinaryRead(reader, reader.uint32(), options, message.input.prepareConnectorOAuth)
                    };
                    break;
                case /* DisconnectConnectorInput disconnectConnector */ 103:
                    message.input = {
                        oneofKind: "disconnectConnector",
                        disconnectConnector: DisconnectConnectorInput.internalBinaryRead(reader, reader.uint32(), options, message.input.disconnectConnector)
                    };
                    break;
                case /* SearchUsersInput searchUsers */ 104:
                    message.input = {
                        oneofKind: "searchUsers",
                        searchUsers: SearchUsersInput.internalBinaryRead(reader, reader.uint32(), options, message.input.searchUsers)
                    };
                    break;
                case /* InviteToInlineInput inviteToInline */ 105:
                    message.input = {
                        oneofKind: "inviteToInline",
                        inviteToInline: InviteToInlineInput.internalBinaryRead(reader, reader.uint32(), options, message.input.inviteToInline)
                    };
                    break;
                case /* ResolveUrlPreviewInput resolveUrlPreview */ 106:
                    message.input = {
                        oneofKind: "resolveUrlPreview",
                        resolveUrlPreview: ResolveUrlPreviewInput.internalBinaryRead(reader, reader.uint32(), options, message.input.resolveUrlPreview)
                    };
                    break;
                case /* CreateBotAgentInput createBotAgent */ 107:
                    message.input = {
                        oneofKind: "createBotAgent",
                        createBotAgent: CreateBotAgentInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createBotAgent)
                    };
                    break;
                case /* GetBotAgentInput getBotAgent */ 108:
                    message.input = {
                        oneofKind: "getBotAgent",
                        getBotAgent: GetBotAgentInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getBotAgent)
                    };
                    break;
                case /* ListBotAgentsInput listBotAgents */ 109:
                    message.input = {
                        oneofKind: "listBotAgents",
                        listBotAgents: ListBotAgentsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.listBotAgents)
                    };
                    break;
                case /* CreateSpaceInput createSpace */ 110:
                    message.input = {
                        oneofKind: "createSpace",
                        createSpace: CreateSpaceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createSpace)
                    };
                    break;
                case /* DeleteSpaceInput deleteSpace */ 111:
                    message.input = {
                        oneofKind: "deleteSpace",
                        deleteSpace: DeleteSpaceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteSpace)
                    };
                    break;
                case /* LeaveSpaceInput leaveSpace */ 112:
                    message.input = {
                        oneofKind: "leaveSpace",
                        leaveSpace: LeaveSpaceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.leaveSpace)
                    };
                    break;
                case /* GetConnectorConfigInput getConnectorConfig */ 113:
                    message.input = {
                        oneofKind: "getConnectorConfig",
                        getConnectorConfig: GetConnectorConfigInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getConnectorConfig)
                    };
                    break;
                case /* SetConnectorConfigInput setConnectorConfig */ 114:
                    message.input = {
                        oneofKind: "setConnectorConfig",
                        setConnectorConfig: SetConnectorConfigInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setConnectorConfig)
                    };
                    break;
                case /* CreateExternalTaskInput createExternalTask */ 115:
                    message.input = {
                        oneofKind: "createExternalTask",
                        createExternalTask: CreateExternalTaskInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createExternalTask)
                    };
                    break;
                case /* UnregisterDeviceInput unregisterDevice */ 116:
                    message.input = {
                        oneofKind: "unregisterDevice",
                        unregisterDevice: UnregisterDeviceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.unregisterDevice)
                    };
                    break;
                case /* LogOutInput logOut */ 117:
                    message.input = {
                        oneofKind: "logOut",
                        logOut: LogOutInput.internalBinaryRead(reader, reader.uint32(), options, message.input.logOut)
                    };
                    break;
                case /* CreateUploadInput createUpload */ 118:
                    message.input = {
                        oneofKind: "createUpload",
                        createUpload: CreateUploadInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createUpload)
                    };
                    break;
                case /* SaveUploadPartInput saveUploadPart */ 119:
                    message.input = {
                        oneofKind: "saveUploadPart",
                        saveUploadPart: SaveUploadPartInput.internalBinaryRead(reader, reader.uint32(), options, message.input.saveUploadPart)
                    };
                    break;
                case /* GetUploadStateInput getUploadState */ 120:
                    message.input = {
                        oneofKind: "getUploadState",
                        getUploadState: GetUploadStateInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getUploadState)
                    };
                    break;
                case /* FinishUploadInput finishUpload */ 121:
                    message.input = {
                        oneofKind: "finishUpload",
                        finishUpload: FinishUploadInput.internalBinaryRead(reader, reader.uint32(), options, message.input.finishUpload)
                    };
                    break;
                case /* CancelUploadInput cancelUpload */ 122:
                    message.input = {
                        oneofKind: "cancelUpload",
                        cancelUpload: CancelUploadInput.internalBinaryRead(reader, reader.uint32(), options, message.input.cancelUpload)
                    };
                    break;
                case /* UpdateSessionInput updateSession */ 123:
                    message.input = {
                        oneofKind: "updateSession",
                        updateSession: UpdateSessionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateSession)
                    };
                    break;
                case /* UpdateDialogArchivedInput updateDialogArchived */ 124:
                    message.input = {
                        oneofKind: "updateDialogArchived",
                        updateDialogArchived: UpdateDialogArchivedInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateDialogArchived)
                    };
                    break;
                case /* CreateDialogFolderInput createDialogFolder */ 125:
                    message.input = {
                        oneofKind: "createDialogFolder",
                        createDialogFolder: CreateDialogFolderInput.internalBinaryRead(reader, reader.uint32(), options, message.input.createDialogFolder)
                    };
                    break;
                case /* UpdateDialogFolderInput updateDialogFolder */ 126:
                    message.input = {
                        oneofKind: "updateDialogFolder",
                        updateDialogFolder: UpdateDialogFolderInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateDialogFolder)
                    };
                    break;
                case /* DeleteDialogFolderInput deleteDialogFolder */ 127:
                    message.input = {
                        oneofKind: "deleteDialogFolder",
                        deleteDialogFolder: DeleteDialogFolderInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteDialogFolder)
                    };
                    break;
                case /* GetSpaceInput getSpace */ 128:
                    message.input = {
                        oneofKind: "getSpace",
                        getSpace: GetSpaceInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getSpace)
                    };
                    break;
                case /* ConnectAgentSessionInput connectAgentSession */ 129:
                    message.input = {
                        oneofKind: "connectAgentSession",
                        connectAgentSession: ConnectAgentSessionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.connectAgentSession)
                    };
                    break;
                case /* SyncAgentSessionMessagesInput syncAgentSessionMessages */ 130:
                    message.input = {
                        oneofKind: "syncAgentSessionMessages",
                        syncAgentSessionMessages: SyncAgentSessionMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.syncAgentSessionMessages)
                    };
                    break;
                case /* GetAgentSessionInput getAgentSession */ 131:
                    message.input = {
                        oneofKind: "getAgentSession",
                        getAgentSession: GetAgentSessionInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getAgentSession)
                    };
                    break;
                case /* UpdateBotAgentInput updateBotAgent */ 132:
                    message.input = {
                        oneofKind: "updateBotAgent",
                        updateBotAgent: UpdateBotAgentInput.internalBinaryRead(reader, reader.uint32(), options, message.input.updateBotAgent)
                    };
                    break;
                case /* DeleteBotAgentInput deleteBotAgent */ 133:
                    message.input = {
                        oneofKind: "deleteBotAgent",
                        deleteBotAgent: DeleteBotAgentInput.internalBinaryRead(reader, reader.uint32(), options, message.input.deleteBotAgent)
                    };
                    break;
                case /* JoinSpaceByInviteTokenInput joinSpaceByInviteToken */ 134:
                    message.input = {
                        oneofKind: "joinSpaceByInviteToken",
                        joinSpaceByInviteToken: JoinSpaceByInviteTokenInput.internalBinaryRead(reader, reader.uint32(), options, message.input.joinSpaceByInviteToken)
                    };
                    break;
                case /* GetSpaceInviteLinkInput getSpaceInviteLink */ 135:
                    message.input = {
                        oneofKind: "getSpaceInviteLink",
                        getSpaceInviteLink: GetSpaceInviteLinkInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getSpaceInviteLink)
                    };
                    break;
                case /* SetSpaceInviteLinkEnabledInput setSpaceInviteLinkEnabled */ 136:
                    message.input = {
                        oneofKind: "setSpaceInviteLinkEnabled",
                        setSpaceInviteLinkEnabled: SetSpaceInviteLinkEnabledInput.internalBinaryRead(reader, reader.uint32(), options, message.input.setSpaceInviteLinkEnabled)
                    };
                    break;
                case /* GetFilePartInput getFilePart */ 137:
                    message.input = {
                        oneofKind: "getFilePart",
                        getFilePart: GetFilePartInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getFilePart)
                    };
                    break;
                case /* AcknowledgeMessagesInput acknowledgeMessages */ 138:
                    message.input = {
                        oneofKind: "acknowledgeMessages",
                        acknowledgeMessages: AcknowledgeMessagesInput.internalBinaryRead(reader, reader.uint32(), options, message.input.acknowledgeMessages)
                    };
                    break;
                case /* GetUsersInput getUsers */ 139:
                    message.input = {
                        oneofKind: "getUsers",
                        getUsers: GetUsersInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getUsers)
                    };
                    break;
                case /* GetBotSkillsInput getBotSkills */ 140:
                    message.input = {
                        oneofKind: "getBotSkills",
                        getBotSkills: GetBotSkillsInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getBotSkills)
                    };
                    break;
                case /* GetBotConfigurationCatalogInput getBotConfigurationCatalog */ 141:
                    message.input = {
                        oneofKind: "getBotConfigurationCatalog",
                        getBotConfigurationCatalog: GetBotConfigurationCatalogInput.internalBinaryRead(reader, reader.uint32(), options, message.input.getBotConfigurationCatalog)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Method method = 1; */
        if (message.method !== 0)
            writer.tag(1, WireType.Varint).int32(message.method);
        /* GetMeInput getMe = 2; */
        if (message.input.oneofKind === "getMe")
            GetMeInput.internalBinaryWrite(message.input.getMe, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* GetPeerPhotoInput getPeerPhoto = 3; */
        if (message.input.oneofKind === "getPeerPhoto")
            GetPeerPhotoInput.internalBinaryWrite(message.input.getPeerPhoto, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* DeleteMessagesInput deleteMessages = 4; */
        if (message.input.oneofKind === "deleteMessages")
            DeleteMessagesInput.internalBinaryWrite(message.input.deleteMessages, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* SendMessageInput sendMessage = 5; */
        if (message.input.oneofKind === "sendMessage")
            SendMessageInput.internalBinaryWrite(message.input.sendMessage, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* GetChatHistoryInput getChatHistory = 6; */
        if (message.input.oneofKind === "getChatHistory")
            GetChatHistoryInput.internalBinaryWrite(message.input.getChatHistory, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* AddReactionInput addReaction = 7; */
        if (message.input.oneofKind === "addReaction")
            AddReactionInput.internalBinaryWrite(message.input.addReaction, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* DeleteReactionInput deleteReaction = 8; */
        if (message.input.oneofKind === "deleteReaction")
            DeleteReactionInput.internalBinaryWrite(message.input.deleteReaction, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* EditMessageInput editMessage = 9; */
        if (message.input.oneofKind === "editMessage")
            EditMessageInput.internalBinaryWrite(message.input.editMessage, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* CreateChatInput createChat = 10; */
        if (message.input.oneofKind === "createChat")
            CreateChatInput.internalBinaryWrite(message.input.createChat, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceMembersInput getSpaceMembers = 11; */
        if (message.input.oneofKind === "getSpaceMembers")
            GetSpaceMembersInput.internalBinaryWrite(message.input.getSpaceMembers, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* DeleteChatInput deleteChat = 12; */
        if (message.input.oneofKind === "deleteChat")
            DeleteChatInput.internalBinaryWrite(message.input.deleteChat, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* InviteToSpaceInput inviteToSpace = 13; */
        if (message.input.oneofKind === "inviteToSpace")
            InviteToSpaceInput.internalBinaryWrite(message.input.inviteToSpace, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* GetChatParticipantsInput getChatParticipants = 14; */
        if (message.input.oneofKind === "getChatParticipants")
            GetChatParticipantsInput.internalBinaryWrite(message.input.getChatParticipants, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* AddChatParticipantInput addChatParticipant = 15; */
        if (message.input.oneofKind === "addChatParticipant")
            AddChatParticipantInput.internalBinaryWrite(message.input.addChatParticipant, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* RemoveChatParticipantInput removeChatParticipant = 16; */
        if (message.input.oneofKind === "removeChatParticipant")
            RemoveChatParticipantInput.internalBinaryWrite(message.input.removeChatParticipant, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* TranslateMessagesInput translateMessages = 17; */
        if (message.input.oneofKind === "translateMessages")
            TranslateMessagesInput.internalBinaryWrite(message.input.translateMessages, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* GetChatsInput getChats = 18; */
        if (message.input.oneofKind === "getChats")
            GetChatsInput.internalBinaryWrite(message.input.getChats, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserSettingsInput updateUserSettings = 19; */
        if (message.input.oneofKind === "updateUserSettings")
            UpdateUserSettingsInput.internalBinaryWrite(message.input.updateUserSettings, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* GetUserSettingsInput getUserSettings = 20; */
        if (message.input.oneofKind === "getUserSettings")
            GetUserSettingsInput.internalBinaryWrite(message.input.getUserSettings, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* SendComposeActionInput sendComposeAction = 21; */
        if (message.input.oneofKind === "sendComposeAction")
            SendComposeActionInput.internalBinaryWrite(message.input.sendComposeAction, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* CreateBotInput createBot = 22; */
        if (message.input.oneofKind === "createBot")
            CreateBotInput.internalBinaryWrite(message.input.createBot, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* DeleteMemberInput deleteMember = 23; */
        if (message.input.oneofKind === "deleteMember")
            DeleteMemberInput.internalBinaryWrite(message.input.deleteMember, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* MarkAsUnreadInput markAsUnread = 24; */
        if (message.input.oneofKind === "markAsUnread")
            MarkAsUnreadInput.internalBinaryWrite(message.input.markAsUnread, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* GetUpdatesStateInput getUpdatesState = 25; */
        if (message.input.oneofKind === "getUpdatesState")
            GetUpdatesStateInput.internalBinaryWrite(message.input.getUpdatesState, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* GetChatInput getChat = 26; */
        if (message.input.oneofKind === "getChat")
            GetChatInput.internalBinaryWrite(message.input.getChat, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* GetUpdatesInput getUpdates = 27; */
        if (message.input.oneofKind === "getUpdates")
            GetUpdatesInput.internalBinaryWrite(message.input.getUpdates, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMemberAccessInput updateMemberAccess = 28; */
        if (message.input.oneofKind === "updateMemberAccess")
            UpdateMemberAccessInput.internalBinaryWrite(message.input.updateMemberAccess, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* SearchMessagesInput searchMessages = 29; */
        if (message.input.oneofKind === "searchMessages")
            SearchMessagesInput.internalBinaryWrite(message.input.searchMessages, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* ForwardMessagesInput forwardMessages = 30; */
        if (message.input.oneofKind === "forwardMessages")
            ForwardMessagesInput.internalBinaryWrite(message.input.forwardMessages, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatVisibilityInput updateChatVisibility = 31; */
        if (message.input.oneofKind === "updateChatVisibility")
            UpdateChatVisibilityInput.internalBinaryWrite(message.input.updateChatVisibility, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* PinMessageInput pinMessage = 32; */
        if (message.input.oneofKind === "pinMessage")
            PinMessageInput.internalBinaryWrite(message.input.pinMessage, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatInfoInput updateChatInfo = 33; */
        if (message.input.oneofKind === "updateChatInfo")
            UpdateChatInfoInput.internalBinaryWrite(message.input.updateChatInfo, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* ListBotsInput listBots = 34; */
        if (message.input.oneofKind === "listBots")
            ListBotsInput.internalBinaryWrite(message.input.listBots, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* RevealBotTokenInput revealBotToken = 35; */
        if (message.input.oneofKind === "revealBotToken")
            RevealBotTokenInput.internalBinaryWrite(message.input.revealBotToken, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* MoveThreadInput moveThread = 36; */
        if (message.input.oneofKind === "moveThread")
            MoveThreadInput.internalBinaryWrite(message.input.moveThread, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* RotateBotTokenInput rotateBotToken = 37; */
        if (message.input.oneofKind === "rotateBotToken")
            RotateBotTokenInput.internalBinaryWrite(message.input.rotateBotToken, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBotProfileInput updateBotProfile = 38; */
        if (message.input.oneofKind === "updateBotProfile")
            UpdateBotProfileInput.internalBinaryWrite(message.input.updateBotProfile, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* GetMessagesInput getMessages = 39; */
        if (message.input.oneofKind === "getMessages")
            GetMessagesInput.internalBinaryWrite(message.input.getMessages, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogNotificationSettingsInput updateDialogNotificationSettings = 40; */
        if (message.input.oneofKind === "updateDialogNotificationSettings")
            UpdateDialogNotificationSettingsInput.internalBinaryWrite(message.input.updateDialogNotificationSettings, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* ReadMessagesInput readMessages = 41; */
        if (message.input.oneofKind === "readMessages")
            ReadMessagesInput.internalBinaryWrite(message.input.readMessages, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* RegisterDeviceInput registerDevice = 42; */
        if (message.input.oneofKind === "registerDevice")
            RegisterDeviceInput.internalBinaryWrite(message.input.registerDevice, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* CreateSubthreadInput createSubthread = 43; */
        if (message.input.oneofKind === "createSubthread")
            CreateSubthreadInput.internalBinaryWrite(message.input.createSubthread, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* GetBotCommandsInput getBotCommands = 44; */
        if (message.input.oneofKind === "getBotCommands")
            GetBotCommandsInput.internalBinaryWrite(message.input.getBotCommands, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* SetBotCommandsInput setBotCommands = 45; */
        if (message.input.oneofKind === "setBotCommands")
            SetBotCommandsInput.internalBinaryWrite(message.input.setBotCommands, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* GetPeerBotCommandsInput getPeerBotCommands = 46; */
        if (message.input.oneofKind === "getPeerBotCommands")
            GetPeerBotCommandsInput.internalBinaryWrite(message.input.getPeerBotCommands, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* ShowInChatListInput showInChatList = 47; */
        if (message.input.oneofKind === "showInChatList")
            ShowInChatListInput.internalBinaryWrite(message.input.showInChatList, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* ReserveChatIdsInput reserveChatIds = 48; */
        if (message.input.oneofKind === "reserveChatIds")
            ReserveChatIdsInput.internalBinaryWrite(message.input.reserveChatIds, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* InvokeMessageActionInput invokeMessageAction = 49; */
        if (message.input.oneofKind === "invokeMessageAction")
            InvokeMessageActionInput.internalBinaryWrite(message.input.invokeMessageAction, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* AnswerMessageActionInput answerMessageAction = 50; */
        if (message.input.oneofKind === "answerMessageAction")
            AnswerMessageActionInput.internalBinaryWrite(message.input.answerMessageAction, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* RevokeSessionInput revokeSession = 51; */
        if (message.input.oneofKind === "revokeSession")
            RevokeSessionInput.internalBinaryWrite(message.input.revokeSession, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogOpenInput updateDialogOpen = 52; */
        if (message.input.oneofKind === "updateDialogOpen")
            UpdateDialogOpenInput.internalBinaryWrite(message.input.updateDialogOpen, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogOrderInput updateDialogOrder = 53; */
        if (message.input.oneofKind === "updateDialogOrder")
            UpdateDialogOrderInput.internalBinaryWrite(message.input.updateDialogOrder, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* ClearChatHistoryInput clearChatHistory = 54; */
        if (message.input.oneofKind === "clearChatHistory")
            ClearChatHistoryInput.internalBinaryWrite(message.input.clearChatHistory, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* DeleteBotInput deleteBot = 55; */
        if (message.input.oneofKind === "deleteBot")
            DeleteBotInput.internalBinaryWrite(message.input.deleteBot, writer.tag(55, WireType.LengthDelimited).fork(), options).join();
        /* DeleteMessageAttachmentInput deleteMessageAttachment = 56; */
        if (message.input.oneofKind === "deleteMessageAttachment")
            DeleteMessageAttachmentInput.internalBinaryWrite(message.input.deleteMessageAttachment, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* SetBotAvatarInput setBotAvatar = 57; */
        if (message.input.oneofKind === "setBotAvatar")
            SetBotAvatarInput.internalBinaryWrite(message.input.setBotAvatar, writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* ClearBotAvatarInput clearBotAvatar = 58; */
        if (message.input.oneofKind === "clearBotAvatar")
            ClearBotAvatarInput.internalBinaryWrite(message.input.clearBotAvatar, writer.tag(58, WireType.LengthDelimited).fork(), options).join();
        /* GetBotPresenceInput getBotPresence = 59; */
        if (message.input.oneofKind === "getBotPresence")
            GetBotPresenceInput.internalBinaryWrite(message.input.getBotPresence, writer.tag(59, WireType.LengthDelimited).fork(), options).join();
        /* SetBotPresenceStateInput setBotPresenceState = 60; */
        if (message.input.oneofKind === "setBotPresenceState")
            SetBotPresenceStateInput.internalBinaryWrite(message.input.setBotPresenceState, writer.tag(60, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogFollowModeInput updateDialogFollowMode = 61; */
        if (message.input.oneofKind === "updateDialogFollowMode")
            UpdateDialogFollowModeInput.internalBinaryWrite(message.input.updateDialogFollowMode, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* GetSessionsInput getSessions = 62; */
        if (message.input.oneofKind === "getSessions")
            GetSessionsInput.internalBinaryWrite(message.input.getSessions, writer.tag(62, WireType.LengthDelimited).fork(), options).join();
        /* CheckUsernameInput checkUsername = 63; */
        if (message.input.oneofKind === "checkUsername")
            CheckUsernameInput.internalBinaryWrite(message.input.checkUsername, writer.tag(63, WireType.LengthDelimited).fork(), options).join();
        /* ChangeUsernameInput changeUsername = 64; */
        if (message.input.oneofKind === "changeUsername")
            ChangeUsernameInput.internalBinaryWrite(message.input.changeUsername, writer.tag(64, WireType.LengthDelimited).fork(), options).join();
        /* UpdateProfileInput updateProfile = 65; */
        if (message.input.oneofKind === "updateProfile")
            UpdateProfileInput.internalBinaryWrite(message.input.updateProfile, writer.tag(65, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceUrlPreviewExclusionsInput getSpaceUrlPreviewExclusions = 66; */
        if (message.input.oneofKind === "getSpaceUrlPreviewExclusions")
            GetSpaceUrlPreviewExclusionsInput.internalBinaryWrite(message.input.getSpaceUrlPreviewExclusions, writer.tag(66, WireType.LengthDelimited).fork(), options).join();
        /* AddSpaceUrlPreviewExclusionInput addSpaceUrlPreviewExclusion = 67; */
        if (message.input.oneofKind === "addSpaceUrlPreviewExclusion")
            AddSpaceUrlPreviewExclusionInput.internalBinaryWrite(message.input.addSpaceUrlPreviewExclusion, writer.tag(67, WireType.LengthDelimited).fork(), options).join();
        /* RemoveSpaceUrlPreviewExclusionInput removeSpaceUrlPreviewExclusion = 68; */
        if (message.input.oneofKind === "removeSpaceUrlPreviewExclusion")
            RemoveSpaceUrlPreviewExclusionInput.internalBinaryWrite(message.input.removeSpaceUrlPreviewExclusion, writer.tag(68, WireType.LengthDelimited).fork(), options).join();
        /* GetUserGroupsInput getUserGroups = 69; */
        if (message.input.oneofKind === "getUserGroups")
            GetUserGroupsInput.internalBinaryWrite(message.input.getUserGroups, writer.tag(69, WireType.LengthDelimited).fork(), options).join();
        /* CreateUserGroupInput createUserGroup = 70; */
        if (message.input.oneofKind === "createUserGroup")
            CreateUserGroupInput.internalBinaryWrite(message.input.createUserGroup, writer.tag(70, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserGroupInput updateUserGroup = 71; */
        if (message.input.oneofKind === "updateUserGroup")
            UpdateUserGroupInput.internalBinaryWrite(message.input.updateUserGroup, writer.tag(71, WireType.LengthDelimited).fork(), options).join();
        /* DeleteUserGroupInput deleteUserGroup = 72; */
        if (message.input.oneofKind === "deleteUserGroup")
            DeleteUserGroupInput.internalBinaryWrite(message.input.deleteUserGroup, writer.tag(72, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceSettingsInput getSpaceSettings = 73; */
        if (message.input.oneofKind === "getSpaceSettings")
            GetSpaceSettingsInput.internalBinaryWrite(message.input.getSpaceSettings, writer.tag(73, WireType.LengthDelimited).fork(), options).join();
        /* ToggleSpaceGridInput toggleSpaceGrid = 74; */
        if (message.input.oneofKind === "toggleSpaceGrid")
            ToggleSpaceGridInput.internalBinaryWrite(message.input.toggleSpaceGrid, writer.tag(74, WireType.LengthDelimited).fork(), options).join();
        /* GetThreadReferencesInput getThreadReferences = 75; */
        if (message.input.oneofKind === "getThreadReferences")
            GetThreadReferencesInput.internalBinaryWrite(message.input.getThreadReferences, writer.tag(75, WireType.LengthDelimited).fork(), options).join();
        /* GetThreadSubthreadsInput getThreadSubthreads = 76; */
        if (message.input.oneofKind === "getThreadSubthreads")
            GetThreadSubthreadsInput.internalBinaryWrite(message.input.getThreadSubthreads, writer.tag(76, WireType.LengthDelimited).fork(), options).join();
        /* GetPeerBotsInput getPeerBots = 77; */
        if (message.input.oneofKind === "getPeerBots")
            GetPeerBotsInput.internalBinaryWrite(message.input.getPeerBots, writer.tag(77, WireType.LengthDelimited).fork(), options).join();
        /* GetMyBotCapabilitiesInput getMyBotCapabilities = 78; */
        if (message.input.oneofKind === "getMyBotCapabilities")
            GetMyBotCapabilitiesInput.internalBinaryWrite(message.input.getMyBotCapabilities, writer.tag(78, WireType.LengthDelimited).fork(), options).join();
        /* SetMyBotCapabilitiesInput setMyBotCapabilities = 79; */
        if (message.input.oneofKind === "setMyBotCapabilities")
            SetMyBotCapabilitiesInput.internalBinaryWrite(message.input.setMyBotCapabilities, writer.tag(79, WireType.LengthDelimited).fork(), options).join();
        /* RequestBotChatSettingsInput requestBotChatSettings = 80; */
        if (message.input.oneofKind === "requestBotChatSettings")
            RequestBotChatSettingsInput.internalBinaryWrite(message.input.requestBotChatSettings, writer.tag(80, WireType.LengthDelimited).fork(), options).join();
        /* InvokeBotChatSettingsItemInput invokeBotChatSettingsItem = 81; */
        if (message.input.oneofKind === "invokeBotChatSettingsItem")
            InvokeBotChatSettingsItemInput.internalBinaryWrite(message.input.invokeBotChatSettingsItem, writer.tag(81, WireType.LengthDelimited).fork(), options).join();
        /* AnswerBotChatSettingsInput answerBotChatSettings = 82; */
        if (message.input.oneofKind === "answerBotChatSettings")
            AnswerBotChatSettingsInput.internalBinaryWrite(message.input.answerBotChatSettings, writer.tag(82, WireType.LengthDelimited).fork(), options).join();
        /* GetGridInput getGrid = 84; */
        if (message.input.oneofKind === "getGrid")
            GetGridInput.internalBinaryWrite(message.input.getGrid, writer.tag(84, WireType.LengthDelimited).fork(), options).join();
        /* CreateGridRoomInput createGridRoom = 85; */
        if (message.input.oneofKind === "createGridRoom")
            CreateGridRoomInput.internalBinaryWrite(message.input.createGridRoom, writer.tag(85, WireType.LengthDelimited).fork(), options).join();
        /* JoinGridRoomInput joinGridRoom = 86; */
        if (message.input.oneofKind === "joinGridRoom")
            JoinGridRoomInput.internalBinaryWrite(message.input.joinGridRoom, writer.tag(86, WireType.LengthDelimited).fork(), options).join();
        /* LeaveGridRoomInput leaveGridRoom = 87; */
        if (message.input.oneofKind === "leaveGridRoom")
            LeaveGridRoomInput.internalBinaryWrite(message.input.leaveGridRoom, writer.tag(87, WireType.LengthDelimited).fork(), options).join();
        /* SetGridRoomTitleInput setGridRoomTitle = 88; */
        if (message.input.oneofKind === "setGridRoomTitle")
            SetGridRoomTitleInput.internalBinaryWrite(message.input.setGridRoomTitle, writer.tag(88, WireType.LengthDelimited).fork(), options).join();
        /* SetGridRoomLockedInput setGridRoomLocked = 89; */
        if (message.input.oneofKind === "setGridRoomLocked")
            SetGridRoomLockedInput.internalBinaryWrite(message.input.setGridRoomLocked, writer.tag(89, WireType.LengthDelimited).fork(), options).join();
        /* DeleteGridRoomInput deleteGridRoom = 90; */
        if (message.input.oneofKind === "deleteGridRoom")
            DeleteGridRoomInput.internalBinaryWrite(message.input.deleteGridRoom, writer.tag(90, WireType.LengthDelimited).fork(), options).join();
        /* PrepareGridConnectionInput prepareGridConnection = 91; */
        if (message.input.oneofKind === "prepareGridConnection")
            PrepareGridConnectionInput.internalBinaryWrite(message.input.prepareGridConnection, writer.tag(91, WireType.LengthDelimited).fork(), options).join();
        /* SetGridAvatarMicrophoneEnabledInput setGridAvatarMicrophoneEnabled = 92; */
        if (message.input.oneofKind === "setGridAvatarMicrophoneEnabled")
            SetGridAvatarMicrophoneEnabledInput.internalBinaryWrite(message.input.setGridAvatarMicrophoneEnabled, writer.tag(92, WireType.LengthDelimited).fork(), options).join();
        /* GetGridHomeInput getGridHome = 93; */
        if (message.input.oneofKind === "getGridHome")
            GetGridHomeInput.internalBinaryWrite(message.input.getGridHome, writer.tag(93, WireType.LengthDelimited).fork(), options).join();
        /* CreateCliSessionInput createCliSession = 94; */
        if (message.input.oneofKind === "createCliSession")
            CreateCliSessionInput.internalBinaryWrite(message.input.createCliSession, writer.tag(94, WireType.LengthDelimited).fork(), options).join();
        /* SetProfilePhotoInput setProfilePhoto = 95; */
        if (message.input.oneofKind === "setProfilePhoto")
            SetProfilePhotoInput.internalBinaryWrite(message.input.setProfilePhoto, writer.tag(95, WireType.LengthDelimited).fork(), options).join();
        /* GetExternalProfilePhotoInput getExternalProfilePhoto = 96; */
        if (message.input.oneofKind === "getExternalProfilePhoto")
            GetExternalProfilePhotoInput.internalBinaryWrite(message.input.getExternalProfilePhoto, writer.tag(96, WireType.LengthDelimited).fork(), options).join();
        /* GetChatTranscriptInput getChatTranscript = 97; */
        if (message.input.oneofKind === "getChatTranscript")
            GetChatTranscriptInput.internalBinaryWrite(message.input.getChatTranscript, writer.tag(97, WireType.LengthDelimited).fork(), options).join();
        /* SearchExternalResourcesInput searchExternalResources = 98; */
        if (message.input.oneofKind === "searchExternalResources")
            SearchExternalResourcesInput.internalBinaryWrite(message.input.searchExternalResources, writer.tag(98, WireType.LengthDelimited).fork(), options).join();
        /* JoinPublicSpaceInput joinPublicSpace = 99; */
        if (message.input.oneofKind === "joinPublicSpace")
            JoinPublicSpaceInput.internalBinaryWrite(message.input.joinPublicSpace, writer.tag(99, WireType.LengthDelimited).fork(), options).join();
        /* CollapseHistoryInput collapseHistory = 100; */
        if (message.input.oneofKind === "collapseHistory")
            CollapseHistoryInput.internalBinaryWrite(message.input.collapseHistory, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* ListConnectorsInput listConnectors = 101; */
        if (message.input.oneofKind === "listConnectors")
            ListConnectorsInput.internalBinaryWrite(message.input.listConnectors, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* PrepareConnectorOAuthInput prepareConnectorOAuth = 102; */
        if (message.input.oneofKind === "prepareConnectorOAuth")
            PrepareConnectorOAuthInput.internalBinaryWrite(message.input.prepareConnectorOAuth, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* DisconnectConnectorInput disconnectConnector = 103; */
        if (message.input.oneofKind === "disconnectConnector")
            DisconnectConnectorInput.internalBinaryWrite(message.input.disconnectConnector, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* SearchUsersInput searchUsers = 104; */
        if (message.input.oneofKind === "searchUsers")
            SearchUsersInput.internalBinaryWrite(message.input.searchUsers, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* InviteToInlineInput inviteToInline = 105; */
        if (message.input.oneofKind === "inviteToInline")
            InviteToInlineInput.internalBinaryWrite(message.input.inviteToInline, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* ResolveUrlPreviewInput resolveUrlPreview = 106; */
        if (message.input.oneofKind === "resolveUrlPreview")
            ResolveUrlPreviewInput.internalBinaryWrite(message.input.resolveUrlPreview, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* CreateBotAgentInput createBotAgent = 107; */
        if (message.input.oneofKind === "createBotAgent")
            CreateBotAgentInput.internalBinaryWrite(message.input.createBotAgent, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* GetBotAgentInput getBotAgent = 108; */
        if (message.input.oneofKind === "getBotAgent")
            GetBotAgentInput.internalBinaryWrite(message.input.getBotAgent, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* ListBotAgentsInput listBotAgents = 109; */
        if (message.input.oneofKind === "listBotAgents")
            ListBotAgentsInput.internalBinaryWrite(message.input.listBotAgents, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* CreateSpaceInput createSpace = 110; */
        if (message.input.oneofKind === "createSpace")
            CreateSpaceInput.internalBinaryWrite(message.input.createSpace, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* DeleteSpaceInput deleteSpace = 111; */
        if (message.input.oneofKind === "deleteSpace")
            DeleteSpaceInput.internalBinaryWrite(message.input.deleteSpace, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* LeaveSpaceInput leaveSpace = 112; */
        if (message.input.oneofKind === "leaveSpace")
            LeaveSpaceInput.internalBinaryWrite(message.input.leaveSpace, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        /* GetConnectorConfigInput getConnectorConfig = 113; */
        if (message.input.oneofKind === "getConnectorConfig")
            GetConnectorConfigInput.internalBinaryWrite(message.input.getConnectorConfig, writer.tag(113, WireType.LengthDelimited).fork(), options).join();
        /* SetConnectorConfigInput setConnectorConfig = 114; */
        if (message.input.oneofKind === "setConnectorConfig")
            SetConnectorConfigInput.internalBinaryWrite(message.input.setConnectorConfig, writer.tag(114, WireType.LengthDelimited).fork(), options).join();
        /* CreateExternalTaskInput createExternalTask = 115; */
        if (message.input.oneofKind === "createExternalTask")
            CreateExternalTaskInput.internalBinaryWrite(message.input.createExternalTask, writer.tag(115, WireType.LengthDelimited).fork(), options).join();
        /* UnregisterDeviceInput unregisterDevice = 116; */
        if (message.input.oneofKind === "unregisterDevice")
            UnregisterDeviceInput.internalBinaryWrite(message.input.unregisterDevice, writer.tag(116, WireType.LengthDelimited).fork(), options).join();
        /* LogOutInput logOut = 117; */
        if (message.input.oneofKind === "logOut")
            LogOutInput.internalBinaryWrite(message.input.logOut, writer.tag(117, WireType.LengthDelimited).fork(), options).join();
        /* CreateUploadInput createUpload = 118; */
        if (message.input.oneofKind === "createUpload")
            CreateUploadInput.internalBinaryWrite(message.input.createUpload, writer.tag(118, WireType.LengthDelimited).fork(), options).join();
        /* SaveUploadPartInput saveUploadPart = 119; */
        if (message.input.oneofKind === "saveUploadPart")
            SaveUploadPartInput.internalBinaryWrite(message.input.saveUploadPart, writer.tag(119, WireType.LengthDelimited).fork(), options).join();
        /* GetUploadStateInput getUploadState = 120; */
        if (message.input.oneofKind === "getUploadState")
            GetUploadStateInput.internalBinaryWrite(message.input.getUploadState, writer.tag(120, WireType.LengthDelimited).fork(), options).join();
        /* FinishUploadInput finishUpload = 121; */
        if (message.input.oneofKind === "finishUpload")
            FinishUploadInput.internalBinaryWrite(message.input.finishUpload, writer.tag(121, WireType.LengthDelimited).fork(), options).join();
        /* CancelUploadInput cancelUpload = 122; */
        if (message.input.oneofKind === "cancelUpload")
            CancelUploadInput.internalBinaryWrite(message.input.cancelUpload, writer.tag(122, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSessionInput updateSession = 123; */
        if (message.input.oneofKind === "updateSession")
            UpdateSessionInput.internalBinaryWrite(message.input.updateSession, writer.tag(123, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogArchivedInput updateDialogArchived = 124; */
        if (message.input.oneofKind === "updateDialogArchived")
            UpdateDialogArchivedInput.internalBinaryWrite(message.input.updateDialogArchived, writer.tag(124, WireType.LengthDelimited).fork(), options).join();
        /* CreateDialogFolderInput createDialogFolder = 125; */
        if (message.input.oneofKind === "createDialogFolder")
            CreateDialogFolderInput.internalBinaryWrite(message.input.createDialogFolder, writer.tag(125, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogFolderInput updateDialogFolder = 126; */
        if (message.input.oneofKind === "updateDialogFolder")
            UpdateDialogFolderInput.internalBinaryWrite(message.input.updateDialogFolder, writer.tag(126, WireType.LengthDelimited).fork(), options).join();
        /* DeleteDialogFolderInput deleteDialogFolder = 127; */
        if (message.input.oneofKind === "deleteDialogFolder")
            DeleteDialogFolderInput.internalBinaryWrite(message.input.deleteDialogFolder, writer.tag(127, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceInput getSpace = 128; */
        if (message.input.oneofKind === "getSpace")
            GetSpaceInput.internalBinaryWrite(message.input.getSpace, writer.tag(128, WireType.LengthDelimited).fork(), options).join();
        /* ConnectAgentSessionInput connectAgentSession = 129; */
        if (message.input.oneofKind === "connectAgentSession")
            ConnectAgentSessionInput.internalBinaryWrite(message.input.connectAgentSession, writer.tag(129, WireType.LengthDelimited).fork(), options).join();
        /* SyncAgentSessionMessagesInput syncAgentSessionMessages = 130; */
        if (message.input.oneofKind === "syncAgentSessionMessages")
            SyncAgentSessionMessagesInput.internalBinaryWrite(message.input.syncAgentSessionMessages, writer.tag(130, WireType.LengthDelimited).fork(), options).join();
        /* GetAgentSessionInput getAgentSession = 131; */
        if (message.input.oneofKind === "getAgentSession")
            GetAgentSessionInput.internalBinaryWrite(message.input.getAgentSession, writer.tag(131, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBotAgentInput updateBotAgent = 132; */
        if (message.input.oneofKind === "updateBotAgent")
            UpdateBotAgentInput.internalBinaryWrite(message.input.updateBotAgent, writer.tag(132, WireType.LengthDelimited).fork(), options).join();
        /* DeleteBotAgentInput deleteBotAgent = 133; */
        if (message.input.oneofKind === "deleteBotAgent")
            DeleteBotAgentInput.internalBinaryWrite(message.input.deleteBotAgent, writer.tag(133, WireType.LengthDelimited).fork(), options).join();
        /* JoinSpaceByInviteTokenInput joinSpaceByInviteToken = 134; */
        if (message.input.oneofKind === "joinSpaceByInviteToken")
            JoinSpaceByInviteTokenInput.internalBinaryWrite(message.input.joinSpaceByInviteToken, writer.tag(134, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceInviteLinkInput getSpaceInviteLink = 135; */
        if (message.input.oneofKind === "getSpaceInviteLink")
            GetSpaceInviteLinkInput.internalBinaryWrite(message.input.getSpaceInviteLink, writer.tag(135, WireType.LengthDelimited).fork(), options).join();
        /* SetSpaceInviteLinkEnabledInput setSpaceInviteLinkEnabled = 136; */
        if (message.input.oneofKind === "setSpaceInviteLinkEnabled")
            SetSpaceInviteLinkEnabledInput.internalBinaryWrite(message.input.setSpaceInviteLinkEnabled, writer.tag(136, WireType.LengthDelimited).fork(), options).join();
        /* GetFilePartInput getFilePart = 137; */
        if (message.input.oneofKind === "getFilePart")
            GetFilePartInput.internalBinaryWrite(message.input.getFilePart, writer.tag(137, WireType.LengthDelimited).fork(), options).join();
        /* AcknowledgeMessagesInput acknowledgeMessages = 138; */
        if (message.input.oneofKind === "acknowledgeMessages")
            AcknowledgeMessagesInput.internalBinaryWrite(message.input.acknowledgeMessages, writer.tag(138, WireType.LengthDelimited).fork(), options).join();
        /* GetUsersInput getUsers = 139; */
        if (message.input.oneofKind === "getUsers")
            GetUsersInput.internalBinaryWrite(message.input.getUsers, writer.tag(139, WireType.LengthDelimited).fork(), options).join();
        /* GetBotSkillsInput getBotSkills = 140; */
        if (message.input.oneofKind === "getBotSkills")
            GetBotSkillsInput.internalBinaryWrite(message.input.getBotSkills, writer.tag(140, WireType.LengthDelimited).fork(), options).join();
        /* GetBotConfigurationCatalogInput getBotConfigurationCatalog = 141; */
        if (message.input.oneofKind === "getBotConfigurationCatalog")
            GetBotConfigurationCatalogInput.internalBinaryWrite(message.input.getBotConfigurationCatalog, writer.tag(141, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RpcCall
 */
export const RpcCall = new RpcCall$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RpcResult$Type extends MessageType {
    constructor() {
        super("RpcResult", [
            { no: 1, name: "req_msg_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "getMe", kind: "message", oneof: "result", T: () => GetMeResult },
            { no: 3, name: "getPeerPhoto", kind: "message", oneof: "result", T: () => GetPeerPhotoResult },
            { no: 4, name: "deleteMessages", kind: "message", oneof: "result", T: () => DeleteMessagesResult },
            { no: 5, name: "sendMessage", kind: "message", oneof: "result", T: () => SendMessageResult },
            { no: 6, name: "getChatHistory", kind: "message", oneof: "result", T: () => GetChatHistoryResult },
            { no: 7, name: "addReaction", kind: "message", oneof: "result", T: () => AddReactionResult },
            { no: 8, name: "deleteReaction", kind: "message", oneof: "result", T: () => DeleteReactionResult },
            { no: 9, name: "editMessage", kind: "message", oneof: "result", T: () => EditMessageResult },
            { no: 10, name: "createChat", kind: "message", oneof: "result", T: () => CreateChatResult },
            { no: 11, name: "getSpaceMembers", kind: "message", oneof: "result", T: () => GetSpaceMembersResult },
            { no: 12, name: "deleteChat", kind: "message", oneof: "result", T: () => DeleteChatResult },
            { no: 13, name: "inviteToSpace", kind: "message", oneof: "result", T: () => InviteToSpaceResult },
            { no: 14, name: "getChatParticipants", kind: "message", oneof: "result", T: () => GetChatParticipantsResult },
            { no: 15, name: "addChatParticipant", kind: "message", oneof: "result", T: () => AddChatParticipantResult },
            { no: 16, name: "removeChatParticipant", kind: "message", oneof: "result", T: () => RemoveChatParticipantResult },
            { no: 17, name: "translateMessages", kind: "message", oneof: "result", T: () => TranslateMessagesResult },
            { no: 18, name: "getChats", kind: "message", oneof: "result", T: () => GetChatsResult },
            { no: 19, name: "updateUserSettings", kind: "message", oneof: "result", T: () => UpdateUserSettingsResult },
            { no: 20, name: "getUserSettings", kind: "message", oneof: "result", T: () => GetUserSettingsResult },
            { no: 21, name: "sendComposeAction", kind: "message", oneof: "result", T: () => SendComposeActionResult },
            { no: 22, name: "createBot", kind: "message", oneof: "result", T: () => CreateBotResult },
            { no: 23, name: "deleteMember", kind: "message", oneof: "result", T: () => DeleteMemberResult },
            { no: 24, name: "markAsUnread", kind: "message", oneof: "result", T: () => MarkAsUnreadResult },
            { no: 25, name: "getUpdatesState", kind: "message", oneof: "result", T: () => GetUpdatesStateResult },
            { no: 26, name: "getChat", kind: "message", oneof: "result", T: () => GetChatResult },
            { no: 27, name: "getUpdates", kind: "message", oneof: "result", T: () => GetUpdatesResult },
            { no: 28, name: "updateMemberAccess", kind: "message", oneof: "result", T: () => UpdateMemberAccessResult },
            { no: 29, name: "searchMessages", kind: "message", oneof: "result", T: () => SearchMessagesResult },
            { no: 30, name: "forwardMessages", kind: "message", oneof: "result", T: () => ForwardMessagesResult },
            { no: 31, name: "updateChatVisibility", kind: "message", oneof: "result", T: () => UpdateChatVisibilityResult },
            { no: 32, name: "pinMessage", kind: "message", oneof: "result", T: () => PinMessageResult },
            { no: 33, name: "updateChatInfo", kind: "message", oneof: "result", T: () => UpdateChatInfoResult },
            { no: 34, name: "listBots", kind: "message", oneof: "result", T: () => ListBotsResult },
            { no: 35, name: "revealBotToken", kind: "message", oneof: "result", T: () => RevealBotTokenResult },
            { no: 36, name: "moveThread", kind: "message", oneof: "result", T: () => MoveThreadResult },
            { no: 37, name: "rotateBotToken", kind: "message", oneof: "result", T: () => RotateBotTokenResult },
            { no: 38, name: "updateBotProfile", kind: "message", oneof: "result", T: () => UpdateBotProfileResult },
            { no: 39, name: "getMessages", kind: "message", oneof: "result", T: () => GetMessagesResult },
            { no: 40, name: "updateDialogNotificationSettings", kind: "message", oneof: "result", T: () => UpdateDialogNotificationSettingsResult },
            { no: 41, name: "readMessages", kind: "message", oneof: "result", T: () => ReadMessagesResult },
            { no: 42, name: "registerDevice", kind: "message", oneof: "result", T: () => RegisterDeviceResult },
            { no: 43, name: "createSubthread", kind: "message", oneof: "result", T: () => CreateSubthreadResult },
            { no: 44, name: "getBotCommands", kind: "message", oneof: "result", T: () => GetBotCommandsResult },
            { no: 45, name: "setBotCommands", kind: "message", oneof: "result", T: () => SetBotCommandsResult },
            { no: 46, name: "getPeerBotCommands", kind: "message", oneof: "result", T: () => GetPeerBotCommandsResult },
            { no: 47, name: "showInChatList", kind: "message", oneof: "result", T: () => ShowInChatListResult },
            { no: 48, name: "reserveChatIds", kind: "message", oneof: "result", T: () => ReserveChatIdsResult },
            { no: 49, name: "invokeMessageAction", kind: "message", oneof: "result", T: () => InvokeMessageActionResult },
            { no: 50, name: "answerMessageAction", kind: "message", oneof: "result", T: () => AnswerMessageActionResult },
            { no: 51, name: "revokeSession", kind: "message", oneof: "result", T: () => RevokeSessionResult },
            { no: 52, name: "updateDialogOpen", kind: "message", oneof: "result", T: () => UpdateDialogOpenResult },
            { no: 53, name: "updateDialogOrder", kind: "message", oneof: "result", T: () => UpdateDialogOrderResult },
            { no: 54, name: "clearChatHistory", kind: "message", oneof: "result", T: () => ClearChatHistoryResult },
            { no: 55, name: "deleteBot", kind: "message", oneof: "result", T: () => DeleteBotResult },
            { no: 56, name: "deleteMessageAttachment", kind: "message", oneof: "result", T: () => DeleteMessageAttachmentResult },
            { no: 57, name: "setBotAvatar", kind: "message", oneof: "result", T: () => SetBotAvatarResult },
            { no: 58, name: "clearBotAvatar", kind: "message", oneof: "result", T: () => ClearBotAvatarResult },
            { no: 59, name: "getBotPresence", kind: "message", oneof: "result", T: () => GetBotPresenceResult },
            { no: 60, name: "setBotPresenceState", kind: "message", oneof: "result", T: () => SetBotPresenceStateResult },
            { no: 61, name: "updateDialogFollowMode", kind: "message", oneof: "result", T: () => UpdateDialogFollowModeResult },
            { no: 62, name: "getSessions", kind: "message", oneof: "result", T: () => GetSessionsResult },
            { no: 63, name: "checkUsername", kind: "message", oneof: "result", T: () => CheckUsernameResult },
            { no: 64, name: "changeUsername", kind: "message", oneof: "result", T: () => ChangeUsernameResult },
            { no: 65, name: "updateProfile", kind: "message", oneof: "result", T: () => UpdateProfileResult },
            { no: 66, name: "getSpaceUrlPreviewExclusions", kind: "message", oneof: "result", T: () => GetSpaceUrlPreviewExclusionsResult },
            { no: 67, name: "addSpaceUrlPreviewExclusion", kind: "message", oneof: "result", T: () => AddSpaceUrlPreviewExclusionResult },
            { no: 68, name: "removeSpaceUrlPreviewExclusion", kind: "message", oneof: "result", T: () => RemoveSpaceUrlPreviewExclusionResult },
            { no: 69, name: "getUserGroups", kind: "message", oneof: "result", T: () => GetUserGroupsResult },
            { no: 70, name: "createUserGroup", kind: "message", oneof: "result", T: () => CreateUserGroupResult },
            { no: 71, name: "updateUserGroup", kind: "message", oneof: "result", T: () => UpdateUserGroupResult },
            { no: 72, name: "deleteUserGroup", kind: "message", oneof: "result", T: () => DeleteUserGroupResult },
            { no: 73, name: "getSpaceSettings", kind: "message", oneof: "result", T: () => GetSpaceSettingsResult },
            { no: 74, name: "toggleSpaceGrid", kind: "message", oneof: "result", T: () => ToggleSpaceGridResult },
            { no: 75, name: "getThreadReferences", kind: "message", oneof: "result", T: () => GetThreadReferencesResult },
            { no: 76, name: "getThreadSubthreads", kind: "message", oneof: "result", T: () => GetThreadSubthreadsResult },
            { no: 77, name: "getPeerBots", kind: "message", oneof: "result", T: () => GetPeerBotsResult },
            { no: 78, name: "getMyBotCapabilities", kind: "message", oneof: "result", T: () => GetMyBotCapabilitiesResult },
            { no: 79, name: "setMyBotCapabilities", kind: "message", oneof: "result", T: () => SetMyBotCapabilitiesResult },
            { no: 80, name: "requestBotChatSettings", kind: "message", oneof: "result", T: () => RequestBotChatSettingsResult },
            { no: 81, name: "invokeBotChatSettingsItem", kind: "message", oneof: "result", T: () => InvokeBotChatSettingsItemResult },
            { no: 82, name: "answerBotChatSettings", kind: "message", oneof: "result", T: () => AnswerBotChatSettingsResult },
            { no: 84, name: "getGrid", kind: "message", oneof: "result", T: () => GetGridResult },
            { no: 85, name: "createGridRoom", kind: "message", oneof: "result", T: () => CreateGridRoomResult },
            { no: 86, name: "joinGridRoom", kind: "message", oneof: "result", T: () => JoinGridRoomResult },
            { no: 87, name: "leaveGridRoom", kind: "message", oneof: "result", T: () => LeaveGridRoomResult },
            { no: 88, name: "setGridRoomTitle", kind: "message", oneof: "result", T: () => SetGridRoomTitleResult },
            { no: 89, name: "setGridRoomLocked", kind: "message", oneof: "result", T: () => SetGridRoomLockedResult },
            { no: 90, name: "deleteGridRoom", kind: "message", oneof: "result", T: () => DeleteGridRoomResult },
            { no: 91, name: "prepareGridConnection", kind: "message", oneof: "result", T: () => PrepareGridConnectionResult },
            { no: 92, name: "setGridAvatarMicrophoneEnabled", kind: "message", oneof: "result", T: () => SetGridAvatarMicrophoneEnabledResult },
            { no: 93, name: "getGridHome", kind: "message", oneof: "result", T: () => GetGridHomeResult },
            { no: 94, name: "createCliSession", kind: "message", oneof: "result", T: () => CreateCliSessionResult },
            { no: 95, name: "setProfilePhoto", kind: "message", oneof: "result", T: () => SetProfilePhotoResult },
            { no: 96, name: "getExternalProfilePhoto", kind: "message", oneof: "result", T: () => GetExternalProfilePhotoResult },
            { no: 97, name: "getChatTranscript", kind: "message", oneof: "result", T: () => GetChatTranscriptResult },
            { no: 98, name: "searchExternalResources", kind: "message", oneof: "result", T: () => SearchExternalResourcesResult },
            { no: 99, name: "joinPublicSpace", kind: "message", oneof: "result", T: () => JoinPublicSpaceResult },
            { no: 100, name: "collapseHistory", kind: "message", oneof: "result", T: () => CollapseHistoryResult },
            { no: 101, name: "listConnectors", kind: "message", oneof: "result", T: () => ListConnectorsResult },
            { no: 102, name: "prepareConnectorOAuth", kind: "message", oneof: "result", T: () => PrepareConnectorOAuthResult },
            { no: 103, name: "disconnectConnector", kind: "message", oneof: "result", T: () => DisconnectConnectorResult },
            { no: 104, name: "searchUsers", kind: "message", oneof: "result", T: () => SearchUsersResult },
            { no: 105, name: "inviteToInline", kind: "message", oneof: "result", T: () => InviteToInlineResult },
            { no: 106, name: "resolveUrlPreview", kind: "message", oneof: "result", T: () => ResolveUrlPreviewResult },
            { no: 107, name: "createBotAgent", kind: "message", oneof: "result", T: () => CreateBotAgentResult },
            { no: 108, name: "getBotAgent", kind: "message", oneof: "result", T: () => GetBotAgentResult },
            { no: 109, name: "listBotAgents", kind: "message", oneof: "result", T: () => ListBotAgentsResult },
            { no: 110, name: "createSpace", kind: "message", oneof: "result", T: () => CreateSpaceResult },
            { no: 111, name: "deleteSpace", kind: "message", oneof: "result", T: () => DeleteSpaceResult },
            { no: 112, name: "leaveSpace", kind: "message", oneof: "result", T: () => LeaveSpaceResult },
            { no: 113, name: "getConnectorConfig", kind: "message", oneof: "result", T: () => GetConnectorConfigResult },
            { no: 114, name: "setConnectorConfig", kind: "message", oneof: "result", T: () => SetConnectorConfigResult },
            { no: 115, name: "createExternalTask", kind: "message", oneof: "result", T: () => CreateExternalTaskResult },
            { no: 116, name: "unregisterDevice", kind: "message", oneof: "result", T: () => UnregisterDeviceResult },
            { no: 117, name: "logOut", kind: "message", oneof: "result", T: () => LogOutResult },
            { no: 118, name: "createUpload", kind: "message", oneof: "result", T: () => CreateUploadResult },
            { no: 119, name: "saveUploadPart", kind: "message", oneof: "result", T: () => SaveUploadPartResult },
            { no: 120, name: "getUploadState", kind: "message", oneof: "result", T: () => GetUploadStateResult },
            { no: 121, name: "finishUpload", kind: "message", oneof: "result", T: () => FinishUploadResult },
            { no: 122, name: "cancelUpload", kind: "message", oneof: "result", T: () => CancelUploadResult },
            { no: 123, name: "updateSession", kind: "message", oneof: "result", T: () => UpdateSessionResult },
            { no: 124, name: "updateDialogArchived", kind: "message", oneof: "result", T: () => UpdateDialogArchivedResult },
            { no: 125, name: "createDialogFolder", kind: "message", oneof: "result", T: () => CreateDialogFolderResult },
            { no: 126, name: "updateDialogFolder", kind: "message", oneof: "result", T: () => UpdateDialogFolderResult },
            { no: 127, name: "deleteDialogFolder", kind: "message", oneof: "result", T: () => DeleteDialogFolderResult },
            { no: 128, name: "getSpace", kind: "message", oneof: "result", T: () => GetSpaceResult },
            { no: 129, name: "connectAgentSession", kind: "message", oneof: "result", T: () => ConnectAgentSessionResult },
            { no: 130, name: "syncAgentSessionMessages", kind: "message", oneof: "result", T: () => SyncAgentSessionMessagesResult },
            { no: 131, name: "getAgentSession", kind: "message", oneof: "result", T: () => GetAgentSessionResult },
            { no: 132, name: "updateBotAgent", kind: "message", oneof: "result", T: () => UpdateBotAgentResult },
            { no: 133, name: "deleteBotAgent", kind: "message", oneof: "result", T: () => DeleteBotAgentResult },
            { no: 134, name: "joinSpaceByInviteToken", kind: "message", oneof: "result", T: () => JoinSpaceByInviteTokenResult },
            { no: 135, name: "getSpaceInviteLink", kind: "message", oneof: "result", T: () => GetSpaceInviteLinkResult },
            { no: 136, name: "setSpaceInviteLinkEnabled", kind: "message", oneof: "result", T: () => SetSpaceInviteLinkEnabledResult },
            { no: 137, name: "getFilePart", kind: "message", oneof: "result", T: () => GetFilePartResult },
            { no: 138, name: "acknowledgeMessages", kind: "message", oneof: "result", T: () => AcknowledgeMessagesResult },
            { no: 139, name: "getUsers", kind: "message", oneof: "result", T: () => GetUsersResult },
            { no: 140, name: "getBotSkills", kind: "message", oneof: "result", T: () => GetBotSkillsResult },
            { no: 141, name: "getBotConfigurationCatalog", kind: "message", oneof: "result", T: () => GetBotConfigurationCatalogResult }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reqMsgId = 0n;
        message.result = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 req_msg_id */ 1:
                    message.reqMsgId = reader.uint64().toBigInt();
                    break;
                case /* GetMeResult getMe */ 2:
                    message.result = {
                        oneofKind: "getMe",
                        getMe: GetMeResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getMe)
                    };
                    break;
                case /* GetPeerPhotoResult getPeerPhoto */ 3:
                    message.result = {
                        oneofKind: "getPeerPhoto",
                        getPeerPhoto: GetPeerPhotoResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getPeerPhoto)
                    };
                    break;
                case /* DeleteMessagesResult deleteMessages */ 4:
                    message.result = {
                        oneofKind: "deleteMessages",
                        deleteMessages: DeleteMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteMessages)
                    };
                    break;
                case /* SendMessageResult sendMessage */ 5:
                    message.result = {
                        oneofKind: "sendMessage",
                        sendMessage: SendMessageResult.internalBinaryRead(reader, reader.uint32(), options, message.result.sendMessage)
                    };
                    break;
                case /* GetChatHistoryResult getChatHistory */ 6:
                    message.result = {
                        oneofKind: "getChatHistory",
                        getChatHistory: GetChatHistoryResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getChatHistory)
                    };
                    break;
                case /* AddReactionResult addReaction */ 7:
                    message.result = {
                        oneofKind: "addReaction",
                        addReaction: AddReactionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.addReaction)
                    };
                    break;
                case /* DeleteReactionResult deleteReaction */ 8:
                    message.result = {
                        oneofKind: "deleteReaction",
                        deleteReaction: DeleteReactionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteReaction)
                    };
                    break;
                case /* EditMessageResult editMessage */ 9:
                    message.result = {
                        oneofKind: "editMessage",
                        editMessage: EditMessageResult.internalBinaryRead(reader, reader.uint32(), options, message.result.editMessage)
                    };
                    break;
                case /* CreateChatResult createChat */ 10:
                    message.result = {
                        oneofKind: "createChat",
                        createChat: CreateChatResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createChat)
                    };
                    break;
                case /* GetSpaceMembersResult getSpaceMembers */ 11:
                    message.result = {
                        oneofKind: "getSpaceMembers",
                        getSpaceMembers: GetSpaceMembersResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getSpaceMembers)
                    };
                    break;
                case /* DeleteChatResult deleteChat */ 12:
                    message.result = {
                        oneofKind: "deleteChat",
                        deleteChat: DeleteChatResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteChat)
                    };
                    break;
                case /* InviteToSpaceResult inviteToSpace */ 13:
                    message.result = {
                        oneofKind: "inviteToSpace",
                        inviteToSpace: InviteToSpaceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.inviteToSpace)
                    };
                    break;
                case /* GetChatParticipantsResult getChatParticipants */ 14:
                    message.result = {
                        oneofKind: "getChatParticipants",
                        getChatParticipants: GetChatParticipantsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getChatParticipants)
                    };
                    break;
                case /* AddChatParticipantResult addChatParticipant */ 15:
                    message.result = {
                        oneofKind: "addChatParticipant",
                        addChatParticipant: AddChatParticipantResult.internalBinaryRead(reader, reader.uint32(), options, message.result.addChatParticipant)
                    };
                    break;
                case /* RemoveChatParticipantResult removeChatParticipant */ 16:
                    message.result = {
                        oneofKind: "removeChatParticipant",
                        removeChatParticipant: RemoveChatParticipantResult.internalBinaryRead(reader, reader.uint32(), options, message.result.removeChatParticipant)
                    };
                    break;
                case /* TranslateMessagesResult translateMessages */ 17:
                    message.result = {
                        oneofKind: "translateMessages",
                        translateMessages: TranslateMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.translateMessages)
                    };
                    break;
                case /* GetChatsResult getChats */ 18:
                    message.result = {
                        oneofKind: "getChats",
                        getChats: GetChatsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getChats)
                    };
                    break;
                case /* UpdateUserSettingsResult updateUserSettings */ 19:
                    message.result = {
                        oneofKind: "updateUserSettings",
                        updateUserSettings: UpdateUserSettingsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateUserSettings)
                    };
                    break;
                case /* GetUserSettingsResult getUserSettings */ 20:
                    message.result = {
                        oneofKind: "getUserSettings",
                        getUserSettings: GetUserSettingsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getUserSettings)
                    };
                    break;
                case /* SendComposeActionResult sendComposeAction */ 21:
                    message.result = {
                        oneofKind: "sendComposeAction",
                        sendComposeAction: SendComposeActionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.sendComposeAction)
                    };
                    break;
                case /* CreateBotResult createBot */ 22:
                    message.result = {
                        oneofKind: "createBot",
                        createBot: CreateBotResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createBot)
                    };
                    break;
                case /* DeleteMemberResult deleteMember */ 23:
                    message.result = {
                        oneofKind: "deleteMember",
                        deleteMember: DeleteMemberResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteMember)
                    };
                    break;
                case /* MarkAsUnreadResult markAsUnread */ 24:
                    message.result = {
                        oneofKind: "markAsUnread",
                        markAsUnread: MarkAsUnreadResult.internalBinaryRead(reader, reader.uint32(), options, message.result.markAsUnread)
                    };
                    break;
                case /* GetUpdatesStateResult getUpdatesState */ 25:
                    message.result = {
                        oneofKind: "getUpdatesState",
                        getUpdatesState: GetUpdatesStateResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getUpdatesState)
                    };
                    break;
                case /* GetChatResult getChat */ 26:
                    message.result = {
                        oneofKind: "getChat",
                        getChat: GetChatResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getChat)
                    };
                    break;
                case /* GetUpdatesResult getUpdates */ 27:
                    message.result = {
                        oneofKind: "getUpdates",
                        getUpdates: GetUpdatesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getUpdates)
                    };
                    break;
                case /* UpdateMemberAccessResult updateMemberAccess */ 28:
                    message.result = {
                        oneofKind: "updateMemberAccess",
                        updateMemberAccess: UpdateMemberAccessResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateMemberAccess)
                    };
                    break;
                case /* SearchMessagesResult searchMessages */ 29:
                    message.result = {
                        oneofKind: "searchMessages",
                        searchMessages: SearchMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.searchMessages)
                    };
                    break;
                case /* ForwardMessagesResult forwardMessages */ 30:
                    message.result = {
                        oneofKind: "forwardMessages",
                        forwardMessages: ForwardMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.forwardMessages)
                    };
                    break;
                case /* UpdateChatVisibilityResult updateChatVisibility */ 31:
                    message.result = {
                        oneofKind: "updateChatVisibility",
                        updateChatVisibility: UpdateChatVisibilityResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateChatVisibility)
                    };
                    break;
                case /* PinMessageResult pinMessage */ 32:
                    message.result = {
                        oneofKind: "pinMessage",
                        pinMessage: PinMessageResult.internalBinaryRead(reader, reader.uint32(), options, message.result.pinMessage)
                    };
                    break;
                case /* UpdateChatInfoResult updateChatInfo */ 33:
                    message.result = {
                        oneofKind: "updateChatInfo",
                        updateChatInfo: UpdateChatInfoResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateChatInfo)
                    };
                    break;
                case /* ListBotsResult listBots */ 34:
                    message.result = {
                        oneofKind: "listBots",
                        listBots: ListBotsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.listBots)
                    };
                    break;
                case /* RevealBotTokenResult revealBotToken */ 35:
                    message.result = {
                        oneofKind: "revealBotToken",
                        revealBotToken: RevealBotTokenResult.internalBinaryRead(reader, reader.uint32(), options, message.result.revealBotToken)
                    };
                    break;
                case /* MoveThreadResult moveThread */ 36:
                    message.result = {
                        oneofKind: "moveThread",
                        moveThread: MoveThreadResult.internalBinaryRead(reader, reader.uint32(), options, message.result.moveThread)
                    };
                    break;
                case /* RotateBotTokenResult rotateBotToken */ 37:
                    message.result = {
                        oneofKind: "rotateBotToken",
                        rotateBotToken: RotateBotTokenResult.internalBinaryRead(reader, reader.uint32(), options, message.result.rotateBotToken)
                    };
                    break;
                case /* UpdateBotProfileResult updateBotProfile */ 38:
                    message.result = {
                        oneofKind: "updateBotProfile",
                        updateBotProfile: UpdateBotProfileResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateBotProfile)
                    };
                    break;
                case /* GetMessagesResult getMessages */ 39:
                    message.result = {
                        oneofKind: "getMessages",
                        getMessages: GetMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getMessages)
                    };
                    break;
                case /* UpdateDialogNotificationSettingsResult updateDialogNotificationSettings */ 40:
                    message.result = {
                        oneofKind: "updateDialogNotificationSettings",
                        updateDialogNotificationSettings: UpdateDialogNotificationSettingsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateDialogNotificationSettings)
                    };
                    break;
                case /* ReadMessagesResult readMessages */ 41:
                    message.result = {
                        oneofKind: "readMessages",
                        readMessages: ReadMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.readMessages)
                    };
                    break;
                case /* RegisterDeviceResult registerDevice */ 42:
                    message.result = {
                        oneofKind: "registerDevice",
                        registerDevice: RegisterDeviceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.registerDevice)
                    };
                    break;
                case /* CreateSubthreadResult createSubthread */ 43:
                    message.result = {
                        oneofKind: "createSubthread",
                        createSubthread: CreateSubthreadResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createSubthread)
                    };
                    break;
                case /* GetBotCommandsResult getBotCommands */ 44:
                    message.result = {
                        oneofKind: "getBotCommands",
                        getBotCommands: GetBotCommandsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getBotCommands)
                    };
                    break;
                case /* SetBotCommandsResult setBotCommands */ 45:
                    message.result = {
                        oneofKind: "setBotCommands",
                        setBotCommands: SetBotCommandsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setBotCommands)
                    };
                    break;
                case /* GetPeerBotCommandsResult getPeerBotCommands */ 46:
                    message.result = {
                        oneofKind: "getPeerBotCommands",
                        getPeerBotCommands: GetPeerBotCommandsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getPeerBotCommands)
                    };
                    break;
                case /* ShowInChatListResult showInChatList */ 47:
                    message.result = {
                        oneofKind: "showInChatList",
                        showInChatList: ShowInChatListResult.internalBinaryRead(reader, reader.uint32(), options, message.result.showInChatList)
                    };
                    break;
                case /* ReserveChatIdsResult reserveChatIds */ 48:
                    message.result = {
                        oneofKind: "reserveChatIds",
                        reserveChatIds: ReserveChatIdsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.reserveChatIds)
                    };
                    break;
                case /* InvokeMessageActionResult invokeMessageAction */ 49:
                    message.result = {
                        oneofKind: "invokeMessageAction",
                        invokeMessageAction: InvokeMessageActionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.invokeMessageAction)
                    };
                    break;
                case /* AnswerMessageActionResult answerMessageAction */ 50:
                    message.result = {
                        oneofKind: "answerMessageAction",
                        answerMessageAction: AnswerMessageActionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.answerMessageAction)
                    };
                    break;
                case /* RevokeSessionResult revokeSession */ 51:
                    message.result = {
                        oneofKind: "revokeSession",
                        revokeSession: RevokeSessionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.revokeSession)
                    };
                    break;
                case /* UpdateDialogOpenResult updateDialogOpen */ 52:
                    message.result = {
                        oneofKind: "updateDialogOpen",
                        updateDialogOpen: UpdateDialogOpenResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateDialogOpen)
                    };
                    break;
                case /* UpdateDialogOrderResult updateDialogOrder */ 53:
                    message.result = {
                        oneofKind: "updateDialogOrder",
                        updateDialogOrder: UpdateDialogOrderResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateDialogOrder)
                    };
                    break;
                case /* ClearChatHistoryResult clearChatHistory */ 54:
                    message.result = {
                        oneofKind: "clearChatHistory",
                        clearChatHistory: ClearChatHistoryResult.internalBinaryRead(reader, reader.uint32(), options, message.result.clearChatHistory)
                    };
                    break;
                case /* DeleteBotResult deleteBot */ 55:
                    message.result = {
                        oneofKind: "deleteBot",
                        deleteBot: DeleteBotResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteBot)
                    };
                    break;
                case /* DeleteMessageAttachmentResult deleteMessageAttachment */ 56:
                    message.result = {
                        oneofKind: "deleteMessageAttachment",
                        deleteMessageAttachment: DeleteMessageAttachmentResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteMessageAttachment)
                    };
                    break;
                case /* SetBotAvatarResult setBotAvatar */ 57:
                    message.result = {
                        oneofKind: "setBotAvatar",
                        setBotAvatar: SetBotAvatarResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setBotAvatar)
                    };
                    break;
                case /* ClearBotAvatarResult clearBotAvatar */ 58:
                    message.result = {
                        oneofKind: "clearBotAvatar",
                        clearBotAvatar: ClearBotAvatarResult.internalBinaryRead(reader, reader.uint32(), options, message.result.clearBotAvatar)
                    };
                    break;
                case /* GetBotPresenceResult getBotPresence */ 59:
                    message.result = {
                        oneofKind: "getBotPresence",
                        getBotPresence: GetBotPresenceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getBotPresence)
                    };
                    break;
                case /* SetBotPresenceStateResult setBotPresenceState */ 60:
                    message.result = {
                        oneofKind: "setBotPresenceState",
                        setBotPresenceState: SetBotPresenceStateResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setBotPresenceState)
                    };
                    break;
                case /* UpdateDialogFollowModeResult updateDialogFollowMode */ 61:
                    message.result = {
                        oneofKind: "updateDialogFollowMode",
                        updateDialogFollowMode: UpdateDialogFollowModeResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateDialogFollowMode)
                    };
                    break;
                case /* GetSessionsResult getSessions */ 62:
                    message.result = {
                        oneofKind: "getSessions",
                        getSessions: GetSessionsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getSessions)
                    };
                    break;
                case /* CheckUsernameResult checkUsername */ 63:
                    message.result = {
                        oneofKind: "checkUsername",
                        checkUsername: CheckUsernameResult.internalBinaryRead(reader, reader.uint32(), options, message.result.checkUsername)
                    };
                    break;
                case /* ChangeUsernameResult changeUsername */ 64:
                    message.result = {
                        oneofKind: "changeUsername",
                        changeUsername: ChangeUsernameResult.internalBinaryRead(reader, reader.uint32(), options, message.result.changeUsername)
                    };
                    break;
                case /* UpdateProfileResult updateProfile */ 65:
                    message.result = {
                        oneofKind: "updateProfile",
                        updateProfile: UpdateProfileResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateProfile)
                    };
                    break;
                case /* GetSpaceUrlPreviewExclusionsResult getSpaceUrlPreviewExclusions */ 66:
                    message.result = {
                        oneofKind: "getSpaceUrlPreviewExclusions",
                        getSpaceUrlPreviewExclusions: GetSpaceUrlPreviewExclusionsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getSpaceUrlPreviewExclusions)
                    };
                    break;
                case /* AddSpaceUrlPreviewExclusionResult addSpaceUrlPreviewExclusion */ 67:
                    message.result = {
                        oneofKind: "addSpaceUrlPreviewExclusion",
                        addSpaceUrlPreviewExclusion: AddSpaceUrlPreviewExclusionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.addSpaceUrlPreviewExclusion)
                    };
                    break;
                case /* RemoveSpaceUrlPreviewExclusionResult removeSpaceUrlPreviewExclusion */ 68:
                    message.result = {
                        oneofKind: "removeSpaceUrlPreviewExclusion",
                        removeSpaceUrlPreviewExclusion: RemoveSpaceUrlPreviewExclusionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.removeSpaceUrlPreviewExclusion)
                    };
                    break;
                case /* GetUserGroupsResult getUserGroups */ 69:
                    message.result = {
                        oneofKind: "getUserGroups",
                        getUserGroups: GetUserGroupsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getUserGroups)
                    };
                    break;
                case /* CreateUserGroupResult createUserGroup */ 70:
                    message.result = {
                        oneofKind: "createUserGroup",
                        createUserGroup: CreateUserGroupResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createUserGroup)
                    };
                    break;
                case /* UpdateUserGroupResult updateUserGroup */ 71:
                    message.result = {
                        oneofKind: "updateUserGroup",
                        updateUserGroup: UpdateUserGroupResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateUserGroup)
                    };
                    break;
                case /* DeleteUserGroupResult deleteUserGroup */ 72:
                    message.result = {
                        oneofKind: "deleteUserGroup",
                        deleteUserGroup: DeleteUserGroupResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteUserGroup)
                    };
                    break;
                case /* GetSpaceSettingsResult getSpaceSettings */ 73:
                    message.result = {
                        oneofKind: "getSpaceSettings",
                        getSpaceSettings: GetSpaceSettingsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getSpaceSettings)
                    };
                    break;
                case /* ToggleSpaceGridResult toggleSpaceGrid */ 74:
                    message.result = {
                        oneofKind: "toggleSpaceGrid",
                        toggleSpaceGrid: ToggleSpaceGridResult.internalBinaryRead(reader, reader.uint32(), options, message.result.toggleSpaceGrid)
                    };
                    break;
                case /* GetThreadReferencesResult getThreadReferences */ 75:
                    message.result = {
                        oneofKind: "getThreadReferences",
                        getThreadReferences: GetThreadReferencesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getThreadReferences)
                    };
                    break;
                case /* GetThreadSubthreadsResult getThreadSubthreads */ 76:
                    message.result = {
                        oneofKind: "getThreadSubthreads",
                        getThreadSubthreads: GetThreadSubthreadsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getThreadSubthreads)
                    };
                    break;
                case /* GetPeerBotsResult getPeerBots */ 77:
                    message.result = {
                        oneofKind: "getPeerBots",
                        getPeerBots: GetPeerBotsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getPeerBots)
                    };
                    break;
                case /* GetMyBotCapabilitiesResult getMyBotCapabilities */ 78:
                    message.result = {
                        oneofKind: "getMyBotCapabilities",
                        getMyBotCapabilities: GetMyBotCapabilitiesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getMyBotCapabilities)
                    };
                    break;
                case /* SetMyBotCapabilitiesResult setMyBotCapabilities */ 79:
                    message.result = {
                        oneofKind: "setMyBotCapabilities",
                        setMyBotCapabilities: SetMyBotCapabilitiesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setMyBotCapabilities)
                    };
                    break;
                case /* RequestBotChatSettingsResult requestBotChatSettings */ 80:
                    message.result = {
                        oneofKind: "requestBotChatSettings",
                        requestBotChatSettings: RequestBotChatSettingsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.requestBotChatSettings)
                    };
                    break;
                case /* InvokeBotChatSettingsItemResult invokeBotChatSettingsItem */ 81:
                    message.result = {
                        oneofKind: "invokeBotChatSettingsItem",
                        invokeBotChatSettingsItem: InvokeBotChatSettingsItemResult.internalBinaryRead(reader, reader.uint32(), options, message.result.invokeBotChatSettingsItem)
                    };
                    break;
                case /* AnswerBotChatSettingsResult answerBotChatSettings */ 82:
                    message.result = {
                        oneofKind: "answerBotChatSettings",
                        answerBotChatSettings: AnswerBotChatSettingsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.answerBotChatSettings)
                    };
                    break;
                case /* GetGridResult getGrid */ 84:
                    message.result = {
                        oneofKind: "getGrid",
                        getGrid: GetGridResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getGrid)
                    };
                    break;
                case /* CreateGridRoomResult createGridRoom */ 85:
                    message.result = {
                        oneofKind: "createGridRoom",
                        createGridRoom: CreateGridRoomResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createGridRoom)
                    };
                    break;
                case /* JoinGridRoomResult joinGridRoom */ 86:
                    message.result = {
                        oneofKind: "joinGridRoom",
                        joinGridRoom: JoinGridRoomResult.internalBinaryRead(reader, reader.uint32(), options, message.result.joinGridRoom)
                    };
                    break;
                case /* LeaveGridRoomResult leaveGridRoom */ 87:
                    message.result = {
                        oneofKind: "leaveGridRoom",
                        leaveGridRoom: LeaveGridRoomResult.internalBinaryRead(reader, reader.uint32(), options, message.result.leaveGridRoom)
                    };
                    break;
                case /* SetGridRoomTitleResult setGridRoomTitle */ 88:
                    message.result = {
                        oneofKind: "setGridRoomTitle",
                        setGridRoomTitle: SetGridRoomTitleResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setGridRoomTitle)
                    };
                    break;
                case /* SetGridRoomLockedResult setGridRoomLocked */ 89:
                    message.result = {
                        oneofKind: "setGridRoomLocked",
                        setGridRoomLocked: SetGridRoomLockedResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setGridRoomLocked)
                    };
                    break;
                case /* DeleteGridRoomResult deleteGridRoom */ 90:
                    message.result = {
                        oneofKind: "deleteGridRoom",
                        deleteGridRoom: DeleteGridRoomResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteGridRoom)
                    };
                    break;
                case /* PrepareGridConnectionResult prepareGridConnection */ 91:
                    message.result = {
                        oneofKind: "prepareGridConnection",
                        prepareGridConnection: PrepareGridConnectionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.prepareGridConnection)
                    };
                    break;
                case /* SetGridAvatarMicrophoneEnabledResult setGridAvatarMicrophoneEnabled */ 92:
                    message.result = {
                        oneofKind: "setGridAvatarMicrophoneEnabled",
                        setGridAvatarMicrophoneEnabled: SetGridAvatarMicrophoneEnabledResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setGridAvatarMicrophoneEnabled)
                    };
                    break;
                case /* GetGridHomeResult getGridHome */ 93:
                    message.result = {
                        oneofKind: "getGridHome",
                        getGridHome: GetGridHomeResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getGridHome)
                    };
                    break;
                case /* CreateCliSessionResult createCliSession */ 94:
                    message.result = {
                        oneofKind: "createCliSession",
                        createCliSession: CreateCliSessionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createCliSession)
                    };
                    break;
                case /* SetProfilePhotoResult setProfilePhoto */ 95:
                    message.result = {
                        oneofKind: "setProfilePhoto",
                        setProfilePhoto: SetProfilePhotoResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setProfilePhoto)
                    };
                    break;
                case /* GetExternalProfilePhotoResult getExternalProfilePhoto */ 96:
                    message.result = {
                        oneofKind: "getExternalProfilePhoto",
                        getExternalProfilePhoto: GetExternalProfilePhotoResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getExternalProfilePhoto)
                    };
                    break;
                case /* GetChatTranscriptResult getChatTranscript */ 97:
                    message.result = {
                        oneofKind: "getChatTranscript",
                        getChatTranscript: GetChatTranscriptResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getChatTranscript)
                    };
                    break;
                case /* SearchExternalResourcesResult searchExternalResources */ 98:
                    message.result = {
                        oneofKind: "searchExternalResources",
                        searchExternalResources: SearchExternalResourcesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.searchExternalResources)
                    };
                    break;
                case /* JoinPublicSpaceResult joinPublicSpace */ 99:
                    message.result = {
                        oneofKind: "joinPublicSpace",
                        joinPublicSpace: JoinPublicSpaceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.joinPublicSpace)
                    };
                    break;
                case /* CollapseHistoryResult collapseHistory */ 100:
                    message.result = {
                        oneofKind: "collapseHistory",
                        collapseHistory: CollapseHistoryResult.internalBinaryRead(reader, reader.uint32(), options, message.result.collapseHistory)
                    };
                    break;
                case /* ListConnectorsResult listConnectors */ 101:
                    message.result = {
                        oneofKind: "listConnectors",
                        listConnectors: ListConnectorsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.listConnectors)
                    };
                    break;
                case /* PrepareConnectorOAuthResult prepareConnectorOAuth */ 102:
                    message.result = {
                        oneofKind: "prepareConnectorOAuth",
                        prepareConnectorOAuth: PrepareConnectorOAuthResult.internalBinaryRead(reader, reader.uint32(), options, message.result.prepareConnectorOAuth)
                    };
                    break;
                case /* DisconnectConnectorResult disconnectConnector */ 103:
                    message.result = {
                        oneofKind: "disconnectConnector",
                        disconnectConnector: DisconnectConnectorResult.internalBinaryRead(reader, reader.uint32(), options, message.result.disconnectConnector)
                    };
                    break;
                case /* SearchUsersResult searchUsers */ 104:
                    message.result = {
                        oneofKind: "searchUsers",
                        searchUsers: SearchUsersResult.internalBinaryRead(reader, reader.uint32(), options, message.result.searchUsers)
                    };
                    break;
                case /* InviteToInlineResult inviteToInline */ 105:
                    message.result = {
                        oneofKind: "inviteToInline",
                        inviteToInline: InviteToInlineResult.internalBinaryRead(reader, reader.uint32(), options, message.result.inviteToInline)
                    };
                    break;
                case /* ResolveUrlPreviewResult resolveUrlPreview */ 106:
                    message.result = {
                        oneofKind: "resolveUrlPreview",
                        resolveUrlPreview: ResolveUrlPreviewResult.internalBinaryRead(reader, reader.uint32(), options, message.result.resolveUrlPreview)
                    };
                    break;
                case /* CreateBotAgentResult createBotAgent */ 107:
                    message.result = {
                        oneofKind: "createBotAgent",
                        createBotAgent: CreateBotAgentResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createBotAgent)
                    };
                    break;
                case /* GetBotAgentResult getBotAgent */ 108:
                    message.result = {
                        oneofKind: "getBotAgent",
                        getBotAgent: GetBotAgentResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getBotAgent)
                    };
                    break;
                case /* ListBotAgentsResult listBotAgents */ 109:
                    message.result = {
                        oneofKind: "listBotAgents",
                        listBotAgents: ListBotAgentsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.listBotAgents)
                    };
                    break;
                case /* CreateSpaceResult createSpace */ 110:
                    message.result = {
                        oneofKind: "createSpace",
                        createSpace: CreateSpaceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createSpace)
                    };
                    break;
                case /* DeleteSpaceResult deleteSpace */ 111:
                    message.result = {
                        oneofKind: "deleteSpace",
                        deleteSpace: DeleteSpaceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteSpace)
                    };
                    break;
                case /* LeaveSpaceResult leaveSpace */ 112:
                    message.result = {
                        oneofKind: "leaveSpace",
                        leaveSpace: LeaveSpaceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.leaveSpace)
                    };
                    break;
                case /* GetConnectorConfigResult getConnectorConfig */ 113:
                    message.result = {
                        oneofKind: "getConnectorConfig",
                        getConnectorConfig: GetConnectorConfigResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getConnectorConfig)
                    };
                    break;
                case /* SetConnectorConfigResult setConnectorConfig */ 114:
                    message.result = {
                        oneofKind: "setConnectorConfig",
                        setConnectorConfig: SetConnectorConfigResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setConnectorConfig)
                    };
                    break;
                case /* CreateExternalTaskResult createExternalTask */ 115:
                    message.result = {
                        oneofKind: "createExternalTask",
                        createExternalTask: CreateExternalTaskResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createExternalTask)
                    };
                    break;
                case /* UnregisterDeviceResult unregisterDevice */ 116:
                    message.result = {
                        oneofKind: "unregisterDevice",
                        unregisterDevice: UnregisterDeviceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.unregisterDevice)
                    };
                    break;
                case /* LogOutResult logOut */ 117:
                    message.result = {
                        oneofKind: "logOut",
                        logOut: LogOutResult.internalBinaryRead(reader, reader.uint32(), options, message.result.logOut)
                    };
                    break;
                case /* CreateUploadResult createUpload */ 118:
                    message.result = {
                        oneofKind: "createUpload",
                        createUpload: CreateUploadResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createUpload)
                    };
                    break;
                case /* SaveUploadPartResult saveUploadPart */ 119:
                    message.result = {
                        oneofKind: "saveUploadPart",
                        saveUploadPart: SaveUploadPartResult.internalBinaryRead(reader, reader.uint32(), options, message.result.saveUploadPart)
                    };
                    break;
                case /* GetUploadStateResult getUploadState */ 120:
                    message.result = {
                        oneofKind: "getUploadState",
                        getUploadState: GetUploadStateResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getUploadState)
                    };
                    break;
                case /* FinishUploadResult finishUpload */ 121:
                    message.result = {
                        oneofKind: "finishUpload",
                        finishUpload: FinishUploadResult.internalBinaryRead(reader, reader.uint32(), options, message.result.finishUpload)
                    };
                    break;
                case /* CancelUploadResult cancelUpload */ 122:
                    message.result = {
                        oneofKind: "cancelUpload",
                        cancelUpload: CancelUploadResult.internalBinaryRead(reader, reader.uint32(), options, message.result.cancelUpload)
                    };
                    break;
                case /* UpdateSessionResult updateSession */ 123:
                    message.result = {
                        oneofKind: "updateSession",
                        updateSession: UpdateSessionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateSession)
                    };
                    break;
                case /* UpdateDialogArchivedResult updateDialogArchived */ 124:
                    message.result = {
                        oneofKind: "updateDialogArchived",
                        updateDialogArchived: UpdateDialogArchivedResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateDialogArchived)
                    };
                    break;
                case /* CreateDialogFolderResult createDialogFolder */ 125:
                    message.result = {
                        oneofKind: "createDialogFolder",
                        createDialogFolder: CreateDialogFolderResult.internalBinaryRead(reader, reader.uint32(), options, message.result.createDialogFolder)
                    };
                    break;
                case /* UpdateDialogFolderResult updateDialogFolder */ 126:
                    message.result = {
                        oneofKind: "updateDialogFolder",
                        updateDialogFolder: UpdateDialogFolderResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateDialogFolder)
                    };
                    break;
                case /* DeleteDialogFolderResult deleteDialogFolder */ 127:
                    message.result = {
                        oneofKind: "deleteDialogFolder",
                        deleteDialogFolder: DeleteDialogFolderResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteDialogFolder)
                    };
                    break;
                case /* GetSpaceResult getSpace */ 128:
                    message.result = {
                        oneofKind: "getSpace",
                        getSpace: GetSpaceResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getSpace)
                    };
                    break;
                case /* ConnectAgentSessionResult connectAgentSession */ 129:
                    message.result = {
                        oneofKind: "connectAgentSession",
                        connectAgentSession: ConnectAgentSessionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.connectAgentSession)
                    };
                    break;
                case /* SyncAgentSessionMessagesResult syncAgentSessionMessages */ 130:
                    message.result = {
                        oneofKind: "syncAgentSessionMessages",
                        syncAgentSessionMessages: SyncAgentSessionMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.syncAgentSessionMessages)
                    };
                    break;
                case /* GetAgentSessionResult getAgentSession */ 131:
                    message.result = {
                        oneofKind: "getAgentSession",
                        getAgentSession: GetAgentSessionResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getAgentSession)
                    };
                    break;
                case /* UpdateBotAgentResult updateBotAgent */ 132:
                    message.result = {
                        oneofKind: "updateBotAgent",
                        updateBotAgent: UpdateBotAgentResult.internalBinaryRead(reader, reader.uint32(), options, message.result.updateBotAgent)
                    };
                    break;
                case /* DeleteBotAgentResult deleteBotAgent */ 133:
                    message.result = {
                        oneofKind: "deleteBotAgent",
                        deleteBotAgent: DeleteBotAgentResult.internalBinaryRead(reader, reader.uint32(), options, message.result.deleteBotAgent)
                    };
                    break;
                case /* JoinSpaceByInviteTokenResult joinSpaceByInviteToken */ 134:
                    message.result = {
                        oneofKind: "joinSpaceByInviteToken",
                        joinSpaceByInviteToken: JoinSpaceByInviteTokenResult.internalBinaryRead(reader, reader.uint32(), options, message.result.joinSpaceByInviteToken)
                    };
                    break;
                case /* GetSpaceInviteLinkResult getSpaceInviteLink */ 135:
                    message.result = {
                        oneofKind: "getSpaceInviteLink",
                        getSpaceInviteLink: GetSpaceInviteLinkResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getSpaceInviteLink)
                    };
                    break;
                case /* SetSpaceInviteLinkEnabledResult setSpaceInviteLinkEnabled */ 136:
                    message.result = {
                        oneofKind: "setSpaceInviteLinkEnabled",
                        setSpaceInviteLinkEnabled: SetSpaceInviteLinkEnabledResult.internalBinaryRead(reader, reader.uint32(), options, message.result.setSpaceInviteLinkEnabled)
                    };
                    break;
                case /* GetFilePartResult getFilePart */ 137:
                    message.result = {
                        oneofKind: "getFilePart",
                        getFilePart: GetFilePartResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getFilePart)
                    };
                    break;
                case /* AcknowledgeMessagesResult acknowledgeMessages */ 138:
                    message.result = {
                        oneofKind: "acknowledgeMessages",
                        acknowledgeMessages: AcknowledgeMessagesResult.internalBinaryRead(reader, reader.uint32(), options, message.result.acknowledgeMessages)
                    };
                    break;
                case /* GetUsersResult getUsers */ 139:
                    message.result = {
                        oneofKind: "getUsers",
                        getUsers: GetUsersResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getUsers)
                    };
                    break;
                case /* GetBotSkillsResult getBotSkills */ 140:
                    message.result = {
                        oneofKind: "getBotSkills",
                        getBotSkills: GetBotSkillsResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getBotSkills)
                    };
                    break;
                case /* GetBotConfigurationCatalogResult getBotConfigurationCatalog */ 141:
                    message.result = {
                        oneofKind: "getBotConfigurationCatalog",
                        getBotConfigurationCatalog: GetBotConfigurationCatalogResult.internalBinaryRead(reader, reader.uint32(), options, message.result.getBotConfigurationCatalog)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 req_msg_id = 1; */
        if (message.reqMsgId !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.reqMsgId);
        /* GetMeResult getMe = 2; */
        if (message.result.oneofKind === "getMe")
            GetMeResult.internalBinaryWrite(message.result.getMe, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* GetPeerPhotoResult getPeerPhoto = 3; */
        if (message.result.oneofKind === "getPeerPhoto")
            GetPeerPhotoResult.internalBinaryWrite(message.result.getPeerPhoto, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* DeleteMessagesResult deleteMessages = 4; */
        if (message.result.oneofKind === "deleteMessages")
            DeleteMessagesResult.internalBinaryWrite(message.result.deleteMessages, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* SendMessageResult sendMessage = 5; */
        if (message.result.oneofKind === "sendMessage")
            SendMessageResult.internalBinaryWrite(message.result.sendMessage, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* GetChatHistoryResult getChatHistory = 6; */
        if (message.result.oneofKind === "getChatHistory")
            GetChatHistoryResult.internalBinaryWrite(message.result.getChatHistory, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* AddReactionResult addReaction = 7; */
        if (message.result.oneofKind === "addReaction")
            AddReactionResult.internalBinaryWrite(message.result.addReaction, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* DeleteReactionResult deleteReaction = 8; */
        if (message.result.oneofKind === "deleteReaction")
            DeleteReactionResult.internalBinaryWrite(message.result.deleteReaction, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* EditMessageResult editMessage = 9; */
        if (message.result.oneofKind === "editMessage")
            EditMessageResult.internalBinaryWrite(message.result.editMessage, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* CreateChatResult createChat = 10; */
        if (message.result.oneofKind === "createChat")
            CreateChatResult.internalBinaryWrite(message.result.createChat, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceMembersResult getSpaceMembers = 11; */
        if (message.result.oneofKind === "getSpaceMembers")
            GetSpaceMembersResult.internalBinaryWrite(message.result.getSpaceMembers, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* DeleteChatResult deleteChat = 12; */
        if (message.result.oneofKind === "deleteChat")
            DeleteChatResult.internalBinaryWrite(message.result.deleteChat, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* InviteToSpaceResult inviteToSpace = 13; */
        if (message.result.oneofKind === "inviteToSpace")
            InviteToSpaceResult.internalBinaryWrite(message.result.inviteToSpace, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* GetChatParticipantsResult getChatParticipants = 14; */
        if (message.result.oneofKind === "getChatParticipants")
            GetChatParticipantsResult.internalBinaryWrite(message.result.getChatParticipants, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* AddChatParticipantResult addChatParticipant = 15; */
        if (message.result.oneofKind === "addChatParticipant")
            AddChatParticipantResult.internalBinaryWrite(message.result.addChatParticipant, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* RemoveChatParticipantResult removeChatParticipant = 16; */
        if (message.result.oneofKind === "removeChatParticipant")
            RemoveChatParticipantResult.internalBinaryWrite(message.result.removeChatParticipant, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* TranslateMessagesResult translateMessages = 17; */
        if (message.result.oneofKind === "translateMessages")
            TranslateMessagesResult.internalBinaryWrite(message.result.translateMessages, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* GetChatsResult getChats = 18; */
        if (message.result.oneofKind === "getChats")
            GetChatsResult.internalBinaryWrite(message.result.getChats, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserSettingsResult updateUserSettings = 19; */
        if (message.result.oneofKind === "updateUserSettings")
            UpdateUserSettingsResult.internalBinaryWrite(message.result.updateUserSettings, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* GetUserSettingsResult getUserSettings = 20; */
        if (message.result.oneofKind === "getUserSettings")
            GetUserSettingsResult.internalBinaryWrite(message.result.getUserSettings, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* SendComposeActionResult sendComposeAction = 21; */
        if (message.result.oneofKind === "sendComposeAction")
            SendComposeActionResult.internalBinaryWrite(message.result.sendComposeAction, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* CreateBotResult createBot = 22; */
        if (message.result.oneofKind === "createBot")
            CreateBotResult.internalBinaryWrite(message.result.createBot, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* DeleteMemberResult deleteMember = 23; */
        if (message.result.oneofKind === "deleteMember")
            DeleteMemberResult.internalBinaryWrite(message.result.deleteMember, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* MarkAsUnreadResult markAsUnread = 24; */
        if (message.result.oneofKind === "markAsUnread")
            MarkAsUnreadResult.internalBinaryWrite(message.result.markAsUnread, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* GetUpdatesStateResult getUpdatesState = 25; */
        if (message.result.oneofKind === "getUpdatesState")
            GetUpdatesStateResult.internalBinaryWrite(message.result.getUpdatesState, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* GetChatResult getChat = 26; */
        if (message.result.oneofKind === "getChat")
            GetChatResult.internalBinaryWrite(message.result.getChat, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* GetUpdatesResult getUpdates = 27; */
        if (message.result.oneofKind === "getUpdates")
            GetUpdatesResult.internalBinaryWrite(message.result.getUpdates, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMemberAccessResult updateMemberAccess = 28; */
        if (message.result.oneofKind === "updateMemberAccess")
            UpdateMemberAccessResult.internalBinaryWrite(message.result.updateMemberAccess, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* SearchMessagesResult searchMessages = 29; */
        if (message.result.oneofKind === "searchMessages")
            SearchMessagesResult.internalBinaryWrite(message.result.searchMessages, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* ForwardMessagesResult forwardMessages = 30; */
        if (message.result.oneofKind === "forwardMessages")
            ForwardMessagesResult.internalBinaryWrite(message.result.forwardMessages, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatVisibilityResult updateChatVisibility = 31; */
        if (message.result.oneofKind === "updateChatVisibility")
            UpdateChatVisibilityResult.internalBinaryWrite(message.result.updateChatVisibility, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* PinMessageResult pinMessage = 32; */
        if (message.result.oneofKind === "pinMessage")
            PinMessageResult.internalBinaryWrite(message.result.pinMessage, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatInfoResult updateChatInfo = 33; */
        if (message.result.oneofKind === "updateChatInfo")
            UpdateChatInfoResult.internalBinaryWrite(message.result.updateChatInfo, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* ListBotsResult listBots = 34; */
        if (message.result.oneofKind === "listBots")
            ListBotsResult.internalBinaryWrite(message.result.listBots, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* RevealBotTokenResult revealBotToken = 35; */
        if (message.result.oneofKind === "revealBotToken")
            RevealBotTokenResult.internalBinaryWrite(message.result.revealBotToken, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* MoveThreadResult moveThread = 36; */
        if (message.result.oneofKind === "moveThread")
            MoveThreadResult.internalBinaryWrite(message.result.moveThread, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* RotateBotTokenResult rotateBotToken = 37; */
        if (message.result.oneofKind === "rotateBotToken")
            RotateBotTokenResult.internalBinaryWrite(message.result.rotateBotToken, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBotProfileResult updateBotProfile = 38; */
        if (message.result.oneofKind === "updateBotProfile")
            UpdateBotProfileResult.internalBinaryWrite(message.result.updateBotProfile, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* GetMessagesResult getMessages = 39; */
        if (message.result.oneofKind === "getMessages")
            GetMessagesResult.internalBinaryWrite(message.result.getMessages, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogNotificationSettingsResult updateDialogNotificationSettings = 40; */
        if (message.result.oneofKind === "updateDialogNotificationSettings")
            UpdateDialogNotificationSettingsResult.internalBinaryWrite(message.result.updateDialogNotificationSettings, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* ReadMessagesResult readMessages = 41; */
        if (message.result.oneofKind === "readMessages")
            ReadMessagesResult.internalBinaryWrite(message.result.readMessages, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* RegisterDeviceResult registerDevice = 42; */
        if (message.result.oneofKind === "registerDevice")
            RegisterDeviceResult.internalBinaryWrite(message.result.registerDevice, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* CreateSubthreadResult createSubthread = 43; */
        if (message.result.oneofKind === "createSubthread")
            CreateSubthreadResult.internalBinaryWrite(message.result.createSubthread, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* GetBotCommandsResult getBotCommands = 44; */
        if (message.result.oneofKind === "getBotCommands")
            GetBotCommandsResult.internalBinaryWrite(message.result.getBotCommands, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* SetBotCommandsResult setBotCommands = 45; */
        if (message.result.oneofKind === "setBotCommands")
            SetBotCommandsResult.internalBinaryWrite(message.result.setBotCommands, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* GetPeerBotCommandsResult getPeerBotCommands = 46; */
        if (message.result.oneofKind === "getPeerBotCommands")
            GetPeerBotCommandsResult.internalBinaryWrite(message.result.getPeerBotCommands, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* ShowInChatListResult showInChatList = 47; */
        if (message.result.oneofKind === "showInChatList")
            ShowInChatListResult.internalBinaryWrite(message.result.showInChatList, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* ReserveChatIdsResult reserveChatIds = 48; */
        if (message.result.oneofKind === "reserveChatIds")
            ReserveChatIdsResult.internalBinaryWrite(message.result.reserveChatIds, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* InvokeMessageActionResult invokeMessageAction = 49; */
        if (message.result.oneofKind === "invokeMessageAction")
            InvokeMessageActionResult.internalBinaryWrite(message.result.invokeMessageAction, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* AnswerMessageActionResult answerMessageAction = 50; */
        if (message.result.oneofKind === "answerMessageAction")
            AnswerMessageActionResult.internalBinaryWrite(message.result.answerMessageAction, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* RevokeSessionResult revokeSession = 51; */
        if (message.result.oneofKind === "revokeSession")
            RevokeSessionResult.internalBinaryWrite(message.result.revokeSession, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogOpenResult updateDialogOpen = 52; */
        if (message.result.oneofKind === "updateDialogOpen")
            UpdateDialogOpenResult.internalBinaryWrite(message.result.updateDialogOpen, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogOrderResult updateDialogOrder = 53; */
        if (message.result.oneofKind === "updateDialogOrder")
            UpdateDialogOrderResult.internalBinaryWrite(message.result.updateDialogOrder, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* ClearChatHistoryResult clearChatHistory = 54; */
        if (message.result.oneofKind === "clearChatHistory")
            ClearChatHistoryResult.internalBinaryWrite(message.result.clearChatHistory, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* DeleteBotResult deleteBot = 55; */
        if (message.result.oneofKind === "deleteBot")
            DeleteBotResult.internalBinaryWrite(message.result.deleteBot, writer.tag(55, WireType.LengthDelimited).fork(), options).join();
        /* DeleteMessageAttachmentResult deleteMessageAttachment = 56; */
        if (message.result.oneofKind === "deleteMessageAttachment")
            DeleteMessageAttachmentResult.internalBinaryWrite(message.result.deleteMessageAttachment, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* SetBotAvatarResult setBotAvatar = 57; */
        if (message.result.oneofKind === "setBotAvatar")
            SetBotAvatarResult.internalBinaryWrite(message.result.setBotAvatar, writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* ClearBotAvatarResult clearBotAvatar = 58; */
        if (message.result.oneofKind === "clearBotAvatar")
            ClearBotAvatarResult.internalBinaryWrite(message.result.clearBotAvatar, writer.tag(58, WireType.LengthDelimited).fork(), options).join();
        /* GetBotPresenceResult getBotPresence = 59; */
        if (message.result.oneofKind === "getBotPresence")
            GetBotPresenceResult.internalBinaryWrite(message.result.getBotPresence, writer.tag(59, WireType.LengthDelimited).fork(), options).join();
        /* SetBotPresenceStateResult setBotPresenceState = 60; */
        if (message.result.oneofKind === "setBotPresenceState")
            SetBotPresenceStateResult.internalBinaryWrite(message.result.setBotPresenceState, writer.tag(60, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogFollowModeResult updateDialogFollowMode = 61; */
        if (message.result.oneofKind === "updateDialogFollowMode")
            UpdateDialogFollowModeResult.internalBinaryWrite(message.result.updateDialogFollowMode, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* GetSessionsResult getSessions = 62; */
        if (message.result.oneofKind === "getSessions")
            GetSessionsResult.internalBinaryWrite(message.result.getSessions, writer.tag(62, WireType.LengthDelimited).fork(), options).join();
        /* CheckUsernameResult checkUsername = 63; */
        if (message.result.oneofKind === "checkUsername")
            CheckUsernameResult.internalBinaryWrite(message.result.checkUsername, writer.tag(63, WireType.LengthDelimited).fork(), options).join();
        /* ChangeUsernameResult changeUsername = 64; */
        if (message.result.oneofKind === "changeUsername")
            ChangeUsernameResult.internalBinaryWrite(message.result.changeUsername, writer.tag(64, WireType.LengthDelimited).fork(), options).join();
        /* UpdateProfileResult updateProfile = 65; */
        if (message.result.oneofKind === "updateProfile")
            UpdateProfileResult.internalBinaryWrite(message.result.updateProfile, writer.tag(65, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceUrlPreviewExclusionsResult getSpaceUrlPreviewExclusions = 66; */
        if (message.result.oneofKind === "getSpaceUrlPreviewExclusions")
            GetSpaceUrlPreviewExclusionsResult.internalBinaryWrite(message.result.getSpaceUrlPreviewExclusions, writer.tag(66, WireType.LengthDelimited).fork(), options).join();
        /* AddSpaceUrlPreviewExclusionResult addSpaceUrlPreviewExclusion = 67; */
        if (message.result.oneofKind === "addSpaceUrlPreviewExclusion")
            AddSpaceUrlPreviewExclusionResult.internalBinaryWrite(message.result.addSpaceUrlPreviewExclusion, writer.tag(67, WireType.LengthDelimited).fork(), options).join();
        /* RemoveSpaceUrlPreviewExclusionResult removeSpaceUrlPreviewExclusion = 68; */
        if (message.result.oneofKind === "removeSpaceUrlPreviewExclusion")
            RemoveSpaceUrlPreviewExclusionResult.internalBinaryWrite(message.result.removeSpaceUrlPreviewExclusion, writer.tag(68, WireType.LengthDelimited).fork(), options).join();
        /* GetUserGroupsResult getUserGroups = 69; */
        if (message.result.oneofKind === "getUserGroups")
            GetUserGroupsResult.internalBinaryWrite(message.result.getUserGroups, writer.tag(69, WireType.LengthDelimited).fork(), options).join();
        /* CreateUserGroupResult createUserGroup = 70; */
        if (message.result.oneofKind === "createUserGroup")
            CreateUserGroupResult.internalBinaryWrite(message.result.createUserGroup, writer.tag(70, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserGroupResult updateUserGroup = 71; */
        if (message.result.oneofKind === "updateUserGroup")
            UpdateUserGroupResult.internalBinaryWrite(message.result.updateUserGroup, writer.tag(71, WireType.LengthDelimited).fork(), options).join();
        /* DeleteUserGroupResult deleteUserGroup = 72; */
        if (message.result.oneofKind === "deleteUserGroup")
            DeleteUserGroupResult.internalBinaryWrite(message.result.deleteUserGroup, writer.tag(72, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceSettingsResult getSpaceSettings = 73; */
        if (message.result.oneofKind === "getSpaceSettings")
            GetSpaceSettingsResult.internalBinaryWrite(message.result.getSpaceSettings, writer.tag(73, WireType.LengthDelimited).fork(), options).join();
        /* ToggleSpaceGridResult toggleSpaceGrid = 74; */
        if (message.result.oneofKind === "toggleSpaceGrid")
            ToggleSpaceGridResult.internalBinaryWrite(message.result.toggleSpaceGrid, writer.tag(74, WireType.LengthDelimited).fork(), options).join();
        /* GetThreadReferencesResult getThreadReferences = 75; */
        if (message.result.oneofKind === "getThreadReferences")
            GetThreadReferencesResult.internalBinaryWrite(message.result.getThreadReferences, writer.tag(75, WireType.LengthDelimited).fork(), options).join();
        /* GetThreadSubthreadsResult getThreadSubthreads = 76; */
        if (message.result.oneofKind === "getThreadSubthreads")
            GetThreadSubthreadsResult.internalBinaryWrite(message.result.getThreadSubthreads, writer.tag(76, WireType.LengthDelimited).fork(), options).join();
        /* GetPeerBotsResult getPeerBots = 77; */
        if (message.result.oneofKind === "getPeerBots")
            GetPeerBotsResult.internalBinaryWrite(message.result.getPeerBots, writer.tag(77, WireType.LengthDelimited).fork(), options).join();
        /* GetMyBotCapabilitiesResult getMyBotCapabilities = 78; */
        if (message.result.oneofKind === "getMyBotCapabilities")
            GetMyBotCapabilitiesResult.internalBinaryWrite(message.result.getMyBotCapabilities, writer.tag(78, WireType.LengthDelimited).fork(), options).join();
        /* SetMyBotCapabilitiesResult setMyBotCapabilities = 79; */
        if (message.result.oneofKind === "setMyBotCapabilities")
            SetMyBotCapabilitiesResult.internalBinaryWrite(message.result.setMyBotCapabilities, writer.tag(79, WireType.LengthDelimited).fork(), options).join();
        /* RequestBotChatSettingsResult requestBotChatSettings = 80; */
        if (message.result.oneofKind === "requestBotChatSettings")
            RequestBotChatSettingsResult.internalBinaryWrite(message.result.requestBotChatSettings, writer.tag(80, WireType.LengthDelimited).fork(), options).join();
        /* InvokeBotChatSettingsItemResult invokeBotChatSettingsItem = 81; */
        if (message.result.oneofKind === "invokeBotChatSettingsItem")
            InvokeBotChatSettingsItemResult.internalBinaryWrite(message.result.invokeBotChatSettingsItem, writer.tag(81, WireType.LengthDelimited).fork(), options).join();
        /* AnswerBotChatSettingsResult answerBotChatSettings = 82; */
        if (message.result.oneofKind === "answerBotChatSettings")
            AnswerBotChatSettingsResult.internalBinaryWrite(message.result.answerBotChatSettings, writer.tag(82, WireType.LengthDelimited).fork(), options).join();
        /* GetGridResult getGrid = 84; */
        if (message.result.oneofKind === "getGrid")
            GetGridResult.internalBinaryWrite(message.result.getGrid, writer.tag(84, WireType.LengthDelimited).fork(), options).join();
        /* CreateGridRoomResult createGridRoom = 85; */
        if (message.result.oneofKind === "createGridRoom")
            CreateGridRoomResult.internalBinaryWrite(message.result.createGridRoom, writer.tag(85, WireType.LengthDelimited).fork(), options).join();
        /* JoinGridRoomResult joinGridRoom = 86; */
        if (message.result.oneofKind === "joinGridRoom")
            JoinGridRoomResult.internalBinaryWrite(message.result.joinGridRoom, writer.tag(86, WireType.LengthDelimited).fork(), options).join();
        /* LeaveGridRoomResult leaveGridRoom = 87; */
        if (message.result.oneofKind === "leaveGridRoom")
            LeaveGridRoomResult.internalBinaryWrite(message.result.leaveGridRoom, writer.tag(87, WireType.LengthDelimited).fork(), options).join();
        /* SetGridRoomTitleResult setGridRoomTitle = 88; */
        if (message.result.oneofKind === "setGridRoomTitle")
            SetGridRoomTitleResult.internalBinaryWrite(message.result.setGridRoomTitle, writer.tag(88, WireType.LengthDelimited).fork(), options).join();
        /* SetGridRoomLockedResult setGridRoomLocked = 89; */
        if (message.result.oneofKind === "setGridRoomLocked")
            SetGridRoomLockedResult.internalBinaryWrite(message.result.setGridRoomLocked, writer.tag(89, WireType.LengthDelimited).fork(), options).join();
        /* DeleteGridRoomResult deleteGridRoom = 90; */
        if (message.result.oneofKind === "deleteGridRoom")
            DeleteGridRoomResult.internalBinaryWrite(message.result.deleteGridRoom, writer.tag(90, WireType.LengthDelimited).fork(), options).join();
        /* PrepareGridConnectionResult prepareGridConnection = 91; */
        if (message.result.oneofKind === "prepareGridConnection")
            PrepareGridConnectionResult.internalBinaryWrite(message.result.prepareGridConnection, writer.tag(91, WireType.LengthDelimited).fork(), options).join();
        /* SetGridAvatarMicrophoneEnabledResult setGridAvatarMicrophoneEnabled = 92; */
        if (message.result.oneofKind === "setGridAvatarMicrophoneEnabled")
            SetGridAvatarMicrophoneEnabledResult.internalBinaryWrite(message.result.setGridAvatarMicrophoneEnabled, writer.tag(92, WireType.LengthDelimited).fork(), options).join();
        /* GetGridHomeResult getGridHome = 93; */
        if (message.result.oneofKind === "getGridHome")
            GetGridHomeResult.internalBinaryWrite(message.result.getGridHome, writer.tag(93, WireType.LengthDelimited).fork(), options).join();
        /* CreateCliSessionResult createCliSession = 94; */
        if (message.result.oneofKind === "createCliSession")
            CreateCliSessionResult.internalBinaryWrite(message.result.createCliSession, writer.tag(94, WireType.LengthDelimited).fork(), options).join();
        /* SetProfilePhotoResult setProfilePhoto = 95; */
        if (message.result.oneofKind === "setProfilePhoto")
            SetProfilePhotoResult.internalBinaryWrite(message.result.setProfilePhoto, writer.tag(95, WireType.LengthDelimited).fork(), options).join();
        /* GetExternalProfilePhotoResult getExternalProfilePhoto = 96; */
        if (message.result.oneofKind === "getExternalProfilePhoto")
            GetExternalProfilePhotoResult.internalBinaryWrite(message.result.getExternalProfilePhoto, writer.tag(96, WireType.LengthDelimited).fork(), options).join();
        /* GetChatTranscriptResult getChatTranscript = 97; */
        if (message.result.oneofKind === "getChatTranscript")
            GetChatTranscriptResult.internalBinaryWrite(message.result.getChatTranscript, writer.tag(97, WireType.LengthDelimited).fork(), options).join();
        /* SearchExternalResourcesResult searchExternalResources = 98; */
        if (message.result.oneofKind === "searchExternalResources")
            SearchExternalResourcesResult.internalBinaryWrite(message.result.searchExternalResources, writer.tag(98, WireType.LengthDelimited).fork(), options).join();
        /* JoinPublicSpaceResult joinPublicSpace = 99; */
        if (message.result.oneofKind === "joinPublicSpace")
            JoinPublicSpaceResult.internalBinaryWrite(message.result.joinPublicSpace, writer.tag(99, WireType.LengthDelimited).fork(), options).join();
        /* CollapseHistoryResult collapseHistory = 100; */
        if (message.result.oneofKind === "collapseHistory")
            CollapseHistoryResult.internalBinaryWrite(message.result.collapseHistory, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* ListConnectorsResult listConnectors = 101; */
        if (message.result.oneofKind === "listConnectors")
            ListConnectorsResult.internalBinaryWrite(message.result.listConnectors, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* PrepareConnectorOAuthResult prepareConnectorOAuth = 102; */
        if (message.result.oneofKind === "prepareConnectorOAuth")
            PrepareConnectorOAuthResult.internalBinaryWrite(message.result.prepareConnectorOAuth, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* DisconnectConnectorResult disconnectConnector = 103; */
        if (message.result.oneofKind === "disconnectConnector")
            DisconnectConnectorResult.internalBinaryWrite(message.result.disconnectConnector, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* SearchUsersResult searchUsers = 104; */
        if (message.result.oneofKind === "searchUsers")
            SearchUsersResult.internalBinaryWrite(message.result.searchUsers, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* InviteToInlineResult inviteToInline = 105; */
        if (message.result.oneofKind === "inviteToInline")
            InviteToInlineResult.internalBinaryWrite(message.result.inviteToInline, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* ResolveUrlPreviewResult resolveUrlPreview = 106; */
        if (message.result.oneofKind === "resolveUrlPreview")
            ResolveUrlPreviewResult.internalBinaryWrite(message.result.resolveUrlPreview, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* CreateBotAgentResult createBotAgent = 107; */
        if (message.result.oneofKind === "createBotAgent")
            CreateBotAgentResult.internalBinaryWrite(message.result.createBotAgent, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* GetBotAgentResult getBotAgent = 108; */
        if (message.result.oneofKind === "getBotAgent")
            GetBotAgentResult.internalBinaryWrite(message.result.getBotAgent, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* ListBotAgentsResult listBotAgents = 109; */
        if (message.result.oneofKind === "listBotAgents")
            ListBotAgentsResult.internalBinaryWrite(message.result.listBotAgents, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* CreateSpaceResult createSpace = 110; */
        if (message.result.oneofKind === "createSpace")
            CreateSpaceResult.internalBinaryWrite(message.result.createSpace, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* DeleteSpaceResult deleteSpace = 111; */
        if (message.result.oneofKind === "deleteSpace")
            DeleteSpaceResult.internalBinaryWrite(message.result.deleteSpace, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* LeaveSpaceResult leaveSpace = 112; */
        if (message.result.oneofKind === "leaveSpace")
            LeaveSpaceResult.internalBinaryWrite(message.result.leaveSpace, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        /* GetConnectorConfigResult getConnectorConfig = 113; */
        if (message.result.oneofKind === "getConnectorConfig")
            GetConnectorConfigResult.internalBinaryWrite(message.result.getConnectorConfig, writer.tag(113, WireType.LengthDelimited).fork(), options).join();
        /* SetConnectorConfigResult setConnectorConfig = 114; */
        if (message.result.oneofKind === "setConnectorConfig")
            SetConnectorConfigResult.internalBinaryWrite(message.result.setConnectorConfig, writer.tag(114, WireType.LengthDelimited).fork(), options).join();
        /* CreateExternalTaskResult createExternalTask = 115; */
        if (message.result.oneofKind === "createExternalTask")
            CreateExternalTaskResult.internalBinaryWrite(message.result.createExternalTask, writer.tag(115, WireType.LengthDelimited).fork(), options).join();
        /* UnregisterDeviceResult unregisterDevice = 116; */
        if (message.result.oneofKind === "unregisterDevice")
            UnregisterDeviceResult.internalBinaryWrite(message.result.unregisterDevice, writer.tag(116, WireType.LengthDelimited).fork(), options).join();
        /* LogOutResult logOut = 117; */
        if (message.result.oneofKind === "logOut")
            LogOutResult.internalBinaryWrite(message.result.logOut, writer.tag(117, WireType.LengthDelimited).fork(), options).join();
        /* CreateUploadResult createUpload = 118; */
        if (message.result.oneofKind === "createUpload")
            CreateUploadResult.internalBinaryWrite(message.result.createUpload, writer.tag(118, WireType.LengthDelimited).fork(), options).join();
        /* SaveUploadPartResult saveUploadPart = 119; */
        if (message.result.oneofKind === "saveUploadPart")
            SaveUploadPartResult.internalBinaryWrite(message.result.saveUploadPart, writer.tag(119, WireType.LengthDelimited).fork(), options).join();
        /* GetUploadStateResult getUploadState = 120; */
        if (message.result.oneofKind === "getUploadState")
            GetUploadStateResult.internalBinaryWrite(message.result.getUploadState, writer.tag(120, WireType.LengthDelimited).fork(), options).join();
        /* FinishUploadResult finishUpload = 121; */
        if (message.result.oneofKind === "finishUpload")
            FinishUploadResult.internalBinaryWrite(message.result.finishUpload, writer.tag(121, WireType.LengthDelimited).fork(), options).join();
        /* CancelUploadResult cancelUpload = 122; */
        if (message.result.oneofKind === "cancelUpload")
            CancelUploadResult.internalBinaryWrite(message.result.cancelUpload, writer.tag(122, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSessionResult updateSession = 123; */
        if (message.result.oneofKind === "updateSession")
            UpdateSessionResult.internalBinaryWrite(message.result.updateSession, writer.tag(123, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogArchivedResult updateDialogArchived = 124; */
        if (message.result.oneofKind === "updateDialogArchived")
            UpdateDialogArchivedResult.internalBinaryWrite(message.result.updateDialogArchived, writer.tag(124, WireType.LengthDelimited).fork(), options).join();
        /* CreateDialogFolderResult createDialogFolder = 125; */
        if (message.result.oneofKind === "createDialogFolder")
            CreateDialogFolderResult.internalBinaryWrite(message.result.createDialogFolder, writer.tag(125, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogFolderResult updateDialogFolder = 126; */
        if (message.result.oneofKind === "updateDialogFolder")
            UpdateDialogFolderResult.internalBinaryWrite(message.result.updateDialogFolder, writer.tag(126, WireType.LengthDelimited).fork(), options).join();
        /* DeleteDialogFolderResult deleteDialogFolder = 127; */
        if (message.result.oneofKind === "deleteDialogFolder")
            DeleteDialogFolderResult.internalBinaryWrite(message.result.deleteDialogFolder, writer.tag(127, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceResult getSpace = 128; */
        if (message.result.oneofKind === "getSpace")
            GetSpaceResult.internalBinaryWrite(message.result.getSpace, writer.tag(128, WireType.LengthDelimited).fork(), options).join();
        /* ConnectAgentSessionResult connectAgentSession = 129; */
        if (message.result.oneofKind === "connectAgentSession")
            ConnectAgentSessionResult.internalBinaryWrite(message.result.connectAgentSession, writer.tag(129, WireType.LengthDelimited).fork(), options).join();
        /* SyncAgentSessionMessagesResult syncAgentSessionMessages = 130; */
        if (message.result.oneofKind === "syncAgentSessionMessages")
            SyncAgentSessionMessagesResult.internalBinaryWrite(message.result.syncAgentSessionMessages, writer.tag(130, WireType.LengthDelimited).fork(), options).join();
        /* GetAgentSessionResult getAgentSession = 131; */
        if (message.result.oneofKind === "getAgentSession")
            GetAgentSessionResult.internalBinaryWrite(message.result.getAgentSession, writer.tag(131, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBotAgentResult updateBotAgent = 132; */
        if (message.result.oneofKind === "updateBotAgent")
            UpdateBotAgentResult.internalBinaryWrite(message.result.updateBotAgent, writer.tag(132, WireType.LengthDelimited).fork(), options).join();
        /* DeleteBotAgentResult deleteBotAgent = 133; */
        if (message.result.oneofKind === "deleteBotAgent")
            DeleteBotAgentResult.internalBinaryWrite(message.result.deleteBotAgent, writer.tag(133, WireType.LengthDelimited).fork(), options).join();
        /* JoinSpaceByInviteTokenResult joinSpaceByInviteToken = 134; */
        if (message.result.oneofKind === "joinSpaceByInviteToken")
            JoinSpaceByInviteTokenResult.internalBinaryWrite(message.result.joinSpaceByInviteToken, writer.tag(134, WireType.LengthDelimited).fork(), options).join();
        /* GetSpaceInviteLinkResult getSpaceInviteLink = 135; */
        if (message.result.oneofKind === "getSpaceInviteLink")
            GetSpaceInviteLinkResult.internalBinaryWrite(message.result.getSpaceInviteLink, writer.tag(135, WireType.LengthDelimited).fork(), options).join();
        /* SetSpaceInviteLinkEnabledResult setSpaceInviteLinkEnabled = 136; */
        if (message.result.oneofKind === "setSpaceInviteLinkEnabled")
            SetSpaceInviteLinkEnabledResult.internalBinaryWrite(message.result.setSpaceInviteLinkEnabled, writer.tag(136, WireType.LengthDelimited).fork(), options).join();
        /* GetFilePartResult getFilePart = 137; */
        if (message.result.oneofKind === "getFilePart")
            GetFilePartResult.internalBinaryWrite(message.result.getFilePart, writer.tag(137, WireType.LengthDelimited).fork(), options).join();
        /* AcknowledgeMessagesResult acknowledgeMessages = 138; */
        if (message.result.oneofKind === "acknowledgeMessages")
            AcknowledgeMessagesResult.internalBinaryWrite(message.result.acknowledgeMessages, writer.tag(138, WireType.LengthDelimited).fork(), options).join();
        /* GetUsersResult getUsers = 139; */
        if (message.result.oneofKind === "getUsers")
            GetUsersResult.internalBinaryWrite(message.result.getUsers, writer.tag(139, WireType.LengthDelimited).fork(), options).join();
        /* GetBotSkillsResult getBotSkills = 140; */
        if (message.result.oneofKind === "getBotSkills")
            GetBotSkillsResult.internalBinaryWrite(message.result.getBotSkills, writer.tag(140, WireType.LengthDelimited).fork(), options).join();
        /* GetBotConfigurationCatalogResult getBotConfigurationCatalog = 141; */
        if (message.result.oneofKind === "getBotConfigurationCatalog")
            GetBotConfigurationCatalogResult.internalBinaryWrite(message.result.getBotConfigurationCatalog, writer.tag(141, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RpcResult
 */
export const RpcResult = new RpcResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBucket$Type extends MessageType {
    constructor() {
        super("UpdateBucket", [
            { no: 1, name: "user", kind: "message", oneof: "type", T: () => UpdateBucketUser },
            { no: 2, name: "space", kind: "message", oneof: "type", T: () => UpdateBucketSpace },
            { no: 3, name: "chat", kind: "message", oneof: "type", T: () => UpdateBucketChat }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UpdateBucketUser user */ 1:
                    message.type = {
                        oneofKind: "user",
                        user: UpdateBucketUser.internalBinaryRead(reader, reader.uint32(), options, message.type.user)
                    };
                    break;
                case /* UpdateBucketSpace space */ 2:
                    message.type = {
                        oneofKind: "space",
                        space: UpdateBucketSpace.internalBinaryRead(reader, reader.uint32(), options, message.type.space)
                    };
                    break;
                case /* UpdateBucketChat chat */ 3:
                    message.type = {
                        oneofKind: "chat",
                        chat: UpdateBucketChat.internalBinaryRead(reader, reader.uint32(), options, message.type.chat)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UpdateBucketUser user = 1; */
        if (message.type.oneofKind === "user")
            UpdateBucketUser.internalBinaryWrite(message.type.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBucketSpace space = 2; */
        if (message.type.oneofKind === "space")
            UpdateBucketSpace.internalBinaryWrite(message.type.space, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBucketChat chat = 3; */
        if (message.type.oneofKind === "chat")
            UpdateBucketChat.internalBinaryWrite(message.type.chat, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBucket
 */
export const UpdateBucket = new UpdateBucket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBucketUser$Type extends MessageType {
    constructor() {
        super("UpdateBucketUser", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBucketUser
 */
export const UpdateBucketUser = new UpdateBucketUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBucketSpace$Type extends MessageType {
    constructor() {
        super("UpdateBucketSpace", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBucketSpace
 */
export const UpdateBucketSpace = new UpdateBucketSpace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBucketChat$Type extends MessageType {
    constructor() {
        super("UpdateBucketChat", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBucketChat
 */
export const UpdateBucketChat = new UpdateBucketChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUpdatesInput$Type extends MessageType {
    constructor() {
        super("GetUpdatesInput", [
            { no: 1, name: "bucket", kind: "message", T: () => UpdateBucket },
            { no: 2, name: "start_seq", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "total_limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "seq_end", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startSeq = 0n;
        message.totalLimit = 0;
        message.seqEnd = 0n;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UpdateBucket bucket */ 1:
                    message.bucket = UpdateBucket.internalBinaryRead(reader, reader.uint32(), options, message.bucket);
                    break;
                case /* int64 start_seq */ 2:
                    message.startSeq = reader.int64().toBigInt();
                    break;
                case /* int32 total_limit */ 3:
                    message.totalLimit = reader.int32();
                    break;
                case /* int64 seq_end */ 4:
                    message.seqEnd = reader.int64().toBigInt();
                    break;
                case /* int32 limit */ 5:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UpdateBucket bucket = 1; */
        if (message.bucket)
            UpdateBucket.internalBinaryWrite(message.bucket, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 start_seq = 2; */
        if (message.startSeq !== 0n)
            writer.tag(2, WireType.Varint).int64(message.startSeq);
        /* int32 total_limit = 3; */
        if (message.totalLimit !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalLimit);
        /* int64 seq_end = 4; */
        if (message.seqEnd !== 0n)
            writer.tag(4, WireType.Varint).int64(message.seqEnd);
        /* int32 limit = 5; */
        if (message.limit !== 0)
            writer.tag(5, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUpdatesInput
 */
export const GetUpdatesInput = new GetUpdatesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSidecars$Type extends MessageType {
    constructor() {
        super("UpdateSidecars", [
            { no: 1, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User },
            { no: 2, name: "chats", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Chat },
            { no: 3, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog },
            { no: 4, name: "spaces", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Space },
            { no: 5, name: "user_groups", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UserGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        message.chats = [];
        message.dialogs = [];
        message.spaces = [];
        message.userGroups = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated User users */ 1:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Chat chats */ 2:
                    message.chats.push(Chat.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Dialog dialogs */ 3:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Space spaces */ 4:
                    message.spaces.push(Space.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated UserGroup user_groups */ 5:
                    message.userGroups.push(UserGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Chat chats = 2; */
        for (let i = 0; i < message.chats.length; i++)
            Chat.internalBinaryWrite(message.chats[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated Dialog dialogs = 3; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated Space spaces = 4; */
        for (let i = 0; i < message.spaces.length; i++)
            Space.internalBinaryWrite(message.spaces[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated UserGroup user_groups = 5; */
        for (let i = 0; i < message.userGroups.length; i++)
            UserGroup.internalBinaryWrite(message.userGroups[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSidecars
 */
export const UpdateSidecars = new UpdateSidecars$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncSkippedSequence$Type extends MessageType {
    constructor() {
        super("SyncSkippedSequence", [
            { no: 1, name: "seq", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "reason", kind: "enum", T: () => ["SyncSkippedSequence.Reason", SyncSkippedSequence_Reason] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.seq = 0n;
        message.reason = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 seq */ 1:
                    message.seq = reader.int64().toBigInt();
                    break;
                case /* SyncSkippedSequence.Reason reason */ 2:
                    message.reason = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 seq = 1; */
        if (message.seq !== 0n)
            writer.tag(1, WireType.Varint).int64(message.seq);
        /* SyncSkippedSequence.Reason reason = 2; */
        if (message.reason !== 0)
            writer.tag(2, WireType.Varint).int32(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncSkippedSequence
 */
export const SyncSkippedSequence = new SyncSkippedSequence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUpdatesResult$Type extends MessageType {
    constructor() {
        super("GetUpdatesResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update },
            { no: 2, name: "seq", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "final", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "result_type", kind: "enum", T: () => ["GetUpdatesResult.ResultType", GetUpdatesResult_ResultType, "RESULT_TYPE_"] },
            { no: 6, name: "sidecars", kind: "message", T: () => UpdateSidecars },
            { no: 7, name: "skipped_sequences", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SyncSkippedSequence }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        message.seq = 0n;
        message.date = 0n;
        message.resultType = 0;
        message.skippedSequences = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 seq */ 2:
                    message.seq = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 3:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional bool final */ 4:
                    message.final = reader.bool();
                    break;
                case /* GetUpdatesResult.ResultType result_type */ 5:
                    message.resultType = reader.int32();
                    break;
                case /* UpdateSidecars sidecars */ 6:
                    message.sidecars = UpdateSidecars.internalBinaryRead(reader, reader.uint32(), options, message.sidecars);
                    break;
                case /* repeated SyncSkippedSequence skipped_sequences */ 7:
                    message.skippedSequences.push(SyncSkippedSequence.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 seq = 2; */
        if (message.seq !== 0n)
            writer.tag(2, WireType.Varint).int64(message.seq);
        /* int64 date = 3; */
        if (message.date !== 0n)
            writer.tag(3, WireType.Varint).int64(message.date);
        /* optional bool final = 4; */
        if (message.final !== undefined)
            writer.tag(4, WireType.Varint).bool(message.final);
        /* GetUpdatesResult.ResultType result_type = 5; */
        if (message.resultType !== 0)
            writer.tag(5, WireType.Varint).int32(message.resultType);
        /* UpdateSidecars sidecars = 6; */
        if (message.sidecars)
            UpdateSidecars.internalBinaryWrite(message.sidecars, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated SyncSkippedSequence skipped_sequences = 7; */
        for (let i = 0; i < message.skippedSequences.length; i++)
            SyncSkippedSequence.internalBinaryWrite(message.skippedSequences[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUpdatesResult
 */
export const GetUpdatesResult = new GetUpdatesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMemberInput$Type extends MessageType {
    constructor() {
        super("DeleteMemberInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "block_join", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.userId = 0n;
        message.blockJoin = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* bool block_join */ 3:
                    message.blockJoin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* bool block_join = 3; */
        if (message.blockJoin !== false)
            writer.tag(3, WireType.Varint).bool(message.blockJoin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteMemberInput
 */
export const DeleteMemberInput = new DeleteMemberInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMemberResult$Type extends MessageType {
    constructor() {
        super("DeleteMemberResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteMemberResult
 */
export const DeleteMemberResult = new DeleteMemberResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMemberAccessInput$Type extends MessageType {
    constructor() {
        super("UpdateMemberAccessInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "role", kind: "message", T: () => SpaceMemberRole }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* SpaceMemberRole role */ 3:
                    message.role = SpaceMemberRole.internalBinaryRead(reader, reader.uint32(), options, message.role);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* SpaceMemberRole role = 3; */
        if (message.role)
            SpaceMemberRole.internalBinaryWrite(message.role, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMemberAccessInput
 */
export const UpdateMemberAccessInput = new UpdateMemberAccessInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMemberAccessResult$Type extends MessageType {
    constructor() {
        super("UpdateMemberAccessResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMemberAccessResult
 */
export const UpdateMemberAccessResult = new UpdateMemberAccessResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpaceSettings$Type extends MessageType {
    constructor() {
        super("SpaceSettings", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "grid_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.gridEnabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* bool grid_enabled */ 2:
                    message.gridEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* bool grid_enabled = 2; */
        if (message.gridEnabled !== false)
            writer.tag(2, WireType.Varint).bool(message.gridEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpaceSettings
 */
export const SpaceSettings = new SpaceSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceSettingsInput$Type extends MessageType {
    constructor() {
        super("GetSpaceSettingsInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceSettingsInput
 */
export const GetSpaceSettingsInput = new GetSpaceSettingsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceSettingsResult$Type extends MessageType {
    constructor() {
        super("GetSpaceSettingsResult", [
            { no: 1, name: "settings", kind: "message", T: () => SpaceSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* SpaceSettings settings */ 1:
                    message.settings = SpaceSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* SpaceSettings settings = 1; */
        if (message.settings)
            SpaceSettings.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceSettingsResult
 */
export const GetSpaceSettingsResult = new GetSpaceSettingsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToggleSpaceGridInput$Type extends MessageType {
    constructor() {
        super("ToggleSpaceGridInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ToggleSpaceGridInput
 */
export const ToggleSpaceGridInput = new ToggleSpaceGridInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToggleSpaceGridResult$Type extends MessageType {
    constructor() {
        super("ToggleSpaceGridResult", [
            { no: 1, name: "settings", kind: "message", T: () => SpaceSettings },
            { no: 2, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* SpaceSettings settings */ 1:
                    message.settings = SpaceSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* repeated Update updates */ 2:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* SpaceSettings settings = 1; */
        if (message.settings)
            SpaceSettings.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Update updates = 2; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ToggleSpaceGridResult
 */
export const ToggleSpaceGridResult = new ToggleSpaceGridResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridAvatar$Type extends MessageType {
    constructor() {
        super("GridAvatar", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "joined_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "owned_by_current_session", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "microphone_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "membership_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "microphone_revision", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.joinedAt = 0n;
        message.ownedByCurrentSession = false;
        message.microphoneEnabled = false;
        message.membershipId = "";
        message.microphoneRevision = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* int64 joined_at */ 2:
                    message.joinedAt = reader.int64().toBigInt();
                    break;
                case /* bool owned_by_current_session */ 3:
                    message.ownedByCurrentSession = reader.bool();
                    break;
                case /* bool microphone_enabled */ 4:
                    message.microphoneEnabled = reader.bool();
                    break;
                case /* string membership_id */ 5:
                    message.membershipId = reader.string();
                    break;
                case /* int32 microphone_revision */ 6:
                    message.microphoneRevision = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 joined_at = 2; */
        if (message.joinedAt !== 0n)
            writer.tag(2, WireType.Varint).int64(message.joinedAt);
        /* bool owned_by_current_session = 3; */
        if (message.ownedByCurrentSession !== false)
            writer.tag(3, WireType.Varint).bool(message.ownedByCurrentSession);
        /* bool microphone_enabled = 4; */
        if (message.microphoneEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.microphoneEnabled);
        /* string membership_id = 5; */
        if (message.membershipId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.membershipId);
        /* int32 microphone_revision = 6; */
        if (message.microphoneRevision !== 0)
            writer.tag(6, WireType.Varint).int32(message.microphoneRevision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridAvatar
 */
export const GridAvatar = new GridAvatar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridConnection$Type extends MessageType {
    constructor() {
        super("GridConnection", [
            { no: 1, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "generation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "started_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.roomId = 0n;
        message.generation = 0;
        message.startedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 room_id */ 1:
                    message.roomId = reader.int64().toBigInt();
                    break;
                case /* int32 generation */ 2:
                    message.generation = reader.int32();
                    break;
                case /* int64 started_at */ 3:
                    message.startedAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 room_id = 1; */
        if (message.roomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.roomId);
        /* int32 generation = 2; */
        if (message.generation !== 0)
            writer.tag(2, WireType.Varint).int32(message.generation);
        /* int64 started_at = 3; */
        if (message.startedAt !== 0n)
            writer.tag(3, WireType.Varint).int64(message.startedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridConnection
 */
export const GridConnection = new GridConnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridRoom$Type extends MessageType {
    constructor() {
        super("GridRoom", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "created_by_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "locked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "updated_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "avatars", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GridAvatar },
            { no: 9, name: "connection", kind: "message", T: () => GridConnection }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.spaceId = 0n;
        message.createdByUserId = 0n;
        message.locked = false;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.avatars = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 created_by_user_id */ 3:
                    message.createdByUserId = reader.int64().toBigInt();
                    break;
                case /* optional string title */ 4:
                    message.title = reader.string();
                    break;
                case /* bool locked */ 5:
                    message.locked = reader.bool();
                    break;
                case /* int64 created_at */ 6:
                    message.createdAt = reader.int64().toBigInt();
                    break;
                case /* int64 updated_at */ 7:
                    message.updatedAt = reader.int64().toBigInt();
                    break;
                case /* repeated GridAvatar avatars */ 8:
                    message.avatars.push(GridAvatar.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional GridConnection connection */ 9:
                    message.connection = GridConnection.internalBinaryRead(reader, reader.uint32(), options, message.connection);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 space_id = 2; */
        if (message.spaceId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        /* int64 created_by_user_id = 3; */
        if (message.createdByUserId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.createdByUserId);
        /* optional string title = 4; */
        if (message.title !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* bool locked = 5; */
        if (message.locked !== false)
            writer.tag(5, WireType.Varint).bool(message.locked);
        /* int64 created_at = 6; */
        if (message.createdAt !== 0n)
            writer.tag(6, WireType.Varint).int64(message.createdAt);
        /* int64 updated_at = 7; */
        if (message.updatedAt !== 0n)
            writer.tag(7, WireType.Varint).int64(message.updatedAt);
        /* repeated GridAvatar avatars = 8; */
        for (let i = 0; i < message.avatars.length; i++)
            GridAvatar.internalBinaryWrite(message.avatars[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional GridConnection connection = 9; */
        if (message.connection)
            GridConnection.internalBinaryWrite(message.connection, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridRoom
 */
export const GridRoom = new GridRoom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Grid$Type extends MessageType {
    constructor() {
        super("Grid", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "rooms", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GridRoom },
            { no: 4, name: "current_room_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "revision", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.enabled = false;
        message.rooms = [];
        message.revision = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                case /* repeated GridRoom rooms */ 3:
                    message.rooms.push(GridRoom.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional int64 current_room_id */ 4:
                    message.currentRoomId = reader.int64().toBigInt();
                    break;
                case /* int64 revision */ 5:
                    message.revision = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        /* repeated GridRoom rooms = 3; */
        for (let i = 0; i < message.rooms.length; i++)
            GridRoom.internalBinaryWrite(message.rooms[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 current_room_id = 4; */
        if (message.currentRoomId !== undefined)
            writer.tag(4, WireType.Varint).int64(message.currentRoomId);
        /* int64 revision = 5; */
        if (message.revision !== 0n)
            writer.tag(5, WireType.Varint).int64(message.revision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Grid
 */
export const Grid = new Grid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridConnectionCredentials$Type extends MessageType {
    constructor() {
        super("GridConnectionCredentials", [
            { no: 1, name: "connection", kind: "message", T: () => GridConnection },
            { no: 2, name: "server_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "participant_identity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expires_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.serverUrl = "";
        message.participantIdentity = "";
        message.token = "";
        message.expiresAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* GridConnection connection */ 1:
                    message.connection = GridConnection.internalBinaryRead(reader, reader.uint32(), options, message.connection);
                    break;
                case /* string server_url */ 2:
                    message.serverUrl = reader.string();
                    break;
                case /* string participant_identity */ 3:
                    message.participantIdentity = reader.string();
                    break;
                case /* string token */ 4:
                    message.token = reader.string();
                    break;
                case /* int64 expires_at */ 5:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* GridConnection connection = 1; */
        if (message.connection)
            GridConnection.internalBinaryWrite(message.connection, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string server_url = 2; */
        if (message.serverUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.serverUrl);
        /* string participant_identity = 3; */
        if (message.participantIdentity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.participantIdentity);
        /* string token = 4; */
        if (message.token !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.token);
        /* int64 expires_at = 5; */
        if (message.expiresAt !== 0n)
            writer.tag(5, WireType.Varint).int64(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridConnectionCredentials
 */
export const GridConnectionCredentials = new GridConnectionCredentials$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGridInput$Type extends MessageType {
    constructor() {
        super("GetGridInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGridInput
 */
export const GetGridInput = new GetGridInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGridResult$Type extends MessageType {
    constructor() {
        super("GetGridResult", [
            { no: 1, name: "grid", kind: "message", T: () => Grid }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Grid grid */ 1:
                    message.grid = Grid.internalBinaryRead(reader, reader.uint32(), options, message.grid);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Grid grid = 1; */
        if (message.grid)
            Grid.internalBinaryWrite(message.grid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGridResult
 */
export const GetGridResult = new GetGridResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridHomeSpace$Type extends MessageType {
    constructor() {
        super("GridHomeSpace", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "active_avatar_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "recent_avatars", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GridAvatar },
            { no: 4, name: "latest_activity_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.activeAvatarCount = 0;
        message.recentAvatars = [];
        message.latestActivityAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int32 active_avatar_count */ 2:
                    message.activeAvatarCount = reader.int32();
                    break;
                case /* repeated GridAvatar recent_avatars */ 3:
                    message.recentAvatars.push(GridAvatar.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 latest_activity_at */ 4:
                    message.latestActivityAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int32 active_avatar_count = 2; */
        if (message.activeAvatarCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.activeAvatarCount);
        /* repeated GridAvatar recent_avatars = 3; */
        for (let i = 0; i < message.recentAvatars.length; i++)
            GridAvatar.internalBinaryWrite(message.recentAvatars[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 latest_activity_at = 4; */
        if (message.latestActivityAt !== 0n)
            writer.tag(4, WireType.Varint).int64(message.latestActivityAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridHomeSpace
 */
export const GridHomeSpace = new GridHomeSpace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGridHomeInput$Type extends MessageType {
    constructor() {
        super("GetGridHomeInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGridHomeInput
 */
export const GetGridHomeInput = new GetGridHomeInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGridHomeResult$Type extends MessageType {
    constructor() {
        super("GetGridHomeResult", [
            { no: 1, name: "spaces", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GridHomeSpace }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaces = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated GridHomeSpace spaces */ 1:
                    message.spaces.push(GridHomeSpace.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated GridHomeSpace spaces = 1; */
        for (let i = 0; i < message.spaces.length; i++)
            GridHomeSpace.internalBinaryWrite(message.spaces[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGridHomeResult
 */
export const GetGridHomeResult = new GetGridHomeResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateGridRoomInput$Type extends MessageType {
    constructor() {
        super("CreateGridRoomInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "microphone_enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* optional bool microphone_enabled */ 2:
                    message.microphoneEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* optional bool microphone_enabled = 2; */
        if (message.microphoneEnabled !== undefined)
            writer.tag(2, WireType.Varint).bool(message.microphoneEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateGridRoomInput
 */
export const CreateGridRoomInput = new CreateGridRoomInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateGridRoomResult$Type extends MessageType {
    constructor() {
        super("CreateGridRoomResult", [
            { no: 1, name: "grids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Grid },
            { no: 2, name: "connection", kind: "message", T: () => GridConnectionCredentials }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.grids = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Grid grids */ 1:
                    message.grids.push(Grid.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional GridConnectionCredentials connection */ 2:
                    message.connection = GridConnectionCredentials.internalBinaryRead(reader, reader.uint32(), options, message.connection);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Grid grids = 1; */
        for (let i = 0; i < message.grids.length; i++)
            Grid.internalBinaryWrite(message.grids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional GridConnectionCredentials connection = 2; */
        if (message.connection)
            GridConnectionCredentials.internalBinaryWrite(message.connection, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateGridRoomResult
 */
export const CreateGridRoomResult = new CreateGridRoomResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinGridRoomInput$Type extends MessageType {
    constructor() {
        super("JoinGridRoomInput", [
            { no: 1, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "microphone_enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.roomId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 room_id */ 1:
                    message.roomId = reader.int64().toBigInt();
                    break;
                case /* optional bool microphone_enabled */ 2:
                    message.microphoneEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 room_id = 1; */
        if (message.roomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.roomId);
        /* optional bool microphone_enabled = 2; */
        if (message.microphoneEnabled !== undefined)
            writer.tag(2, WireType.Varint).bool(message.microphoneEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JoinGridRoomInput
 */
export const JoinGridRoomInput = new JoinGridRoomInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinGridRoomResult$Type extends MessageType {
    constructor() {
        super("JoinGridRoomResult", [
            { no: 1, name: "grids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Grid },
            { no: 2, name: "connection", kind: "message", T: () => GridConnectionCredentials }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.grids = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Grid grids */ 1:
                    message.grids.push(Grid.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional GridConnectionCredentials connection */ 2:
                    message.connection = GridConnectionCredentials.internalBinaryRead(reader, reader.uint32(), options, message.connection);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Grid grids = 1; */
        for (let i = 0; i < message.grids.length; i++)
            Grid.internalBinaryWrite(message.grids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional GridConnectionCredentials connection = 2; */
        if (message.connection)
            GridConnectionCredentials.internalBinaryWrite(message.connection, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JoinGridRoomResult
 */
export const JoinGridRoomResult = new JoinGridRoomResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveGridRoomInput$Type extends MessageType {
    constructor() {
        super("LeaveGridRoomInput", [
            { no: 1, name: "expected_room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.expectedRoomId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 expected_room_id */ 1:
                    message.expectedRoomId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 expected_room_id = 1; */
        if (message.expectedRoomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.expectedRoomId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LeaveGridRoomInput
 */
export const LeaveGridRoomInput = new LeaveGridRoomInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveGridRoomResult$Type extends MessageType {
    constructor() {
        super("LeaveGridRoomResult", [
            { no: 1, name: "grids", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Grid }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.grids = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Grid grids */ 1:
                    message.grids.push(Grid.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Grid grids = 1; */
        for (let i = 0; i < message.grids.length; i++)
            Grid.internalBinaryWrite(message.grids[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LeaveGridRoomResult
 */
export const LeaveGridRoomResult = new LeaveGridRoomResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGridRoomTitleInput$Type extends MessageType {
    constructor() {
        super("SetGridRoomTitleInput", [
            { no: 1, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.roomId = 0n;
        message.title = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 room_id */ 1:
                    message.roomId = reader.int64().toBigInt();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 room_id = 1; */
        if (message.roomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.roomId);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetGridRoomTitleInput
 */
export const SetGridRoomTitleInput = new SetGridRoomTitleInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGridRoomTitleResult$Type extends MessageType {
    constructor() {
        super("SetGridRoomTitleResult", [
            { no: 1, name: "grid", kind: "message", T: () => Grid }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Grid grid */ 1:
                    message.grid = Grid.internalBinaryRead(reader, reader.uint32(), options, message.grid);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Grid grid = 1; */
        if (message.grid)
            Grid.internalBinaryWrite(message.grid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetGridRoomTitleResult
 */
export const SetGridRoomTitleResult = new SetGridRoomTitleResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGridRoomLockedInput$Type extends MessageType {
    constructor() {
        super("SetGridRoomLockedInput", [
            { no: 1, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "locked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.roomId = 0n;
        message.locked = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 room_id */ 1:
                    message.roomId = reader.int64().toBigInt();
                    break;
                case /* bool locked */ 2:
                    message.locked = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 room_id = 1; */
        if (message.roomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.roomId);
        /* bool locked = 2; */
        if (message.locked !== false)
            writer.tag(2, WireType.Varint).bool(message.locked);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetGridRoomLockedInput
 */
export const SetGridRoomLockedInput = new SetGridRoomLockedInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGridRoomLockedResult$Type extends MessageType {
    constructor() {
        super("SetGridRoomLockedResult", [
            { no: 1, name: "grid", kind: "message", T: () => Grid }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Grid grid */ 1:
                    message.grid = Grid.internalBinaryRead(reader, reader.uint32(), options, message.grid);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Grid grid = 1; */
        if (message.grid)
            Grid.internalBinaryWrite(message.grid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetGridRoomLockedResult
 */
export const SetGridRoomLockedResult = new SetGridRoomLockedResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteGridRoomInput$Type extends MessageType {
    constructor() {
        super("DeleteGridRoomInput", [
            { no: 1, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.roomId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 room_id */ 1:
                    message.roomId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 room_id = 1; */
        if (message.roomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.roomId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteGridRoomInput
 */
export const DeleteGridRoomInput = new DeleteGridRoomInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteGridRoomResult$Type extends MessageType {
    constructor() {
        super("DeleteGridRoomResult", [
            { no: 1, name: "grid", kind: "message", T: () => Grid }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Grid grid */ 1:
                    message.grid = Grid.internalBinaryRead(reader, reader.uint32(), options, message.grid);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Grid grid = 1; */
        if (message.grid)
            Grid.internalBinaryWrite(message.grid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteGridRoomResult
 */
export const DeleteGridRoomResult = new DeleteGridRoomResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrepareGridConnectionInput$Type extends MessageType {
    constructor() {
        super("PrepareGridConnectionInput", [
            { no: 1, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "generation", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.roomId = 0n;
        message.generation = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 room_id */ 1:
                    message.roomId = reader.int64().toBigInt();
                    break;
                case /* int32 generation */ 2:
                    message.generation = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 room_id = 1; */
        if (message.roomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.roomId);
        /* int32 generation = 2; */
        if (message.generation !== 0)
            writer.tag(2, WireType.Varint).int32(message.generation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PrepareGridConnectionInput
 */
export const PrepareGridConnectionInput = new PrepareGridConnectionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrepareGridConnectionResult$Type extends MessageType {
    constructor() {
        super("PrepareGridConnectionResult", [
            { no: 1, name: "connection", kind: "message", T: () => GridConnectionCredentials },
            { no: 2, name: "unavailable_reason", kind: "enum", T: () => ["GridConnectionUnavailableReason", GridConnectionUnavailableReason, "GRID_CONNECTION_UNAVAILABLE_REASON_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.unavailableReason = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional GridConnectionCredentials connection */ 1:
                    message.connection = GridConnectionCredentials.internalBinaryRead(reader, reader.uint32(), options, message.connection);
                    break;
                case /* GridConnectionUnavailableReason unavailable_reason */ 2:
                    message.unavailableReason = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional GridConnectionCredentials connection = 1; */
        if (message.connection)
            GridConnectionCredentials.internalBinaryWrite(message.connection, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* GridConnectionUnavailableReason unavailable_reason = 2; */
        if (message.unavailableReason !== 0)
            writer.tag(2, WireType.Varint).int32(message.unavailableReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PrepareGridConnectionResult
 */
export const PrepareGridConnectionResult = new PrepareGridConnectionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGridAvatarMicrophoneEnabledInput$Type extends MessageType {
    constructor() {
        super("SetGridAvatarMicrophoneEnabledInput", [
            { no: 1, name: "expected_room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.expectedRoomId = 0n;
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 expected_room_id */ 1:
                    message.expectedRoomId = reader.int64().toBigInt();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 expected_room_id = 1; */
        if (message.expectedRoomId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.expectedRoomId);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetGridAvatarMicrophoneEnabledInput
 */
export const SetGridAvatarMicrophoneEnabledInput = new SetGridAvatarMicrophoneEnabledInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGridAvatarMicrophoneEnabledResult$Type extends MessageType {
    constructor() {
        super("SetGridAvatarMicrophoneEnabledResult", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetGridAvatarMicrophoneEnabledResult
 */
export const SetGridAvatarMicrophoneEnabledResult = new SetGridAvatarMicrophoneEnabledResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridEvent$Type extends MessageType {
    constructor() {
        super("GridEvent", [
            { no: 1, name: "changed", kind: "message", oneof: "event", T: () => GridChanged },
            { no: 2, name: "connection_ready", kind: "message", oneof: "event", T: () => GridConnectionReady },
            { no: 3, name: "avatar_state_changed", kind: "message", oneof: "event", T: () => GridAvatarStateChanged },
            { no: 4, name: "access_revoked", kind: "message", oneof: "event", T: () => GridAccessRevoked }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.event = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* GridChanged changed */ 1:
                    message.event = {
                        oneofKind: "changed",
                        changed: GridChanged.internalBinaryRead(reader, reader.uint32(), options, message.event.changed)
                    };
                    break;
                case /* GridConnectionReady connection_ready */ 2:
                    message.event = {
                        oneofKind: "connectionReady",
                        connectionReady: GridConnectionReady.internalBinaryRead(reader, reader.uint32(), options, message.event.connectionReady)
                    };
                    break;
                case /* GridAvatarStateChanged avatar_state_changed */ 3:
                    message.event = {
                        oneofKind: "avatarStateChanged",
                        avatarStateChanged: GridAvatarStateChanged.internalBinaryRead(reader, reader.uint32(), options, message.event.avatarStateChanged)
                    };
                    break;
                case /* GridAccessRevoked access_revoked */ 4:
                    message.event = {
                        oneofKind: "accessRevoked",
                        accessRevoked: GridAccessRevoked.internalBinaryRead(reader, reader.uint32(), options, message.event.accessRevoked)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* GridChanged changed = 1; */
        if (message.event.oneofKind === "changed")
            GridChanged.internalBinaryWrite(message.event.changed, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* GridConnectionReady connection_ready = 2; */
        if (message.event.oneofKind === "connectionReady")
            GridConnectionReady.internalBinaryWrite(message.event.connectionReady, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* GridAvatarStateChanged avatar_state_changed = 3; */
        if (message.event.oneofKind === "avatarStateChanged")
            GridAvatarStateChanged.internalBinaryWrite(message.event.avatarStateChanged, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* GridAccessRevoked access_revoked = 4; */
        if (message.event.oneofKind === "accessRevoked")
            GridAccessRevoked.internalBinaryWrite(message.event.accessRevoked, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridEvent
 */
export const GridEvent = new GridEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridChanged$Type extends MessageType {
    constructor() {
        super("GridChanged", [
            { no: 1, name: "space_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "room_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 space_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.spaceIds.push(reader.int64().toBigInt());
                    else
                        message.spaceIds.push(reader.int64().toBigInt());
                    break;
                case /* optional int64 room_id */ 2:
                    message.roomId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int64 space_ids = 1; */
        if (message.spaceIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.spaceIds.length; i++)
                writer.int64(message.spaceIds[i]);
            writer.join();
        }
        /* optional int64 room_id = 2; */
        if (message.roomId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.roomId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridChanged
 */
export const GridChanged = new GridChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridConnectionReady$Type extends MessageType {
    constructor() {
        super("GridConnectionReady", [
            { no: 1, name: "credentials", kind: "message", T: () => GridConnectionCredentials }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* GridConnectionCredentials credentials */ 1:
                    message.credentials = GridConnectionCredentials.internalBinaryRead(reader, reader.uint32(), options, message.credentials);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* GridConnectionCredentials credentials = 1; */
        if (message.credentials)
            GridConnectionCredentials.internalBinaryWrite(message.credentials, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridConnectionReady
 */
export const GridConnectionReady = new GridConnectionReady$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridAvatarStateChanged$Type extends MessageType {
    constructor() {
        super("GridAvatarStateChanged", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "room_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "microphone_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "membership_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "microphone_revision", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.roomId = 0n;
        message.userId = 0n;
        message.microphoneEnabled = false;
        message.membershipId = "";
        message.microphoneRevision = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 room_id */ 2:
                    message.roomId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 3:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* bool microphone_enabled */ 4:
                    message.microphoneEnabled = reader.bool();
                    break;
                case /* string membership_id */ 5:
                    message.membershipId = reader.string();
                    break;
                case /* int32 microphone_revision */ 6:
                    message.microphoneRevision = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int64 room_id = 2; */
        if (message.roomId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.roomId);
        /* int64 user_id = 3; */
        if (message.userId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.userId);
        /* bool microphone_enabled = 4; */
        if (message.microphoneEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.microphoneEnabled);
        /* string membership_id = 5; */
        if (message.membershipId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.membershipId);
        /* int32 microphone_revision = 6; */
        if (message.microphoneRevision !== 0)
            writer.tag(6, WireType.Varint).int32(message.microphoneRevision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridAvatarStateChanged
 */
export const GridAvatarStateChanged = new GridAvatarStateChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GridAccessRevoked$Type extends MessageType {
    constructor() {
        super("GridAccessRevoked", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GridAccessRevoked
 */
export const GridAccessRevoked = new GridAccessRevoked$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpaceUrlPreviewExclusion$Type extends MessageType {
    constructor() {
        super("SpaceUrlPreviewExclusion", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "path_prefix", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_by", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.spaceId = 0n;
        message.host = "";
        message.createdBy = 0n;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* string host */ 3:
                    message.host = reader.string();
                    break;
                case /* optional string path_prefix */ 4:
                    message.pathPrefix = reader.string();
                    break;
                case /* int64 created_by */ 5:
                    message.createdBy = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 6:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 space_id = 2; */
        if (message.spaceId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        /* string host = 3; */
        if (message.host !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.host);
        /* optional string path_prefix = 4; */
        if (message.pathPrefix !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.pathPrefix);
        /* int64 created_by = 5; */
        if (message.createdBy !== 0n)
            writer.tag(5, WireType.Varint).int64(message.createdBy);
        /* int64 date = 6; */
        if (message.date !== 0n)
            writer.tag(6, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpaceUrlPreviewExclusion
 */
export const SpaceUrlPreviewExclusion = new SpaceUrlPreviewExclusion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceUrlPreviewExclusionsInput$Type extends MessageType {
    constructor() {
        super("GetSpaceUrlPreviewExclusionsInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceUrlPreviewExclusionsInput
 */
export const GetSpaceUrlPreviewExclusionsInput = new GetSpaceUrlPreviewExclusionsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceUrlPreviewExclusionsResult$Type extends MessageType {
    constructor() {
        super("GetSpaceUrlPreviewExclusionsResult", [
            { no: 1, name: "exclusions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SpaceUrlPreviewExclusion }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.exclusions = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SpaceUrlPreviewExclusion exclusions */ 1:
                    message.exclusions.push(SpaceUrlPreviewExclusion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SpaceUrlPreviewExclusion exclusions = 1; */
        for (let i = 0; i < message.exclusions.length; i++)
            SpaceUrlPreviewExclusion.internalBinaryWrite(message.exclusions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceUrlPreviewExclusionsResult
 */
export const GetSpaceUrlPreviewExclusionsResult = new GetSpaceUrlPreviewExclusionsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSpaceUrlPreviewExclusionInput$Type extends MessageType {
    constructor() {
        super("AddSpaceUrlPreviewExclusionInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "path_prefix", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 5, name: "message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.host = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* string host */ 2:
                    message.host = reader.string();
                    break;
                case /* optional string path_prefix */ 3:
                    message.pathPrefix = reader.string();
                    break;
                case /* optional InputPeer peer_id */ 4:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional int64 message_id */ 5:
                    message.messageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* string host = 2; */
        if (message.host !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.host);
        /* optional string path_prefix = 3; */
        if (message.pathPrefix !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.pathPrefix);
        /* optional InputPeer peer_id = 4; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 message_id = 5; */
        if (message.messageId !== undefined)
            writer.tag(5, WireType.Varint).int64(message.messageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddSpaceUrlPreviewExclusionInput
 */
export const AddSpaceUrlPreviewExclusionInput = new AddSpaceUrlPreviewExclusionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSpaceUrlPreviewExclusionResult$Type extends MessageType {
    constructor() {
        super("AddSpaceUrlPreviewExclusionResult", [
            { no: 1, name: "exclusion", kind: "message", T: () => SpaceUrlPreviewExclusion },
            { no: 2, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* SpaceUrlPreviewExclusion exclusion */ 1:
                    message.exclusion = SpaceUrlPreviewExclusion.internalBinaryRead(reader, reader.uint32(), options, message.exclusion);
                    break;
                case /* repeated Update updates */ 2:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* SpaceUrlPreviewExclusion exclusion = 1; */
        if (message.exclusion)
            SpaceUrlPreviewExclusion.internalBinaryWrite(message.exclusion, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Update updates = 2; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddSpaceUrlPreviewExclusionResult
 */
export const AddSpaceUrlPreviewExclusionResult = new AddSpaceUrlPreviewExclusionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSpaceUrlPreviewExclusionInput$Type extends MessageType {
    constructor() {
        super("RemoveSpaceUrlPreviewExclusionInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "exclusion_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.exclusionId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 exclusion_id */ 2:
                    message.exclusionId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int64 exclusion_id = 2; */
        if (message.exclusionId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.exclusionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveSpaceUrlPreviewExclusionInput
 */
export const RemoveSpaceUrlPreviewExclusionInput = new RemoveSpaceUrlPreviewExclusionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSpaceUrlPreviewExclusionResult$Type extends MessageType {
    constructor() {
        super("RemoveSpaceUrlPreviewExclusionResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveSpaceUrlPreviewExclusionResult
 */
export const RemoveSpaceUrlPreviewExclusionResult = new RemoveSpaceUrlPreviewExclusionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUpdatesStateInput$Type extends MessageType {
    constructor() {
        super("GetUpdatesStateInput", [
            { no: 2, name: "date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 date = 2; */
        if (message.date !== undefined)
            writer.tag(2, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUpdatesStateInput
 */
export const GetUpdatesStateInput = new GetUpdatesStateInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUpdatesStateResult$Type extends MessageType {
    constructor() {
        super("GetUpdatesStateResult", [
            { no: 1, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "updates_found", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "seq", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 date */ 1:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional bool updates_found */ 2:
                    message.updatesFound = reader.bool();
                    break;
                case /* optional int32 seq */ 4:
                    message.seq = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 date = 1; */
        if (message.date !== 0n)
            writer.tag(1, WireType.Varint).int64(message.date);
        /* optional bool updates_found = 2; */
        if (message.updatesFound !== undefined)
            writer.tag(2, WireType.Varint).bool(message.updatesFound);
        /* optional int32 seq = 4; */
        if (message.seq !== undefined)
            writer.tag(4, WireType.Varint).int32(message.seq);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUpdatesStateResult
 */
export const GetUpdatesStateResult = new GetUpdatesStateResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatInput$Type extends MessageType {
    constructor() {
        super("GetChatInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "include_recent_messages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeRecentMessages = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* bool include_recent_messages */ 2:
                    message.includeRecentMessages = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool include_recent_messages = 2; */
        if (message.includeRecentMessages !== false)
            writer.tag(2, WireType.Varint).bool(message.includeRecentMessages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatInput
 */
export const GetChatInput = new GetChatInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatResult$Type extends MessageType {
    constructor() {
        super("GetChatResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog },
            { no: 3, name: "pinned_message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "anchor_message", kind: "message", T: () => Message },
            { no: 5, name: "user", kind: "message", T: () => User },
            { no: 6, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Message }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.pinnedMessageIds = [];
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                case /* repeated int64 pinned_message_ids */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.pinnedMessageIds.push(reader.int64().toBigInt());
                    else
                        message.pinnedMessageIds.push(reader.int64().toBigInt());
                    break;
                case /* Message anchor_message */ 4:
                    message.anchorMessage = Message.internalBinaryRead(reader, reader.uint32(), options, message.anchorMessage);
                    break;
                case /* optional User user */ 5:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated Message messages */ 6:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 pinned_message_ids = 3; */
        if (message.pinnedMessageIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.pinnedMessageIds.length; i++)
                writer.int64(message.pinnedMessageIds[i]);
            writer.join();
        }
        /* Message anchor_message = 4; */
        if (message.anchorMessage)
            Message.internalBinaryWrite(message.anchorMessage, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional User user = 5; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated Message messages = 6; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatResult
 */
export const GetChatResult = new GetChatResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShowInChatListInput$Type extends MessageType {
    constructor() {
        super("ShowInChatListInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ShowInChatListInput
 */
export const ShowInChatListInput = new ShowInChatListInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShowInChatListResult$Type extends MessageType {
    constructor() {
        super("ShowInChatListResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ShowInChatListResult
 */
export const ShowInChatListResult = new ShowInChatListResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogOpenInput$Type extends MessageType {
    constructor() {
        super("UpdateDialogOpenInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "open", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "folder_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.open = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* bool open */ 2:
                    message.open = reader.bool();
                    break;
                case /* optional string order */ 3:
                    message.order = reader.string();
                    break;
                case /* optional int64 folder_id */ 4:
                    message.folderId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool open = 2; */
        if (message.open !== false)
            writer.tag(2, WireType.Varint).bool(message.open);
        /* optional string order = 3; */
        if (message.order !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.order);
        /* optional int64 folder_id = 4; */
        if (message.folderId !== undefined)
            writer.tag(4, WireType.Varint).int64(message.folderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogOpenInput
 */
export const UpdateDialogOpenInput = new UpdateDialogOpenInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogOpenResult$Type extends MessageType {
    constructor() {
        super("UpdateDialogOpenResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog },
            { no: 3, name: "user", kind: "message", T: () => User },
            { no: 4, name: "deleted_chat", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                case /* optional User user */ 3:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* optional bool deleted_chat */ 4:
                    message.deletedChat = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional User user = 3; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional bool deleted_chat = 4; */
        if (message.deletedChat !== undefined)
            writer.tag(4, WireType.Varint).bool(message.deletedChat);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogOpenResult
 */
export const UpdateDialogOpenResult = new UpdateDialogOpenResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogOrderInput$Type extends MessageType {
    constructor() {
        super("UpdateDialogOrderInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pinned_order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pinned", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "destination", kind: "message", T: () => DialogFolderDestination }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional string order */ 2:
                    message.order = reader.string();
                    break;
                case /* optional string pinned_order */ 3:
                    message.pinnedOrder = reader.string();
                    break;
                case /* optional bool pinned */ 4:
                    message.pinned = reader.bool();
                    break;
                case /* optional DialogFolderDestination destination */ 5:
                    message.destination = DialogFolderDestination.internalBinaryRead(reader, reader.uint32(), options, message.destination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string order = 2; */
        if (message.order !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.order);
        /* optional string pinned_order = 3; */
        if (message.pinnedOrder !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.pinnedOrder);
        /* optional bool pinned = 4; */
        if (message.pinned !== undefined)
            writer.tag(4, WireType.Varint).bool(message.pinned);
        /* optional DialogFolderDestination destination = 5; */
        if (message.destination)
            DialogFolderDestination.internalBinaryWrite(message.destination, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogOrderInput
 */
export const UpdateDialogOrderInput = new UpdateDialogOrderInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DialogFolderDestination$Type extends MessageType {
    constructor() {
        super("DialogFolderDestination", [
            { no: 1, name: "root", kind: "scalar", oneof: "destination", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "folder_id", kind: "scalar", oneof: "destination", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.destination = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool root */ 1:
                    message.destination = {
                        oneofKind: "root",
                        root: reader.bool()
                    };
                    break;
                case /* int64 folder_id */ 2:
                    message.destination = {
                        oneofKind: "folderId",
                        folderId: reader.int64().toBigInt()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool root = 1; */
        if (message.destination.oneofKind === "root")
            writer.tag(1, WireType.Varint).bool(message.destination.root);
        /* int64 folder_id = 2; */
        if (message.destination.oneofKind === "folderId")
            writer.tag(2, WireType.Varint).int64(message.destination.folderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DialogFolderDestination
 */
export const DialogFolderDestination = new DialogFolderDestination$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogOrderResult$Type extends MessageType {
    constructor() {
        super("UpdateDialogOrderResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog },
            { no: 3, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                case /* optional User user */ 3:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional User user = 3; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogOrderResult
 */
export const UpdateDialogOrderResult = new UpdateDialogOrderResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogFollowModeInput$Type extends MessageType {
    constructor() {
        super("UpdateDialogFollowModeInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "follow_mode", kind: "enum", opt: true, T: () => ["DialogFollowMode", DialogFollowMode] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional DialogFollowMode follow_mode */ 2:
                    message.followMode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional DialogFollowMode follow_mode = 2; */
        if (message.followMode !== undefined)
            writer.tag(2, WireType.Varint).int32(message.followMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogFollowModeInput
 */
export const UpdateDialogFollowModeInput = new UpdateDialogFollowModeInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogFollowModeResult$Type extends MessageType {
    constructor() {
        super("UpdateDialogFollowModeResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogFollowModeResult
 */
export const UpdateDialogFollowModeResult = new UpdateDialogFollowModeResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CollapseHistoryInput$Type extends MessageType {
    constructor() {
        super("CollapseHistoryInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "max_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional int64 max_id */ 2:
                    message.maxId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 max_id = 2; */
        if (message.maxId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.maxId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CollapseHistoryInput
 */
export const CollapseHistoryInput = new CollapseHistoryInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CollapseHistoryResult$Type extends MessageType {
    constructor() {
        super("CollapseHistoryResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CollapseHistoryResult
 */
export const CollapseHistoryResult = new CollapseHistoryResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkAsUnreadInput$Type extends MessageType {
    constructor() {
        super("MarkAsUnreadInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkAsUnreadInput
 */
export const MarkAsUnreadInput = new MarkAsUnreadInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkAsUnreadResult$Type extends MessageType {
    constructor() {
        super("MarkAsUnreadResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkAsUnreadResult
 */
export const MarkAsUnreadResult = new MarkAsUnreadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadMessagesInput$Type extends MessageType {
    constructor() {
        super("ReadMessagesInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "max_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional int64 max_id */ 2:
                    message.maxId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 max_id = 2; */
        if (message.maxId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.maxId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReadMessagesInput
 */
export const ReadMessagesInput = new ReadMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadMessagesResult$Type extends MessageType {
    constructor() {
        super("ReadMessagesResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReadMessagesResult
 */
export const ReadMessagesResult = new ReadMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBotInput$Type extends MessageType {
    constructor() {
        super("CreateBotInput", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "add_to_space", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                case /* optional int64 add_to_space */ 3:
                    message.addToSpace = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        /* optional int64 add_to_space = 3; */
        if (message.addToSpace !== undefined)
            writer.tag(3, WireType.Varint).int64(message.addToSpace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateBotInput
 */
export const CreateBotInput = new CreateBotInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBotResult$Type extends MessageType {
    constructor() {
        super("CreateBotResult", [
            { no: 1, name: "bot", kind: "message", T: () => User },
            { no: 2, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                case /* string token */ 2:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string token = 2; */
        if (message.token !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateBotResult
 */
export const CreateBotResult = new CreateBotResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotAgent$Type extends MessageType {
    constructor() {
        super("BotAgent", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "handle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "skill_key", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "instructions", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.botUserId = 0n;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 bot_user_id */ 2:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* optional string handle */ 4:
                    message.handle = reader.string();
                    break;
                case /* optional string emoji */ 5:
                    message.emoji = reader.string();
                    break;
                case /* optional string description */ 6:
                    message.description = reader.string();
                    break;
                case /* optional string skill_key */ 7:
                    message.skillKey = reader.string();
                    break;
                case /* optional string instructions */ 8:
                    message.instructions = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 bot_user_id = 2; */
        if (message.botUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.botUserId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* optional string handle = 4; */
        if (message.handle !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.handle);
        /* optional string emoji = 5; */
        if (message.emoji !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.emoji);
        /* optional string description = 6; */
        if (message.description !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* optional string skill_key = 7; */
        if (message.skillKey !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.skillKey);
        /* optional string instructions = 8; */
        if (message.instructions !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.instructions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotAgent
 */
export const BotAgent = new BotAgent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotAgentProfile$Type extends MessageType {
    constructor() {
        super("BotAgentProfile", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "handle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.botUserId = 0n;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* int64 bot_user_id */ 2:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* optional string handle */ 4:
                    message.handle = reader.string();
                    break;
                case /* optional string emoji */ 5:
                    message.emoji = reader.string();
                    break;
                case /* optional string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* int64 bot_user_id = 2; */
        if (message.botUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.botUserId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* optional string handle = 4; */
        if (message.handle !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.handle);
        /* optional string emoji = 5; */
        if (message.emoji !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.emoji);
        /* optional string description = 6; */
        if (message.description !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotAgentProfile
 */
export const BotAgentProfile = new BotAgentProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBotAgentInput$Type extends MessageType {
    constructor() {
        super("CreateBotAgentInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "handle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "skill_key", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "instructions", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string handle */ 3:
                    message.handle = reader.string();
                    break;
                case /* optional string emoji */ 4:
                    message.emoji = reader.string();
                    break;
                case /* optional string description */ 5:
                    message.description = reader.string();
                    break;
                case /* optional string skill_key */ 6:
                    message.skillKey = reader.string();
                    break;
                case /* optional string instructions */ 7:
                    message.instructions = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string handle = 3; */
        if (message.handle !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.handle);
        /* optional string emoji = 4; */
        if (message.emoji !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.emoji);
        /* optional string description = 5; */
        if (message.description !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* optional string skill_key = 6; */
        if (message.skillKey !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.skillKey);
        /* optional string instructions = 7; */
        if (message.instructions !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.instructions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateBotAgentInput
 */
export const CreateBotAgentInput = new CreateBotAgentInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBotAgentResult$Type extends MessageType {
    constructor() {
        super("CreateBotAgentResult", [
            { no: 1, name: "agent", kind: "message", T: () => BotAgent }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotAgent agent */ 1:
                    message.agent = BotAgent.internalBinaryRead(reader, reader.uint32(), options, message.agent);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotAgent agent = 1; */
        if (message.agent)
            BotAgent.internalBinaryWrite(message.agent, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateBotAgentResult
 */
export const CreateBotAgentResult = new CreateBotAgentResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotAgentInput$Type extends MessageType {
    constructor() {
        super("GetBotAgentInput", [
            { no: 1, name: "agent_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agentId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 agent_id */ 1:
                    message.agentId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 agent_id = 1; */
        if (message.agentId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.agentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotAgentInput
 */
export const GetBotAgentInput = new GetBotAgentInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotAgentResult$Type extends MessageType {
    constructor() {
        super("GetBotAgentResult", [
            { no: 1, name: "bot", kind: "message", T: () => User },
            { no: 2, name: "agent", kind: "message", T: () => BotAgent }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                case /* BotAgent agent */ 2:
                    message.agent = BotAgent.internalBinaryRead(reader, reader.uint32(), options, message.agent);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BotAgent agent = 2; */
        if (message.agent)
            BotAgent.internalBinaryWrite(message.agent, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotAgentResult
 */
export const GetBotAgentResult = new GetBotAgentResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListBotAgentsInput$Type extends MessageType {
    constructor() {
        super("ListBotAgentsInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListBotAgentsInput
 */
export const ListBotAgentsInput = new ListBotAgentsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListBotAgentsResult$Type extends MessageType {
    constructor() {
        super("ListBotAgentsResult", [
            { no: 1, name: "agents", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotAgent }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agents = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotAgent agents */ 1:
                    message.agents.push(BotAgent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotAgent agents = 1; */
        for (let i = 0; i < message.agents.length; i++)
            BotAgent.internalBinaryWrite(message.agents[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListBotAgentsResult
 */
export const ListBotAgentsResult = new ListBotAgentsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBotAgentInput$Type extends MessageType {
    constructor() {
        super("UpdateBotAgentInput", [
            { no: 1, name: "agent_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "handle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "skill_key", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "instructions", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agentId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 agent_id */ 1:
                    message.agentId = reader.int64().toBigInt();
                    break;
                case /* optional string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string handle */ 3:
                    message.handle = reader.string();
                    break;
                case /* optional string emoji */ 4:
                    message.emoji = reader.string();
                    break;
                case /* optional string description */ 5:
                    message.description = reader.string();
                    break;
                case /* optional string skill_key */ 6:
                    message.skillKey = reader.string();
                    break;
                case /* optional string instructions */ 7:
                    message.instructions = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 agent_id = 1; */
        if (message.agentId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.agentId);
        /* optional string name = 2; */
        if (message.name !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string handle = 3; */
        if (message.handle !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.handle);
        /* optional string emoji = 4; */
        if (message.emoji !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.emoji);
        /* optional string description = 5; */
        if (message.description !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* optional string skill_key = 6; */
        if (message.skillKey !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.skillKey);
        /* optional string instructions = 7; */
        if (message.instructions !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.instructions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBotAgentInput
 */
export const UpdateBotAgentInput = new UpdateBotAgentInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBotAgentResult$Type extends MessageType {
    constructor() {
        super("UpdateBotAgentResult", [
            { no: 1, name: "agent", kind: "message", T: () => BotAgent }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotAgent agent */ 1:
                    message.agent = BotAgent.internalBinaryRead(reader, reader.uint32(), options, message.agent);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotAgent agent = 1; */
        if (message.agent)
            BotAgent.internalBinaryWrite(message.agent, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBotAgentResult
 */
export const UpdateBotAgentResult = new UpdateBotAgentResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBotAgentInput$Type extends MessageType {
    constructor() {
        super("DeleteBotAgentInput", [
            { no: 1, name: "agent_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agentId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 agent_id */ 1:
                    message.agentId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 agent_id = 1; */
        if (message.agentId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.agentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteBotAgentInput
 */
export const DeleteBotAgentInput = new DeleteBotAgentInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBotAgentResult$Type extends MessageType {
    constructor() {
        super("DeleteBotAgentResult", [
            { no: 1, name: "agent_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.agentId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 agent_id */ 1:
                    message.agentId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 agent_id = 1; */
        if (message.agentId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.agentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteBotAgentResult
 */
export const DeleteBotAgentResult = new DeleteBotAgentResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListBotsInput$Type extends MessageType {
    constructor() {
        super("ListBotsInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListBotsInput
 */
export const ListBotsInput = new ListBotsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListBotsResult$Type extends MessageType {
    constructor() {
        super("ListBotsResult", [
            { no: 1, name: "bots", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.bots = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated User bots */ 1:
                    message.bots.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated User bots = 1; */
        for (let i = 0; i < message.bots.length; i++)
            User.internalBinaryWrite(message.bots[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListBotsResult
 */
export const ListBotsResult = new ListBotsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBotInput$Type extends MessageType {
    constructor() {
        super("DeleteBotInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteBotInput
 */
export const DeleteBotInput = new DeleteBotInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBotResult$Type extends MessageType {
    constructor() {
        super("DeleteBotResult", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteBotResult
 */
export const DeleteBotResult = new DeleteBotResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMessageAttachmentInput$Type extends MessageType {
    constructor() {
        super("DeleteMessageAttachmentInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "attachment_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.attachmentId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 message_id */ 2:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* int64 attachment_id */ 3:
                    message.attachmentId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 message_id = 2; */
        if (message.messageId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.messageId);
        /* int64 attachment_id = 3; */
        if (message.attachmentId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.attachmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteMessageAttachmentInput
 */
export const DeleteMessageAttachmentInput = new DeleteMessageAttachmentInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMessageAttachmentResult$Type extends MessageType {
    constructor() {
        super("DeleteMessageAttachmentResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteMessageAttachmentResult
 */
export const DeleteMessageAttachmentResult = new DeleteMessageAttachmentResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeSessionInput$Type extends MessageType {
    constructor() {
        super("RevokeSessionInput", [
            { no: 1, name: "session_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.sessionId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 session_id */ 1:
                    message.sessionId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 session_id = 1; */
        if (message.sessionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeSessionInput
 */
export const RevokeSessionInput = new RevokeSessionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeSessionResult$Type extends MessageType {
    constructor() {
        super("RevokeSessionResult", [
            { no: 1, name: "revoked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "already_revoked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.revoked = false;
        message.alreadyRevoked = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool revoked */ 1:
                    message.revoked = reader.bool();
                    break;
                case /* bool already_revoked */ 2:
                    message.alreadyRevoked = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool revoked = 1; */
        if (message.revoked !== false)
            writer.tag(1, WireType.Varint).bool(message.revoked);
        /* bool already_revoked = 2; */
        if (message.alreadyRevoked !== false)
            writer.tag(2, WireType.Varint).bool(message.alreadyRevoked);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeSessionResult
 */
export const RevokeSessionResult = new RevokeSessionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionsInput$Type extends MessageType {
    constructor() {
        super("GetSessionsInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSessionsInput
 */
export const GetSessionsInput = new GetSessionsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountSession$Type extends MessageType {
    constructor() {
        super("AccountSession", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "client_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "os_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "device_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "city", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "country", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "timezone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "created_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "last_active_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "current", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.clientType = "";
        message.createdAt = 0n;
        message.lastActiveAt = 0n;
        message.active = false;
        message.current = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* string client_type */ 2:
                    message.clientType = reader.string();
                    break;
                case /* optional string client_version */ 3:
                    message.clientVersion = reader.string();
                    break;
                case /* optional string os_version */ 4:
                    message.osVersion = reader.string();
                    break;
                case /* optional string device_name */ 5:
                    message.deviceName = reader.string();
                    break;
                case /* optional string city */ 6:
                    message.city = reader.string();
                    break;
                case /* optional string country */ 7:
                    message.country = reader.string();
                    break;
                case /* optional string timezone */ 8:
                    message.timezone = reader.string();
                    break;
                case /* int64 created_at */ 9:
                    message.createdAt = reader.int64().toBigInt();
                    break;
                case /* int64 last_active_at */ 10:
                    message.lastActiveAt = reader.int64().toBigInt();
                    break;
                case /* bool active */ 11:
                    message.active = reader.bool();
                    break;
                case /* bool current */ 12:
                    message.current = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string client_type = 2; */
        if (message.clientType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientType);
        /* optional string client_version = 3; */
        if (message.clientVersion !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.clientVersion);
        /* optional string os_version = 4; */
        if (message.osVersion !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.osVersion);
        /* optional string device_name = 5; */
        if (message.deviceName !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.deviceName);
        /* optional string city = 6; */
        if (message.city !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.city);
        /* optional string country = 7; */
        if (message.country !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.country);
        /* optional string timezone = 8; */
        if (message.timezone !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.timezone);
        /* int64 created_at = 9; */
        if (message.createdAt !== 0n)
            writer.tag(9, WireType.Varint).int64(message.createdAt);
        /* int64 last_active_at = 10; */
        if (message.lastActiveAt !== 0n)
            writer.tag(10, WireType.Varint).int64(message.lastActiveAt);
        /* bool active = 11; */
        if (message.active !== false)
            writer.tag(11, WireType.Varint).bool(message.active);
        /* bool current = 12; */
        if (message.current !== false)
            writer.tag(12, WireType.Varint).bool(message.current);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AccountSession
 */
export const AccountSession = new AccountSession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionsResult$Type extends MessageType {
    constructor() {
        super("GetSessionsResult", [
            { no: 1, name: "sessions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AccountSession }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.sessions = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AccountSession sessions */ 1:
                    message.sessions.push(AccountSession.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AccountSession sessions = 1; */
        for (let i = 0; i < message.sessions.length; i++)
            AccountSession.internalBinaryWrite(message.sessions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSessionsResult
 */
export const GetSessionsResult = new GetSessionsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCliSessionInput$Type extends MessageType {
    constructor() {
        super("CreateCliSessionInput", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "os_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.clientVersion = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* optional string device_name */ 2:
                    message.deviceName = reader.string();
                    break;
                case /* string client_version */ 3:
                    message.clientVersion = reader.string();
                    break;
                case /* optional string os_version */ 4:
                    message.osVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* optional string device_name = 2; */
        if (message.deviceName !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.deviceName);
        /* string client_version = 3; */
        if (message.clientVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientVersion);
        /* optional string os_version = 4; */
        if (message.osVersion !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.osVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateCliSessionInput
 */
export const CreateCliSessionInput = new CreateCliSessionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCliSessionResult$Type extends MessageType {
    constructor() {
        super("CreateCliSessionResult", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "session_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.sessionId = 0n;
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int64 session_id */ 2:
                    message.sessionId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 3:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int64 session_id = 2; */
        if (message.sessionId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.sessionId);
        /* int64 user_id = 3; */
        if (message.userId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateCliSessionResult
 */
export const CreateCliSessionResult = new CreateCliSessionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckUsernameInput$Type extends MessageType {
    constructor() {
        super("CheckUsernameInput", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckUsernameInput
 */
export const CheckUsernameInput = new CheckUsernameInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckUsernameResult$Type extends MessageType {
    constructor() {
        super("CheckUsernameResult", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "availability", kind: "enum", T: () => ["UsernameAvailability", UsernameAvailability] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        message.availability = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                case /* UsernameAvailability availability */ 2:
                    message.availability = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        /* UsernameAvailability availability = 2; */
        if (message.availability !== 0)
            writer.tag(2, WireType.Varint).int32(message.availability);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckUsernameResult
 */
export const CheckUsernameResult = new CheckUsernameResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeUsernameInput$Type extends MessageType {
    constructor() {
        super("ChangeUsernameInput", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChangeUsernameInput
 */
export const ChangeUsernameInput = new ChangeUsernameInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeUsernameResult$Type extends MessageType {
    constructor() {
        super("ChangeUsernameResult", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated Update updates */ 2:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Update updates = 2; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChangeUsernameResult
 */
export const ChangeUsernameResult = new ChangeUsernameResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProfileInput$Type extends MessageType {
    constructor() {
        super("UpdateProfileInput", [
            { no: 1, name: "first_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "bio", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string first_name */ 1:
                    message.firstName = reader.string();
                    break;
                case /* optional string last_name */ 2:
                    message.lastName = reader.string();
                    break;
                case /* optional string bio */ 3:
                    message.bio = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string first_name = 1; */
        if (message.firstName !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.firstName);
        /* optional string last_name = 2; */
        if (message.lastName !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.lastName);
        /* optional string bio = 3; */
        if (message.bio !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.bio);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateProfileInput
 */
export const UpdateProfileInput = new UpdateProfileInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProfileResult$Type extends MessageType {
    constructor() {
        super("UpdateProfileResult", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated Update updates */ 2:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Update updates = 2; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateProfileResult
 */
export const UpdateProfileResult = new UpdateProfileResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfilePhotoInput$Type extends MessageType {
    constructor() {
        super("SetProfilePhotoInput", [
            { no: 1, name: "file_unique_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileUniqueId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_unique_id */ 1:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string file_unique_id = 1; */
        if (message.fileUniqueId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetProfilePhotoInput
 */
export const SetProfilePhotoInput = new SetProfilePhotoInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfilePhotoResult$Type extends MessageType {
    constructor() {
        super("SetProfilePhotoResult", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated Update updates */ 2:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Update updates = 2; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetProfilePhotoResult
 */
export const SetProfilePhotoResult = new SetProfilePhotoResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalProfilePhotoInput$Type extends MessageType {
    constructor() {
        super("GetExternalProfilePhotoInput", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ExternalProfileProvider", ExternalProfileProvider] },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ExternalProfileProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ExternalProfileProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetExternalProfilePhotoInput
 */
export const GetExternalProfilePhotoInput = new GetExternalProfilePhotoInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExternalProfilePhotoResult$Type extends MessageType {
    constructor() {
        super("GetExternalProfilePhotoResult", [
            { no: 1, name: "status", kind: "enum", T: () => ["ExternalProfilePhotoStatus", ExternalProfilePhotoStatus] },
            { no: 2, name: "photo", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = 0;
        message.photo = new Uint8Array(0);
        message.mimeType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ExternalProfilePhotoStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* bytes photo */ 2:
                    message.photo = reader.bytes();
                    break;
                case /* string mime_type */ 3:
                    message.mimeType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ExternalProfilePhotoStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* bytes photo = 2; */
        if (message.photo.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.photo);
        /* string mime_type = 3; */
        if (message.mimeType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.mimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetExternalProfilePhotoResult
 */
export const GetExternalProfilePhotoResult = new GetExternalProfilePhotoResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotCommand$Type extends MessageType {
    constructor() {
        super("BotCommand", [
            { no: 1, name: "command", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sort_order", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.command = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string command */ 1:
                    message.command = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* optional int32 sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string command = 1; */
        if (message.command !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.command);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* optional int32 sort_order = 3; */
        if (message.sortOrder !== undefined)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotCommand
 */
export const BotCommand = new BotCommand$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotSkill$Type extends MessageType {
    constructor() {
        super("BotSkill", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sort_order", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* optional int32 sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* optional int32 sort_order = 4; */
        if (message.sortOrder !== undefined)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotSkill
 */
export const BotSkill = new BotSkill$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerBotCommands$Type extends MessageType {
    constructor() {
        super("PeerBotCommands", [
            { no: 1, name: "bot", kind: "message", T: () => User },
            { no: 2, name: "commands", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCommand }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.commands = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                case /* repeated BotCommand commands */ 2:
                    message.commands.push(BotCommand.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated BotCommand commands = 2; */
        for (let i = 0; i < message.commands.length; i++)
            BotCommand.internalBinaryWrite(message.commands[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PeerBotCommands
 */
export const PeerBotCommands = new PeerBotCommands$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotCommandsInput$Type extends MessageType {
    constructor() {
        super("GetBotCommandsInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotCommandsInput
 */
export const GetBotCommandsInput = new GetBotCommandsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotCommandsResult$Type extends MessageType {
    constructor() {
        super("GetBotCommandsResult", [
            { no: 1, name: "commands", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCommand }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.commands = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotCommand commands */ 1:
                    message.commands.push(BotCommand.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotCommand commands = 1; */
        for (let i = 0; i < message.commands.length; i++)
            BotCommand.internalBinaryWrite(message.commands[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotCommandsResult
 */
export const GetBotCommandsResult = new GetBotCommandsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBotCommandsInput$Type extends MessageType {
    constructor() {
        super("SetBotCommandsInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "commands", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCommand }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.commands = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* repeated BotCommand commands */ 2:
                    message.commands.push(BotCommand.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* repeated BotCommand commands = 2; */
        for (let i = 0; i < message.commands.length; i++)
            BotCommand.internalBinaryWrite(message.commands[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetBotCommandsInput
 */
export const SetBotCommandsInput = new SetBotCommandsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBotCommandsResult$Type extends MessageType {
    constructor() {
        super("SetBotCommandsResult", [
            { no: 1, name: "commands", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCommand }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.commands = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotCommand commands */ 1:
                    message.commands.push(BotCommand.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotCommand commands = 1; */
        for (let i = 0; i < message.commands.length; i++)
            BotCommand.internalBinaryWrite(message.commands[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetBotCommandsResult
 */
export const SetBotCommandsResult = new SetBotCommandsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotSkillsInput$Type extends MessageType {
    constructor() {
        super("GetBotSkillsInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotSkillsInput
 */
export const GetBotSkillsInput = new GetBotSkillsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotSkillsResult$Type extends MessageType {
    constructor() {
        super("GetBotSkillsResult", [
            { no: 1, name: "skills", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotSkill }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.skills = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotSkill skills */ 1:
                    message.skills.push(BotSkill.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotSkill skills = 1; */
        for (let i = 0; i < message.skills.length; i++)
            BotSkill.internalBinaryWrite(message.skills[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotSkillsResult
 */
export const GetBotSkillsResult = new GetBotSkillsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotConfigurationCatalogInput$Type extends MessageType {
    constructor() {
        super("GetBotConfigurationCatalogInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* optional InputPeer peer_id */ 2:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* optional InputPeer peer_id = 2; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotConfigurationCatalogInput
 */
export const GetBotConfigurationCatalogInput = new GetBotConfigurationCatalogInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotConfigurationCatalogResult$Type extends MessageType {
    constructor() {
        super("GetBotConfigurationCatalogResult", [
            { no: 1, name: "catalog", kind: "message", T: () => AgentConfigurationCatalog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional AgentConfigurationCatalog catalog */ 1:
                    message.catalog = AgentConfigurationCatalog.internalBinaryRead(reader, reader.uint32(), options, message.catalog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional AgentConfigurationCatalog catalog = 1; */
        if (message.catalog)
            AgentConfigurationCatalog.internalBinaryWrite(message.catalog, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotConfigurationCatalogResult
 */
export const GetBotConfigurationCatalogResult = new GetBotConfigurationCatalogResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPeerBotCommandsInput$Type extends MessageType {
    constructor() {
        super("GetPeerBotCommandsInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPeerBotCommandsInput
 */
export const GetPeerBotCommandsInput = new GetPeerBotCommandsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPeerBotCommandsResult$Type extends MessageType {
    constructor() {
        super("GetPeerBotCommandsResult", [
            { no: 1, name: "bots", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PeerBotCommands }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.bots = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PeerBotCommands bots */ 1:
                    message.bots.push(PeerBotCommands.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PeerBotCommands bots = 1; */
        for (let i = 0; i < message.bots.length; i++)
            PeerBotCommands.internalBinaryWrite(message.bots[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPeerBotCommandsResult
 */
export const GetPeerBotCommandsResult = new GetPeerBotCommandsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevealBotTokenInput$Type extends MessageType {
    constructor() {
        super("RevealBotTokenInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevealBotTokenInput
 */
export const RevealBotTokenInput = new RevealBotTokenInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevealBotTokenResult$Type extends MessageType {
    constructor() {
        super("RevealBotTokenResult", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevealBotTokenResult
 */
export const RevealBotTokenResult = new RevealBotTokenResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateBotTokenInput$Type extends MessageType {
    constructor() {
        super("RotateBotTokenInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RotateBotTokenInput
 */
export const RotateBotTokenInput = new RotateBotTokenInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateBotTokenResult$Type extends MessageType {
    constructor() {
        super("RotateBotTokenResult", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RotateBotTokenResult
 */
export const RotateBotTokenResult = new RotateBotTokenResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBotProfileInput$Type extends MessageType {
    constructor() {
        super("UpdateBotProfileInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "photo_file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* optional string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string photo_file_unique_id */ 3:
                    message.photoFileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* optional string name = 2; */
        if (message.name !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string photo_file_unique_id = 3; */
        if (message.photoFileUniqueId !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.photoFileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBotProfileInput
 */
export const UpdateBotProfileInput = new UpdateBotProfileInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBotProfileResult$Type extends MessageType {
    constructor() {
        super("UpdateBotProfileResult", [
            { no: 1, name: "bot", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBotProfileResult
 */
export const UpdateBotProfileResult = new UpdateBotProfileResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBotAvatarInput$Type extends MessageType {
    constructor() {
        super("SetBotAvatarInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["BotAvatar.Kind", BotAvatar_Kind] },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "file_unique_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.kind = 0;
        message.displayName = "";
        message.fileUniqueId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* BotAvatar.Kind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* optional string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string file_unique_id */ 5:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* BotAvatar.Kind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* optional string description = 4; */
        if (message.description !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string file_unique_id = 5; */
        if (message.fileUniqueId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetBotAvatarInput
 */
export const SetBotAvatarInput = new SetBotAvatarInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBotAvatarResult$Type extends MessageType {
    constructor() {
        super("SetBotAvatarResult", [
            { no: 1, name: "bot", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetBotAvatarResult
 */
export const SetBotAvatarResult = new SetBotAvatarResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearBotAvatarInput$Type extends MessageType {
    constructor() {
        super("ClearBotAvatarInput", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClearBotAvatarInput
 */
export const ClearBotAvatarInput = new ClearBotAvatarInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearBotAvatarResult$Type extends MessageType {
    constructor() {
        super("ClearBotAvatarResult", [
            { no: 1, name: "bot", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClearBotAvatarResult
 */
export const ClearBotAvatarResult = new ClearBotAvatarResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotPresenceInput$Type extends MessageType {
    constructor() {
        super("GetBotPresenceInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotPresenceInput
 */
export const GetBotPresenceInput = new GetBotPresenceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBotPresenceResult$Type extends MessageType {
    constructor() {
        super("GetBotPresenceResult", [
            { no: 1, name: "bot_user_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "avatar", kind: "message", T: () => BotAvatar },
            { no: 3, name: "state", kind: "message", T: () => BotPresenceState },
            { no: 4, name: "peer_id", kind: "message", T: () => Peer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* optional BotAvatar avatar */ 2:
                    message.avatar = BotAvatar.internalBinaryRead(reader, reader.uint32(), options, message.avatar);
                    break;
                case /* BotPresenceState state */ 3:
                    message.state = BotPresenceState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* Peer peer_id */ 4:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 bot_user_id = 1; */
        if (message.botUserId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* optional BotAvatar avatar = 2; */
        if (message.avatar)
            BotAvatar.internalBinaryWrite(message.avatar, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* BotPresenceState state = 3; */
        if (message.state)
            BotPresenceState.internalBinaryWrite(message.state, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* Peer peer_id = 4; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBotPresenceResult
 */
export const GetBotPresenceResult = new GetBotPresenceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBotPresenceStateInput$Type extends MessageType {
    constructor() {
        super("SetBotPresenceStateInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "state", kind: "message", T: () => BotPresenceState }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* BotPresenceState state */ 2:
                    message.state = BotPresenceState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BotPresenceState state = 2; */
        if (message.state)
            BotPresenceState.internalBinaryWrite(message.state, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetBotPresenceStateInput
 */
export const SetBotPresenceStateInput = new SetBotPresenceStateInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBotPresenceStateResult$Type extends MessageType {
    constructor() {
        super("SetBotPresenceStateResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetBotPresenceStateResult
 */
export const SetBotPresenceStateResult = new SetBotPresenceStateResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSettingsInput$Type extends MessageType {
    constructor() {
        super("GetUserSettingsInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserSettingsInput
 */
export const GetUserSettingsInput = new GetUserSettingsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSettingsResult$Type extends MessageType {
    constructor() {
        super("GetUserSettingsResult", [
            { no: 1, name: "user_settings", kind: "message", T: () => UserSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UserSettings user_settings */ 1:
                    message.userSettings = UserSettings.internalBinaryRead(reader, reader.uint32(), options, message.userSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UserSettings user_settings = 1; */
        if (message.userSettings)
            UserSettings.internalBinaryWrite(message.userSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserSettingsResult
 */
export const GetUserSettingsResult = new GetUserSettingsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserSettings$Type extends MessageType {
    constructor() {
        super("UserSettings", [
            { no: 1, name: "notification_settings", kind: "message", T: () => NotificationSettings },
            { no: 2, name: "privacy_settings", kind: "message", T: () => PrivacySettings },
            { no: 3, name: "compose_settings", kind: "message", T: () => ComposeSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional NotificationSettings notification_settings */ 1:
                    message.notificationSettings = NotificationSettings.internalBinaryRead(reader, reader.uint32(), options, message.notificationSettings);
                    break;
                case /* optional PrivacySettings privacy_settings */ 2:
                    message.privacySettings = PrivacySettings.internalBinaryRead(reader, reader.uint32(), options, message.privacySettings);
                    break;
                case /* optional ComposeSettings compose_settings */ 3:
                    message.composeSettings = ComposeSettings.internalBinaryRead(reader, reader.uint32(), options, message.composeSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional NotificationSettings notification_settings = 1; */
        if (message.notificationSettings)
            NotificationSettings.internalBinaryWrite(message.notificationSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional PrivacySettings privacy_settings = 2; */
        if (message.privacySettings)
            PrivacySettings.internalBinaryWrite(message.privacySettings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional ComposeSettings compose_settings = 3; */
        if (message.composeSettings)
            ComposeSettings.internalBinaryWrite(message.composeSettings, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserSettings
 */
export const UserSettings = new UserSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComposeSettings$Type extends MessageType {
    constructor() {
        super("ComposeSettings", [
            { no: 1, name: "replace_pasted_links_with_titles", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool replace_pasted_links_with_titles */ 1:
                    message.replacePastedLinksWithTitles = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional bool replace_pasted_links_with_titles = 1; */
        if (message.replacePastedLinksWithTitles !== undefined)
            writer.tag(1, WireType.Varint).bool(message.replacePastedLinksWithTitles);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ComposeSettings
 */
export const ComposeSettings = new ComposeSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrivacySettings$Type extends MessageType {
    constructor() {
        super("PrivacySettings", [
            { no: 1, name: "share_time_zone", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "appear_in_global_search", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool share_time_zone */ 1:
                    message.shareTimeZone = reader.bool();
                    break;
                case /* optional bool appear_in_global_search */ 2:
                    message.appearInGlobalSearch = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional bool share_time_zone = 1; */
        if (message.shareTimeZone !== undefined)
            writer.tag(1, WireType.Varint).bool(message.shareTimeZone);
        /* optional bool appear_in_global_search = 2; */
        if (message.appearInGlobalSearch !== undefined)
            writer.tag(2, WireType.Varint).bool(message.appearInGlobalSearch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PrivacySettings
 */
export const PrivacySettings = new PrivacySettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationSettings$Type extends MessageType {
    constructor() {
        super("NotificationSettings", [
            { no: 1, name: "mode", kind: "enum", opt: true, T: () => ["NotificationSettings.Mode", NotificationSettings_Mode, "MODE_"] },
            { no: 2, name: "silent", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "zen_mode_requires_mention", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "zen_mode_uses_default_rules", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "zen_mode_custom_rules", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "disable_dm_notifications", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional NotificationSettings.Mode mode */ 1:
                    message.mode = reader.int32();
                    break;
                case /* optional bool silent */ 2:
                    message.silent = reader.bool();
                    break;
                case /* optional bool zen_mode_requires_mention */ 3:
                    message.zenModeRequiresMention = reader.bool();
                    break;
                case /* optional bool zen_mode_uses_default_rules */ 4:
                    message.zenModeUsesDefaultRules = reader.bool();
                    break;
                case /* optional string zen_mode_custom_rules */ 5:
                    message.zenModeCustomRules = reader.string();
                    break;
                case /* optional bool disable_dm_notifications */ 6:
                    message.disableDmNotifications = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional NotificationSettings.Mode mode = 1; */
        if (message.mode !== undefined)
            writer.tag(1, WireType.Varint).int32(message.mode);
        /* optional bool silent = 2; */
        if (message.silent !== undefined)
            writer.tag(2, WireType.Varint).bool(message.silent);
        /* optional bool zen_mode_requires_mention = 3; */
        if (message.zenModeRequiresMention !== undefined)
            writer.tag(3, WireType.Varint).bool(message.zenModeRequiresMention);
        /* optional bool zen_mode_uses_default_rules = 4; */
        if (message.zenModeUsesDefaultRules !== undefined)
            writer.tag(4, WireType.Varint).bool(message.zenModeUsesDefaultRules);
        /* optional string zen_mode_custom_rules = 5; */
        if (message.zenModeCustomRules !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.zenModeCustomRules);
        /* optional bool disable_dm_notifications = 6; */
        if (message.disableDmNotifications !== undefined)
            writer.tag(6, WireType.Varint).bool(message.disableDmNotifications);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NotificationSettings
 */
export const NotificationSettings = new NotificationSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DialogNotificationSettings$Type extends MessageType {
    constructor() {
        super("DialogNotificationSettings", [
            { no: 1, name: "mode", kind: "enum", opt: true, T: () => ["DialogNotificationSettings.Mode", DialogNotificationSettings_Mode, "MODE_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional DialogNotificationSettings.Mode mode */ 1:
                    message.mode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional DialogNotificationSettings.Mode mode = 1; */
        if (message.mode !== undefined)
            writer.tag(1, WireType.Varint).int32(message.mode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DialogNotificationSettings
 */
export const DialogNotificationSettings = new DialogNotificationSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserSettingsInput$Type extends MessageType {
    constructor() {
        super("UpdateUserSettingsInput", [
            { no: 1, name: "user_settings", kind: "message", T: () => UserSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UserSettings user_settings */ 1:
                    message.userSettings = UserSettings.internalBinaryRead(reader, reader.uint32(), options, message.userSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UserSettings user_settings = 1; */
        if (message.userSettings)
            UserSettings.internalBinaryWrite(message.userSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserSettingsInput
 */
export const UpdateUserSettingsInput = new UpdateUserSettingsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserSettingsResult$Type extends MessageType {
    constructor() {
        super("UpdateUserSettingsResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserSettingsResult
 */
export const UpdateUserSettingsResult = new UpdateUserSettingsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveUrlPreviewInput$Type extends MessageType {
    constructor() {
        super("ResolveUrlPreviewInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResolveUrlPreviewInput
 */
export const ResolveUrlPreviewInput = new ResolveUrlPreviewInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveUrlPreviewResult$Type extends MessageType {
    constructor() {
        super("ResolveUrlPreviewResult", [
            { no: 1, name: "url_preview", kind: "message", T: () => UrlPreview },
            { no: 2, name: "can_substitute", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.canSubstitute = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UrlPreview url_preview */ 1:
                    message.urlPreview = UrlPreview.internalBinaryRead(reader, reader.uint32(), options, message.urlPreview);
                    break;
                case /* bool can_substitute */ 2:
                    message.canSubstitute = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UrlPreview url_preview = 1; */
        if (message.urlPreview)
            UrlPreview.internalBinaryWrite(message.urlPreview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool can_substitute = 2; */
        if (message.canSubstitute !== false)
            writer.tag(2, WireType.Varint).bool(message.canSubstitute);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResolveUrlPreviewResult
 */
export const ResolveUrlPreviewResult = new ResolveUrlPreviewResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogNotificationSettingsInput$Type extends MessageType {
    constructor() {
        super("UpdateDialogNotificationSettingsInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "notification_settings", kind: "message", T: () => DialogNotificationSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional DialogNotificationSettings notification_settings */ 2:
                    message.notificationSettings = DialogNotificationSettings.internalBinaryRead(reader, reader.uint32(), options, message.notificationSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional DialogNotificationSettings notification_settings = 2; */
        if (message.notificationSettings)
            DialogNotificationSettings.internalBinaryWrite(message.notificationSettings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogNotificationSettingsInput
 */
export const UpdateDialogNotificationSettingsInput = new UpdateDialogNotificationSettingsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogNotificationSettingsResult$Type extends MessageType {
    constructor() {
        super("UpdateDialogNotificationSettingsResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogNotificationSettingsResult
 */
export const UpdateDialogNotificationSettingsResult = new UpdateDialogNotificationSettingsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendComposeActionInput$Type extends MessageType {
    constructor() {
        super("SendComposeActionInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "action", kind: "enum", opt: true, T: () => ["UpdateComposeAction.ComposeAction", UpdateComposeAction_ComposeAction] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional UpdateComposeAction.ComposeAction action */ 2:
                    message.action = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional UpdateComposeAction.ComposeAction action = 2; */
        if (message.action !== undefined)
            writer.tag(2, WireType.Varint).int32(message.action);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SendComposeActionInput
 */
export const SendComposeActionInput = new SendComposeActionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendComposeActionResult$Type extends MessageType {
    constructor() {
        super("SendComposeActionResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SendComposeActionResult
 */
export const SendComposeActionResult = new SendComposeActionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushContentEncryptionKey$Type extends MessageType {
    constructor() {
        super("PushContentEncryptionKey", [
            { no: 1, name: "public_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "key_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "algorithm", kind: "enum", T: () => ["PushContentEncryptionKey.Algorithm", PushContentEncryptionKey_Algorithm, "ALGORITHM_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.publicKey = new Uint8Array(0);
        message.algorithm = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes public_key */ 1:
                    message.publicKey = reader.bytes();
                    break;
                case /* optional string key_id */ 2:
                    message.keyId = reader.string();
                    break;
                case /* PushContentEncryptionKey.Algorithm algorithm */ 3:
                    message.algorithm = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes public_key = 1; */
        if (message.publicKey.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.publicKey);
        /* optional string key_id = 2; */
        if (message.keyId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.keyId);
        /* PushContentEncryptionKey.Algorithm algorithm = 3; */
        if (message.algorithm !== 0)
            writer.tag(3, WireType.Varint).int32(message.algorithm);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PushContentEncryptionKey
 */
export const PushContentEncryptionKey = new PushContentEncryptionKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApnsNotificationMethod$Type extends MessageType {
    constructor() {
        super("ApnsNotificationMethod", [
            { no: 1, name: "device_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_token */ 1:
                    message.deviceToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_token = 1; */
        if (message.deviceToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ApnsNotificationMethod
 */
export const ApnsNotificationMethod = new ApnsNotificationMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpoAndroidNotificationMethod$Type extends MessageType {
    constructor() {
        super("ExpoAndroidNotificationMethod", [
            { no: 1, name: "expo_push_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.expoPushToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expo_push_token */ 1:
                    message.expoPushToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string expo_push_token = 1; */
        if (message.expoPushToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expoPushToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ExpoAndroidNotificationMethod
 */
export const ExpoAndroidNotificationMethod = new ExpoAndroidNotificationMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushNotificationMethod$Type extends MessageType {
    constructor() {
        super("PushNotificationMethod", [
            { no: 1, name: "provider", kind: "enum", T: () => ["PushNotificationProvider", PushNotificationProvider, "PUSH_NOTIFICATION_PROVIDER_"] },
            { no: 2, name: "apns", kind: "message", oneof: "method", T: () => ApnsNotificationMethod },
            { no: 3, name: "expo_android", kind: "message", oneof: "method", T: () => ExpoAndroidNotificationMethod }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.method = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* PushNotificationProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* ApnsNotificationMethod apns */ 2:
                    message.method = {
                        oneofKind: "apns",
                        apns: ApnsNotificationMethod.internalBinaryRead(reader, reader.uint32(), options, message.method.apns)
                    };
                    break;
                case /* ExpoAndroidNotificationMethod expo_android */ 3:
                    message.method = {
                        oneofKind: "expoAndroid",
                        expoAndroid: ExpoAndroidNotificationMethod.internalBinaryRead(reader, reader.uint32(), options, message.method.expoAndroid)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* PushNotificationProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* ApnsNotificationMethod apns = 2; */
        if (message.method.oneofKind === "apns")
            ApnsNotificationMethod.internalBinaryWrite(message.method.apns, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ExpoAndroidNotificationMethod expo_android = 3; */
        if (message.method.oneofKind === "expoAndroid")
            ExpoAndroidNotificationMethod.internalBinaryWrite(message.method.expoAndroid, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PushNotificationMethod
 */
export const PushNotificationMethod = new PushNotificationMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterDeviceInput$Type extends MessageType {
    constructor() {
        super("RegisterDeviceInput", [
            { no: 1, name: "apple_push_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "push_content_encryption_key", kind: "message", T: () => PushContentEncryptionKey },
            { no: 3, name: "push_content_version", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "notification_method", kind: "message", T: () => PushNotificationMethod }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.applePushToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string apple_push_token = 1 [deprecated = true];*/ 1:
                    message.applePushToken = reader.string();
                    break;
                case /* optional PushContentEncryptionKey push_content_encryption_key */ 2:
                    message.pushContentEncryptionKey = PushContentEncryptionKey.internalBinaryRead(reader, reader.uint32(), options, message.pushContentEncryptionKey);
                    break;
                case /* optional uint32 push_content_version */ 3:
                    message.pushContentVersion = reader.uint32();
                    break;
                case /* optional PushNotificationMethod notification_method */ 4:
                    message.notificationMethod = PushNotificationMethod.internalBinaryRead(reader, reader.uint32(), options, message.notificationMethod);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string apple_push_token = 1 [deprecated = true]; */
        if (message.applePushToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.applePushToken);
        /* optional PushContentEncryptionKey push_content_encryption_key = 2; */
        if (message.pushContentEncryptionKey)
            PushContentEncryptionKey.internalBinaryWrite(message.pushContentEncryptionKey, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional uint32 push_content_version = 3; */
        if (message.pushContentVersion !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.pushContentVersion);
        /* optional PushNotificationMethod notification_method = 4; */
        if (message.notificationMethod)
            PushNotificationMethod.internalBinaryWrite(message.notificationMethod, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RegisterDeviceInput
 */
export const RegisterDeviceInput = new RegisterDeviceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterDeviceResult$Type extends MessageType {
    constructor() {
        super("RegisterDeviceResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RegisterDeviceResult
 */
export const RegisterDeviceResult = new RegisterDeviceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnregisterDeviceInput$Type extends MessageType {
    constructor() {
        super("UnregisterDeviceInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnregisterDeviceInput
 */
export const UnregisterDeviceInput = new UnregisterDeviceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnregisterDeviceResult$Type extends MessageType {
    constructor() {
        super("UnregisterDeviceResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnregisterDeviceResult
 */
export const UnregisterDeviceResult = new UnregisterDeviceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LogOutInput$Type extends MessageType {
    constructor() {
        super("LogOutInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LogOutInput
 */
export const LogOutInput = new LogOutInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LogOutResult$Type extends MessageType {
    constructor() {
        super("LogOutResult", [
            { no: 1, name: "logged_out", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.loggedOut = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool logged_out */ 1:
                    message.loggedOut = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool logged_out = 1; */
        if (message.loggedOut !== false)
            writer.tag(1, WireType.Varint).bool(message.loggedOut);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LogOutResult
 */
export const LogOutResult = new LogOutResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSessionInput$Type extends MessageType {
    constructor() {
        super("UpdateSessionInput", [
            { no: 1, name: "time_zone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "os_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string time_zone */ 1:
                    message.timeZone = reader.string();
                    break;
                case /* optional string device_name */ 2:
                    message.deviceName = reader.string();
                    break;
                case /* optional string client_version */ 3:
                    message.clientVersion = reader.string();
                    break;
                case /* optional string os_version */ 4:
                    message.osVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string time_zone = 1; */
        if (message.timeZone !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.timeZone);
        /* optional string device_name = 2; */
        if (message.deviceName !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.deviceName);
        /* optional string client_version = 3; */
        if (message.clientVersion !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.clientVersion);
        /* optional string os_version = 4; */
        if (message.osVersion !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.osVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSessionInput
 */
export const UpdateSessionInput = new UpdateSessionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSessionResult$Type extends MessageType {
    constructor() {
        super("UpdateSessionResult", [
            { no: 1, name: "session", kind: "message", T: () => AccountSession }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AccountSession session */ 1:
                    message.session = AccountSession.internalBinaryRead(reader, reader.uint32(), options, message.session);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AccountSession session = 1; */
        if (message.session)
            AccountSession.internalBinaryWrite(message.session, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSessionResult
 */
export const UpdateSessionResult = new UpdateSessionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogArchivedInput$Type extends MessageType {
    constructor() {
        super("UpdateDialogArchivedInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "archived", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.archived = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* bool archived */ 2:
                    message.archived = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool archived = 2; */
        if (message.archived !== false)
            writer.tag(2, WireType.Varint).bool(message.archived);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogArchivedInput
 */
export const UpdateDialogArchivedInput = new UpdateDialogArchivedInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogArchivedResult$Type extends MessageType {
    constructor() {
        super("UpdateDialogArchivedResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogArchivedResult
 */
export const UpdateDialogArchivedResult = new UpdateDialogArchivedResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDialogFolderInput$Type extends MessageType {
    constructor() {
        super("CreateDialogFolderInput", [
            { no: 1, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "peers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => InputPeer },
            { no: 3, name: "order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pinned_order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.peers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string title */ 1:
                    message.title = reader.string();
                    break;
                case /* repeated InputPeer peers */ 2:
                    message.peers.push(InputPeer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string order */ 3:
                    message.order = reader.string();
                    break;
                case /* optional string pinned_order */ 4:
                    message.pinnedOrder = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string title = 1; */
        if (message.title !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* repeated InputPeer peers = 2; */
        for (let i = 0; i < message.peers.length; i++)
            InputPeer.internalBinaryWrite(message.peers[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional string order = 3; */
        if (message.order !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.order);
        /* optional string pinned_order = 4; */
        if (message.pinnedOrder !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.pinnedOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateDialogFolderInput
 */
export const CreateDialogFolderInput = new CreateDialogFolderInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDialogFolderResult$Type extends MessageType {
    constructor() {
        super("CreateDialogFolderResult", [
            { no: 1, name: "folder", kind: "message", T: () => DialogFolder },
            { no: 2, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dialogs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* DialogFolder folder */ 1:
                    message.folder = DialogFolder.internalBinaryRead(reader, reader.uint32(), options, message.folder);
                    break;
                case /* repeated Dialog dialogs */ 2:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* DialogFolder folder = 1; */
        if (message.folder)
            DialogFolder.internalBinaryWrite(message.folder, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Dialog dialogs = 2; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateDialogFolderResult
 */
export const CreateDialogFolderResult = new CreateDialogFolderResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogFolderInput$Type extends MessageType {
    constructor() {
        super("UpdateDialogFolderInput", [
            { no: 1, name: "folder_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", oneof: "titleUpdate", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "clear_title", kind: "scalar", oneof: "titleUpdate", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "order", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "emoji", kind: "scalar", oneof: "emojiUpdate", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "clear_emoji", kind: "scalar", oneof: "emojiUpdate", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "pinned_order", kind: "scalar", oneof: "pinnedOrderUpdate", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "clear_pinned_order", kind: "scalar", oneof: "pinnedOrderUpdate", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.folderId = 0n;
        message.titleUpdate = { oneofKind: undefined };
        message.emojiUpdate = { oneofKind: undefined };
        message.pinnedOrderUpdate = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 folder_id */ 1:
                    message.folderId = reader.int64().toBigInt();
                    break;
                case /* string title */ 2:
                    message.titleUpdate = {
                        oneofKind: "title",
                        title: reader.string()
                    };
                    break;
                case /* bool clear_title */ 3:
                    message.titleUpdate = {
                        oneofKind: "clearTitle",
                        clearTitle: reader.bool()
                    };
                    break;
                case /* optional string order */ 4:
                    message.order = reader.string();
                    break;
                case /* string emoji */ 5:
                    message.emojiUpdate = {
                        oneofKind: "emoji",
                        emoji: reader.string()
                    };
                    break;
                case /* bool clear_emoji */ 6:
                    message.emojiUpdate = {
                        oneofKind: "clearEmoji",
                        clearEmoji: reader.bool()
                    };
                    break;
                case /* string pinned_order */ 7:
                    message.pinnedOrderUpdate = {
                        oneofKind: "pinnedOrder",
                        pinnedOrder: reader.string()
                    };
                    break;
                case /* bool clear_pinned_order */ 8:
                    message.pinnedOrderUpdate = {
                        oneofKind: "clearPinnedOrder",
                        clearPinnedOrder: reader.bool()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 folder_id = 1; */
        if (message.folderId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.folderId);
        /* string title = 2; */
        if (message.titleUpdate.oneofKind === "title")
            writer.tag(2, WireType.LengthDelimited).string(message.titleUpdate.title);
        /* bool clear_title = 3; */
        if (message.titleUpdate.oneofKind === "clearTitle")
            writer.tag(3, WireType.Varint).bool(message.titleUpdate.clearTitle);
        /* optional string order = 4; */
        if (message.order !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.order);
        /* string emoji = 5; */
        if (message.emojiUpdate.oneofKind === "emoji")
            writer.tag(5, WireType.LengthDelimited).string(message.emojiUpdate.emoji);
        /* bool clear_emoji = 6; */
        if (message.emojiUpdate.oneofKind === "clearEmoji")
            writer.tag(6, WireType.Varint).bool(message.emojiUpdate.clearEmoji);
        /* string pinned_order = 7; */
        if (message.pinnedOrderUpdate.oneofKind === "pinnedOrder")
            writer.tag(7, WireType.LengthDelimited).string(message.pinnedOrderUpdate.pinnedOrder);
        /* bool clear_pinned_order = 8; */
        if (message.pinnedOrderUpdate.oneofKind === "clearPinnedOrder")
            writer.tag(8, WireType.Varint).bool(message.pinnedOrderUpdate.clearPinnedOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogFolderInput
 */
export const UpdateDialogFolderInput = new UpdateDialogFolderInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogFolderResult$Type extends MessageType {
    constructor() {
        super("UpdateDialogFolderResult", [
            { no: 1, name: "folder", kind: "message", T: () => DialogFolder },
            { no: 2, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dialogs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* DialogFolder folder */ 1:
                    message.folder = DialogFolder.internalBinaryRead(reader, reader.uint32(), options, message.folder);
                    break;
                case /* repeated Dialog dialogs */ 2:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* DialogFolder folder = 1; */
        if (message.folder)
            DialogFolder.internalBinaryWrite(message.folder, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Dialog dialogs = 2; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogFolderResult
 */
export const UpdateDialogFolderResult = new UpdateDialogFolderResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDialogFolderInput$Type extends MessageType {
    constructor() {
        super("DeleteDialogFolderInput", [
            { no: 1, name: "folder_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "disposition", kind: "enum", T: () => ["DeleteDialogFolderDisposition", DeleteDialogFolderDisposition] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.folderId = 0n;
        message.disposition = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 folder_id */ 1:
                    message.folderId = reader.int64().toBigInt();
                    break;
                case /* DeleteDialogFolderDisposition disposition */ 2:
                    message.disposition = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 folder_id = 1; */
        if (message.folderId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.folderId);
        /* DeleteDialogFolderDisposition disposition = 2; */
        if (message.disposition !== 0)
            writer.tag(2, WireType.Varint).int32(message.disposition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteDialogFolderInput
 */
export const DeleteDialogFolderInput = new DeleteDialogFolderInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDialogFolderResult$Type extends MessageType {
    constructor() {
        super("DeleteDialogFolderResult", [
            { no: 1, name: "folder_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.folderId = 0n;
        message.dialogs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 folder_id */ 1:
                    message.folderId = reader.int64().toBigInt();
                    break;
                case /* repeated Dialog dialogs */ 2:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 folder_id = 1; */
        if (message.folderId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.folderId);
        /* repeated Dialog dialogs = 2; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteDialogFolderResult
 */
export const DeleteDialogFolderResult = new DeleteDialogFolderResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatsInput$Type extends MessageType {
    constructor() {
        super("GetChatsInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatsInput
 */
export const GetChatsInput = new GetChatsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatsResult$Type extends MessageType {
    constructor() {
        super("GetChatsResult", [
            { no: 1, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog },
            { no: 2, name: "chats", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Chat },
            { no: 3, name: "spaces", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Space },
            { no: 4, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User },
            { no: 5, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Message },
            { no: 6, name: "folders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DialogFolder }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dialogs = [];
        message.chats = [];
        message.spaces = [];
        message.users = [];
        message.messages = [];
        message.folders = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Dialog dialogs */ 1:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Chat chats */ 2:
                    message.chats.push(Chat.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Space spaces */ 3:
                    message.spaces.push(Space.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated User users */ 4:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Message messages */ 5:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated DialogFolder folders */ 6:
                    message.folders.push(DialogFolder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Dialog dialogs = 1; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Chat chats = 2; */
        for (let i = 0; i < message.chats.length; i++)
            Chat.internalBinaryWrite(message.chats[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated Space spaces = 3; */
        for (let i = 0; i < message.spaces.length; i++)
            Space.internalBinaryWrite(message.spaces[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 4; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated Message messages = 5; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated DialogFolder folders = 6; */
        for (let i = 0; i < message.folders.length; i++)
            DialogFolder.internalBinaryWrite(message.folders[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatsResult
 */
export const GetChatsResult = new GetChatsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TranslateMessagesInput$Type extends MessageType {
    constructor() {
        super("TranslateMessagesInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageIds = [];
        message.language = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* repeated int64 message_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.messageIds.push(reader.int64().toBigInt());
                    else
                        message.messageIds.push(reader.int64().toBigInt());
                    break;
                case /* string language */ 4:
                    message.language = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 message_ids = 2; */
        if (message.messageIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.messageIds.length; i++)
                writer.int64(message.messageIds[i]);
            writer.join();
        }
        /* string language = 4; */
        if (message.language !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.language);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TranslateMessagesInput
 */
export const TranslateMessagesInput = new TranslateMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TranslateMessagesResult$Type extends MessageType {
    constructor() {
        super("TranslateMessagesResult", [
            { no: 1, name: "translations", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MessageTranslation }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.translations = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MessageTranslation translations */ 1:
                    message.translations.push(MessageTranslation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MessageTranslation translations = 1; */
        for (let i = 0; i < message.translations.length; i++)
            MessageTranslation.internalBinaryWrite(message.translations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TranslateMessagesResult
 */
export const TranslateMessagesResult = new TranslateMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageTranslation$Type extends MessageType {
    constructor() {
        super("MessageTranslation", [
            { no: 1, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "translation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "entities", kind: "message", T: () => MessageEntities },
            { no: 6, name: "msg_rev", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.language = "";
        message.translation = "";
        message.date = 0n;
        message.msgRev = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 message_id */ 1:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* string language */ 2:
                    message.language = reader.string();
                    break;
                case /* string translation */ 3:
                    message.translation = reader.string();
                    break;
                case /* int64 date */ 4:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* optional MessageEntities entities */ 5:
                    message.entities = MessageEntities.internalBinaryRead(reader, reader.uint32(), options, message.entities);
                    break;
                case /* int64 msg_rev */ 6:
                    message.msgRev = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 message_id = 1; */
        if (message.messageId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.messageId);
        /* string language = 2; */
        if (message.language !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.language);
        /* string translation = 3; */
        if (message.translation !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.translation);
        /* int64 date = 4; */
        if (message.date !== 0n)
            writer.tag(4, WireType.Varint).int64(message.date);
        /* optional MessageEntities entities = 5; */
        if (message.entities)
            MessageEntities.internalBinaryWrite(message.entities, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int64 msg_rev = 6; */
        if (message.msgRev !== 0n)
            writer.tag(6, WireType.Varint).int64(message.msgRev);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MessageTranslation
 */
export const MessageTranslation = new MessageTranslation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMeInput$Type extends MessageType {
    constructor() {
        super("GetMeInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetMeInput
 */
export const GetMeInput = new GetMeInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMeResult$Type extends MessageType {
    constructor() {
        super("GetMeResult", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetMeResult
 */
export const GetMeResult = new GetMeResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPeerPhotoInput$Type extends MessageType {
    constructor() {
        super("GetPeerPhotoInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "photo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.photoId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 photo_id */ 2:
                    message.photoId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 photo_id = 2; */
        if (message.photoId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.photoId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPeerPhotoInput
 */
export const GetPeerPhotoInput = new GetPeerPhotoInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPeerPhotoResult$Type extends MessageType {
    constructor() {
        super("GetPeerPhotoResult", [
            { no: 1, name: "photo", kind: "message", T: () => Photo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Photo photo */ 1:
                    message.photo = Photo.internalBinaryRead(reader, reader.uint32(), options, message.photo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Photo photo = 1; */
        if (message.photo)
            Photo.internalBinaryWrite(message.photo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPeerPhotoResult
 */
export const GetPeerPhotoResult = new GetPeerPhotoResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMessagesInput$Type extends MessageType {
    constructor() {
        super("DeleteMessagesInput", [
            { no: 1, name: "message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 message_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.messageIds.push(reader.int64().toBigInt());
                    else
                        message.messageIds.push(reader.int64().toBigInt());
                    break;
                case /* InputPeer peer_id */ 2:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int64 message_ids = 1; */
        if (message.messageIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.messageIds.length; i++)
                writer.int64(message.messageIds[i]);
            writer.join();
        }
        /* InputPeer peer_id = 2; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteMessagesInput
 */
export const DeleteMessagesInput = new DeleteMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMessagesResult$Type extends MessageType {
    constructor() {
        super("DeleteMessagesResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteMessagesResult
 */
export const DeleteMessagesResult = new DeleteMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearChatHistoryInput$Type extends MessageType {
    constructor() {
        super("ClearChatHistoryInput", [
            { no: 1, name: "peer_id", kind: "message", oneof: "target", T: () => InputPeer },
            { no: 4, name: "space_id", kind: "scalar", oneof: "target", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "keep_last_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "delete_reply_threads", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.target = { oneofKind: undefined };
        message.keepLastDays = 0;
        message.deleteReplyThreads = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.target = {
                        oneofKind: "peerId",
                        peerId: InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.target.peerId)
                    };
                    break;
                case /* int64 space_id */ 4:
                    message.target = {
                        oneofKind: "spaceId",
                        spaceId: reader.int64().toBigInt()
                    };
                    break;
                case /* int32 keep_last_days */ 2:
                    message.keepLastDays = reader.int32();
                    break;
                case /* bool delete_reply_threads */ 3:
                    message.deleteReplyThreads = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.target.oneofKind === "peerId")
            InputPeer.internalBinaryWrite(message.target.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 space_id = 4; */
        if (message.target.oneofKind === "spaceId")
            writer.tag(4, WireType.Varint).int64(message.target.spaceId);
        /* int32 keep_last_days = 2; */
        if (message.keepLastDays !== 0)
            writer.tag(2, WireType.Varint).int32(message.keepLastDays);
        /* bool delete_reply_threads = 3; */
        if (message.deleteReplyThreads !== false)
            writer.tag(3, WireType.Varint).bool(message.deleteReplyThreads);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClearChatHistoryInput
 */
export const ClearChatHistoryInput = new ClearChatHistoryInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClearChatHistoryResult$Type extends MessageType {
    constructor() {
        super("ClearChatHistoryResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClearChatHistoryResult
 */
export const ClearChatHistoryResult = new ClearChatHistoryResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditMessageInput$Type extends MessageType {
    constructor() {
        super("EditMessageInput", [
            { no: 1, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 3, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "entities", kind: "message", T: () => MessageEntities },
            { no: 8, name: "parse_markdown", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "actions", kind: "message", T: () => MessageActions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 message_id */ 1:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* InputPeer peer_id */ 2:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* string text */ 3:
                    message.text = reader.string();
                    break;
                case /* optional MessageEntities entities */ 7:
                    message.entities = MessageEntities.internalBinaryRead(reader, reader.uint32(), options, message.entities);
                    break;
                case /* optional bool parse_markdown */ 8:
                    message.parseMarkdown = reader.bool();
                    break;
                case /* optional MessageActions actions */ 9:
                    message.actions = MessageActions.internalBinaryRead(reader, reader.uint32(), options, message.actions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 message_id = 1; */
        if (message.messageId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.messageId);
        /* InputPeer peer_id = 2; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string text = 3; */
        if (message.text !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.text);
        /* optional MessageEntities entities = 7; */
        if (message.entities)
            MessageEntities.internalBinaryWrite(message.entities, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional bool parse_markdown = 8; */
        if (message.parseMarkdown !== undefined)
            writer.tag(8, WireType.Varint).bool(message.parseMarkdown);
        /* optional MessageActions actions = 9; */
        if (message.actions)
            MessageActions.internalBinaryWrite(message.actions, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EditMessageInput
 */
export const EditMessageInput = new EditMessageInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditMessageResult$Type extends MessageType {
    constructor() {
        super("EditMessageResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EditMessageResult
 */
export const EditMessageResult = new EditMessageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputMedia$Type extends MessageType {
    constructor() {
        super("InputMedia", [
            { no: 1, name: "photo", kind: "message", oneof: "media", T: () => InputMediaPhoto },
            { no: 2, name: "video", kind: "message", oneof: "media", T: () => InputMediaVideo },
            { no: 3, name: "document", kind: "message", oneof: "media", T: () => InputMediaDocument },
            { no: 4, name: "nudge", kind: "message", oneof: "media", T: () => InputMediaNudge },
            { no: 5, name: "voice", kind: "message", oneof: "media", T: () => InputMediaVoice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.media = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputMediaPhoto photo */ 1:
                    message.media = {
                        oneofKind: "photo",
                        photo: InputMediaPhoto.internalBinaryRead(reader, reader.uint32(), options, message.media.photo)
                    };
                    break;
                case /* InputMediaVideo video */ 2:
                    message.media = {
                        oneofKind: "video",
                        video: InputMediaVideo.internalBinaryRead(reader, reader.uint32(), options, message.media.video)
                    };
                    break;
                case /* InputMediaDocument document */ 3:
                    message.media = {
                        oneofKind: "document",
                        document: InputMediaDocument.internalBinaryRead(reader, reader.uint32(), options, message.media.document)
                    };
                    break;
                case /* InputMediaNudge nudge */ 4:
                    message.media = {
                        oneofKind: "nudge",
                        nudge: InputMediaNudge.internalBinaryRead(reader, reader.uint32(), options, message.media.nudge)
                    };
                    break;
                case /* InputMediaVoice voice */ 5:
                    message.media = {
                        oneofKind: "voice",
                        voice: InputMediaVoice.internalBinaryRead(reader, reader.uint32(), options, message.media.voice)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputMediaPhoto photo = 1; */
        if (message.media.oneofKind === "photo")
            InputMediaPhoto.internalBinaryWrite(message.media.photo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* InputMediaVideo video = 2; */
        if (message.media.oneofKind === "video")
            InputMediaVideo.internalBinaryWrite(message.media.video, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* InputMediaDocument document = 3; */
        if (message.media.oneofKind === "document")
            InputMediaDocument.internalBinaryWrite(message.media.document, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* InputMediaNudge nudge = 4; */
        if (message.media.oneofKind === "nudge")
            InputMediaNudge.internalBinaryWrite(message.media.nudge, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* InputMediaVoice voice = 5; */
        if (message.media.oneofKind === "voice")
            InputMediaVoice.internalBinaryWrite(message.media.voice, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputMedia
 */
export const InputMedia = new InputMedia$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputMediaPhoto$Type extends MessageType {
    constructor() {
        super("InputMediaPhoto", [
            { no: 1, name: "photo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.photoId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 photo_id */ 1:
                    message.photoId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 photo_id = 1; */
        if (message.photoId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.photoId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputMediaPhoto
 */
export const InputMediaPhoto = new InputMediaPhoto$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputMediaVideo$Type extends MessageType {
    constructor() {
        super("InputMediaVideo", [
            { no: 1, name: "video_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.videoId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 video_id */ 1:
                    message.videoId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 video_id = 1; */
        if (message.videoId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.videoId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputMediaVideo
 */
export const InputMediaVideo = new InputMediaVideo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputMediaDocument$Type extends MessageType {
    constructor() {
        super("InputMediaDocument", [
            { no: 1, name: "document_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.documentId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 document_id */ 1:
                    message.documentId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 document_id = 1; */
        if (message.documentId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.documentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputMediaDocument
 */
export const InputMediaDocument = new InputMediaDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputMediaVoice$Type extends MessageType {
    constructor() {
        super("InputMediaVoice", [
            { no: 1, name: "voice_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.voiceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 voice_id */ 1:
                    message.voiceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 voice_id = 1; */
        if (message.voiceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.voiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputMediaVoice
 */
export const InputMediaVoice = new InputMediaVoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputMediaNudge$Type extends MessageType {
    constructor() {
        super("InputMediaNudge", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputMediaNudge
 */
export const InputMediaNudge = new InputMediaNudge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendMessageInput$Type extends MessageType {
    constructor() {
        super("SendMessageInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reply_to_msg_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "random_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "media", kind: "message", T: () => InputMedia },
            { no: 1000, name: "temporary_send_date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "is_sticker", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6000, name: "has_link", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "entities", kind: "message", T: () => MessageEntities },
            { no: 8, name: "parse_markdown", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "send_mode", kind: "enum", opt: true, T: () => ["MessageSendMode", MessageSendMode] },
            { no: 10, name: "actions", kind: "message", T: () => MessageActions },
            { no: 11, name: "initial_agent_context", kind: "message", T: () => AgentThreadContext },
            { no: 12, name: "source_chat_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional string message */ 2:
                    message.message = reader.string();
                    break;
                case /* optional int64 reply_to_msg_id */ 3:
                    message.replyToMsgId = reader.int64().toBigInt();
                    break;
                case /* optional int64 random_id */ 4:
                    message.randomId = reader.int64().toBigInt();
                    break;
                case /* optional InputMedia media */ 5:
                    message.media = InputMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* optional int64 temporary_send_date */ 1000:
                    message.temporarySendDate = reader.int64().toBigInt();
                    break;
                case /* optional bool is_sticker */ 6:
                    message.isSticker = reader.bool();
                    break;
                case /* optional bool has_link */ 6000:
                    message.hasLink = reader.bool();
                    break;
                case /* optional MessageEntities entities */ 7:
                    message.entities = MessageEntities.internalBinaryRead(reader, reader.uint32(), options, message.entities);
                    break;
                case /* optional bool parse_markdown */ 8:
                    message.parseMarkdown = reader.bool();
                    break;
                case /* optional MessageSendMode send_mode */ 9:
                    message.sendMode = reader.int32();
                    break;
                case /* optional MessageActions actions */ 10:
                    message.actions = MessageActions.internalBinaryRead(reader, reader.uint32(), options, message.actions);
                    break;
                case /* optional AgentThreadContext initial_agent_context */ 11:
                    message.initialAgentContext = AgentThreadContext.internalBinaryRead(reader, reader.uint32(), options, message.initialAgentContext);
                    break;
                case /* optional int64 source_chat_id */ 12:
                    message.sourceChatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string message = 2; */
        if (message.message !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        /* optional int64 reply_to_msg_id = 3; */
        if (message.replyToMsgId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.replyToMsgId);
        /* optional int64 random_id = 4; */
        if (message.randomId !== undefined)
            writer.tag(4, WireType.Varint).int64(message.randomId);
        /* optional InputMedia media = 5; */
        if (message.media)
            InputMedia.internalBinaryWrite(message.media, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 temporary_send_date = 1000; */
        if (message.temporarySendDate !== undefined)
            writer.tag(1000, WireType.Varint).int64(message.temporarySendDate);
        /* optional bool is_sticker = 6; */
        if (message.isSticker !== undefined)
            writer.tag(6, WireType.Varint).bool(message.isSticker);
        /* optional bool has_link = 6000; */
        if (message.hasLink !== undefined)
            writer.tag(6000, WireType.Varint).bool(message.hasLink);
        /* optional MessageEntities entities = 7; */
        if (message.entities)
            MessageEntities.internalBinaryWrite(message.entities, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional bool parse_markdown = 8; */
        if (message.parseMarkdown !== undefined)
            writer.tag(8, WireType.Varint).bool(message.parseMarkdown);
        /* optional MessageSendMode send_mode = 9; */
        if (message.sendMode !== undefined)
            writer.tag(9, WireType.Varint).int32(message.sendMode);
        /* optional MessageActions actions = 10; */
        if (message.actions)
            MessageActions.internalBinaryWrite(message.actions, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional AgentThreadContext initial_agent_context = 11; */
        if (message.initialAgentContext)
            AgentThreadContext.internalBinaryWrite(message.initialAgentContext, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 source_chat_id = 12; */
        if (message.sourceChatId !== undefined)
            writer.tag(12, WireType.Varint).int64(message.sourceChatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SendMessageInput
 */
export const SendMessageInput = new SendMessageInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendMessageResult$Type extends MessageType {
    constructor() {
        super("SendMessageResult", [
            { no: 2, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 2:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 2; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SendMessageResult
 */
export const SendMessageResult = new SendMessageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeMessageActionInput$Type extends MessageType {
    constructor() {
        super("InvokeMessageActionInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.actionId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 message_id */ 2:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* string action_id */ 3:
                    message.actionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 message_id = 2; */
        if (message.messageId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.messageId);
        /* string action_id = 3; */
        if (message.actionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.actionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvokeMessageActionInput
 */
export const InvokeMessageActionInput = new InvokeMessageActionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeMessageActionResult$Type extends MessageType {
    constructor() {
        super("InvokeMessageActionResult", [
            { no: 1, name: "interaction_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.interactionId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 interaction_id */ 1:
                    message.interactionId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 interaction_id = 1; */
        if (message.interactionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.interactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvokeMessageActionResult
 */
export const InvokeMessageActionResult = new InvokeMessageActionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnswerMessageActionInput$Type extends MessageType {
    constructor() {
        super("AnswerMessageActionInput", [
            { no: 1, name: "interaction_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "ui", kind: "message", T: () => MessageActionResponseUi }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.interactionId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 interaction_id */ 1:
                    message.interactionId = reader.int64().toBigInt();
                    break;
                case /* optional MessageActionResponseUi ui */ 2:
                    message.ui = MessageActionResponseUi.internalBinaryRead(reader, reader.uint32(), options, message.ui);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 interaction_id = 1; */
        if (message.interactionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.interactionId);
        /* optional MessageActionResponseUi ui = 2; */
        if (message.ui)
            MessageActionResponseUi.internalBinaryWrite(message.ui, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AnswerMessageActionInput
 */
export const AnswerMessageActionInput = new AnswerMessageActionInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnswerMessageActionResult$Type extends MessageType {
    constructor() {
        super("AnswerMessageActionResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AnswerMessageActionResult
 */
export const AnswerMessageActionResult = new AnswerMessageActionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForwardMessagesInput$Type extends MessageType {
    constructor() {
        super("ForwardMessagesInput", [
            { no: 1, name: "from_peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "to_peer_id", kind: "message", T: () => InputPeer },
            { no: 4, name: "share_forward_header", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer from_peer_id */ 1:
                    message.fromPeerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.fromPeerId);
                    break;
                case /* repeated int64 message_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.messageIds.push(reader.int64().toBigInt());
                    else
                        message.messageIds.push(reader.int64().toBigInt());
                    break;
                case /* InputPeer to_peer_id */ 3:
                    message.toPeerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.toPeerId);
                    break;
                case /* optional bool share_forward_header */ 4:
                    message.shareForwardHeader = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer from_peer_id = 1; */
        if (message.fromPeerId)
            InputPeer.internalBinaryWrite(message.fromPeerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 message_ids = 2; */
        if (message.messageIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.messageIds.length; i++)
                writer.int64(message.messageIds[i]);
            writer.join();
        }
        /* InputPeer to_peer_id = 3; */
        if (message.toPeerId)
            InputPeer.internalBinaryWrite(message.toPeerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional bool share_forward_header = 4; */
        if (message.shareForwardHeader !== undefined)
            writer.tag(4, WireType.Varint).bool(message.shareForwardHeader);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ForwardMessagesInput
 */
export const ForwardMessagesInput = new ForwardMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForwardMessagesResult$Type extends MessageType {
    constructor() {
        super("ForwardMessagesResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ForwardMessagesResult
 */
export const ForwardMessagesResult = new ForwardMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatHistoryInput$Type extends MessageType {
    constructor() {
        super("GetChatHistoryInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "offset_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "mode", kind: "enum", opt: true, T: () => ["GetChatHistoryMode", GetChatHistoryMode] },
            { no: 5, name: "anchor_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "before_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "after_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "before_limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "after_limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "include_anchor", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional int64 offset_id */ 2:
                    message.offsetId = reader.int64().toBigInt();
                    break;
                case /* optional int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                case /* optional GetChatHistoryMode mode */ 4:
                    message.mode = reader.int32();
                    break;
                case /* optional int64 anchor_id */ 5:
                    message.anchorId = reader.int64().toBigInt();
                    break;
                case /* optional int64 before_id */ 6:
                    message.beforeId = reader.int64().toBigInt();
                    break;
                case /* optional int64 after_id */ 7:
                    message.afterId = reader.int64().toBigInt();
                    break;
                case /* optional int32 before_limit */ 8:
                    message.beforeLimit = reader.int32();
                    break;
                case /* optional int32 after_limit */ 9:
                    message.afterLimit = reader.int32();
                    break;
                case /* optional bool include_anchor */ 10:
                    message.includeAnchor = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 offset_id = 2; */
        if (message.offsetId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.offsetId);
        /* optional int32 limit = 3; */
        if (message.limit !== undefined)
            writer.tag(3, WireType.Varint).int32(message.limit);
        /* optional GetChatHistoryMode mode = 4; */
        if (message.mode !== undefined)
            writer.tag(4, WireType.Varint).int32(message.mode);
        /* optional int64 anchor_id = 5; */
        if (message.anchorId !== undefined)
            writer.tag(5, WireType.Varint).int64(message.anchorId);
        /* optional int64 before_id = 6; */
        if (message.beforeId !== undefined)
            writer.tag(6, WireType.Varint).int64(message.beforeId);
        /* optional int64 after_id = 7; */
        if (message.afterId !== undefined)
            writer.tag(7, WireType.Varint).int64(message.afterId);
        /* optional int32 before_limit = 8; */
        if (message.beforeLimit !== undefined)
            writer.tag(8, WireType.Varint).int32(message.beforeLimit);
        /* optional int32 after_limit = 9; */
        if (message.afterLimit !== undefined)
            writer.tag(9, WireType.Varint).int32(message.afterLimit);
        /* optional bool include_anchor = 10; */
        if (message.includeAnchor !== undefined)
            writer.tag(10, WireType.Varint).bool(message.includeAnchor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatHistoryInput
 */
export const GetChatHistoryInput = new GetChatHistoryInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatHistoryResult$Type extends MessageType {
    constructor() {
        super("GetChatHistoryResult", [
            { no: 1, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Message },
            { no: 2, name: "acknowledgements", kind: "message", T: () => ChatAcknowledgements }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Message messages */ 1:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional ChatAcknowledgements acknowledgements */ 2:
                    message.acknowledgements = ChatAcknowledgements.internalBinaryRead(reader, reader.uint32(), options, message.acknowledgements);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Message messages = 1; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional ChatAcknowledgements acknowledgements = 2; */
        if (message.acknowledgements)
            ChatAcknowledgements.internalBinaryWrite(message.acknowledgements, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatHistoryResult
 */
export const GetChatHistoryResult = new GetChatHistoryResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatTranscriptInput$Type extends MessageType {
    constructor() {
        super("GetChatTranscriptInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "mode", kind: "enum", opt: true, T: () => ["GetChatTranscriptInput.Mode", GetChatTranscriptInput_Mode, "MODE_"] },
            { no: 3, name: "length", kind: "enum", opt: true, T: () => ["GetChatTranscriptInput.Length", GetChatTranscriptInput_Length, "LENGTH_"] },
            { no: 4, name: "media", kind: "enum", opt: true, T: () => ["GetChatTranscriptInput.Media", GetChatTranscriptInput_Media, "MEDIA_"] },
            { no: 5, name: "before_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional GetChatTranscriptInput.Mode mode */ 2:
                    message.mode = reader.int32();
                    break;
                case /* optional GetChatTranscriptInput.Length length */ 3:
                    message.length = reader.int32();
                    break;
                case /* optional GetChatTranscriptInput.Media media */ 4:
                    message.media = reader.int32();
                    break;
                case /* optional int64 before_message_id */ 5:
                    message.beforeMessageId = reader.int64().toBigInt();
                    break;
                case /* optional int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional GetChatTranscriptInput.Mode mode = 2; */
        if (message.mode !== undefined)
            writer.tag(2, WireType.Varint).int32(message.mode);
        /* optional GetChatTranscriptInput.Length length = 3; */
        if (message.length !== undefined)
            writer.tag(3, WireType.Varint).int32(message.length);
        /* optional GetChatTranscriptInput.Media media = 4; */
        if (message.media !== undefined)
            writer.tag(4, WireType.Varint).int32(message.media);
        /* optional int64 before_message_id = 5; */
        if (message.beforeMessageId !== undefined)
            writer.tag(5, WireType.Varint).int64(message.beforeMessageId);
        /* optional int32 limit = 6; */
        if (message.limit !== undefined)
            writer.tag(6, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatTranscriptInput
 */
export const GetChatTranscriptInput = new GetChatTranscriptInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatTranscriptResult$Type extends MessageType {
    constructor() {
        super("GetChatTranscriptResult", [
            { no: 1, name: "markdown", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "from_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "to_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "has_more", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "stop_reason", kind: "enum", T: () => ["GetChatTranscriptResult.StopReason", GetChatTranscriptResult_StopReason, "STOP_REASON_"] },
            { no: 7, name: "expires_at", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.markdown = "";
        message.messageCount = 0;
        message.hasMore = false;
        message.stopReason = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string markdown */ 1:
                    message.markdown = reader.string();
                    break;
                case /* int32 message_count */ 2:
                    message.messageCount = reader.int32();
                    break;
                case /* optional int64 from_message_id */ 3:
                    message.fromMessageId = reader.int64().toBigInt();
                    break;
                case /* optional int64 to_message_id */ 4:
                    message.toMessageId = reader.int64().toBigInt();
                    break;
                case /* bool has_more */ 5:
                    message.hasMore = reader.bool();
                    break;
                case /* GetChatTranscriptResult.StopReason stop_reason */ 6:
                    message.stopReason = reader.int32();
                    break;
                case /* optional int64 expires_at */ 7:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string markdown = 1; */
        if (message.markdown !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.markdown);
        /* int32 message_count = 2; */
        if (message.messageCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.messageCount);
        /* optional int64 from_message_id = 3; */
        if (message.fromMessageId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.fromMessageId);
        /* optional int64 to_message_id = 4; */
        if (message.toMessageId !== undefined)
            writer.tag(4, WireType.Varint).int64(message.toMessageId);
        /* bool has_more = 5; */
        if (message.hasMore !== false)
            writer.tag(5, WireType.Varint).bool(message.hasMore);
        /* GetChatTranscriptResult.StopReason stop_reason = 6; */
        if (message.stopReason !== 0)
            writer.tag(6, WireType.Varint).int32(message.stopReason);
        /* optional int64 expires_at = 7; */
        if (message.expiresAt !== undefined)
            writer.tag(7, WireType.Varint).int64(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatTranscriptResult
 */
export const GetChatTranscriptResult = new GetChatTranscriptResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMessagesInput$Type extends MessageType {
    constructor() {
        super("GetMessagesInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* repeated int64 message_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.messageIds.push(reader.int64().toBigInt());
                    else
                        message.messageIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 message_ids = 2; */
        if (message.messageIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.messageIds.length; i++)
                writer.int64(message.messageIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetMessagesInput
 */
export const GetMessagesInput = new GetMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMessagesResult$Type extends MessageType {
    constructor() {
        super("GetMessagesResult", [
            { no: 1, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Message }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Message messages */ 1:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Message messages = 1; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetMessagesResult
 */
export const GetMessagesResult = new GetMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ThreadReferenceItem$Type extends MessageType {
    constructor() {
        super("ThreadReferenceItem", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["ThreadReferenceKind", ThreadReferenceKind] },
            { no: 3, name: "from_chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "from_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "to_chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0n;
        message.kind = 0;
        message.fromChatId = 0n;
        message.toChatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* ThreadReferenceKind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* int64 from_chat_id */ 3:
                    message.fromChatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 from_message_id */ 4:
                    message.fromMessageId = reader.int64().toBigInt();
                    break;
                case /* int64 to_chat_id */ 5:
                    message.toChatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 date */ 6:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* ThreadReferenceKind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* int64 from_chat_id = 3; */
        if (message.fromChatId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.fromChatId);
        /* optional int64 from_message_id = 4; */
        if (message.fromMessageId !== undefined)
            writer.tag(4, WireType.Varint).int64(message.fromMessageId);
        /* int64 to_chat_id = 5; */
        if (message.toChatId !== 0n)
            writer.tag(5, WireType.Varint).int64(message.toChatId);
        /* optional int64 date = 6; */
        if (message.date !== undefined)
            writer.tag(6, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ThreadReferenceItem
 */
export const ThreadReferenceItem = new ThreadReferenceItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetThreadReferencesInput$Type extends MessageType {
    constructor() {
        super("GetThreadReferencesInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "offset_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 offset_id */ 2:
                    message.offsetId = reader.int64().toBigInt();
                    break;
                case /* optional int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional int64 offset_id = 2; */
        if (message.offsetId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.offsetId);
        /* optional int32 limit = 3; */
        if (message.limit !== undefined)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetThreadReferencesInput
 */
export const GetThreadReferencesInput = new GetThreadReferencesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetThreadReferencesResult$Type extends MessageType {
    constructor() {
        super("GetThreadReferencesResult", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ThreadReferenceItem },
            { no: 2, name: "chats", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Chat },
            { no: 3, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.items = [];
        message.chats = [];
        message.dialogs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ThreadReferenceItem items */ 1:
                    message.items.push(ThreadReferenceItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Chat chats */ 2:
                    message.chats.push(Chat.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Dialog dialogs */ 3:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ThreadReferenceItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            ThreadReferenceItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Chat chats = 2; */
        for (let i = 0; i < message.chats.length; i++)
            Chat.internalBinaryWrite(message.chats[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated Dialog dialogs = 3; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetThreadReferencesResult
 */
export const GetThreadReferencesResult = new GetThreadReferencesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetThreadSubthreadsInput$Type extends MessageType {
    constructor() {
        super("GetThreadSubthreadsInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "offset_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 offset_id */ 2:
                    message.offsetId = reader.int64().toBigInt();
                    break;
                case /* optional int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional int64 offset_id = 2; */
        if (message.offsetId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.offsetId);
        /* optional int32 limit = 3; */
        if (message.limit !== undefined)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetThreadSubthreadsInput
 */
export const GetThreadSubthreadsInput = new GetThreadSubthreadsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetThreadSubthreadsResult$Type extends MessageType {
    constructor() {
        super("GetThreadSubthreadsResult", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ThreadReferenceItem },
            { no: 2, name: "chats", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Chat },
            { no: 3, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.items = [];
        message.chats = [];
        message.dialogs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ThreadReferenceItem items */ 1:
                    message.items.push(ThreadReferenceItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Chat chats */ 2:
                    message.chats.push(Chat.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated Dialog dialogs */ 3:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ThreadReferenceItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            ThreadReferenceItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Chat chats = 2; */
        for (let i = 0; i < message.chats.length; i++)
            Chat.internalBinaryWrite(message.chats[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated Dialog dialogs = 3; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetThreadSubthreadsResult
 */
export const GetThreadSubthreadsResult = new GetThreadSubthreadsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMessagesInput$Type extends MessageType {
    constructor() {
        super("SearchMessagesInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "queries", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "offset_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "filter", kind: "enum", opt: true, T: () => ["SearchMessagesFilter", SearchMessagesFilter] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.queries = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* repeated string queries */ 2:
                    message.queries.push(reader.string());
                    break;
                case /* optional int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                case /* optional int64 offset_id */ 4:
                    message.offsetId = reader.int64().toBigInt();
                    break;
                case /* optional SearchMessagesFilter filter */ 5:
                    message.filter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string queries = 2; */
        for (let i = 0; i < message.queries.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.queries[i]);
        /* optional int32 limit = 3; */
        if (message.limit !== undefined)
            writer.tag(3, WireType.Varint).int32(message.limit);
        /* optional int64 offset_id = 4; */
        if (message.offsetId !== undefined)
            writer.tag(4, WireType.Varint).int64(message.offsetId);
        /* optional SearchMessagesFilter filter = 5; */
        if (message.filter !== undefined)
            writer.tag(5, WireType.Varint).int32(message.filter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchMessagesInput
 */
export const SearchMessagesInput = new SearchMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMessagesResult$Type extends MessageType {
    constructor() {
        super("SearchMessagesResult", [
            { no: 1, name: "messages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Message }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Message messages */ 1:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Message messages = 1; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchMessagesResult
 */
export const SearchMessagesResult = new SearchMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalResource$Type extends MessageType {
    constructor() {
        super("ExternalResource", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "provider", kind: "enum", T: () => ["ExternalResourceProvider", ExternalResourceProvider] },
            { no: 3, name: "kind", kind: "enum", T: () => ["ExternalResourceKind", ExternalResourceKind] },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "subtitle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.provider = 0;
        message.kind = 0;
        message.title = "";
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* ExternalResourceProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                case /* ExternalResourceKind kind */ 3:
                    message.kind = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string url */ 5:
                    message.url = reader.string();
                    break;
                case /* optional string subtitle */ 6:
                    message.subtitle = reader.string();
                    break;
                case /* optional string emoji */ 7:
                    message.emoji = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* ExternalResourceProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        /* ExternalResourceKind kind = 3; */
        if (message.kind !== 0)
            writer.tag(3, WireType.Varint).int32(message.kind);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string url = 5; */
        if (message.url !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.url);
        /* optional string subtitle = 6; */
        if (message.subtitle !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.subtitle);
        /* optional string emoji = 7; */
        if (message.emoji !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.emoji);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ExternalResource
 */
export const ExternalResource = new ExternalResource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExternalResourcesInput$Type extends MessageType {
    constructor() {
        super("SearchExternalResourcesInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                case /* optional int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        /* optional int32 limit = 3; */
        if (message.limit !== undefined)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchExternalResourcesInput
 */
export const SearchExternalResourcesInput = new SearchExternalResourcesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExternalResourcesResult$Type extends MessageType {
    constructor() {
        super("SearchExternalResourcesResult", [
            { no: 1, name: "resources", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ExternalResource }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.resources = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ExternalResource resources */ 1:
                    message.resources.push(ExternalResource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ExternalResource resources = 1; */
        for (let i = 0; i < message.resources.length; i++)
            ExternalResource.internalBinaryWrite(message.resources[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchExternalResourcesResult
 */
export const SearchExternalResourcesResult = new SearchExternalResourcesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorScope$Type extends MessageType {
    constructor() {
        super("ConnectorScope", [
            { no: 1, name: "scope", kind: "message", T: () => Scope },
            { no: 2, name: "can_manage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "allows_connections", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.canManage = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Scope scope */ 1:
                    message.scope = Scope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* bool can_manage */ 2:
                    message.canManage = reader.bool();
                    break;
                case /* optional bool allows_connections */ 3:
                    message.allowsConnections = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Scope scope = 1; */
        if (message.scope)
            Scope.internalBinaryWrite(message.scope, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool can_manage = 2; */
        if (message.canManage !== false)
            writer.tag(2, WireType.Varint).bool(message.canManage);
        /* optional bool allows_connections = 3; */
        if (message.allowsConnections !== undefined)
            writer.tag(3, WireType.Varint).bool(message.allowsConnections);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectorScope
 */
export const ConnectorScope = new ConnectorScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorProviderInfo$Type extends MessageType {
    constructor() {
        super("ConnectorProviderInfo", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "available", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "supports_user_scope", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "supports_space_scope", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.available = false;
        message.supportsUserScope = false;
        message.supportsSpaceScope = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* bool available */ 2:
                    message.available = reader.bool();
                    break;
                case /* bool supports_user_scope */ 3:
                    message.supportsUserScope = reader.bool();
                    break;
                case /* bool supports_space_scope */ 4:
                    message.supportsSpaceScope = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* bool available = 2; */
        if (message.available !== false)
            writer.tag(2, WireType.Varint).bool(message.available);
        /* bool supports_user_scope = 3; */
        if (message.supportsUserScope !== false)
            writer.tag(3, WireType.Varint).bool(message.supportsUserScope);
        /* bool supports_space_scope = 4; */
        if (message.supportsSpaceScope !== false)
            writer.tag(4, WireType.Varint).bool(message.supportsSpaceScope);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectorProviderInfo
 */
export const ConnectorProviderInfo = new ConnectorProviderInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorConnection$Type extends MessageType {
    constructor() {
        super("ConnectorConnection", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "scope", kind: "message", T: () => Scope },
            { no: 3, name: "connected_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "connected_by", kind: "message", T: () => User },
            { no: 5, name: "needs_configuration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.connectedAt = 0n;
        message.needsConfiguration = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* Scope scope */ 2:
                    message.scope = Scope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* int64 connected_at */ 3:
                    message.connectedAt = reader.int64().toBigInt();
                    break;
                case /* User connected_by */ 4:
                    message.connectedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.connectedBy);
                    break;
                case /* bool needs_configuration */ 5:
                    message.needsConfiguration = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* Scope scope = 2; */
        if (message.scope)
            Scope.internalBinaryWrite(message.scope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int64 connected_at = 3; */
        if (message.connectedAt !== 0n)
            writer.tag(3, WireType.Varint).int64(message.connectedAt);
        /* User connected_by = 4; */
        if (message.connectedBy)
            User.internalBinaryWrite(message.connectedBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool needs_configuration = 5; */
        if (message.needsConfiguration !== false)
            writer.tag(5, WireType.Varint).bool(message.needsConfiguration);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectorConnection
 */
export const ConnectorConnection = new ConnectorConnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorsInput$Type extends MessageType {
    constructor() {
        super("ListConnectorsInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListConnectorsInput
 */
export const ListConnectorsInput = new ListConnectorsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorsResult$Type extends MessageType {
    constructor() {
        super("ListConnectorsResult", [
            { no: 1, name: "providers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConnectorProviderInfo },
            { no: 2, name: "scopes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConnectorScope },
            { no: 3, name: "connections", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConnectorConnection }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.providers = [];
        message.scopes = [];
        message.connections = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ConnectorProviderInfo providers */ 1:
                    message.providers.push(ConnectorProviderInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ConnectorScope scopes */ 2:
                    message.scopes.push(ConnectorScope.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ConnectorConnection connections */ 3:
                    message.connections.push(ConnectorConnection.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ConnectorProviderInfo providers = 1; */
        for (let i = 0; i < message.providers.length; i++)
            ConnectorProviderInfo.internalBinaryWrite(message.providers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated ConnectorScope scopes = 2; */
        for (let i = 0; i < message.scopes.length; i++)
            ConnectorScope.internalBinaryWrite(message.scopes[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated ConnectorConnection connections = 3; */
        for (let i = 0; i < message.connections.length; i++)
            ConnectorConnection.internalBinaryWrite(message.connections[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListConnectorsResult
 */
export const ListConnectorsResult = new ListConnectorsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrepareConnectorOAuthInput$Type extends MessageType {
    constructor() {
        super("PrepareConnectorOAuthInput", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "scope", kind: "message", T: () => InputScope },
            { no: 3, name: "callback_scheme", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.callbackScheme = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* InputScope scope */ 2:
                    message.scope = InputScope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* string callback_scheme */ 3:
                    message.callbackScheme = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* InputScope scope = 2; */
        if (message.scope)
            InputScope.internalBinaryWrite(message.scope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string callback_scheme = 3; */
        if (message.callbackScheme !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.callbackScheme);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PrepareConnectorOAuthInput
 */
export const PrepareConnectorOAuthInput = new PrepareConnectorOAuthInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrepareConnectorOAuthResult$Type extends MessageType {
    constructor() {
        super("PrepareConnectorOAuthResult", [
            { no: 1, name: "authorization_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.authorizationUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string authorization_url */ 1:
                    message.authorizationUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string authorization_url = 1; */
        if (message.authorizationUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.authorizationUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PrepareConnectorOAuthResult
 */
export const PrepareConnectorOAuthResult = new PrepareConnectorOAuthResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisconnectConnectorInput$Type extends MessageType {
    constructor() {
        super("DisconnectConnectorInput", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "scope", kind: "message", T: () => InputScope }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* InputScope scope */ 2:
                    message.scope = InputScope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* InputScope scope = 2; */
        if (message.scope)
            InputScope.internalBinaryWrite(message.scope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DisconnectConnectorInput
 */
export const DisconnectConnectorInput = new DisconnectConnectorInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisconnectConnectorResult$Type extends MessageType {
    constructor() {
        super("DisconnectConnectorResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DisconnectConnectorResult
 */
export const DisconnectConnectorResult = new DisconnectConnectorResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorConfigOption$Type extends MessageType {
    constructor() {
        super("ConnectorConfigOption", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "subtitle", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.title = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* optional string subtitle */ 3:
                    message.subtitle = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* optional string subtitle = 3; */
        if (message.subtitle !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.subtitle);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConnectorConfigOption
 */
export const ConnectorConfigOption = new ConnectorConfigOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorConfigInput$Type extends MessageType {
    constructor() {
        super("GetConnectorConfigInput", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "scope", kind: "message", T: () => InputScope }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* InputScope scope */ 2:
                    message.scope = InputScope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* InputScope scope = 2; */
        if (message.scope)
            InputScope.internalBinaryWrite(message.scope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetConnectorConfigInput
 */
export const GetConnectorConfigInput = new GetConnectorConfigInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorConfigResult$Type extends MessageType {
    constructor() {
        super("GetConnectorConfigResult", [
            { no: 1, name: "options", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConnectorConfigOption },
            { no: 2, name: "selected_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.options = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ConnectorConfigOption options */ 1:
                    message.options.push(ConnectorConfigOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string selected_id */ 2:
                    message.selectedId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ConnectorConfigOption options = 1; */
        for (let i = 0; i < message.options.length; i++)
            ConnectorConfigOption.internalBinaryWrite(message.options[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string selected_id = 2; */
        if (message.selectedId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.selectedId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetConnectorConfigResult
 */
export const GetConnectorConfigResult = new GetConnectorConfigResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetConnectorConfigInput$Type extends MessageType {
    constructor() {
        super("SetConnectorConfigInput", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "scope", kind: "message", T: () => InputScope },
            { no: 3, name: "selected_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.selectedId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* InputScope scope */ 2:
                    message.scope = InputScope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* string selected_id */ 3:
                    message.selectedId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* InputScope scope = 2; */
        if (message.scope)
            InputScope.internalBinaryWrite(message.scope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string selected_id = 3; */
        if (message.selectedId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.selectedId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetConnectorConfigInput
 */
export const SetConnectorConfigInput = new SetConnectorConfigInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetConnectorConfigResult$Type extends MessageType {
    constructor() {
        super("SetConnectorConfigResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetConnectorConfigResult
 */
export const SetConnectorConfigResult = new SetConnectorConfigResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTaskInput$Type extends MessageType {
    constructor() {
        super("CreateExternalTaskInput", [
            { no: 1, name: "provider", kind: "enum", T: () => ["ConnectorProvider", ConnectorProvider, "CONNECTOR_PROVIDER_"] },
            { no: 2, name: "scope", kind: "message", T: () => InputScope },
            { no: 3, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 4, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.provider = 0;
        message.messageId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ConnectorProvider provider */ 1:
                    message.provider = reader.int32();
                    break;
                case /* InputScope scope */ 2:
                    message.scope = InputScope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* InputPeer peer_id */ 3:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 message_id */ 4:
                    message.messageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ConnectorProvider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        /* InputScope scope = 2; */
        if (message.scope)
            InputScope.internalBinaryWrite(message.scope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* InputPeer peer_id = 3; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 message_id = 4; */
        if (message.messageId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.messageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateExternalTaskInput
 */
export const CreateExternalTaskInput = new CreateExternalTaskInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExternalTaskResult$Type extends MessageType {
    constructor() {
        super("CreateExternalTaskResult", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "attachment", kind: "message", T: () => MessageAttachment }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                case /* MessageAttachment attachment */ 2:
                    message.attachment = MessageAttachment.internalBinaryRead(reader, reader.uint32(), options, message.attachment);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        /* MessageAttachment attachment = 2; */
        if (message.attachment)
            MessageAttachment.internalBinaryWrite(message.attachment, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateExternalTaskResult
 */
export const CreateExternalTaskResult = new CreateExternalTaskResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSpaceInput$Type extends MessageType {
    constructor() {
        super("CreateSpaceInput", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSpaceInput
 */
export const CreateSpaceInput = new CreateSpaceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSpaceResult$Type extends MessageType {
    constructor() {
        super("CreateSpaceResult", [
            { no: 1, name: "space", kind: "message", T: () => Space },
            { no: 2, name: "member", kind: "message", T: () => Member },
            { no: 3, name: "chat", kind: "message", T: () => Chat },
            { no: 4, name: "dialog", kind: "message", T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Space space */ 1:
                    message.space = Space.internalBinaryRead(reader, reader.uint32(), options, message.space);
                    break;
                case /* Member member */ 2:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                case /* Chat chat */ 3:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 4:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Space space = 1; */
        if (message.space)
            Space.internalBinaryWrite(message.space, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Member member = 2; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Chat chat = 3; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 4; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSpaceResult
 */
export const CreateSpaceResult = new CreateSpaceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSpaceInput$Type extends MessageType {
    constructor() {
        super("DeleteSpaceInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteSpaceInput
 */
export const DeleteSpaceInput = new DeleteSpaceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSpaceResult$Type extends MessageType {
    constructor() {
        super("DeleteSpaceResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteSpaceResult
 */
export const DeleteSpaceResult = new DeleteSpaceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveSpaceInput$Type extends MessageType {
    constructor() {
        super("LeaveSpaceInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LeaveSpaceInput
 */
export const LeaveSpaceInput = new LeaveSpaceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveSpaceResult$Type extends MessageType {
    constructor() {
        super("LeaveSpaceResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LeaveSpaceResult
 */
export const LeaveSpaceResult = new LeaveSpaceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InputChatParticipant$Type extends MessageType {
    constructor() {
        super("InputChatParticipant", [
            { no: 1, name: "user_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "group_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* optional int64 group_id */ 2:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 user_id = 1; */
        if (message.userId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.userId);
        /* optional int64 group_id = 2; */
        if (message.groupId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InputChatParticipant
 */
export const InputChatParticipant = new InputChatParticipant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReserveChatIdsInput$Type extends MessageType {
    constructor() {
        super("ReserveChatIdsInput", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReserveChatIdsInput
 */
export const ReserveChatIdsInput = new ReserveChatIdsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReservedChatId$Type extends MessageType {
    constructor() {
        super("ReservedChatId", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "expires_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.expiresAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 expires_at */ 2:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* int64 expires_at = 2; */
        if (message.expiresAt !== 0n)
            writer.tag(2, WireType.Varint).int64(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReservedChatId
 */
export const ReservedChatId = new ReservedChatId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReserveChatIdsResult$Type extends MessageType {
    constructor() {
        super("ReserveChatIdsResult", [
            { no: 1, name: "reservations", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ReservedChatId }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reservations = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ReservedChatId reservations */ 1:
                    message.reservations.push(ReservedChatId.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ReservedChatId reservations = 1; */
        for (let i = 0; i < message.reservations.length; i++)
            ReservedChatId.internalBinaryWrite(message.reservations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReserveChatIdsResult
 */
export const ReserveChatIdsResult = new ReserveChatIdsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateChatInput$Type extends MessageType {
    constructor() {
        super("CreateChatInput", [
            { no: 1, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "space_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_public", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "participants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => InputChatParticipant },
            { no: 7, name: "reserved_chat_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "placeholder_title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "agent_context", kind: "message", T: () => AgentThreadContext }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.isPublic = false;
        message.participants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string title */ 1:
                    message.title = reader.string();
                    break;
                case /* optional int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* optional string emoji */ 4:
                    message.emoji = reader.string();
                    break;
                case /* bool is_public */ 5:
                    message.isPublic = reader.bool();
                    break;
                case /* repeated InputChatParticipant participants */ 6:
                    message.participants.push(InputChatParticipant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional int64 reserved_chat_id */ 7:
                    message.reservedChatId = reader.int64().toBigInt();
                    break;
                case /* optional string placeholder_title */ 8:
                    message.placeholderTitle = reader.string();
                    break;
                case /* optional AgentThreadContext agent_context */ 9:
                    message.agentContext = AgentThreadContext.internalBinaryRead(reader, reader.uint32(), options, message.agentContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string title = 1; */
        if (message.title !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* optional int64 space_id = 2; */
        if (message.spaceId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* optional string emoji = 4; */
        if (message.emoji !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.emoji);
        /* bool is_public = 5; */
        if (message.isPublic !== false)
            writer.tag(5, WireType.Varint).bool(message.isPublic);
        /* repeated InputChatParticipant participants = 6; */
        for (let i = 0; i < message.participants.length; i++)
            InputChatParticipant.internalBinaryWrite(message.participants[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 reserved_chat_id = 7; */
        if (message.reservedChatId !== undefined)
            writer.tag(7, WireType.Varint).int64(message.reservedChatId);
        /* optional string placeholder_title = 8; */
        if (message.placeholderTitle !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.placeholderTitle);
        /* optional AgentThreadContext agent_context = 9; */
        if (message.agentContext)
            AgentThreadContext.internalBinaryWrite(message.agentContext, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateChatInput
 */
export const CreateChatInput = new CreateChatInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateChatResult$Type extends MessageType {
    constructor() {
        super("CreateChatResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateChatResult
 */
export const CreateChatResult = new CreateChatResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSubthreadInput$Type extends MessageType {
    constructor() {
        super("CreateSubthreadInput", [
            { no: 1, name: "parent_chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "parent_message_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "participants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => InputChatParticipant },
            { no: 7, name: "agent_context", kind: "message", T: () => AgentThreadContext }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.parentChatId = 0n;
        message.participants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 parent_chat_id */ 1:
                    message.parentChatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 parent_message_id */ 2:
                    message.parentMessageId = reader.int64().toBigInt();
                    break;
                case /* optional string title */ 3:
                    message.title = reader.string();
                    break;
                case /* optional string description */ 4:
                    message.description = reader.string();
                    break;
                case /* optional string emoji */ 5:
                    message.emoji = reader.string();
                    break;
                case /* repeated InputChatParticipant participants */ 6:
                    message.participants.push(InputChatParticipant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional AgentThreadContext agent_context */ 7:
                    message.agentContext = AgentThreadContext.internalBinaryRead(reader, reader.uint32(), options, message.agentContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 parent_chat_id = 1; */
        if (message.parentChatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.parentChatId);
        /* optional int64 parent_message_id = 2; */
        if (message.parentMessageId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.parentMessageId);
        /* optional string title = 3; */
        if (message.title !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* optional string description = 4; */
        if (message.description !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* optional string emoji = 5; */
        if (message.emoji !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.emoji);
        /* repeated InputChatParticipant participants = 6; */
        for (let i = 0; i < message.participants.length; i++)
            InputChatParticipant.internalBinaryWrite(message.participants[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* optional AgentThreadContext agent_context = 7; */
        if (message.agentContext)
            AgentThreadContext.internalBinaryWrite(message.agentContext, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSubthreadInput
 */
export const CreateSubthreadInput = new CreateSubthreadInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSubthreadResult$Type extends MessageType {
    constructor() {
        super("CreateSubthreadResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog },
            { no: 3, name: "anchor_message", kind: "message", T: () => Message }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                case /* Message anchor_message */ 3:
                    message.anchorMessage = Message.internalBinaryRead(reader, reader.uint32(), options, message.anchorMessage);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Message anchor_message = 3; */
        if (message.anchorMessage)
            Message.internalBinaryWrite(message.anchorMessage, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSubthreadResult
 */
export const CreateSubthreadResult = new CreateSubthreadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceMembersInput$Type extends MessageType {
    constructor() {
        super("GetSpaceMembersInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceMembersInput
 */
export const GetSpaceMembersInput = new GetSpaceMembersInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSpaceMembersResult$Type extends MessageType {
    constructor() {
        super("GetSpaceMembersResult", [
            { no: 1, name: "members", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Member },
            { no: 2, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.members = [];
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Member members */ 1:
                    message.members.push(Member.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated User users */ 2:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Member members = 1; */
        for (let i = 0; i < message.members.length; i++)
            Member.internalBinaryWrite(message.members[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 2; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSpaceMembersResult
 */
export const GetSpaceMembersResult = new GetSpaceMembersResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserGroupsInput$Type extends MessageType {
    constructor() {
        super("GetUserGroupsInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserGroupsInput
 */
export const GetUserGroupsInput = new GetUserGroupsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserGroupsResult$Type extends MessageType {
    constructor() {
        super("GetUserGroupsResult", [
            { no: 1, name: "groups", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UserGroup },
            { no: 2, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groups = [];
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated UserGroup groups */ 1:
                    message.groups.push(UserGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated User users */ 2:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated UserGroup groups = 1; */
        for (let i = 0; i < message.groups.length; i++)
            UserGroup.internalBinaryWrite(message.groups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 2; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserGroupsResult
 */
export const GetUserGroupsResult = new GetUserGroupsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserGroupInput$Type extends MessageType {
    constructor() {
        super("CreateUserGroupInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.name = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated int64 user_ids */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userIds.push(reader.int64().toBigInt());
                    else
                        message.userIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated int64 user_ids = 4; */
        if (message.userIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userIds.length; i++)
                writer.int64(message.userIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateUserGroupInput
 */
export const CreateUserGroupInput = new CreateUserGroupInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserGroupResult$Type extends MessageType {
    constructor() {
        super("CreateUserGroupResult", [
            { no: 1, name: "group", kind: "message", T: () => UserGroup },
            { no: 2, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UserGroup group */ 1:
                    message.group = UserGroup.internalBinaryRead(reader, reader.uint32(), options, message.group);
                    break;
                case /* repeated User users */ 2:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UserGroup group = 1; */
        if (message.group)
            UserGroup.internalBinaryWrite(message.group, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 2; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateUserGroupResult
 */
export const CreateUserGroupResult = new CreateUserGroupResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserGroupInput$Type extends MessageType {
    constructor() {
        super("UpdateUserGroupInput", [
            { no: 1, name: "group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groupId = 0n;
        message.name = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 group_id */ 1:
                    message.groupId = reader.int64().toBigInt();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated int64 user_ids */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userIds.push(reader.int64().toBigInt());
                    else
                        message.userIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 group_id = 1; */
        if (message.groupId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.groupId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated int64 user_ids = 4; */
        if (message.userIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userIds.length; i++)
                writer.int64(message.userIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserGroupInput
 */
export const UpdateUserGroupInput = new UpdateUserGroupInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserGroupResult$Type extends MessageType {
    constructor() {
        super("UpdateUserGroupResult", [
            { no: 1, name: "group", kind: "message", T: () => UserGroup },
            { no: 2, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UserGroup group */ 1:
                    message.group = UserGroup.internalBinaryRead(reader, reader.uint32(), options, message.group);
                    break;
                case /* repeated User users */ 2:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UserGroup group = 1; */
        if (message.group)
            UserGroup.internalBinaryWrite(message.group, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 2; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserGroupResult
 */
export const UpdateUserGroupResult = new UpdateUserGroupResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserGroupInput$Type extends MessageType {
    constructor() {
        super("DeleteUserGroupInput", [
            { no: 1, name: "group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groupId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 group_id */ 1:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 group_id = 1; */
        if (message.groupId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteUserGroupInput
 */
export const DeleteUserGroupInput = new DeleteUserGroupInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserGroupResult$Type extends MessageType {
    constructor() {
        super("DeleteUserGroupResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteUserGroupResult
 */
export const DeleteUserGroupResult = new DeleteUserGroupResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Update$Type extends MessageType {
    constructor() {
        super("Update", [
            { no: 1, name: "seq", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "new_message", kind: "message", oneof: "update", T: () => UpdateNewMessage },
            { no: 5, name: "edit_message", kind: "message", oneof: "update", T: () => UpdateEditMessage },
            { no: 6, name: "update_message_id", kind: "message", oneof: "update", T: () => UpdateMessageId },
            { no: 7, name: "delete_messages", kind: "message", oneof: "update", T: () => UpdateDeleteMessages },
            { no: 8, name: "update_compose_action", kind: "message", oneof: "update", T: () => UpdateComposeAction },
            { no: 9, name: "update_user_status", kind: "message", oneof: "update", T: () => UpdateUserStatus },
            { no: 10, name: "message_attachment", kind: "message", oneof: "update", T: () => UpdateMessageAttachment },
            { no: 11, name: "update_reaction", kind: "message", oneof: "update", T: () => UpdateReaction },
            { no: 12, name: "delete_reaction", kind: "message", oneof: "update", T: () => UpdateDeleteReaction },
            { no: 13, name: "participant_add", kind: "message", oneof: "update", T: () => UpdateChatParticipantAdd },
            { no: 14, name: "participant_delete", kind: "message", oneof: "update", T: () => UpdateChatParticipantDelete },
            { no: 15, name: "new_chat", kind: "message", oneof: "update", T: () => UpdateNewChat },
            { no: 16, name: "delete_chat", kind: "message", oneof: "update", T: () => UpdateDeleteChat },
            { no: 17, name: "space_member_add", kind: "message", oneof: "update", T: () => UpdateSpaceMemberAdd },
            { no: 18, name: "space_member_delete", kind: "message", oneof: "update", T: () => UpdateSpaceMemberDelete },
            { no: 19, name: "join_space", kind: "message", oneof: "update", T: () => UpdateJoinSpace },
            { no: 20, name: "update_read_max_id", kind: "message", oneof: "update", T: () => UpdateReadMaxId },
            { no: 21, name: "update_user_settings", kind: "message", oneof: "update", T: () => UpdateUserSettings },
            { no: 22, name: "new_message_notification", kind: "message", oneof: "update", T: () => UpdateNewMessageNotification },
            { no: 23, name: "mark_as_unread", kind: "message", oneof: "update", T: () => UpdateMarkAsUnread },
            { no: 24, name: "chat_skip_pts", kind: "message", oneof: "update", T: () => UpdateChatSkipPts },
            { no: 25, name: "chat_has_new_updates", kind: "message", oneof: "update", T: () => UpdateChatHasNewUpdates },
            { no: 26, name: "space_has_new_updates", kind: "message", oneof: "update", T: () => UpdateSpaceHasNewUpdates },
            { no: 27, name: "space_member_update", kind: "message", oneof: "update", T: () => UpdateSpaceMemberUpdate },
            { no: 28, name: "chat_visibility", kind: "message", oneof: "update", T: () => UpdateChatVisibility },
            { no: 29, name: "dialog_archived", kind: "message", oneof: "update", T: () => UpdateDialogArchived },
            { no: 30, name: "chat_info", kind: "message", oneof: "update", T: () => UpdateChatInfo },
            { no: 31, name: "pinned_messages", kind: "message", oneof: "update", T: () => UpdatePinnedMessages },
            { no: 32, name: "chat_moved", kind: "message", oneof: "update", T: () => UpdateChatMoved },
            { no: 33, name: "dialog_notification_settings", kind: "message", oneof: "update", T: () => UpdateDialogNotificationSettings },
            { no: 34, name: "chat_open", kind: "message", oneof: "update", T: () => UpdateChatOpen },
            { no: 35, name: "message_action_invoked", kind: "message", oneof: "update", T: () => UpdateMessageActionInvoked },
            { no: 36, name: "message_action_answered", kind: "message", oneof: "update", T: () => UpdateMessageActionAnswered },
            { no: 37, name: "clear_chat_history", kind: "message", oneof: "update", T: () => UpdateClearChatHistory },
            { no: 38, name: "bot_presence", kind: "message", oneof: "update", T: () => UpdateBotPresence },
            { no: 39, name: "dialog_follow_mode", kind: "message", oneof: "update", T: () => UpdateDialogFollowMode },
            { no: 40, name: "updated_user", kind: "message", oneof: "update", T: () => UpdateUpdatedUser },
            { no: 41, name: "participant_group_add", kind: "message", oneof: "update", T: () => UpdateChatParticipantGroupAdd },
            { no: 42, name: "participant_group_delete", kind: "message", oneof: "update", T: () => UpdateChatParticipantGroupDelete },
            { no: 43, name: "space_settings", kind: "message", oneof: "update", T: () => UpdateSpaceSettings },
            { no: 44, name: "chat_permissions", kind: "message", oneof: "update", T: () => UpdateChatPermissions },
            { no: 45, name: "dialog_collapsed_max_id", kind: "message", oneof: "update", T: () => UpdateDialogCollapsedMaxId },
            { no: 46, name: "dialog_folder", kind: "message", oneof: "update", T: () => UpdateDialogFolder },
            { no: 47, name: "user_added_to_chat", kind: "message", oneof: "update", T: () => UpdateUserAddedToChat },
            { no: 48, name: "user_removed_from_chat", kind: "message", oneof: "update", T: () => UpdateUserRemovedFromChat },
            { no: 49, name: "acknowledgement", kind: "message", oneof: "update", T: () => ChatAcknowledgement }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.update = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 seq */ 1:
                    message.seq = reader.int32();
                    break;
                case /* optional int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                case /* UpdateNewMessage new_message */ 4:
                    message.update = {
                        oneofKind: "newMessage",
                        newMessage: UpdateNewMessage.internalBinaryRead(reader, reader.uint32(), options, message.update.newMessage)
                    };
                    break;
                case /* UpdateEditMessage edit_message */ 5:
                    message.update = {
                        oneofKind: "editMessage",
                        editMessage: UpdateEditMessage.internalBinaryRead(reader, reader.uint32(), options, message.update.editMessage)
                    };
                    break;
                case /* UpdateMessageId update_message_id */ 6:
                    message.update = {
                        oneofKind: "updateMessageId",
                        updateMessageId: UpdateMessageId.internalBinaryRead(reader, reader.uint32(), options, message.update.updateMessageId)
                    };
                    break;
                case /* UpdateDeleteMessages delete_messages */ 7:
                    message.update = {
                        oneofKind: "deleteMessages",
                        deleteMessages: UpdateDeleteMessages.internalBinaryRead(reader, reader.uint32(), options, message.update.deleteMessages)
                    };
                    break;
                case /* UpdateComposeAction update_compose_action */ 8:
                    message.update = {
                        oneofKind: "updateComposeAction",
                        updateComposeAction: UpdateComposeAction.internalBinaryRead(reader, reader.uint32(), options, message.update.updateComposeAction)
                    };
                    break;
                case /* UpdateUserStatus update_user_status */ 9:
                    message.update = {
                        oneofKind: "updateUserStatus",
                        updateUserStatus: UpdateUserStatus.internalBinaryRead(reader, reader.uint32(), options, message.update.updateUserStatus)
                    };
                    break;
                case /* UpdateMessageAttachment message_attachment */ 10:
                    message.update = {
                        oneofKind: "messageAttachment",
                        messageAttachment: UpdateMessageAttachment.internalBinaryRead(reader, reader.uint32(), options, message.update.messageAttachment)
                    };
                    break;
                case /* UpdateReaction update_reaction */ 11:
                    message.update = {
                        oneofKind: "updateReaction",
                        updateReaction: UpdateReaction.internalBinaryRead(reader, reader.uint32(), options, message.update.updateReaction)
                    };
                    break;
                case /* UpdateDeleteReaction delete_reaction */ 12:
                    message.update = {
                        oneofKind: "deleteReaction",
                        deleteReaction: UpdateDeleteReaction.internalBinaryRead(reader, reader.uint32(), options, message.update.deleteReaction)
                    };
                    break;
                case /* UpdateChatParticipantAdd participant_add */ 13:
                    message.update = {
                        oneofKind: "participantAdd",
                        participantAdd: UpdateChatParticipantAdd.internalBinaryRead(reader, reader.uint32(), options, message.update.participantAdd)
                    };
                    break;
                case /* UpdateChatParticipantDelete participant_delete */ 14:
                    message.update = {
                        oneofKind: "participantDelete",
                        participantDelete: UpdateChatParticipantDelete.internalBinaryRead(reader, reader.uint32(), options, message.update.participantDelete)
                    };
                    break;
                case /* UpdateNewChat new_chat */ 15:
                    message.update = {
                        oneofKind: "newChat",
                        newChat: UpdateNewChat.internalBinaryRead(reader, reader.uint32(), options, message.update.newChat)
                    };
                    break;
                case /* UpdateDeleteChat delete_chat */ 16:
                    message.update = {
                        oneofKind: "deleteChat",
                        deleteChat: UpdateDeleteChat.internalBinaryRead(reader, reader.uint32(), options, message.update.deleteChat)
                    };
                    break;
                case /* UpdateSpaceMemberAdd space_member_add */ 17:
                    message.update = {
                        oneofKind: "spaceMemberAdd",
                        spaceMemberAdd: UpdateSpaceMemberAdd.internalBinaryRead(reader, reader.uint32(), options, message.update.spaceMemberAdd)
                    };
                    break;
                case /* UpdateSpaceMemberDelete space_member_delete */ 18:
                    message.update = {
                        oneofKind: "spaceMemberDelete",
                        spaceMemberDelete: UpdateSpaceMemberDelete.internalBinaryRead(reader, reader.uint32(), options, message.update.spaceMemberDelete)
                    };
                    break;
                case /* UpdateJoinSpace join_space */ 19:
                    message.update = {
                        oneofKind: "joinSpace",
                        joinSpace: UpdateJoinSpace.internalBinaryRead(reader, reader.uint32(), options, message.update.joinSpace)
                    };
                    break;
                case /* UpdateReadMaxId update_read_max_id */ 20:
                    message.update = {
                        oneofKind: "updateReadMaxId",
                        updateReadMaxId: UpdateReadMaxId.internalBinaryRead(reader, reader.uint32(), options, message.update.updateReadMaxId)
                    };
                    break;
                case /* UpdateUserSettings update_user_settings */ 21:
                    message.update = {
                        oneofKind: "updateUserSettings",
                        updateUserSettings: UpdateUserSettings.internalBinaryRead(reader, reader.uint32(), options, message.update.updateUserSettings)
                    };
                    break;
                case /* UpdateNewMessageNotification new_message_notification */ 22:
                    message.update = {
                        oneofKind: "newMessageNotification",
                        newMessageNotification: UpdateNewMessageNotification.internalBinaryRead(reader, reader.uint32(), options, message.update.newMessageNotification)
                    };
                    break;
                case /* UpdateMarkAsUnread mark_as_unread */ 23:
                    message.update = {
                        oneofKind: "markAsUnread",
                        markAsUnread: UpdateMarkAsUnread.internalBinaryRead(reader, reader.uint32(), options, message.update.markAsUnread)
                    };
                    break;
                case /* UpdateChatSkipPts chat_skip_pts */ 24:
                    message.update = {
                        oneofKind: "chatSkipPts",
                        chatSkipPts: UpdateChatSkipPts.internalBinaryRead(reader, reader.uint32(), options, message.update.chatSkipPts)
                    };
                    break;
                case /* UpdateChatHasNewUpdates chat_has_new_updates */ 25:
                    message.update = {
                        oneofKind: "chatHasNewUpdates",
                        chatHasNewUpdates: UpdateChatHasNewUpdates.internalBinaryRead(reader, reader.uint32(), options, message.update.chatHasNewUpdates)
                    };
                    break;
                case /* UpdateSpaceHasNewUpdates space_has_new_updates */ 26:
                    message.update = {
                        oneofKind: "spaceHasNewUpdates",
                        spaceHasNewUpdates: UpdateSpaceHasNewUpdates.internalBinaryRead(reader, reader.uint32(), options, message.update.spaceHasNewUpdates)
                    };
                    break;
                case /* UpdateSpaceMemberUpdate space_member_update */ 27:
                    message.update = {
                        oneofKind: "spaceMemberUpdate",
                        spaceMemberUpdate: UpdateSpaceMemberUpdate.internalBinaryRead(reader, reader.uint32(), options, message.update.spaceMemberUpdate)
                    };
                    break;
                case /* UpdateChatVisibility chat_visibility */ 28:
                    message.update = {
                        oneofKind: "chatVisibility",
                        chatVisibility: UpdateChatVisibility.internalBinaryRead(reader, reader.uint32(), options, message.update.chatVisibility)
                    };
                    break;
                case /* UpdateDialogArchived dialog_archived */ 29:
                    message.update = {
                        oneofKind: "dialogArchived",
                        dialogArchived: UpdateDialogArchived.internalBinaryRead(reader, reader.uint32(), options, message.update.dialogArchived)
                    };
                    break;
                case /* UpdateChatInfo chat_info */ 30:
                    message.update = {
                        oneofKind: "chatInfo",
                        chatInfo: UpdateChatInfo.internalBinaryRead(reader, reader.uint32(), options, message.update.chatInfo)
                    };
                    break;
                case /* UpdatePinnedMessages pinned_messages */ 31:
                    message.update = {
                        oneofKind: "pinnedMessages",
                        pinnedMessages: UpdatePinnedMessages.internalBinaryRead(reader, reader.uint32(), options, message.update.pinnedMessages)
                    };
                    break;
                case /* UpdateChatMoved chat_moved */ 32:
                    message.update = {
                        oneofKind: "chatMoved",
                        chatMoved: UpdateChatMoved.internalBinaryRead(reader, reader.uint32(), options, message.update.chatMoved)
                    };
                    break;
                case /* UpdateDialogNotificationSettings dialog_notification_settings */ 33:
                    message.update = {
                        oneofKind: "dialogNotificationSettings",
                        dialogNotificationSettings: UpdateDialogNotificationSettings.internalBinaryRead(reader, reader.uint32(), options, message.update.dialogNotificationSettings)
                    };
                    break;
                case /* UpdateChatOpen chat_open */ 34:
                    message.update = {
                        oneofKind: "chatOpen",
                        chatOpen: UpdateChatOpen.internalBinaryRead(reader, reader.uint32(), options, message.update.chatOpen)
                    };
                    break;
                case /* UpdateMessageActionInvoked message_action_invoked */ 35:
                    message.update = {
                        oneofKind: "messageActionInvoked",
                        messageActionInvoked: UpdateMessageActionInvoked.internalBinaryRead(reader, reader.uint32(), options, message.update.messageActionInvoked)
                    };
                    break;
                case /* UpdateMessageActionAnswered message_action_answered */ 36:
                    message.update = {
                        oneofKind: "messageActionAnswered",
                        messageActionAnswered: UpdateMessageActionAnswered.internalBinaryRead(reader, reader.uint32(), options, message.update.messageActionAnswered)
                    };
                    break;
                case /* UpdateClearChatHistory clear_chat_history */ 37:
                    message.update = {
                        oneofKind: "clearChatHistory",
                        clearChatHistory: UpdateClearChatHistory.internalBinaryRead(reader, reader.uint32(), options, message.update.clearChatHistory)
                    };
                    break;
                case /* UpdateBotPresence bot_presence */ 38:
                    message.update = {
                        oneofKind: "botPresence",
                        botPresence: UpdateBotPresence.internalBinaryRead(reader, reader.uint32(), options, message.update.botPresence)
                    };
                    break;
                case /* UpdateDialogFollowMode dialog_follow_mode */ 39:
                    message.update = {
                        oneofKind: "dialogFollowMode",
                        dialogFollowMode: UpdateDialogFollowMode.internalBinaryRead(reader, reader.uint32(), options, message.update.dialogFollowMode)
                    };
                    break;
                case /* UpdateUpdatedUser updated_user */ 40:
                    message.update = {
                        oneofKind: "updatedUser",
                        updatedUser: UpdateUpdatedUser.internalBinaryRead(reader, reader.uint32(), options, message.update.updatedUser)
                    };
                    break;
                case /* UpdateChatParticipantGroupAdd participant_group_add */ 41:
                    message.update = {
                        oneofKind: "participantGroupAdd",
                        participantGroupAdd: UpdateChatParticipantGroupAdd.internalBinaryRead(reader, reader.uint32(), options, message.update.participantGroupAdd)
                    };
                    break;
                case /* UpdateChatParticipantGroupDelete participant_group_delete */ 42:
                    message.update = {
                        oneofKind: "participantGroupDelete",
                        participantGroupDelete: UpdateChatParticipantGroupDelete.internalBinaryRead(reader, reader.uint32(), options, message.update.participantGroupDelete)
                    };
                    break;
                case /* UpdateSpaceSettings space_settings */ 43:
                    message.update = {
                        oneofKind: "spaceSettings",
                        spaceSettings: UpdateSpaceSettings.internalBinaryRead(reader, reader.uint32(), options, message.update.spaceSettings)
                    };
                    break;
                case /* UpdateChatPermissions chat_permissions */ 44:
                    message.update = {
                        oneofKind: "chatPermissions",
                        chatPermissions: UpdateChatPermissions.internalBinaryRead(reader, reader.uint32(), options, message.update.chatPermissions)
                    };
                    break;
                case /* UpdateDialogCollapsedMaxId dialog_collapsed_max_id */ 45:
                    message.update = {
                        oneofKind: "dialogCollapsedMaxId",
                        dialogCollapsedMaxId: UpdateDialogCollapsedMaxId.internalBinaryRead(reader, reader.uint32(), options, message.update.dialogCollapsedMaxId)
                    };
                    break;
                case /* UpdateDialogFolder dialog_folder */ 46:
                    message.update = {
                        oneofKind: "dialogFolder",
                        dialogFolder: UpdateDialogFolder.internalBinaryRead(reader, reader.uint32(), options, message.update.dialogFolder)
                    };
                    break;
                case /* UpdateUserAddedToChat user_added_to_chat */ 47:
                    message.update = {
                        oneofKind: "userAddedToChat",
                        userAddedToChat: UpdateUserAddedToChat.internalBinaryRead(reader, reader.uint32(), options, message.update.userAddedToChat)
                    };
                    break;
                case /* UpdateUserRemovedFromChat user_removed_from_chat */ 48:
                    message.update = {
                        oneofKind: "userRemovedFromChat",
                        userRemovedFromChat: UpdateUserRemovedFromChat.internalBinaryRead(reader, reader.uint32(), options, message.update.userRemovedFromChat)
                    };
                    break;
                case /* ChatAcknowledgement acknowledgement */ 49:
                    message.update = {
                        oneofKind: "acknowledgement",
                        acknowledgement: ChatAcknowledgement.internalBinaryRead(reader, reader.uint32(), options, message.update.acknowledgement)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int32 seq = 1; */
        if (message.seq !== undefined)
            writer.tag(1, WireType.Varint).int32(message.seq);
        /* optional int64 date = 2; */
        if (message.date !== undefined)
            writer.tag(2, WireType.Varint).int64(message.date);
        /* UpdateNewMessage new_message = 4; */
        if (message.update.oneofKind === "newMessage")
            UpdateNewMessage.internalBinaryWrite(message.update.newMessage, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* UpdateEditMessage edit_message = 5; */
        if (message.update.oneofKind === "editMessage")
            UpdateEditMessage.internalBinaryWrite(message.update.editMessage, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMessageId update_message_id = 6; */
        if (message.update.oneofKind === "updateMessageId")
            UpdateMessageId.internalBinaryWrite(message.update.updateMessageId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDeleteMessages delete_messages = 7; */
        if (message.update.oneofKind === "deleteMessages")
            UpdateDeleteMessages.internalBinaryWrite(message.update.deleteMessages, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* UpdateComposeAction update_compose_action = 8; */
        if (message.update.oneofKind === "updateComposeAction")
            UpdateComposeAction.internalBinaryWrite(message.update.updateComposeAction, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserStatus update_user_status = 9; */
        if (message.update.oneofKind === "updateUserStatus")
            UpdateUserStatus.internalBinaryWrite(message.update.updateUserStatus, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMessageAttachment message_attachment = 10; */
        if (message.update.oneofKind === "messageAttachment")
            UpdateMessageAttachment.internalBinaryWrite(message.update.messageAttachment, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* UpdateReaction update_reaction = 11; */
        if (message.update.oneofKind === "updateReaction")
            UpdateReaction.internalBinaryWrite(message.update.updateReaction, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDeleteReaction delete_reaction = 12; */
        if (message.update.oneofKind === "deleteReaction")
            UpdateDeleteReaction.internalBinaryWrite(message.update.deleteReaction, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatParticipantAdd participant_add = 13; */
        if (message.update.oneofKind === "participantAdd")
            UpdateChatParticipantAdd.internalBinaryWrite(message.update.participantAdd, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatParticipantDelete participant_delete = 14; */
        if (message.update.oneofKind === "participantDelete")
            UpdateChatParticipantDelete.internalBinaryWrite(message.update.participantDelete, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* UpdateNewChat new_chat = 15; */
        if (message.update.oneofKind === "newChat")
            UpdateNewChat.internalBinaryWrite(message.update.newChat, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDeleteChat delete_chat = 16; */
        if (message.update.oneofKind === "deleteChat")
            UpdateDeleteChat.internalBinaryWrite(message.update.deleteChat, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSpaceMemberAdd space_member_add = 17; */
        if (message.update.oneofKind === "spaceMemberAdd")
            UpdateSpaceMemberAdd.internalBinaryWrite(message.update.spaceMemberAdd, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSpaceMemberDelete space_member_delete = 18; */
        if (message.update.oneofKind === "spaceMemberDelete")
            UpdateSpaceMemberDelete.internalBinaryWrite(message.update.spaceMemberDelete, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* UpdateJoinSpace join_space = 19; */
        if (message.update.oneofKind === "joinSpace")
            UpdateJoinSpace.internalBinaryWrite(message.update.joinSpace, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* UpdateReadMaxId update_read_max_id = 20; */
        if (message.update.oneofKind === "updateReadMaxId")
            UpdateReadMaxId.internalBinaryWrite(message.update.updateReadMaxId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserSettings update_user_settings = 21; */
        if (message.update.oneofKind === "updateUserSettings")
            UpdateUserSettings.internalBinaryWrite(message.update.updateUserSettings, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* UpdateNewMessageNotification new_message_notification = 22; */
        if (message.update.oneofKind === "newMessageNotification")
            UpdateNewMessageNotification.internalBinaryWrite(message.update.newMessageNotification, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMarkAsUnread mark_as_unread = 23; */
        if (message.update.oneofKind === "markAsUnread")
            UpdateMarkAsUnread.internalBinaryWrite(message.update.markAsUnread, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatSkipPts chat_skip_pts = 24; */
        if (message.update.oneofKind === "chatSkipPts")
            UpdateChatSkipPts.internalBinaryWrite(message.update.chatSkipPts, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatHasNewUpdates chat_has_new_updates = 25; */
        if (message.update.oneofKind === "chatHasNewUpdates")
            UpdateChatHasNewUpdates.internalBinaryWrite(message.update.chatHasNewUpdates, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSpaceHasNewUpdates space_has_new_updates = 26; */
        if (message.update.oneofKind === "spaceHasNewUpdates")
            UpdateSpaceHasNewUpdates.internalBinaryWrite(message.update.spaceHasNewUpdates, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSpaceMemberUpdate space_member_update = 27; */
        if (message.update.oneofKind === "spaceMemberUpdate")
            UpdateSpaceMemberUpdate.internalBinaryWrite(message.update.spaceMemberUpdate, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatVisibility chat_visibility = 28; */
        if (message.update.oneofKind === "chatVisibility")
            UpdateChatVisibility.internalBinaryWrite(message.update.chatVisibility, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogArchived dialog_archived = 29; */
        if (message.update.oneofKind === "dialogArchived")
            UpdateDialogArchived.internalBinaryWrite(message.update.dialogArchived, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatInfo chat_info = 30; */
        if (message.update.oneofKind === "chatInfo")
            UpdateChatInfo.internalBinaryWrite(message.update.chatInfo, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* UpdatePinnedMessages pinned_messages = 31; */
        if (message.update.oneofKind === "pinnedMessages")
            UpdatePinnedMessages.internalBinaryWrite(message.update.pinnedMessages, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatMoved chat_moved = 32; */
        if (message.update.oneofKind === "chatMoved")
            UpdateChatMoved.internalBinaryWrite(message.update.chatMoved, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogNotificationSettings dialog_notification_settings = 33; */
        if (message.update.oneofKind === "dialogNotificationSettings")
            UpdateDialogNotificationSettings.internalBinaryWrite(message.update.dialogNotificationSettings, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatOpen chat_open = 34; */
        if (message.update.oneofKind === "chatOpen")
            UpdateChatOpen.internalBinaryWrite(message.update.chatOpen, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMessageActionInvoked message_action_invoked = 35; */
        if (message.update.oneofKind === "messageActionInvoked")
            UpdateMessageActionInvoked.internalBinaryWrite(message.update.messageActionInvoked, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* UpdateMessageActionAnswered message_action_answered = 36; */
        if (message.update.oneofKind === "messageActionAnswered")
            UpdateMessageActionAnswered.internalBinaryWrite(message.update.messageActionAnswered, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* UpdateClearChatHistory clear_chat_history = 37; */
        if (message.update.oneofKind === "clearChatHistory")
            UpdateClearChatHistory.internalBinaryWrite(message.update.clearChatHistory, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* UpdateBotPresence bot_presence = 38; */
        if (message.update.oneofKind === "botPresence")
            UpdateBotPresence.internalBinaryWrite(message.update.botPresence, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogFollowMode dialog_follow_mode = 39; */
        if (message.update.oneofKind === "dialogFollowMode")
            UpdateDialogFollowMode.internalBinaryWrite(message.update.dialogFollowMode, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUpdatedUser updated_user = 40; */
        if (message.update.oneofKind === "updatedUser")
            UpdateUpdatedUser.internalBinaryWrite(message.update.updatedUser, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatParticipantGroupAdd participant_group_add = 41; */
        if (message.update.oneofKind === "participantGroupAdd")
            UpdateChatParticipantGroupAdd.internalBinaryWrite(message.update.participantGroupAdd, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatParticipantGroupDelete participant_group_delete = 42; */
        if (message.update.oneofKind === "participantGroupDelete")
            UpdateChatParticipantGroupDelete.internalBinaryWrite(message.update.participantGroupDelete, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* UpdateSpaceSettings space_settings = 43; */
        if (message.update.oneofKind === "spaceSettings")
            UpdateSpaceSettings.internalBinaryWrite(message.update.spaceSettings, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* UpdateChatPermissions chat_permissions = 44; */
        if (message.update.oneofKind === "chatPermissions")
            UpdateChatPermissions.internalBinaryWrite(message.update.chatPermissions, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogCollapsedMaxId dialog_collapsed_max_id = 45; */
        if (message.update.oneofKind === "dialogCollapsedMaxId")
            UpdateDialogCollapsedMaxId.internalBinaryWrite(message.update.dialogCollapsedMaxId, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* UpdateDialogFolder dialog_folder = 46; */
        if (message.update.oneofKind === "dialogFolder")
            UpdateDialogFolder.internalBinaryWrite(message.update.dialogFolder, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserAddedToChat user_added_to_chat = 47; */
        if (message.update.oneofKind === "userAddedToChat")
            UpdateUserAddedToChat.internalBinaryWrite(message.update.userAddedToChat, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* UpdateUserRemovedFromChat user_removed_from_chat = 48; */
        if (message.update.oneofKind === "userRemovedFromChat")
            UpdateUserRemovedFromChat.internalBinaryWrite(message.update.userRemovedFromChat, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* ChatAcknowledgement acknowledgement = 49; */
        if (message.update.oneofKind === "acknowledgement")
            ChatAcknowledgement.internalBinaryWrite(message.update.acknowledgement, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Update
 */
export const Update = new Update$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogFolder$Type extends MessageType {
    constructor() {
        super("UpdateDialogFolder", [
            { no: 1, name: "folder", kind: "message", oneof: "folderChange", T: () => DialogFolder },
            { no: 2, name: "deleted_folder_id", kind: "scalar", oneof: "folderChange", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "dialogs", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.folderChange = { oneofKind: undefined };
        message.dialogs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* DialogFolder folder */ 1:
                    message.folderChange = {
                        oneofKind: "folder",
                        folder: DialogFolder.internalBinaryRead(reader, reader.uint32(), options, message.folderChange.folder)
                    };
                    break;
                case /* int64 deleted_folder_id */ 2:
                    message.folderChange = {
                        oneofKind: "deletedFolderId",
                        deletedFolderId: reader.int64().toBigInt()
                    };
                    break;
                case /* repeated Dialog dialogs */ 3:
                    message.dialogs.push(Dialog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* DialogFolder folder = 1; */
        if (message.folderChange.oneofKind === "folder")
            DialogFolder.internalBinaryWrite(message.folderChange.folder, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 deleted_folder_id = 2; */
        if (message.folderChange.oneofKind === "deletedFolderId")
            writer.tag(2, WireType.Varint).int64(message.folderChange.deletedFolderId);
        /* repeated Dialog dialogs = 3; */
        for (let i = 0; i < message.dialogs.length; i++)
            Dialog.internalBinaryWrite(message.dialogs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogFolder
 */
export const UpdateDialogFolder = new UpdateDialogFolder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpaceHasNewUpdates$Type extends MessageType {
    constructor() {
        super("UpdateSpaceHasNewUpdates", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "update_seq", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.updateSeq = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int32 update_seq */ 2:
                    message.updateSeq = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int32 update_seq = 2; */
        if (message.updateSeq !== 0)
            writer.tag(2, WireType.Varint).int32(message.updateSeq);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSpaceHasNewUpdates
 */
export const UpdateSpaceHasNewUpdates = new UpdateSpaceHasNewUpdates$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatHasNewUpdates$Type extends MessageType {
    constructor() {
        super("UpdateChatHasNewUpdates", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "update_seq", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.updateSeq = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 3:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int32 update_seq */ 2:
                    message.updateSeq = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* Peer peer_id = 3; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 update_seq = 2; */
        if (message.updateSeq !== 0)
            writer.tag(2, WireType.Varint).int32(message.updateSeq);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatHasNewUpdates
 */
export const UpdateChatHasNewUpdates = new UpdateChatHasNewUpdates$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatSkipPts$Type extends MessageType {
    constructor() {
        super("UpdateChatSkipPts", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatSkipPts
 */
export const UpdateChatSkipPts = new UpdateChatSkipPts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatVisibility$Type extends MessageType {
    constructor() {
        super("UpdateChatVisibility", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "is_public", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.isPublic = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* bool is_public */ 2:
                    message.isPublic = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* bool is_public = 2; */
        if (message.isPublic !== false)
            writer.tag(2, WireType.Varint).bool(message.isPublic);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatVisibility
 */
export const UpdateChatVisibility = new UpdateChatVisibility$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatInfo$Type extends MessageType {
    constructor() {
        super("UpdateChatInfo", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "untitled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "agent_context", kind: "message", T: () => AgentThreadContext }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional string title */ 2:
                    message.title = reader.string();
                    break;
                case /* optional string emoji */ 3:
                    message.emoji = reader.string();
                    break;
                case /* optional bool untitled */ 4:
                    message.untitled = reader.bool();
                    break;
                case /* optional AgentThreadContext agent_context */ 5:
                    message.agentContext = AgentThreadContext.internalBinaryRead(reader, reader.uint32(), options, message.agentContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional string title = 2; */
        if (message.title !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* optional string emoji = 3; */
        if (message.emoji !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.emoji);
        /* optional bool untitled = 4; */
        if (message.untitled !== undefined)
            writer.tag(4, WireType.Varint).bool(message.untitled);
        /* optional AgentThreadContext agent_context = 5; */
        if (message.agentContext)
            AgentThreadContext.internalBinaryWrite(message.agentContext, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatInfo
 */
export const UpdateChatInfo = new UpdateChatInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatPermissions$Type extends MessageType {
    constructor() {
        super("UpdateChatPermissions", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "permissions", kind: "message", T: () => ChatPermissions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* ChatPermissions permissions */ 2:
                    message.permissions = ChatPermissions.internalBinaryRead(reader, reader.uint32(), options, message.permissions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* ChatPermissions permissions = 2; */
        if (message.permissions)
            ChatPermissions.internalBinaryWrite(message.permissions, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatPermissions
 */
export const UpdateChatPermissions = new UpdateChatPermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePinnedMessages$Type extends MessageType {
    constructor() {
        super("UpdatePinnedMessages", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* repeated int64 message_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.messageIds.push(reader.int64().toBigInt());
                    else
                        message.messageIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 message_ids = 2; */
        if (message.messageIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.messageIds.length; i++)
                writer.int64(message.messageIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdatePinnedMessages
 */
export const UpdatePinnedMessages = new UpdatePinnedMessages$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatMoved$Type extends MessageType {
    constructor() {
        super("UpdateChatMoved", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "old_space_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "new_space_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* optional int64 old_space_id */ 2:
                    message.oldSpaceId = reader.int64().toBigInt();
                    break;
                case /* optional int64 new_space_id */ 3:
                    message.newSpaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 old_space_id = 2; */
        if (message.oldSpaceId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.oldSpaceId);
        /* optional int64 new_space_id = 3; */
        if (message.newSpaceId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.newSpaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatMoved
 */
export const UpdateChatMoved = new UpdateChatMoved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNewMessageNotification$Type extends MessageType {
    constructor() {
        super("UpdateNewMessageNotification", [
            { no: 1, name: "message", kind: "message", T: () => Message },
            { no: 2, name: "reason", kind: "enum", T: () => ["UpdateNewMessageNotification.Reason", UpdateNewMessageNotification_Reason, "REASON_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reason = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Message message */ 1:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* UpdateNewMessageNotification.Reason reason */ 2:
                    message.reason = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Message message = 1; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* UpdateNewMessageNotification.Reason reason = 2; */
        if (message.reason !== 0)
            writer.tag(2, WireType.Varint).int32(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateNewMessageNotification
 */
export const UpdateNewMessageNotification = new UpdateNewMessageNotification$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserSettings$Type extends MessageType {
    constructor() {
        super("UpdateUserSettings", [
            { no: 1, name: "settings", kind: "message", T: () => UserSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UserSettings settings */ 1:
                    message.settings = UserSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UserSettings settings = 1; */
        if (message.settings)
            UserSettings.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserSettings
 */
export const UpdateUserSettings = new UpdateUserSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpaceSettings$Type extends MessageType {
    constructor() {
        super("UpdateSpaceSettings", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "settings", kind: "message", T: () => SpaceSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* SpaceSettings settings */ 2:
                    message.settings = SpaceSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* SpaceSettings settings = 2; */
        if (message.settings)
            SpaceSettings.internalBinaryWrite(message.settings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSpaceSettings
 */
export const UpdateSpaceSettings = new UpdateSpaceSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUpdatedUser$Type extends MessageType {
    constructor() {
        super("UpdateUpdatedUser", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUpdatedUser
 */
export const UpdateUpdatedUser = new UpdateUpdatedUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpaceMemberAdd$Type extends MessageType {
    constructor() {
        super("UpdateSpaceMemberAdd", [
            { no: 1, name: "member", kind: "message", T: () => Member },
            { no: 2, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Member member */ 1:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                case /* User user */ 2:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Member member = 1; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* User user = 2; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSpaceMemberAdd
 */
export const UpdateSpaceMemberAdd = new UpdateSpaceMemberAdd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpaceMemberDelete$Type extends MessageType {
    constructor() {
        super("UpdateSpaceMemberDelete", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSpaceMemberDelete
 */
export const UpdateSpaceMemberDelete = new UpdateSpaceMemberDelete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSpaceMemberUpdate$Type extends MessageType {
    constructor() {
        super("UpdateSpaceMemberUpdate", [
            { no: 1, name: "member", kind: "message", T: () => Member }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Member member */ 1:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Member member = 1; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSpaceMemberUpdate
 */
export const UpdateSpaceMemberUpdate = new UpdateSpaceMemberUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateJoinSpace$Type extends MessageType {
    constructor() {
        super("UpdateJoinSpace", [
            { no: 1, name: "space", kind: "message", T: () => Space },
            { no: 2, name: "member", kind: "message", T: () => Member }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Space space */ 1:
                    message.space = Space.internalBinaryRead(reader, reader.uint32(), options, message.space);
                    break;
                case /* Member member */ 2:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Space space = 1; */
        if (message.space)
            Space.internalBinaryWrite(message.space, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Member member = 2; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateJoinSpace
 */
export const UpdateJoinSpace = new UpdateJoinSpace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReadMaxId$Type extends MessageType {
    constructor() {
        super("UpdateReadMaxId", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 3, name: "read_max_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "unread_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.readMaxId = 0n;
        message.unreadCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 read_max_id */ 3:
                    message.readMaxId = reader.int64().toBigInt();
                    break;
                case /* int32 unread_count */ 4:
                    message.unreadCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 read_max_id = 3; */
        if (message.readMaxId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.readMaxId);
        /* int32 unread_count = 4; */
        if (message.unreadCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.unreadCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateReadMaxId
 */
export const UpdateReadMaxId = new UpdateReadMaxId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMarkAsUnread$Type extends MessageType {
    constructor() {
        super("UpdateMarkAsUnread", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "unread_mark", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.unreadMark = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* bool unread_mark */ 2:
                    message.unreadMark = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool unread_mark = 2; */
        if (message.unreadMark !== false)
            writer.tag(2, WireType.Varint).bool(message.unreadMark);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMarkAsUnread
 */
export const UpdateMarkAsUnread = new UpdateMarkAsUnread$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogArchived$Type extends MessageType {
    constructor() {
        super("UpdateDialogArchived", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "archived", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.archived = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* bool archived */ 2:
                    message.archived = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool archived = 2; */
        if (message.archived !== false)
            writer.tag(2, WireType.Varint).bool(message.archived);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogArchived
 */
export const UpdateDialogArchived = new UpdateDialogArchived$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogNotificationSettings$Type extends MessageType {
    constructor() {
        super("UpdateDialogNotificationSettings", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "notification_settings", kind: "message", T: () => DialogNotificationSettings }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional DialogNotificationSettings notification_settings */ 2:
                    message.notificationSettings = DialogNotificationSettings.internalBinaryRead(reader, reader.uint32(), options, message.notificationSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional DialogNotificationSettings notification_settings = 2; */
        if (message.notificationSettings)
            DialogNotificationSettings.internalBinaryWrite(message.notificationSettings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogNotificationSettings
 */
export const UpdateDialogNotificationSettings = new UpdateDialogNotificationSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogFollowMode$Type extends MessageType {
    constructor() {
        super("UpdateDialogFollowMode", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "follow_mode", kind: "enum", opt: true, T: () => ["DialogFollowMode", DialogFollowMode] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional DialogFollowMode follow_mode */ 2:
                    message.followMode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional DialogFollowMode follow_mode = 2; */
        if (message.followMode !== undefined)
            writer.tag(2, WireType.Varint).int32(message.followMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogFollowMode
 */
export const UpdateDialogFollowMode = new UpdateDialogFollowMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDialogCollapsedMaxId$Type extends MessageType {
    constructor() {
        super("UpdateDialogCollapsedMaxId", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer },
            { no: 2, name: "max_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* optional int64 max_id */ 2:
                    message.maxId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 max_id = 2; */
        if (message.maxId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.maxId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDialogCollapsedMaxId
 */
export const UpdateDialogCollapsedMaxId = new UpdateDialogCollapsedMaxId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNewChat$Type extends MessageType {
    constructor() {
        super("UpdateNewChat", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 3, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* optional User user */ 3:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional User user = 3; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateNewChat
 */
export const UpdateNewChat = new UpdateNewChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatOpen$Type extends MessageType {
    constructor() {
        super("UpdateChatOpen", [
            { no: 1, name: "chat", kind: "message", T: () => Chat },
            { no: 2, name: "dialog", kind: "message", T: () => Dialog },
            { no: 3, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 2:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                case /* optional User user */ 3:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 2; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional User user = 3; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatOpen
 */
export const UpdateChatOpen = new UpdateChatOpen$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMessageActionInvoked$Type extends MessageType {
    constructor() {
        super("UpdateMessageActionInvoked", [
            { no: 1, name: "interaction_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "actor_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.interactionId = 0n;
        message.chatId = 0n;
        message.messageId = 0n;
        message.actorUserId = 0n;
        message.actionId = "";
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 interaction_id */ 1:
                    message.interactionId = reader.int64().toBigInt();
                    break;
                case /* int64 chat_id */ 2:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 message_id */ 3:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* int64 actor_user_id */ 4:
                    message.actorUserId = reader.int64().toBigInt();
                    break;
                case /* string action_id */ 5:
                    message.actionId = reader.string();
                    break;
                case /* bytes data */ 6:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 interaction_id = 1; */
        if (message.interactionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.interactionId);
        /* int64 chat_id = 2; */
        if (message.chatId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.chatId);
        /* int64 message_id = 3; */
        if (message.messageId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.messageId);
        /* int64 actor_user_id = 4; */
        if (message.actorUserId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.actorUserId);
        /* string action_id = 5; */
        if (message.actionId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.actionId);
        /* bytes data = 6; */
        if (message.data.length)
            writer.tag(6, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMessageActionInvoked
 */
export const UpdateMessageActionInvoked = new UpdateMessageActionInvoked$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMessageActionAnswered$Type extends MessageType {
    constructor() {
        super("UpdateMessageActionAnswered", [
            { no: 1, name: "interaction_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "ui", kind: "message", T: () => MessageActionResponseUi }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.interactionId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 interaction_id */ 1:
                    message.interactionId = reader.int64().toBigInt();
                    break;
                case /* optional MessageActionResponseUi ui */ 2:
                    message.ui = MessageActionResponseUi.internalBinaryRead(reader, reader.uint32(), options, message.ui);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 interaction_id = 1; */
        if (message.interactionId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.interactionId);
        /* optional MessageActionResponseUi ui = 2; */
        if (message.ui)
            MessageActionResponseUi.internalBinaryWrite(message.ui, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMessageActionAnswered
 */
export const UpdateMessageActionAnswered = new UpdateMessageActionAnswered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeleteChat$Type extends MessageType {
    constructor() {
        super("UpdateDeleteChat", [
            { no: 1, name: "peer_id", kind: "message", T: () => Peer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDeleteChat
 */
export const UpdateDeleteChat = new UpdateDeleteChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNewMessage$Type extends MessageType {
    constructor() {
        super("UpdateNewMessage", [
            { no: 1, name: "message", kind: "message", T: () => Message }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Message message */ 1:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Message message = 1; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateNewMessage
 */
export const UpdateNewMessage = new UpdateNewMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEditMessage$Type extends MessageType {
    constructor() {
        super("UpdateEditMessage", [
            { no: 1, name: "message", kind: "message", T: () => Message }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Message message */ 1:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Message message = 1; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateEditMessage
 */
export const UpdateEditMessage = new UpdateEditMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeleteMessages$Type extends MessageType {
    constructor() {
        super("UpdateDeleteMessages", [
            { no: 1, name: "message_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => Peer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 message_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.messageIds.push(reader.int64().toBigInt());
                    else
                        message.messageIds.push(reader.int64().toBigInt());
                    break;
                case /* Peer peer_id */ 2:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int64 message_ids = 1; */
        if (message.messageIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.messageIds.length; i++)
                writer.int64(message.messageIds[i]);
            writer.join();
        }
        /* Peer peer_id = 2; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDeleteMessages
 */
export const UpdateDeleteMessages = new UpdateDeleteMessages$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateClearChatHistory$Type extends MessageType {
    constructor() {
        super("UpdateClearChatHistory", [
            { no: 1, name: "peer_id", kind: "message", oneof: "target", T: () => Peer },
            { no: 4, name: "space_id", kind: "scalar", oneof: "target", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "before_date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "delete_reply_threads", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "deleted_chat_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "orphaned_chat_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "detached_chat_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.target = { oneofKind: undefined };
        message.deleteReplyThreads = false;
        message.deletedChatIds = [];
        message.orphanedChatIds = [];
        message.detachedChatIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Peer peer_id */ 1:
                    message.target = {
                        oneofKind: "peerId",
                        peerId: Peer.internalBinaryRead(reader, reader.uint32(), options, message.target.peerId)
                    };
                    break;
                case /* int64 space_id */ 4:
                    message.target = {
                        oneofKind: "spaceId",
                        spaceId: reader.int64().toBigInt()
                    };
                    break;
                case /* optional int64 before_date */ 2:
                    message.beforeDate = reader.int64().toBigInt();
                    break;
                case /* bool delete_reply_threads */ 3:
                    message.deleteReplyThreads = reader.bool();
                    break;
                case /* repeated int64 deleted_chat_ids */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.deletedChatIds.push(reader.int64().toBigInt());
                    else
                        message.deletedChatIds.push(reader.int64().toBigInt());
                    break;
                case /* repeated int64 orphaned_chat_ids */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.orphanedChatIds.push(reader.int64().toBigInt());
                    else
                        message.orphanedChatIds.push(reader.int64().toBigInt());
                    break;
                case /* repeated int64 detached_chat_ids */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.detachedChatIds.push(reader.int64().toBigInt());
                    else
                        message.detachedChatIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Peer peer_id = 1; */
        if (message.target.oneofKind === "peerId")
            Peer.internalBinaryWrite(message.target.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 space_id = 4; */
        if (message.target.oneofKind === "spaceId")
            writer.tag(4, WireType.Varint).int64(message.target.spaceId);
        /* optional int64 before_date = 2; */
        if (message.beforeDate !== undefined)
            writer.tag(2, WireType.Varint).int64(message.beforeDate);
        /* bool delete_reply_threads = 3; */
        if (message.deleteReplyThreads !== false)
            writer.tag(3, WireType.Varint).bool(message.deleteReplyThreads);
        /* repeated int64 deleted_chat_ids = 5; */
        if (message.deletedChatIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.deletedChatIds.length; i++)
                writer.int64(message.deletedChatIds[i]);
            writer.join();
        }
        /* repeated int64 orphaned_chat_ids = 6; */
        if (message.orphanedChatIds.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.orphanedChatIds.length; i++)
                writer.int64(message.orphanedChatIds[i]);
            writer.join();
        }
        /* repeated int64 detached_chat_ids = 7; */
        if (message.detachedChatIds.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.detachedChatIds.length; i++)
                writer.int64(message.detachedChatIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateClearChatHistory
 */
export const UpdateClearChatHistory = new UpdateClearChatHistory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBotPresence$Type extends MessageType {
    constructor() {
        super("UpdateBotPresence", [
            { no: 1, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => Peer },
            { no: 3, name: "state", kind: "message", T: () => BotPresenceState },
            { no: 4, name: "avatar", kind: "message", T: () => BotAvatar },
            { no: 5, name: "avatar_changed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.avatarChanged = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bot_user_id */ 1:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 2:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* BotPresenceState state */ 3:
                    message.state = BotPresenceState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* optional BotAvatar avatar */ 4:
                    message.avatar = BotAvatar.internalBinaryRead(reader, reader.uint32(), options, message.avatar);
                    break;
                case /* bool avatar_changed */ 5:
                    message.avatarChanged = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 bot_user_id = 1; */
        if (message.botUserId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.botUserId);
        /* Peer peer_id = 2; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* BotPresenceState state = 3; */
        if (message.state)
            BotPresenceState.internalBinaryWrite(message.state, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional BotAvatar avatar = 4; */
        if (message.avatar)
            BotAvatar.internalBinaryWrite(message.avatar, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool avatar_changed = 5; */
        if (message.avatarChanged !== false)
            writer.tag(5, WireType.Varint).bool(message.avatarChanged);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateBotPresence
 */
export const UpdateBotPresence = new UpdateBotPresence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMessageId$Type extends MessageType {
    constructor() {
        super("UpdateMessageId", [
            { no: 1, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "random_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.randomId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 message_id */ 1:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* int64 random_id */ 2:
                    message.randomId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 message_id = 1; */
        if (message.messageId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.messageId);
        /* int64 random_id = 2; */
        if (message.randomId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.randomId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMessageId
 */
export const UpdateMessageId = new UpdateMessageId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateComposeAction$Type extends MessageType {
    constructor() {
        super("UpdateComposeAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "peer_id", kind: "message", T: () => Peer },
            { no: 3, name: "action", kind: "enum", T: () => ["UpdateComposeAction.ComposeAction", UpdateComposeAction_ComposeAction] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        message.action = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 2:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* UpdateComposeAction.ComposeAction action */ 3:
                    message.action = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        /* Peer peer_id = 2; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* UpdateComposeAction.ComposeAction action = 3; */
        if (message.action !== 0)
            writer.tag(3, WireType.Varint).int32(message.action);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateComposeAction
 */
export const UpdateComposeAction = new UpdateComposeAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMessageAttachment$Type extends MessageType {
    constructor() {
        super("UpdateMessageAttachment", [
            { no: 1, name: "attachment", kind: "message", T: () => MessageAttachment },
            { no: 2, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "peer_id", kind: "message", T: () => Peer },
            { no: 50, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* MessageAttachment attachment */ 1:
                    message.attachment = MessageAttachment.internalBinaryRead(reader, reader.uint32(), options, message.attachment);
                    break;
                case /* int64 message_id */ 2:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* Peer peer_id */ 3:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 chat_id */ 50:
                    message.chatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* MessageAttachment attachment = 1; */
        if (message.attachment)
            MessageAttachment.internalBinaryWrite(message.attachment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 message_id = 2; */
        if (message.messageId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.messageId);
        /* Peer peer_id = 3; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 chat_id = 50; */
        if (message.chatId !== 0n)
            writer.tag(50, WireType.Varint).int64(message.chatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMessageAttachment
 */
export const UpdateMessageAttachment = new UpdateMessageAttachment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReaction$Type extends MessageType {
    constructor() {
        super("UpdateReaction", [
            { no: 1, name: "reaction", kind: "message", T: () => Reaction }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Reaction reaction */ 1:
                    message.reaction = Reaction.internalBinaryRead(reader, reader.uint32(), options, message.reaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Reaction reaction = 1; */
        if (message.reaction)
            Reaction.internalBinaryWrite(message.reaction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateReaction
 */
export const UpdateReaction = new UpdateReaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeleteReaction$Type extends MessageType {
    constructor() {
        super("UpdateDeleteReaction", [
            { no: 1, name: "emoji", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.emoji = "";
        message.chatId = 0n;
        message.messageId = 0n;
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string emoji */ 1:
                    message.emoji = reader.string();
                    break;
                case /* int64 chat_id */ 2:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 message_id */ 3:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 4:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string emoji = 1; */
        if (message.emoji !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.emoji);
        /* int64 chat_id = 2; */
        if (message.chatId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.chatId);
        /* int64 message_id = 3; */
        if (message.messageId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.messageId);
        /* int64 user_id = 4; */
        if (message.userId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateDeleteReaction
 */
export const UpdateDeleteReaction = new UpdateDeleteReaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserStatus$Type extends MessageType {
    constructor() {
        super("UpdateUserStatus", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "status", kind: "message", T: () => UserStatus }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* UserStatus status */ 2:
                    message.status = UserStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        /* UserStatus status = 2; */
        if (message.status)
            UserStatus.internalBinaryWrite(message.status, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserStatus
 */
export const UpdateUserStatus = new UpdateUserStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatParticipant$Type extends MessageType {
    constructor() {
        super("ChatParticipant", [
            { no: 1, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0n;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.userId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.userId);
        /* int64 date = 2; */
        if (message.date !== 0n)
            writer.tag(2, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChatParticipant
 */
export const ChatParticipant = new ChatParticipant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatParticipantGroup$Type extends MessageType {
    constructor() {
        super("ChatParticipantGroup", [
            { no: 1, name: "group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groupId = 0n;
        message.date = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 group_id */ 1:
                    message.groupId = reader.int64().toBigInt();
                    break;
                case /* int64 date */ 2:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 group_id = 1; */
        if (message.groupId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.groupId);
        /* int64 date = 2; */
        if (message.date !== 0n)
            writer.tag(2, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChatParticipantGroup
 */
export const ChatParticipantGroup = new ChatParticipantGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatParticipantAdd$Type extends MessageType {
    constructor() {
        super("UpdateChatParticipantAdd", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "participant", kind: "message", T: () => ChatParticipant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* ChatParticipant participant */ 2:
                    message.participant = ChatParticipant.internalBinaryRead(reader, reader.uint32(), options, message.participant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* ChatParticipant participant = 2; */
        if (message.participant)
            ChatParticipant.internalBinaryWrite(message.participant, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatParticipantAdd
 */
export const UpdateChatParticipantAdd = new UpdateChatParticipantAdd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatParticipantDelete$Type extends MessageType {
    constructor() {
        super("UpdateChatParticipantDelete", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.userId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatParticipantDelete
 */
export const UpdateChatParticipantDelete = new UpdateChatParticipantDelete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatParticipantGroupAdd$Type extends MessageType {
    constructor() {
        super("UpdateChatParticipantGroupAdd", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "group_participant", kind: "message", T: () => ChatParticipantGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* ChatParticipantGroup group_participant */ 2:
                    message.groupParticipant = ChatParticipantGroup.internalBinaryRead(reader, reader.uint32(), options, message.groupParticipant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* ChatParticipantGroup group_participant = 2; */
        if (message.groupParticipant)
            ChatParticipantGroup.internalBinaryWrite(message.groupParticipant, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatParticipantGroupAdd
 */
export const UpdateChatParticipantGroupAdd = new UpdateChatParticipantGroupAdd$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatParticipantGroupDelete$Type extends MessageType {
    constructor() {
        super("UpdateChatParticipantGroupDelete", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.groupId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 group_id */ 2:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* int64 group_id = 2; */
        if (message.groupId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatParticipantGroupDelete
 */
export const UpdateChatParticipantGroupDelete = new UpdateChatParticipantGroupDelete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserAddedToChat$Type extends MessageType {
    constructor() {
        super("UpdateUserAddedToChat", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "participant", kind: "message", T: () => ChatParticipant },
            { no: 3, name: "group", kind: "message", T: () => ChatParticipantGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional ChatParticipant participant */ 2:
                    message.participant = ChatParticipant.internalBinaryRead(reader, reader.uint32(), options, message.participant);
                    break;
                case /* optional ChatParticipantGroup group */ 3:
                    message.group = ChatParticipantGroup.internalBinaryRead(reader, reader.uint32(), options, message.group);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional ChatParticipant participant = 2; */
        if (message.participant)
            ChatParticipant.internalBinaryWrite(message.participant, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional ChatParticipantGroup group = 3; */
        if (message.group)
            ChatParticipantGroup.internalBinaryWrite(message.group, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserAddedToChat
 */
export const UpdateUserAddedToChat = new UpdateUserAddedToChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserRemovedFromChat$Type extends MessageType {
    constructor() {
        super("UpdateUserRemovedFromChat", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "group_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 group_id */ 2:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional int64 group_id = 2; */
        if (message.groupId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateUserRemovedFromChat
 */
export const UpdateUserRemovedFromChat = new UpdateUserRemovedFromChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserStatus$Type extends MessageType {
    constructor() {
        super("UserStatus", [
            { no: 1, name: "online", kind: "enum", T: () => ["UserStatus.Status", UserStatus_Status] },
            { no: 2, name: "last_online", kind: "message", T: () => LastOnline }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.online = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UserStatus.Status online */ 1:
                    message.online = reader.int32();
                    break;
                case /* LastOnline last_online */ 2:
                    message.lastOnline = LastOnline.internalBinaryRead(reader, reader.uint32(), options, message.lastOnline);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UserStatus.Status online = 1; */
        if (message.online !== 0)
            writer.tag(1, WireType.Varint).int32(message.online);
        /* LastOnline last_online = 2; */
        if (message.lastOnline)
            LastOnline.internalBinaryWrite(message.lastOnline, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserStatus
 */
export const UserStatus = new UserStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LastOnline$Type extends MessageType {
    constructor() {
        super("LastOnline", [
            { no: 1, name: "date", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 date */ 1:
                    message.date = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional int64 date = 1; */
        if (message.date !== undefined)
            writer.tag(1, WireType.Varint).int64(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LastOnline
 */
export const LastOnline = new LastOnline$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteChatInput$Type extends MessageType {
    constructor() {
        super("DeleteChatInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteChatInput
 */
export const DeleteChatInput = new DeleteChatInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteChatResult$Type extends MessageType {
    constructor() {
        super("DeleteChatResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteChatResult
 */
export const DeleteChatResult = new DeleteChatResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpaceMemberOptions$Type extends MessageType {
    constructor() {
        super("SpaceMemberOptions", [
            { no: 1, name: "can_access_public_chats", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.canAccessPublicChats = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool can_access_public_chats */ 1:
                    message.canAccessPublicChats = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool can_access_public_chats = 1; */
        if (message.canAccessPublicChats !== false)
            writer.tag(1, WireType.Varint).bool(message.canAccessPublicChats);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpaceMemberOptions
 */
export const SpaceMemberOptions = new SpaceMemberOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpaceAdminOptions$Type extends MessageType {
    constructor() {
        super("SpaceAdminOptions", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpaceAdminOptions
 */
export const SpaceAdminOptions = new SpaceAdminOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpaceMemberRole$Type extends MessageType {
    constructor() {
        super("SpaceMemberRole", [
            { no: 1, name: "member", kind: "message", oneof: "role", T: () => SpaceMemberOptions },
            { no: 2, name: "admin", kind: "message", oneof: "role", T: () => SpaceAdminOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.role = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* SpaceMemberOptions member */ 1:
                    message.role = {
                        oneofKind: "member",
                        member: SpaceMemberOptions.internalBinaryRead(reader, reader.uint32(), options, message.role.member)
                    };
                    break;
                case /* SpaceAdminOptions admin */ 2:
                    message.role = {
                        oneofKind: "admin",
                        admin: SpaceAdminOptions.internalBinaryRead(reader, reader.uint32(), options, message.role.admin)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* SpaceMemberOptions member = 1; */
        if (message.role.oneofKind === "member")
            SpaceMemberOptions.internalBinaryWrite(message.role.member, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* SpaceAdminOptions admin = 2; */
        if (message.role.oneofKind === "admin")
            SpaceAdminOptions.internalBinaryWrite(message.role.admin, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpaceMemberRole
 */
export const SpaceMemberRole = new SpaceMemberRole$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InviteToSpaceInput$Type extends MessageType {
    constructor() {
        super("InviteToSpaceInput", [
            { no: 1, name: "space_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "role", kind: "message", T: () => SpaceMemberRole },
            { no: 3, name: "user_id", kind: "scalar", oneof: "via", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "email", kind: "scalar", oneof: "via", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "phone_number", kind: "scalar", oneof: "via", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spaceId = 0n;
        message.via = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 space_id */ 1:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                case /* SpaceMemberRole role */ 6:
                    message.role = SpaceMemberRole.internalBinaryRead(reader, reader.uint32(), options, message.role);
                    break;
                case /* int64 user_id */ 3:
                    message.via = {
                        oneofKind: "userId",
                        userId: reader.int64().toBigInt()
                    };
                    break;
                case /* string email */ 4:
                    message.via = {
                        oneofKind: "email",
                        email: reader.string()
                    };
                    break;
                case /* string phone_number */ 5:
                    message.via = {
                        oneofKind: "phoneNumber",
                        phoneNumber: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 space_id = 1; */
        if (message.spaceId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.spaceId);
        /* SpaceMemberRole role = 6; */
        if (message.role)
            SpaceMemberRole.internalBinaryWrite(message.role, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int64 user_id = 3; */
        if (message.via.oneofKind === "userId")
            writer.tag(3, WireType.Varint).int64(message.via.userId);
        /* string email = 4; */
        if (message.via.oneofKind === "email")
            writer.tag(4, WireType.LengthDelimited).string(message.via.email);
        /* string phone_number = 5; */
        if (message.via.oneofKind === "phoneNumber")
            writer.tag(5, WireType.LengthDelimited).string(message.via.phoneNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InviteToSpaceInput
 */
export const InviteToSpaceInput = new InviteToSpaceInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InviteToSpaceResult$Type extends MessageType {
    constructor() {
        super("InviteToSpaceResult", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "member", kind: "message", T: () => Member },
            { no: 3, name: "chat", kind: "message", T: () => Chat },
            { no: 4, name: "dialog", kind: "message", T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* Member member */ 2:
                    message.member = Member.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                case /* Chat chat */ 3:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 4:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Member member = 2; */
        if (message.member)
            Member.internalBinaryWrite(message.member, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Chat chat = 3; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 4; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InviteToSpaceResult
 */
export const InviteToSpaceResult = new InviteToSpaceResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersInput$Type extends MessageType {
    constructor() {
        super("SearchUsersInput", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* optional int32 limit */ 2:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* optional int32 limit = 2; */
        if (message.limit !== undefined)
            writer.tag(2, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchUsersInput
 */
export const SearchUsersInput = new SearchUsersInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersResult$Type extends MessageType {
    constructor() {
        super("SearchUsersResult", [
            { no: 1, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated User users */ 1:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchUsersResult
 */
export const SearchUsersResult = new SearchUsersResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsersInput$Type extends MessageType {
    constructor() {
        super("GetUsersInput", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 user_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userIds.push(reader.int64().toBigInt());
                    else
                        message.userIds.push(reader.int64().toBigInt());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int64 user_ids = 1; */
        if (message.userIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userIds.length; i++)
                writer.int64(message.userIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUsersInput
 */
export const GetUsersInput = new GetUsersInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsersResult$Type extends MessageType {
    constructor() {
        super("GetUsersResult", [
            { no: 1, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated User users */ 1:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUsersResult
 */
export const GetUsersResult = new GetUsersResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InviteToInlineInput$Type extends MessageType {
    constructor() {
        super("InviteToInlineInput", [
            { no: 1, name: "user_id", kind: "scalar", oneof: "via", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "email", kind: "scalar", oneof: "via", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "phone_number", kind: "scalar", oneof: "via", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.via = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_id */ 1:
                    message.via = {
                        oneofKind: "userId",
                        userId: reader.int64().toBigInt()
                    };
                    break;
                case /* string email */ 2:
                    message.via = {
                        oneofKind: "email",
                        email: reader.string()
                    };
                    break;
                case /* string phone_number */ 3:
                    message.via = {
                        oneofKind: "phoneNumber",
                        phoneNumber: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 user_id = 1; */
        if (message.via.oneofKind === "userId")
            writer.tag(1, WireType.Varint).int64(message.via.userId);
        /* string email = 2; */
        if (message.via.oneofKind === "email")
            writer.tag(2, WireType.LengthDelimited).string(message.via.email);
        /* string phone_number = 3; */
        if (message.via.oneofKind === "phoneNumber")
            writer.tag(3, WireType.LengthDelimited).string(message.via.phoneNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InviteToInlineInput
 */
export const InviteToInlineInput = new InviteToInlineInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InviteToInlineResult$Type extends MessageType {
    constructor() {
        super("InviteToInlineResult", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "chat", kind: "message", T: () => Chat },
            { no: 3, name: "dialog", kind: "message", T: () => Dialog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* Chat chat */ 2:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                case /* Dialog dialog */ 3:
                    message.dialog = Dialog.internalBinaryRead(reader, reader.uint32(), options, message.dialog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Chat chat = 2; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Dialog dialog = 3; */
        if (message.dialog)
            Dialog.internalBinaryWrite(message.dialog, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InviteToInlineResult
 */
export const InviteToInlineResult = new InviteToInlineResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatParticipantsInput$Type extends MessageType {
    constructor() {
        super("GetChatParticipantsInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatParticipantsInput
 */
export const GetChatParticipantsInput = new GetChatParticipantsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChatParticipantsResult$Type extends MessageType {
    constructor() {
        super("GetChatParticipantsResult", [
            { no: 1, name: "participants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ChatParticipant },
            { no: 2, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User },
            { no: 3, name: "group_participants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ChatParticipantGroup },
            { no: 4, name: "groups", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => UserGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.participants = [];
        message.users = [];
        message.groupParticipants = [];
        message.groups = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ChatParticipant participants */ 1:
                    message.participants.push(ChatParticipant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated User users */ 2:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ChatParticipantGroup group_participants */ 3:
                    message.groupParticipants.push(ChatParticipantGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated UserGroup groups */ 4:
                    message.groups.push(UserGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ChatParticipant participants = 1; */
        for (let i = 0; i < message.participants.length; i++)
            ChatParticipant.internalBinaryWrite(message.participants[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 2; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated ChatParticipantGroup group_participants = 3; */
        for (let i = 0; i < message.groupParticipants.length; i++)
            ChatParticipantGroup.internalBinaryWrite(message.groupParticipants[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated UserGroup groups = 4; */
        for (let i = 0; i < message.groups.length; i++)
            UserGroup.internalBinaryWrite(message.groups[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetChatParticipantsResult
 */
export const GetChatParticipantsResult = new GetChatParticipantsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddChatParticipantInput$Type extends MessageType {
    constructor() {
        super("AddChatParticipantInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "group_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* optional int64 group_id */ 3:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional int64 user_id = 2; */
        if (message.userId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* optional int64 group_id = 3; */
        if (message.groupId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddChatParticipantInput
 */
export const AddChatParticipantInput = new AddChatParticipantInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddChatParticipantResult$Type extends MessageType {
    constructor() {
        super("AddChatParticipantResult", [
            { no: 1, name: "participant", kind: "message", T: () => ChatParticipant },
            { no: 2, name: "group_participant", kind: "message", T: () => ChatParticipantGroup },
            { no: 3, name: "group", kind: "message", T: () => UserGroup },
            { no: 4, name: "users", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional ChatParticipant participant */ 1:
                    message.participant = ChatParticipant.internalBinaryRead(reader, reader.uint32(), options, message.participant);
                    break;
                case /* optional ChatParticipantGroup group_participant */ 2:
                    message.groupParticipant = ChatParticipantGroup.internalBinaryRead(reader, reader.uint32(), options, message.groupParticipant);
                    break;
                case /* optional UserGroup group */ 3:
                    message.group = UserGroup.internalBinaryRead(reader, reader.uint32(), options, message.group);
                    break;
                case /* repeated User users */ 4:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional ChatParticipant participant = 1; */
        if (message.participant)
            ChatParticipant.internalBinaryWrite(message.participant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional ChatParticipantGroup group_participant = 2; */
        if (message.groupParticipant)
            ChatParticipantGroup.internalBinaryWrite(message.groupParticipant, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional UserGroup group = 3; */
        if (message.group)
            UserGroup.internalBinaryWrite(message.group, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated User users = 4; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddChatParticipantResult
 */
export const AddChatParticipantResult = new AddChatParticipantResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveChatParticipantInput$Type extends MessageType {
    constructor() {
        super("RemoveChatParticipantInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "group_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* optional int64 group_id */ 3:
                    message.groupId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional int64 user_id = 2; */
        if (message.userId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* optional int64 group_id = 3; */
        if (message.groupId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.groupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveChatParticipantInput
 */
export const RemoveChatParticipantInput = new RemoveChatParticipantInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveChatParticipantResult$Type extends MessageType {
    constructor() {
        super("RemoveChatParticipantResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveChatParticipantResult
 */
export const RemoveChatParticipantResult = new RemoveChatParticipantResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatVisibilityInput$Type extends MessageType {
    constructor() {
        super("UpdateChatVisibilityInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "is_public", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "participants", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => InputChatParticipant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.isPublic = false;
        message.participants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* bool is_public */ 2:
                    message.isPublic = reader.bool();
                    break;
                case /* repeated InputChatParticipant participants */ 3:
                    message.participants.push(InputChatParticipant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* bool is_public = 2; */
        if (message.isPublic !== false)
            writer.tag(2, WireType.Varint).bool(message.isPublic);
        /* repeated InputChatParticipant participants = 3; */
        for (let i = 0; i < message.participants.length; i++)
            InputChatParticipant.internalBinaryWrite(message.participants[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatVisibilityInput
 */
export const UpdateChatVisibilityInput = new UpdateChatVisibilityInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatVisibilityResult$Type extends MessageType {
    constructor() {
        super("UpdateChatVisibilityResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatVisibilityResult
 */
export const UpdateChatVisibilityResult = new UpdateChatVisibilityResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatInfoInput$Type extends MessageType {
    constructor() {
        super("UpdateChatInfoInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "emoji", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "agent_context", kind: "message", T: () => AgentThreadContext }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional string title */ 2:
                    message.title = reader.string();
                    break;
                case /* optional string emoji */ 3:
                    message.emoji = reader.string();
                    break;
                case /* optional AgentThreadContext agent_context */ 4:
                    message.agentContext = AgentThreadContext.internalBinaryRead(reader, reader.uint32(), options, message.agentContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional string title = 2; */
        if (message.title !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* optional string emoji = 3; */
        if (message.emoji !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.emoji);
        /* optional AgentThreadContext agent_context = 4; */
        if (message.agentContext)
            AgentThreadContext.internalBinaryWrite(message.agentContext, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatInfoInput
 */
export const UpdateChatInfoInput = new UpdateChatInfoInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateChatInfoResult$Type extends MessageType {
    constructor() {
        super("UpdateChatInfoResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateChatInfoResult
 */
export const UpdateChatInfoResult = new UpdateChatInfoResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThreadInput$Type extends MessageType {
    constructor() {
        super("MoveThreadInput", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "space_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* optional int64 space_id */ 2:
                    message.spaceId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* optional int64 space_id = 2; */
        if (message.spaceId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.spaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MoveThreadInput
 */
export const MoveThreadInput = new MoveThreadInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThreadResult$Type extends MessageType {
    constructor() {
        super("MoveThreadResult", [
            { no: 1, name: "chat", kind: "message", T: () => Chat }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Chat chat */ 1:
                    message.chat = Chat.internalBinaryRead(reader, reader.uint32(), options, message.chat);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Chat chat = 1; */
        if (message.chat)
            Chat.internalBinaryWrite(message.chat, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MoveThreadResult
 */
export const MoveThreadResult = new MoveThreadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PinMessageInput$Type extends MessageType {
    constructor() {
        super("PinMessageInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "unpin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.messageId = 0n;
        message.unpin = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 message_id */ 2:
                    message.messageId = reader.int64().toBigInt();
                    break;
                case /* bool unpin */ 3:
                    message.unpin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 message_id = 2; */
        if (message.messageId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.messageId);
        /* bool unpin = 3; */
        if (message.unpin !== false)
            writer.tag(3, WireType.Varint).bool(message.unpin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PinMessageInput
 */
export const PinMessageInput = new PinMessageInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PinMessageResult$Type extends MessageType {
    constructor() {
        super("PinMessageResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PinMessageResult
 */
export const PinMessageResult = new PinMessageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DraftMessage$Type extends MessageType {
    constructor() {
        super("DraftMessage", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entities", kind: "message", T: () => MessageEntities }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                case /* optional MessageEntities entities */ 2:
                    message.entities = MessageEntities.internalBinaryRead(reader, reader.uint32(), options, message.entities);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        /* optional MessageEntities entities = 2; */
        if (message.entities)
            MessageEntities.internalBinaryWrite(message.entities, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DraftMessage
 */
export const DraftMessage = new DraftMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentProjectOption$Type extends MessageType {
    constructor() {
        super("AgentProjectOption", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentProjectOption
 */
export const AgentProjectOption = new AgentProjectOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentProjectCatalog$Type extends MessageType {
    constructor() {
        super("AgentProjectCatalog", [
            { no: 1, name: "options", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentProjectOption },
            { no: 2, name: "can_select_folder", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "default_project_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.options = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AgentProjectOption options */ 1:
                    message.options.push(AgentProjectOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool can_select_folder */ 2:
                    message.canSelectFolder = reader.bool();
                    break;
                case /* optional string default_project_id */ 3:
                    message.defaultProjectId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AgentProjectOption options = 1; */
        for (let i = 0; i < message.options.length; i++)
            AgentProjectOption.internalBinaryWrite(message.options[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional bool can_select_folder = 2; */
        if (message.canSelectFolder !== undefined)
            writer.tag(2, WireType.Varint).bool(message.canSelectFolder);
        /* optional string default_project_id = 3; */
        if (message.defaultProjectId !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.defaultProjectId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentProjectCatalog
 */
export const AgentProjectCatalog = new AgentProjectCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentReasoningEffortOption$Type extends MessageType {
    constructor() {
        super("AgentReasoningEffortOption", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentReasoningEffortOption
 */
export const AgentReasoningEffortOption = new AgentReasoningEffortOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentReasoningCatalog$Type extends MessageType {
    constructor() {
        super("AgentReasoningCatalog", [
            { no: 1, name: "options", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentReasoningEffortOption }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.options = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AgentReasoningEffortOption options */ 1:
                    message.options.push(AgentReasoningEffortOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AgentReasoningEffortOption options = 1; */
        for (let i = 0; i < message.options.length; i++)
            AgentReasoningEffortOption.internalBinaryWrite(message.options[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentReasoningCatalog
 */
export const AgentReasoningCatalog = new AgentReasoningCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentModelOption$Type extends MessageType {
    constructor() {
        super("AgentModelOption", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reasoning_effort_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default_reasoning_effort_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.label = "";
        message.reasoningEffortIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated string reasoning_effort_ids */ 4:
                    message.reasoningEffortIds.push(reader.string());
                    break;
                case /* optional string default_reasoning_effort_id */ 5:
                    message.defaultReasoningEffortId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated string reasoning_effort_ids = 4; */
        for (let i = 0; i < message.reasoningEffortIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.reasoningEffortIds[i]);
        /* optional string default_reasoning_effort_id = 5; */
        if (message.defaultReasoningEffortId !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.defaultReasoningEffortId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentModelOption
 */
export const AgentModelOption = new AgentModelOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentModelCatalog$Type extends MessageType {
    constructor() {
        super("AgentModelCatalog", [
            { no: 1, name: "options", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentModelOption },
            { no: 2, name: "default_model_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.options = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated AgentModelOption options */ 1:
                    message.options.push(AgentModelOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string default_model_id */ 2:
                    message.defaultModelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated AgentModelOption options = 1; */
        for (let i = 0; i < message.options.length; i++)
            AgentModelOption.internalBinaryWrite(message.options[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string default_model_id = 2; */
        if (message.defaultModelId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.defaultModelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentModelCatalog
 */
export const AgentModelCatalog = new AgentModelCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentConfigurationCatalog$Type extends MessageType {
    constructor() {
        super("AgentConfigurationCatalog", [
            { no: 1, name: "projects", kind: "message", T: () => AgentProjectCatalog },
            { no: 2, name: "models", kind: "message", T: () => AgentModelCatalog },
            { no: 3, name: "reasoning", kind: "message", T: () => AgentReasoningCatalog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional AgentProjectCatalog projects */ 1:
                    message.projects = AgentProjectCatalog.internalBinaryRead(reader, reader.uint32(), options, message.projects);
                    break;
                case /* optional AgentModelCatalog models */ 2:
                    message.models = AgentModelCatalog.internalBinaryRead(reader, reader.uint32(), options, message.models);
                    break;
                case /* optional AgentReasoningCatalog reasoning */ 3:
                    message.reasoning = AgentReasoningCatalog.internalBinaryRead(reader, reader.uint32(), options, message.reasoning);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional AgentProjectCatalog projects = 1; */
        if (message.projects)
            AgentProjectCatalog.internalBinaryWrite(message.projects, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional AgentModelCatalog models = 2; */
        if (message.models)
            AgentModelCatalog.internalBinaryWrite(message.models, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional AgentReasoningCatalog reasoning = 3; */
        if (message.reasoning)
            AgentReasoningCatalog.internalBinaryWrite(message.reasoning, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AgentConfigurationCatalog
 */
export const AgentConfigurationCatalog = new AgentConfigurationCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotCapability$Type extends MessageType {
    constructor() {
        super("BotCapability", [
            { no: 1, name: "kind", kind: "enum", T: () => ["BotCapability.Kind", BotCapability_Kind] },
            { no: 2, name: "version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "agent_configuration", kind: "message", T: () => AgentConfigurationCatalog }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        message.version = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotCapability.Kind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* uint32 version */ 2:
                    message.version = reader.uint32();
                    break;
                case /* optional AgentConfigurationCatalog agent_configuration */ 3:
                    message.agentConfiguration = AgentConfigurationCatalog.internalBinaryRead(reader, reader.uint32(), options, message.agentConfiguration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotCapability.Kind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* uint32 version = 2; */
        if (message.version !== 0)
            writer.tag(2, WireType.Varint).uint32(message.version);
        /* optional AgentConfigurationCatalog agent_configuration = 3; */
        if (message.agentConfiguration)
            AgentConfigurationCatalog.internalBinaryWrite(message.agentConfiguration, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotCapability
 */
export const BotCapability = new BotCapability$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerBot$Type extends MessageType {
    constructor() {
        super("PeerBot", [
            { no: 1, name: "bot", kind: "message", T: () => User },
            { no: 2, name: "capabilities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCapability },
            { no: 3, name: "agents", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotAgentProfile }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.capabilities = [];
        message.agents = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User bot */ 1:
                    message.bot = User.internalBinaryRead(reader, reader.uint32(), options, message.bot);
                    break;
                case /* repeated BotCapability capabilities */ 2:
                    message.capabilities.push(BotCapability.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated BotAgentProfile agents */ 3:
                    message.agents.push(BotAgentProfile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User bot = 1; */
        if (message.bot)
            User.internalBinaryWrite(message.bot, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated BotCapability capabilities = 2; */
        for (let i = 0; i < message.capabilities.length; i++)
            BotCapability.internalBinaryWrite(message.capabilities[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated BotAgentProfile agents = 3; */
        for (let i = 0; i < message.agents.length; i++)
            BotAgentProfile.internalBinaryWrite(message.agents[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PeerBot
 */
export const PeerBot = new PeerBot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPeerBotsInput$Type extends MessageType {
    constructor() {
        super("GetPeerBotsInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPeerBotsInput
 */
export const GetPeerBotsInput = new GetPeerBotsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPeerBotsResult$Type extends MessageType {
    constructor() {
        super("GetPeerBotsResult", [
            { no: 1, name: "bots", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PeerBot },
            { no: 2, name: "suggested_bot_user_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.bots = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PeerBot bots */ 1:
                    message.bots.push(PeerBot.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional int64 suggested_bot_user_id */ 2:
                    message.suggestedBotUserId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PeerBot bots = 1; */
        for (let i = 0; i < message.bots.length; i++)
            PeerBot.internalBinaryWrite(message.bots[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 suggested_bot_user_id = 2; */
        if (message.suggestedBotUserId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.suggestedBotUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPeerBotsResult
 */
export const GetPeerBotsResult = new GetPeerBotsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyBotCapabilitiesInput$Type extends MessageType {
    constructor() {
        super("GetMyBotCapabilitiesInput", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetMyBotCapabilitiesInput
 */
export const GetMyBotCapabilitiesInput = new GetMyBotCapabilitiesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMyBotCapabilitiesResult$Type extends MessageType {
    constructor() {
        super("GetMyBotCapabilitiesResult", [
            { no: 1, name: "capabilities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCapability }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.capabilities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotCapability capabilities */ 1:
                    message.capabilities.push(BotCapability.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotCapability capabilities = 1; */
        for (let i = 0; i < message.capabilities.length; i++)
            BotCapability.internalBinaryWrite(message.capabilities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetMyBotCapabilitiesResult
 */
export const GetMyBotCapabilitiesResult = new GetMyBotCapabilitiesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetMyBotCapabilitiesInput$Type extends MessageType {
    constructor() {
        super("SetMyBotCapabilitiesInput", [
            { no: 1, name: "capabilities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCapability }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.capabilities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotCapability capabilities */ 1:
                    message.capabilities.push(BotCapability.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotCapability capabilities = 1; */
        for (let i = 0; i < message.capabilities.length; i++)
            BotCapability.internalBinaryWrite(message.capabilities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetMyBotCapabilitiesInput
 */
export const SetMyBotCapabilitiesInput = new SetMyBotCapabilitiesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetMyBotCapabilitiesResult$Type extends MessageType {
    constructor() {
        super("SetMyBotCapabilitiesResult", [
            { no: 1, name: "capabilities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotCapability }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.capabilities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BotCapability capabilities */ 1:
                    message.capabilities.push(BotCapability.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BotCapability capabilities = 1; */
        for (let i = 0; i < message.capabilities.length; i++)
            BotCapability.internalBinaryWrite(message.capabilities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetMyBotCapabilitiesResult
 */
export const SetMyBotCapabilitiesResult = new SetMyBotCapabilitiesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsDocument$Type extends MessageType {
    constructor() {
        super("BotChatSettingsDocument", [
            { no: 1, name: "version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sections", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotChatSettingsSection }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.version = 0;
        message.revision = "";
        message.sections = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 version */ 1:
                    message.version = reader.uint32();
                    break;
                case /* string revision */ 2:
                    message.revision = reader.string();
                    break;
                case /* repeated BotChatSettingsSection sections */ 3:
                    message.sections.push(BotChatSettingsSection.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint32 version = 1; */
        if (message.version !== 0)
            writer.tag(1, WireType.Varint).uint32(message.version);
        /* string revision = 2; */
        if (message.revision !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.revision);
        /* repeated BotChatSettingsSection sections = 3; */
        for (let i = 0; i < message.sections.length; i++)
            BotChatSettingsSection.internalBinaryWrite(message.sections[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsDocument
 */
export const BotChatSettingsDocument = new BotChatSettingsDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsSection$Type extends MessageType {
    constructor() {
        super("BotChatSettingsSection", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotChatSettingsItem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* optional string title */ 2:
                    message.title = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated BotChatSettingsItem items */ 4:
                    message.items.push(BotChatSettingsItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* optional string title = 2; */
        if (message.title !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated BotChatSettingsItem items = 4; */
        for (let i = 0; i < message.items.length; i++)
            BotChatSettingsItem.internalBinaryWrite(message.items[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsSection
 */
export const BotChatSettingsSection = new BotChatSettingsSection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsItem$Type extends MessageType {
    constructor() {
        super("BotChatSettingsItem", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "disabled_reason", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "toggle", kind: "message", oneof: "control", T: () => BotChatSettingsToggle },
            { no: 7, name: "select", kind: "message", oneof: "control", T: () => BotChatSettingsSelect },
            { no: 8, name: "info", kind: "message", oneof: "control", T: () => BotChatSettingsInfo },
            { no: 9, name: "button", kind: "message", oneof: "control", T: () => BotChatSettingsButton },
            { no: 10, name: "folder", kind: "message", oneof: "control", T: () => BotChatSettingsFolder }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.disabled = false;
        message.control = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* optional string label */ 2:
                    message.label = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool disabled */ 4:
                    message.disabled = reader.bool();
                    break;
                case /* optional string disabled_reason */ 5:
                    message.disabledReason = reader.string();
                    break;
                case /* BotChatSettingsToggle toggle */ 6:
                    message.control = {
                        oneofKind: "toggle",
                        toggle: BotChatSettingsToggle.internalBinaryRead(reader, reader.uint32(), options, message.control.toggle)
                    };
                    break;
                case /* BotChatSettingsSelect select */ 7:
                    message.control = {
                        oneofKind: "select",
                        select: BotChatSettingsSelect.internalBinaryRead(reader, reader.uint32(), options, message.control.select)
                    };
                    break;
                case /* BotChatSettingsInfo info */ 8:
                    message.control = {
                        oneofKind: "info",
                        info: BotChatSettingsInfo.internalBinaryRead(reader, reader.uint32(), options, message.control.info)
                    };
                    break;
                case /* BotChatSettingsButton button */ 9:
                    message.control = {
                        oneofKind: "button",
                        button: BotChatSettingsButton.internalBinaryRead(reader, reader.uint32(), options, message.control.button)
                    };
                    break;
                case /* BotChatSettingsFolder folder */ 10:
                    message.control = {
                        oneofKind: "folder",
                        folder: BotChatSettingsFolder.internalBinaryRead(reader, reader.uint32(), options, message.control.folder)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* optional string label = 2; */
        if (message.label !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool disabled = 4; */
        if (message.disabled !== false)
            writer.tag(4, WireType.Varint).bool(message.disabled);
        /* optional string disabled_reason = 5; */
        if (message.disabledReason !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.disabledReason);
        /* BotChatSettingsToggle toggle = 6; */
        if (message.control.oneofKind === "toggle")
            BotChatSettingsToggle.internalBinaryWrite(message.control.toggle, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* BotChatSettingsSelect select = 7; */
        if (message.control.oneofKind === "select")
            BotChatSettingsSelect.internalBinaryWrite(message.control.select, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* BotChatSettingsInfo info = 8; */
        if (message.control.oneofKind === "info")
            BotChatSettingsInfo.internalBinaryWrite(message.control.info, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* BotChatSettingsButton button = 9; */
        if (message.control.oneofKind === "button")
            BotChatSettingsButton.internalBinaryWrite(message.control.button, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* BotChatSettingsFolder folder = 10; */
        if (message.control.oneofKind === "folder")
            BotChatSettingsFolder.internalBinaryWrite(message.control.folder, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsItem
 */
export const BotChatSettingsItem = new BotChatSettingsItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsToggle$Type extends MessageType {
    constructor() {
        super("BotChatSettingsToggle", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsToggle
 */
export const BotChatSettingsToggle = new BotChatSettingsToggle$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsSelect$Type extends MessageType {
    constructor() {
        super("BotChatSettingsSelect", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "options", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotChatSettingsSelectOption }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = "";
        message.options = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* repeated BotChatSettingsSelectOption options */ 2:
                    message.options.push(BotChatSettingsSelectOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* repeated BotChatSettingsSelectOption options = 2; */
        for (let i = 0; i < message.options.length; i++)
            BotChatSettingsSelectOption.internalBinaryWrite(message.options[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsSelect
 */
export const BotChatSettingsSelect = new BotChatSettingsSelect$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsSelectOption$Type extends MessageType {
    constructor() {
        super("BotChatSettingsSelectOption", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = "";
        message.label = "";
        message.disabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* optional string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool disabled */ 4:
                    message.disabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* optional string description = 3; */
        if (message.description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool disabled = 4; */
        if (message.disabled !== false)
            writer.tag(4, WireType.Varint).bool(message.disabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsSelectOption
 */
export const BotChatSettingsSelectOption = new BotChatSettingsSelectOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsInfo$Type extends MessageType {
    constructor() {
        super("BotChatSettingsInfo", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tone", kind: "enum", T: () => ["BotChatSettingsInfo.Tone", BotChatSettingsInfo_Tone] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.text = "";
        message.tone = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string text */ 1:
                    message.text = reader.string();
                    break;
                case /* BotChatSettingsInfo.Tone tone */ 2:
                    message.tone = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string text = 1; */
        if (message.text !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.text);
        /* BotChatSettingsInfo.Tone tone = 2; */
        if (message.tone !== 0)
            writer.tag(2, WireType.Varint).int32(message.tone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsInfo
 */
export const BotChatSettingsInfo = new BotChatSettingsInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsButton$Type extends MessageType {
    constructor() {
        super("BotChatSettingsButton", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsButton
 */
export const BotChatSettingsButton = new BotChatSettingsButton$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsFolder$Type extends MessageType {
    constructor() {
        super("BotChatSettingsFolder", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "recent_folders", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BotChatSettingsFolderOption },
            { no: 3, name: "host_installation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "host_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "allows_local_picker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "local_picker_port", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "local_picker_capability", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = "";
        message.recentFolders = [];
        message.hostInstallationId = "";
        message.hostLabel = "";
        message.allowsLocalPicker = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* repeated BotChatSettingsFolderOption recent_folders */ 2:
                    message.recentFolders.push(BotChatSettingsFolderOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string host_installation_id */ 3:
                    message.hostInstallationId = reader.string();
                    break;
                case /* string host_label */ 4:
                    message.hostLabel = reader.string();
                    break;
                case /* bool allows_local_picker */ 5:
                    message.allowsLocalPicker = reader.bool();
                    break;
                case /* optional uint32 local_picker_port */ 6:
                    message.localPickerPort = reader.uint32();
                    break;
                case /* optional string local_picker_capability */ 7:
                    message.localPickerCapability = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* repeated BotChatSettingsFolderOption recent_folders = 2; */
        for (let i = 0; i < message.recentFolders.length; i++)
            BotChatSettingsFolderOption.internalBinaryWrite(message.recentFolders[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string host_installation_id = 3; */
        if (message.hostInstallationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.hostInstallationId);
        /* string host_label = 4; */
        if (message.hostLabel !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.hostLabel);
        /* bool allows_local_picker = 5; */
        if (message.allowsLocalPicker !== false)
            writer.tag(5, WireType.Varint).bool(message.allowsLocalPicker);
        /* optional uint32 local_picker_port = 6; */
        if (message.localPickerPort !== undefined)
            writer.tag(6, WireType.Varint).uint32(message.localPickerPort);
        /* optional string local_picker_capability = 7; */
        if (message.localPickerCapability !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.localPickerCapability);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsFolder
 */
export const BotChatSettingsFolder = new BotChatSettingsFolder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsFolderOption$Type extends MessageType {
    constructor() {
        super("BotChatSettingsFolderOption", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_hint", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = "";
        message.label = "";
        message.disabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* optional string parent_hint */ 3:
                    message.parentHint = reader.string();
                    break;
                case /* bool disabled */ 4:
                    message.disabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* optional string parent_hint = 3; */
        if (message.parentHint !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.parentHint);
        /* bool disabled = 4; */
        if (message.disabled !== false)
            writer.tag(4, WireType.Varint).bool(message.disabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsFolderOption
 */
export const BotChatSettingsFolderOption = new BotChatSettingsFolderOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsValue$Type extends MessageType {
    constructor() {
        super("BotChatSettingsValue", [
            { no: 1, name: "bool_value", kind: "scalar", oneof: "value", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool bool_value */ 1:
                    message.value = {
                        oneofKind: "boolValue",
                        boolValue: reader.bool()
                    };
                    break;
                case /* string string_value */ 2:
                    message.value = {
                        oneofKind: "stringValue",
                        stringValue: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool bool_value = 1; */
        if (message.value.oneofKind === "boolValue")
            writer.tag(1, WireType.Varint).bool(message.value.boolValue);
        /* string string_value = 2; */
        if (message.value.oneofKind === "stringValue")
            writer.tag(2, WireType.LengthDelimited).string(message.value.stringValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsValue
 */
export const BotChatSettingsValue = new BotChatSettingsValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsProblem$Type extends MessageType {
    constructor() {
        super("BotChatSettingsProblem", [
            { no: 1, name: "code", kind: "enum", T: () => ["BotChatSettingsProblem.Code", BotChatSettingsProblem_Code] },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_document", kind: "message", T: () => BotChatSettingsDocument }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.code = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotChatSettingsProblem.Code code */ 1:
                    message.code = reader.int32();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                case /* optional BotChatSettingsDocument current_document */ 3:
                    message.currentDocument = BotChatSettingsDocument.internalBinaryRead(reader, reader.uint32(), options, message.currentDocument);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotChatSettingsProblem.Code code = 1; */
        if (message.code !== 0)
            writer.tag(1, WireType.Varint).int32(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        /* optional BotChatSettingsDocument current_document = 3; */
        if (message.currentDocument)
            BotChatSettingsDocument.internalBinaryWrite(message.currentDocument, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsProblem
 */
export const BotChatSettingsProblem = new BotChatSettingsProblem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsResponse$Type extends MessageType {
    constructor() {
        super("BotChatSettingsResponse", [
            { no: 1, name: "document", kind: "message", oneof: "result", T: () => BotChatSettingsDocument },
            { no: 2, name: "problem", kind: "message", oneof: "result", T: () => BotChatSettingsProblem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.result = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotChatSettingsDocument document */ 1:
                    message.result = {
                        oneofKind: "document",
                        document: BotChatSettingsDocument.internalBinaryRead(reader, reader.uint32(), options, message.result.document)
                    };
                    break;
                case /* BotChatSettingsProblem problem */ 2:
                    message.result = {
                        oneofKind: "problem",
                        problem: BotChatSettingsProblem.internalBinaryRead(reader, reader.uint32(), options, message.result.problem)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotChatSettingsDocument document = 1; */
        if (message.result.oneofKind === "document")
            BotChatSettingsDocument.internalBinaryWrite(message.result.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* BotChatSettingsProblem problem = 2; */
        if (message.result.oneofKind === "problem")
            BotChatSettingsProblem.internalBinaryWrite(message.result.problem, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsResponse
 */
export const BotChatSettingsResponse = new BotChatSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestBotChatSettingsInput$Type extends MessageType {
    constructor() {
        super("RequestBotChatSettingsInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.version = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 bot_user_id */ 2:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* uint32 version */ 3:
                    message.version = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 bot_user_id = 2; */
        if (message.botUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.botUserId);
        /* uint32 version = 3; */
        if (message.version !== 0)
            writer.tag(3, WireType.Varint).uint32(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RequestBotChatSettingsInput
 */
export const RequestBotChatSettingsInput = new RequestBotChatSettingsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestBotChatSettingsResult$Type extends MessageType {
    constructor() {
        super("RequestBotChatSettingsResult", [
            { no: 1, name: "response", kind: "message", T: () => BotChatSettingsResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotChatSettingsResponse response */ 1:
                    message.response = BotChatSettingsResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotChatSettingsResponse response = 1; */
        if (message.response)
            BotChatSettingsResponse.internalBinaryWrite(message.response, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RequestBotChatSettingsResult
 */
export const RequestBotChatSettingsResult = new RequestBotChatSettingsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeBotChatSettingsItemInput$Type extends MessageType {
    constructor() {
        super("InvokeBotChatSettingsItemInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "bot_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "value", kind: "message", T: () => BotChatSettingsValue },
            { no: 6, name: "document_revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.botUserId = 0n;
        message.version = 0;
        message.itemId = "";
        message.documentRevision = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 bot_user_id */ 2:
                    message.botUserId = reader.int64().toBigInt();
                    break;
                case /* uint32 version */ 3:
                    message.version = reader.uint32();
                    break;
                case /* string item_id */ 4:
                    message.itemId = reader.string();
                    break;
                case /* optional BotChatSettingsValue value */ 5:
                    message.value = BotChatSettingsValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* string document_revision */ 6:
                    message.documentRevision = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 bot_user_id = 2; */
        if (message.botUserId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.botUserId);
        /* uint32 version = 3; */
        if (message.version !== 0)
            writer.tag(3, WireType.Varint).uint32(message.version);
        /* string item_id = 4; */
        if (message.itemId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.itemId);
        /* optional BotChatSettingsValue value = 5; */
        if (message.value)
            BotChatSettingsValue.internalBinaryWrite(message.value, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string document_revision = 6; */
        if (message.documentRevision !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.documentRevision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvokeBotChatSettingsItemInput
 */
export const InvokeBotChatSettingsItemInput = new InvokeBotChatSettingsItemInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvokeBotChatSettingsItemResult$Type extends MessageType {
    constructor() {
        super("InvokeBotChatSettingsItemResult", [
            { no: 1, name: "response", kind: "message", T: () => BotChatSettingsResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* BotChatSettingsResponse response */ 1:
                    message.response = BotChatSettingsResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* BotChatSettingsResponse response = 1; */
        if (message.response)
            BotChatSettingsResponse.internalBinaryWrite(message.response, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvokeBotChatSettingsItemResult
 */
export const InvokeBotChatSettingsItemResult = new InvokeBotChatSettingsItemResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnswerBotChatSettingsInput$Type extends MessageType {
    constructor() {
        super("AnswerBotChatSettingsInput", [
            { no: 1, name: "request_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "response", kind: "message", T: () => BotChatSettingsResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.requestId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 request_id */ 1:
                    message.requestId = reader.uint64().toBigInt();
                    break;
                case /* BotChatSettingsResponse response */ 2:
                    message.response = BotChatSettingsResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 request_id = 1; */
        if (message.requestId !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.requestId);
        /* BotChatSettingsResponse response = 2; */
        if (message.response)
            BotChatSettingsResponse.internalBinaryWrite(message.response, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AnswerBotChatSettingsInput
 */
export const AnswerBotChatSettingsInput = new AnswerBotChatSettingsInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnswerBotChatSettingsResult$Type extends MessageType {
    constructor() {
        super("AnswerBotChatSettingsResult", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AnswerBotChatSettingsResult
 */
export const AnswerBotChatSettingsResult = new AnswerBotChatSettingsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsRequested$Type extends MessageType {
    constructor() {
        super("BotChatSettingsRequested", [
            { no: 1, name: "request_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "actor_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.requestId = 0n;
        message.chatId = 0n;
        message.actorUserId = 0n;
        message.version = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 request_id */ 1:
                    message.requestId = reader.uint64().toBigInt();
                    break;
                case /* int64 chat_id */ 2:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 actor_user_id */ 3:
                    message.actorUserId = reader.int64().toBigInt();
                    break;
                case /* uint32 version */ 4:
                    message.version = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 request_id = 1; */
        if (message.requestId !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.requestId);
        /* int64 chat_id = 2; */
        if (message.chatId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.chatId);
        /* int64 actor_user_id = 3; */
        if (message.actorUserId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.actorUserId);
        /* uint32 version = 4; */
        if (message.version !== 0)
            writer.tag(4, WireType.Varint).uint32(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsRequested
 */
export const BotChatSettingsRequested = new BotChatSettingsRequested$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BotChatSettingsItemInvoked$Type extends MessageType {
    constructor() {
        super("BotChatSettingsItemInvoked", [
            { no: 1, name: "request_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "actor_user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "value", kind: "message", T: () => BotChatSettingsValue },
            { no: 7, name: "document_revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.requestId = 0n;
        message.chatId = 0n;
        message.actorUserId = 0n;
        message.version = 0;
        message.itemId = "";
        message.documentRevision = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 request_id */ 1:
                    message.requestId = reader.uint64().toBigInt();
                    break;
                case /* int64 chat_id */ 2:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 actor_user_id */ 3:
                    message.actorUserId = reader.int64().toBigInt();
                    break;
                case /* uint32 version */ 4:
                    message.version = reader.uint32();
                    break;
                case /* string item_id */ 5:
                    message.itemId = reader.string();
                    break;
                case /* optional BotChatSettingsValue value */ 6:
                    message.value = BotChatSettingsValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* string document_revision */ 7:
                    message.documentRevision = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 request_id = 1; */
        if (message.requestId !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.requestId);
        /* int64 chat_id = 2; */
        if (message.chatId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.chatId);
        /* int64 actor_user_id = 3; */
        if (message.actorUserId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.actorUserId);
        /* uint32 version = 4; */
        if (message.version !== 0)
            writer.tag(4, WireType.Varint).uint32(message.version);
        /* string item_id = 5; */
        if (message.itemId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.itemId);
        /* optional BotChatSettingsValue value = 6; */
        if (message.value)
            BotChatSettingsValue.internalBinaryWrite(message.value, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string document_revision = 7; */
        if (message.documentRevision !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.documentRevision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BotChatSettingsItemInvoked
 */
export const BotChatSettingsItemInvoked = new BotChatSettingsItemInvoked$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RealtimeV3Request$Type extends MessageType {
    constructor() {
        super("RealtimeV3Request", [
            { no: 1, name: "rpc", kind: "message", oneof: "body", T: () => RpcCall },
            { no: 2, name: "auth_begin", kind: "message", oneof: "body", T: () => AuthBeginRequest },
            { no: 3, name: "auth_complete", kind: "message", oneof: "body", T: () => AuthCompleteRequest },
            { no: 4, name: "create_http_upload", kind: "message", oneof: "body", T: () => CreateHttpUploadRequest },
            { no: 5, name: "finish_http_upload", kind: "message", oneof: "body", T: () => FinishHttpUploadRequest },
            { no: 6, name: "connection_init", kind: "message", oneof: "body", T: () => ConnectionInit },
            { no: 7, name: "auth_begin_browser", kind: "message", oneof: "body", T: () => AuthBeginBrowserRequest },
            { no: 8, name: "auth_browser_status", kind: "message", oneof: "body", T: () => AuthBrowserStatusRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.body = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* RpcCall rpc */ 1:
                    message.body = {
                        oneofKind: "rpc",
                        rpc: RpcCall.internalBinaryRead(reader, reader.uint32(), options, message.body.rpc)
                    };
                    break;
                case /* AuthBeginRequest auth_begin */ 2:
                    message.body = {
                        oneofKind: "authBegin",
                        authBegin: AuthBeginRequest.internalBinaryRead(reader, reader.uint32(), options, message.body.authBegin)
                    };
                    break;
                case /* AuthCompleteRequest auth_complete */ 3:
                    message.body = {
                        oneofKind: "authComplete",
                        authComplete: AuthCompleteRequest.internalBinaryRead(reader, reader.uint32(), options, message.body.authComplete)
                    };
                    break;
                case /* CreateHttpUploadRequest create_http_upload = 4 [deprecated = true];*/ 4:
                    message.body = {
                        oneofKind: "createHttpUpload",
                        createHttpUpload: CreateHttpUploadRequest.internalBinaryRead(reader, reader.uint32(), options, message.body.createHttpUpload)
                    };
                    break;
                case /* FinishHttpUploadRequest finish_http_upload = 5 [deprecated = true];*/ 5:
                    message.body = {
                        oneofKind: "finishHttpUpload",
                        finishHttpUpload: FinishHttpUploadRequest.internalBinaryRead(reader, reader.uint32(), options, message.body.finishHttpUpload)
                    };
                    break;
                case /* ConnectionInit connection_init */ 6:
                    message.body = {
                        oneofKind: "connectionInit",
                        connectionInit: ConnectionInit.internalBinaryRead(reader, reader.uint32(), options, message.body.connectionInit)
                    };
                    break;
                case /* AuthBeginBrowserRequest auth_begin_browser */ 7:
                    message.body = {
                        oneofKind: "authBeginBrowser",
                        authBeginBrowser: AuthBeginBrowserRequest.internalBinaryRead(reader, reader.uint32(), options, message.body.authBeginBrowser)
                    };
                    break;
                case /* AuthBrowserStatusRequest auth_browser_status */ 8:
                    message.body = {
                        oneofKind: "authBrowserStatus",
                        authBrowserStatus: AuthBrowserStatusRequest.internalBinaryRead(reader, reader.uint32(), options, message.body.authBrowserStatus)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* RpcCall rpc = 1; */
        if (message.body.oneofKind === "rpc")
            RpcCall.internalBinaryWrite(message.body.rpc, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* AuthBeginRequest auth_begin = 2; */
        if (message.body.oneofKind === "authBegin")
            AuthBeginRequest.internalBinaryWrite(message.body.authBegin, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* AuthCompleteRequest auth_complete = 3; */
        if (message.body.oneofKind === "authComplete")
            AuthCompleteRequest.internalBinaryWrite(message.body.authComplete, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* CreateHttpUploadRequest create_http_upload = 4 [deprecated = true]; */
        if (message.body.oneofKind === "createHttpUpload")
            CreateHttpUploadRequest.internalBinaryWrite(message.body.createHttpUpload, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* FinishHttpUploadRequest finish_http_upload = 5 [deprecated = true]; */
        if (message.body.oneofKind === "finishHttpUpload")
            FinishHttpUploadRequest.internalBinaryWrite(message.body.finishHttpUpload, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ConnectionInit connection_init = 6; */
        if (message.body.oneofKind === "connectionInit")
            ConnectionInit.internalBinaryWrite(message.body.connectionInit, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* AuthBeginBrowserRequest auth_begin_browser = 7; */
        if (message.body.oneofKind === "authBeginBrowser")
            AuthBeginBrowserRequest.internalBinaryWrite(message.body.authBeginBrowser, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* AuthBrowserStatusRequest auth_browser_status = 8; */
        if (message.body.oneofKind === "authBrowserStatus")
            AuthBrowserStatusRequest.internalBinaryWrite(message.body.authBrowserStatus, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RealtimeV3Request
 */
export const RealtimeV3Request = new RealtimeV3Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RealtimeV3Response$Type extends MessageType {
    constructor() {
        super("RealtimeV3Response", [
            { no: 1, name: "rpc_result", kind: "message", oneof: "body", T: () => RpcResult },
            { no: 2, name: "rpc_error", kind: "message", oneof: "body", T: () => RpcError },
            { no: 3, name: "auth_begin", kind: "message", oneof: "body", T: () => AuthBeginResult },
            { no: 4, name: "auth_complete", kind: "message", oneof: "body", T: () => AuthCompleteResult },
            { no: 5, name: "create_http_upload", kind: "message", oneof: "body", T: () => CreateHttpUploadResult },
            { no: 6, name: "finish_http_upload", kind: "message", oneof: "body", T: () => FinishHttpUploadResult },
            { no: 7, name: "auth_begin_browser", kind: "message", oneof: "body", T: () => AuthBeginBrowserResult },
            { no: 8, name: "auth_browser_status", kind: "message", oneof: "body", T: () => AuthBrowserStatusResult }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.body = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* RpcResult rpc_result */ 1:
                    message.body = {
                        oneofKind: "rpcResult",
                        rpcResult: RpcResult.internalBinaryRead(reader, reader.uint32(), options, message.body.rpcResult)
                    };
                    break;
                case /* RpcError rpc_error */ 2:
                    message.body = {
                        oneofKind: "rpcError",
                        rpcError: RpcError.internalBinaryRead(reader, reader.uint32(), options, message.body.rpcError)
                    };
                    break;
                case /* AuthBeginResult auth_begin */ 3:
                    message.body = {
                        oneofKind: "authBegin",
                        authBegin: AuthBeginResult.internalBinaryRead(reader, reader.uint32(), options, message.body.authBegin)
                    };
                    break;
                case /* AuthCompleteResult auth_complete */ 4:
                    message.body = {
                        oneofKind: "authComplete",
                        authComplete: AuthCompleteResult.internalBinaryRead(reader, reader.uint32(), options, message.body.authComplete)
                    };
                    break;
                case /* CreateHttpUploadResult create_http_upload = 5 [deprecated = true];*/ 5:
                    message.body = {
                        oneofKind: "createHttpUpload",
                        createHttpUpload: CreateHttpUploadResult.internalBinaryRead(reader, reader.uint32(), options, message.body.createHttpUpload)
                    };
                    break;
                case /* FinishHttpUploadResult finish_http_upload = 6 [deprecated = true];*/ 6:
                    message.body = {
                        oneofKind: "finishHttpUpload",
                        finishHttpUpload: FinishHttpUploadResult.internalBinaryRead(reader, reader.uint32(), options, message.body.finishHttpUpload)
                    };
                    break;
                case /* AuthBeginBrowserResult auth_begin_browser */ 7:
                    message.body = {
                        oneofKind: "authBeginBrowser",
                        authBeginBrowser: AuthBeginBrowserResult.internalBinaryRead(reader, reader.uint32(), options, message.body.authBeginBrowser)
                    };
                    break;
                case /* AuthBrowserStatusResult auth_browser_status */ 8:
                    message.body = {
                        oneofKind: "authBrowserStatus",
                        authBrowserStatus: AuthBrowserStatusResult.internalBinaryRead(reader, reader.uint32(), options, message.body.authBrowserStatus)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* RpcResult rpc_result = 1; */
        if (message.body.oneofKind === "rpcResult")
            RpcResult.internalBinaryWrite(message.body.rpcResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* RpcError rpc_error = 2; */
        if (message.body.oneofKind === "rpcError")
            RpcError.internalBinaryWrite(message.body.rpcError, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* AuthBeginResult auth_begin = 3; */
        if (message.body.oneofKind === "authBegin")
            AuthBeginResult.internalBinaryWrite(message.body.authBegin, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* AuthCompleteResult auth_complete = 4; */
        if (message.body.oneofKind === "authComplete")
            AuthCompleteResult.internalBinaryWrite(message.body.authComplete, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* CreateHttpUploadResult create_http_upload = 5 [deprecated = true]; */
        if (message.body.oneofKind === "createHttpUpload")
            CreateHttpUploadResult.internalBinaryWrite(message.body.createHttpUpload, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* FinishHttpUploadResult finish_http_upload = 6 [deprecated = true]; */
        if (message.body.oneofKind === "finishHttpUpload")
            FinishHttpUploadResult.internalBinaryWrite(message.body.finishHttpUpload, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* AuthBeginBrowserResult auth_begin_browser = 7; */
        if (message.body.oneofKind === "authBeginBrowser")
            AuthBeginBrowserResult.internalBinaryWrite(message.body.authBeginBrowser, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* AuthBrowserStatusResult auth_browser_status = 8; */
        if (message.body.oneofKind === "authBrowserStatus")
            AuthBrowserStatusResult.internalBinaryWrite(message.body.authBrowserStatus, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RealtimeV3Response
 */
export const RealtimeV3Response = new RealtimeV3Response$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RealtimeV3Update$Type extends MessageType {
    constructor() {
        super("RealtimeV3Update", [
            { no: 1, name: "message", kind: "message", T: () => ServerMessage }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ServerMessage message */ 1:
                    message.message = ServerMessage.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ServerMessage message = 1; */
        if (message.message)
            ServerMessage.internalBinaryWrite(message.message, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RealtimeV3Update
 */
export const RealtimeV3Update = new RealtimeV3Update$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClientInfo$Type extends MessageType {
    constructor() {
        super("ClientInfo", [
            { no: 1, name: "device_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "os_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "device_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* optional string client_type */ 2:
                    message.clientType = reader.string();
                    break;
                case /* optional string client_version */ 3:
                    message.clientVersion = reader.string();
                    break;
                case /* optional string os_version */ 4:
                    message.osVersion = reader.string();
                    break;
                case /* optional string device_name */ 5:
                    message.deviceName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* optional string device_id = 1; */
        if (message.deviceId !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* optional string client_type = 2; */
        if (message.clientType !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientType);
        /* optional string client_version = 3; */
        if (message.clientVersion !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.clientVersion);
        /* optional string os_version = 4; */
        if (message.osVersion !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.osVersion);
        /* optional string device_name = 5; */
        if (message.deviceName !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.deviceName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClientInfo
 */
export const ClientInfo = new ClientInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBeginRequest$Type extends MessageType {
    constructor() {
        super("AuthBeginRequest", [
            { no: 1, name: "email", kind: "scalar", oneof: "identifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "phone_number", kind: "scalar", oneof: "identifier", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client", kind: "message", T: () => ClientInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.identifier = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.identifier = {
                        oneofKind: "email",
                        email: reader.string()
                    };
                    break;
                case /* string phone_number */ 2:
                    message.identifier = {
                        oneofKind: "phoneNumber",
                        phoneNumber: reader.string()
                    };
                    break;
                case /* ClientInfo client */ 3:
                    message.client = ClientInfo.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.identifier.oneofKind === "email")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier.email);
        /* string phone_number = 2; */
        if (message.identifier.oneofKind === "phoneNumber")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier.phoneNumber);
        /* ClientInfo client = 3; */
        if (message.client)
            ClientInfo.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBeginRequest
 */
export const AuthBeginRequest = new AuthBeginRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBeginResult$Type extends MessageType {
    constructor() {
        super("AuthBeginResult", [
            { no: 1, name: "challenge_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "delivery", kind: "enum", T: () => ["AuthBeginResult.Delivery", AuthBeginResult_Delivery] },
            { no: 3, name: "expires_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "retry_after_seconds", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.challengeId = new Uint8Array(0);
        message.delivery = 0;
        message.expiresAt = 0n;
        message.retryAfterSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes challenge_id */ 1:
                    message.challengeId = reader.bytes();
                    break;
                case /* AuthBeginResult.Delivery delivery */ 2:
                    message.delivery = reader.int32();
                    break;
                case /* int64 expires_at */ 3:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                case /* uint32 retry_after_seconds */ 4:
                    message.retryAfterSeconds = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes challenge_id = 1; */
        if (message.challengeId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.challengeId);
        /* AuthBeginResult.Delivery delivery = 2; */
        if (message.delivery !== 0)
            writer.tag(2, WireType.Varint).int32(message.delivery);
        /* int64 expires_at = 3; */
        if (message.expiresAt !== 0n)
            writer.tag(3, WireType.Varint).int64(message.expiresAt);
        /* uint32 retry_after_seconds = 4; */
        if (message.retryAfterSeconds !== 0)
            writer.tag(4, WireType.Varint).uint32(message.retryAfterSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBeginResult
 */
export const AuthBeginResult = new AuthBeginResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthCompleteRequest$Type extends MessageType {
    constructor() {
        super("AuthCompleteRequest", [
            { no: 1, name: "challenge_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "invite_code", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "time_zone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.challengeId = new Uint8Array(0);
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes challenge_id */ 1:
                    message.challengeId = reader.bytes();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                case /* optional string invite_code */ 3:
                    message.inviteCode = reader.string();
                    break;
                case /* optional string time_zone */ 4:
                    message.timeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes challenge_id = 1; */
        if (message.challengeId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.challengeId);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        /* optional string invite_code = 3; */
        if (message.inviteCode !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.inviteCode);
        /* optional string time_zone = 4; */
        if (message.timeZone !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.timeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthCompleteRequest
 */
export const AuthCompleteRequest = new AuthCompleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthAuthorized$Type extends MessageType {
    constructor() {
        super("AuthAuthorized", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "account_session_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.accountSessionId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* int64 account_session_id */ 2:
                    message.accountSessionId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 account_session_id = 2; */
        if (message.accountSessionId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.accountSessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthAuthorized
 */
export const AuthAuthorized = new AuthAuthorized$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthInviteRequired$Type extends MessageType {
    constructor() {
        super("AuthInviteRequired", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthInviteRequired
 */
export const AuthInviteRequired = new AuthInviteRequired$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthCompleteResult$Type extends MessageType {
    constructor() {
        super("AuthCompleteResult", [
            { no: 1, name: "authorized", kind: "message", oneof: "state", T: () => AuthAuthorized },
            { no: 2, name: "invite_required", kind: "message", oneof: "state", T: () => AuthInviteRequired }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AuthAuthorized authorized */ 1:
                    message.state = {
                        oneofKind: "authorized",
                        authorized: AuthAuthorized.internalBinaryRead(reader, reader.uint32(), options, message.state.authorized)
                    };
                    break;
                case /* AuthInviteRequired invite_required */ 2:
                    message.state = {
                        oneofKind: "inviteRequired",
                        inviteRequired: AuthInviteRequired.internalBinaryRead(reader, reader.uint32(), options, message.state.inviteRequired)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AuthAuthorized authorized = 1; */
        if (message.state.oneofKind === "authorized")
            AuthAuthorized.internalBinaryWrite(message.state.authorized, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* AuthInviteRequired invite_required = 2; */
        if (message.state.oneofKind === "inviteRequired")
            AuthInviteRequired.internalBinaryWrite(message.state.inviteRequired, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthCompleteResult
 */
export const AuthCompleteResult = new AuthCompleteResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBeginBrowserRequest$Type extends MessageType {
    constructor() {
        super("AuthBeginBrowserRequest", [
            { no: 1, name: "client", kind: "message", T: () => ClientInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ClientInfo client */ 1:
                    message.client = ClientInfo.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ClientInfo client = 1; */
        if (message.client)
            ClientInfo.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBeginBrowserRequest
 */
export const AuthBeginBrowserRequest = new AuthBeginBrowserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBeginBrowserResult$Type extends MessageType {
    constructor() {
        super("AuthBeginBrowserResult", [
            { no: 1, name: "login_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "browser_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "verification_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expires_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.loginTransactionId = "";
        message.browserUrl = "";
        message.verificationCode = "";
        message.expiresAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string login_transaction_id */ 1:
                    message.loginTransactionId = reader.string();
                    break;
                case /* string browser_url */ 2:
                    message.browserUrl = reader.string();
                    break;
                case /* string verification_code */ 3:
                    message.verificationCode = reader.string();
                    break;
                case /* int64 expires_at */ 4:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string login_transaction_id = 1; */
        if (message.loginTransactionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.loginTransactionId);
        /* string browser_url = 2; */
        if (message.browserUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.browserUrl);
        /* string verification_code = 3; */
        if (message.verificationCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.verificationCode);
        /* int64 expires_at = 4; */
        if (message.expiresAt !== 0n)
            writer.tag(4, WireType.Varint).int64(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBeginBrowserResult
 */
export const AuthBeginBrowserResult = new AuthBeginBrowserResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBrowserStatusRequest$Type extends MessageType {
    constructor() {
        super("AuthBrowserStatusRequest", [
            { no: 1, name: "login_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.loginTransactionId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string login_transaction_id */ 1:
                    message.loginTransactionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string login_transaction_id = 1; */
        if (message.loginTransactionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.loginTransactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBrowserStatusRequest
 */
export const AuthBrowserStatusRequest = new AuthBrowserStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBrowserStatusResult$Type extends MessageType {
    constructor() {
        super("AuthBrowserStatusResult", [
            { no: 1, name: "pending", kind: "message", oneof: "state", T: () => AuthBrowserPending },
            { no: 2, name: "authorized", kind: "message", oneof: "state", T: () => AuthAuthorized },
            { no: 3, name: "cancelled", kind: "message", oneof: "state", T: () => AuthBrowserCancelled }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* AuthBrowserPending pending */ 1:
                    message.state = {
                        oneofKind: "pending",
                        pending: AuthBrowserPending.internalBinaryRead(reader, reader.uint32(), options, message.state.pending)
                    };
                    break;
                case /* AuthAuthorized authorized */ 2:
                    message.state = {
                        oneofKind: "authorized",
                        authorized: AuthAuthorized.internalBinaryRead(reader, reader.uint32(), options, message.state.authorized)
                    };
                    break;
                case /* AuthBrowserCancelled cancelled */ 3:
                    message.state = {
                        oneofKind: "cancelled",
                        cancelled: AuthBrowserCancelled.internalBinaryRead(reader, reader.uint32(), options, message.state.cancelled)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* AuthBrowserPending pending = 1; */
        if (message.state.oneofKind === "pending")
            AuthBrowserPending.internalBinaryWrite(message.state.pending, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* AuthAuthorized authorized = 2; */
        if (message.state.oneofKind === "authorized")
            AuthAuthorized.internalBinaryWrite(message.state.authorized, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* AuthBrowserCancelled cancelled = 3; */
        if (message.state.oneofKind === "cancelled")
            AuthBrowserCancelled.internalBinaryWrite(message.state.cancelled, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBrowserStatusResult
 */
export const AuthBrowserStatusResult = new AuthBrowserStatusResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBrowserPending$Type extends MessageType {
    constructor() {
        super("AuthBrowserPending", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBrowserPending
 */
export const AuthBrowserPending = new AuthBrowserPending$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBrowserCancelled$Type extends MessageType {
    constructor() {
        super("AuthBrowserCancelled", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        return target ?? this.create();
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthBrowserCancelled
 */
export const AuthBrowserCancelled = new AuthBrowserCancelled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateHttpUploadRequest$Type extends MessageType {
    constructor() {
        super("CreateHttpUploadRequest", [
            { no: 1, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "byte_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "sha256", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "kind", kind: "enum", T: () => ["HttpUploadKind", HttpUploadKind] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileName = "";
        message.mimeType = "";
        message.byteCount = 0n;
        message.sha256 = new Uint8Array(0);
        message.kind = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_name */ 1:
                    message.fileName = reader.string();
                    break;
                case /* string mime_type */ 2:
                    message.mimeType = reader.string();
                    break;
                case /* uint64 byte_count */ 3:
                    message.byteCount = reader.uint64().toBigInt();
                    break;
                case /* bytes sha256 */ 4:
                    message.sha256 = reader.bytes();
                    break;
                case /* HttpUploadKind kind */ 5:
                    message.kind = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string file_name = 1; */
        if (message.fileName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileName);
        /* string mime_type = 2; */
        if (message.mimeType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mimeType);
        /* uint64 byte_count = 3; */
        if (message.byteCount !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.byteCount);
        /* bytes sha256 = 4; */
        if (message.sha256.length)
            writer.tag(4, WireType.LengthDelimited).bytes(message.sha256);
        /* HttpUploadKind kind = 5; */
        if (message.kind !== 0)
            writer.tag(5, WireType.Varint).int32(message.kind);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateHttpUploadRequest
 */
export const CreateHttpUploadRequest = new CreateHttpUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateHttpUploadResult$Type extends MessageType {
    constructor() {
        super("CreateHttpUploadResult", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "upload_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "capability", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "expires_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        message.uploadUrl = "";
        message.capability = new Uint8Array(0);
        message.expiresAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                case /* string upload_url */ 2:
                    message.uploadUrl = reader.string();
                    break;
                case /* bytes capability */ 3:
                    message.capability = reader.bytes();
                    break;
                case /* int64 expires_at */ 4:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        /* string upload_url = 2; */
        if (message.uploadUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.uploadUrl);
        /* bytes capability = 3; */
        if (message.capability.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.capability);
        /* int64 expires_at = 4; */
        if (message.expiresAt !== 0n)
            writer.tag(4, WireType.Varint).int64(message.expiresAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateHttpUploadResult
 */
export const CreateHttpUploadResult = new CreateHttpUploadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinishHttpUploadRequest$Type extends MessageType {
    constructor() {
        super("FinishHttpUploadRequest", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FinishHttpUploadRequest
 */
export const FinishHttpUploadRequest = new FinishHttpUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HttpUploadPending$Type extends MessageType {
    constructor() {
        super("HttpUploadPending", [
            { no: 1, name: "retry_after_seconds", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.retryAfterSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 retry_after_seconds */ 1:
                    message.retryAfterSeconds = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint32 retry_after_seconds = 1; */
        if (message.retryAfterSeconds !== 0)
            writer.tag(1, WireType.Varint).uint32(message.retryAfterSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HttpUploadPending
 */
export const HttpUploadPending = new HttpUploadPending$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HttpUploadComplete$Type extends MessageType {
    constructor() {
        super("HttpUploadComplete", [
            { no: 1, name: "file_unique_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileUniqueId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_unique_id */ 1:
                    message.fileUniqueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string file_unique_id = 1; */
        if (message.fileUniqueId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUniqueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HttpUploadComplete
 */
export const HttpUploadComplete = new HttpUploadComplete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinishHttpUploadResult$Type extends MessageType {
    constructor() {
        super("FinishHttpUploadResult", [
            { no: 1, name: "pending", kind: "message", oneof: "state", T: () => HttpUploadPending },
            { no: 2, name: "complete", kind: "message", oneof: "state", T: () => HttpUploadComplete }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* HttpUploadPending pending */ 1:
                    message.state = {
                        oneofKind: "pending",
                        pending: HttpUploadPending.internalBinaryRead(reader, reader.uint32(), options, message.state.pending)
                    };
                    break;
                case /* HttpUploadComplete complete */ 2:
                    message.state = {
                        oneofKind: "complete",
                        complete: HttpUploadComplete.internalBinaryRead(reader, reader.uint32(), options, message.state.complete)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* HttpUploadPending pending = 1; */
        if (message.state.oneofKind === "pending")
            HttpUploadPending.internalBinaryWrite(message.state.pending, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* HttpUploadComplete complete = 2; */
        if (message.state.oneofKind === "complete")
            HttpUploadComplete.internalBinaryWrite(message.state.complete, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FinishHttpUploadResult
 */
export const FinishHttpUploadResult = new FinishHttpUploadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadVideoMetadata$Type extends MessageType {
    constructor() {
        super("UploadVideoMetadata", [
            { no: 1, name: "width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "height", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "duration", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "is_animated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "has_audio", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.width = 0;
        message.height = 0;
        message.duration = 0;
        message.isAnimated = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 width */ 1:
                    message.width = reader.uint32();
                    break;
                case /* uint32 height */ 2:
                    message.height = reader.uint32();
                    break;
                case /* uint32 duration */ 3:
                    message.duration = reader.uint32();
                    break;
                case /* bool is_animated */ 4:
                    message.isAnimated = reader.bool();
                    break;
                case /* optional bool has_audio */ 5:
                    message.hasAudio = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint32 width = 1; */
        if (message.width !== 0)
            writer.tag(1, WireType.Varint).uint32(message.width);
        /* uint32 height = 2; */
        if (message.height !== 0)
            writer.tag(2, WireType.Varint).uint32(message.height);
        /* uint32 duration = 3; */
        if (message.duration !== 0)
            writer.tag(3, WireType.Varint).uint32(message.duration);
        /* bool is_animated = 4; */
        if (message.isAnimated !== false)
            writer.tag(4, WireType.Varint).bool(message.isAnimated);
        /* optional bool has_audio = 5; */
        if (message.hasAudio !== undefined)
            writer.tag(5, WireType.Varint).bool(message.hasAudio);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadVideoMetadata
 */
export const UploadVideoMetadata = new UploadVideoMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadVoiceMetadata$Type extends MessageType {
    constructor() {
        super("UploadVoiceMetadata", [
            { no: 1, name: "duration", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "waveform", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.duration = 0;
        message.waveform = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 duration */ 1:
                    message.duration = reader.uint32();
                    break;
                case /* bytes waveform */ 2:
                    message.waveform = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint32 duration = 1; */
        if (message.duration !== 0)
            writer.tag(1, WireType.Varint).uint32(message.duration);
        /* bytes waveform = 2; */
        if (message.waveform.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.waveform);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadVoiceMetadata
 */
export const UploadVoiceMetadata = new UploadVoiceMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUploadInput$Type extends MessageType {
    constructor() {
        super("CreateUploadInput", [
            { no: 1, name: "client_upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "byte_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "sha256", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 6, name: "kind", kind: "enum", T: () => ["UploadKind", UploadKind, "UPLOAD_KIND_"] },
            { no: 7, name: "thumbnail_file_unique_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "video", kind: "message", oneof: "metadata", T: () => UploadVideoMetadata },
            { no: 9, name: "voice", kind: "message", oneof: "metadata", T: () => UploadVoiceMetadata }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.clientUploadId = new Uint8Array(0);
        message.fileName = "";
        message.mimeType = "";
        message.byteCount = 0n;
        message.sha256 = new Uint8Array(0);
        message.kind = 0;
        message.metadata = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes client_upload_id */ 1:
                    message.clientUploadId = reader.bytes();
                    break;
                case /* string file_name */ 2:
                    message.fileName = reader.string();
                    break;
                case /* string mime_type */ 3:
                    message.mimeType = reader.string();
                    break;
                case /* uint64 byte_count */ 4:
                    message.byteCount = reader.uint64().toBigInt();
                    break;
                case /* bytes sha256 */ 5:
                    message.sha256 = reader.bytes();
                    break;
                case /* UploadKind kind */ 6:
                    message.kind = reader.int32();
                    break;
                case /* optional string thumbnail_file_unique_id */ 7:
                    message.thumbnailFileUniqueId = reader.string();
                    break;
                case /* UploadVideoMetadata video */ 8:
                    message.metadata = {
                        oneofKind: "video",
                        video: UploadVideoMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata.video)
                    };
                    break;
                case /* UploadVoiceMetadata voice */ 9:
                    message.metadata = {
                        oneofKind: "voice",
                        voice: UploadVoiceMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata.voice)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes client_upload_id = 1; */
        if (message.clientUploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.clientUploadId);
        /* string file_name = 2; */
        if (message.fileName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fileName);
        /* string mime_type = 3; */
        if (message.mimeType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.mimeType);
        /* uint64 byte_count = 4; */
        if (message.byteCount !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.byteCount);
        /* bytes sha256 = 5; */
        if (message.sha256.length)
            writer.tag(5, WireType.LengthDelimited).bytes(message.sha256);
        /* UploadKind kind = 6; */
        if (message.kind !== 0)
            writer.tag(6, WireType.Varint).int32(message.kind);
        /* optional string thumbnail_file_unique_id = 7; */
        if (message.thumbnailFileUniqueId !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.thumbnailFileUniqueId);
        /* UploadVideoMetadata video = 8; */
        if (message.metadata.oneofKind === "video")
            UploadVideoMetadata.internalBinaryWrite(message.metadata.video, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* UploadVoiceMetadata voice = 9; */
        if (message.metadata.oneofKind === "voice")
            UploadVoiceMetadata.internalBinaryWrite(message.metadata.voice, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateUploadInput
 */
export const CreateUploadInput = new CreateUploadInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUploadResult$Type extends MessageType {
    constructor() {
        super("CreateUploadResult", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "part_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "part_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "expires_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "accepted_parts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        message.partSize = 0;
        message.partCount = 0;
        message.expiresAt = 0n;
        message.acceptedParts = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                case /* uint32 part_size */ 2:
                    message.partSize = reader.uint32();
                    break;
                case /* uint32 part_count */ 3:
                    message.partCount = reader.uint32();
                    break;
                case /* int64 expires_at */ 4:
                    message.expiresAt = reader.int64().toBigInt();
                    break;
                case /* repeated uint32 accepted_parts */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.acceptedParts.push(reader.uint32());
                    else
                        message.acceptedParts.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        /* uint32 part_size = 2; */
        if (message.partSize !== 0)
            writer.tag(2, WireType.Varint).uint32(message.partSize);
        /* uint32 part_count = 3; */
        if (message.partCount !== 0)
            writer.tag(3, WireType.Varint).uint32(message.partCount);
        /* int64 expires_at = 4; */
        if (message.expiresAt !== 0n)
            writer.tag(4, WireType.Varint).int64(message.expiresAt);
        /* repeated uint32 accepted_parts = 5; */
        if (message.acceptedParts.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.acceptedParts.length; i++)
                writer.uint32(message.acceptedParts[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateUploadResult
 */
export const CreateUploadResult = new CreateUploadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveUploadPartInput$Type extends MessageType {
    constructor() {
        super("SaveUploadPartInput", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "part_index", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        message.partIndex = 0;
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                case /* uint32 part_index */ 2:
                    message.partIndex = reader.uint32();
                    break;
                case /* bytes data */ 3:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        /* uint32 part_index = 2; */
        if (message.partIndex !== 0)
            writer.tag(2, WireType.Varint).uint32(message.partIndex);
        /* bytes data = 3; */
        if (message.data.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SaveUploadPartInput
 */
export const SaveUploadPartInput = new SaveUploadPartInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveUploadPartResult$Type extends MessageType {
    constructor() {
        super("SaveUploadPartResult", [
            { no: 1, name: "already_present", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.alreadyPresent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool already_present */ 1:
                    message.alreadyPresent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool already_present = 1; */
        if (message.alreadyPresent !== false)
            writer.tag(1, WireType.Varint).bool(message.alreadyPresent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SaveUploadPartResult
 */
export const SaveUploadPartResult = new SaveUploadPartResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUploadStateInput$Type extends MessageType {
    constructor() {
        super("GetUploadStateInput", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUploadStateInput
 */
export const GetUploadStateInput = new GetUploadStateInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadComplete$Type extends MessageType {
    constructor() {
        super("UploadComplete", [
            { no: 1, name: "file_unique_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "photo", kind: "message", oneof: "media", T: () => Photo },
            { no: 3, name: "video", kind: "message", oneof: "media", T: () => Video },
            { no: 4, name: "document", kind: "message", oneof: "media", T: () => Document },
            { no: 5, name: "voice", kind: "message", oneof: "media", T: () => Voice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileUniqueId = "";
        message.media = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_unique_id */ 1:
                    message.fileUniqueId = reader.string();
                    break;
                case /* Photo photo */ 2:
                    message.media = {
                        oneofKind: "photo",
                        photo: Photo.internalBinaryRead(reader, reader.uint32(), options, message.media.photo)
                    };
                    break;
                case /* Video video */ 3:
                    message.media = {
                        oneofKind: "video",
                        video: Video.internalBinaryRead(reader, reader.uint32(), options, message.media.video)
                    };
                    break;
                case /* Document document */ 4:
                    message.media = {
                        oneofKind: "document",
                        document: Document.internalBinaryRead(reader, reader.uint32(), options, message.media.document)
                    };
                    break;
                case /* Voice voice */ 5:
                    message.media = {
                        oneofKind: "voice",
                        voice: Voice.internalBinaryRead(reader, reader.uint32(), options, message.media.voice)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string file_unique_id = 1; */
        if (message.fileUniqueId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUniqueId);
        /* Photo photo = 2; */
        if (message.media.oneofKind === "photo")
            Photo.internalBinaryWrite(message.media.photo, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Video video = 3; */
        if (message.media.oneofKind === "video")
            Video.internalBinaryWrite(message.media.video, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* Document document = 4; */
        if (message.media.oneofKind === "document")
            Document.internalBinaryWrite(message.media.document, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* Voice voice = 5; */
        if (message.media.oneofKind === "voice")
            Voice.internalBinaryWrite(message.media.voice, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadComplete
 */
export const UploadComplete = new UploadComplete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadFailure$Type extends MessageType {
    constructor() {
        super("UploadFailure", [
            { no: 1, name: "code", kind: "enum", T: () => ["UploadFailure.Code", UploadFailure_Code] },
            { no: 2, name: "retryable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.code = 0;
        message.retryable = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UploadFailure.Code code */ 1:
                    message.code = reader.int32();
                    break;
                case /* bool retryable */ 2:
                    message.retryable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UploadFailure.Code code = 1; */
        if (message.code !== 0)
            writer.tag(1, WireType.Varint).int32(message.code);
        /* bool retryable = 2; */
        if (message.retryable !== false)
            writer.tag(2, WireType.Varint).bool(message.retryable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadFailure
 */
export const UploadFailure = new UploadFailure$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUploadStateResult$Type extends MessageType {
    constructor() {
        super("GetUploadStateResult", [
            { no: 1, name: "status", kind: "enum", T: () => ["UploadStatus", UploadStatus, "UPLOAD_STATUS_"] },
            { no: 2, name: "accepted_parts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "complete", kind: "message", T: () => UploadComplete },
            { no: 4, name: "failure", kind: "message", T: () => UploadFailure }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = 0;
        message.acceptedParts = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UploadStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* repeated uint32 accepted_parts */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.acceptedParts.push(reader.uint32());
                    else
                        message.acceptedParts.push(reader.uint32());
                    break;
                case /* optional UploadComplete complete */ 3:
                    message.complete = UploadComplete.internalBinaryRead(reader, reader.uint32(), options, message.complete);
                    break;
                case /* optional UploadFailure failure */ 4:
                    message.failure = UploadFailure.internalBinaryRead(reader, reader.uint32(), options, message.failure);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UploadStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* repeated uint32 accepted_parts = 2; */
        if (message.acceptedParts.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.acceptedParts.length; i++)
                writer.uint32(message.acceptedParts[i]);
            writer.join();
        }
        /* optional UploadComplete complete = 3; */
        if (message.complete)
            UploadComplete.internalBinaryWrite(message.complete, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional UploadFailure failure = 4; */
        if (message.failure)
            UploadFailure.internalBinaryWrite(message.failure, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUploadStateResult
 */
export const GetUploadStateResult = new GetUploadStateResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinishUploadInput$Type extends MessageType {
    constructor() {
        super("FinishUploadInput", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FinishUploadInput
 */
export const FinishUploadInput = new FinishUploadInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadMissingParts$Type extends MessageType {
    constructor() {
        super("UploadMissingParts", [
            { no: 1, name: "part_indices", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.partIndices = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated uint32 part_indices */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.partIndices.push(reader.uint32());
                    else
                        message.partIndices.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated uint32 part_indices = 1; */
        if (message.partIndices.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.partIndices.length; i++)
                writer.uint32(message.partIndices[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadMissingParts
 */
export const UploadMissingParts = new UploadMissingParts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadProcessing$Type extends MessageType {
    constructor() {
        super("UploadProcessing", [
            { no: 1, name: "retry_after_seconds", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.retryAfterSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 retry_after_seconds */ 1:
                    message.retryAfterSeconds = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint32 retry_after_seconds = 1; */
        if (message.retryAfterSeconds !== 0)
            writer.tag(1, WireType.Varint).uint32(message.retryAfterSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadProcessing
 */
export const UploadProcessing = new UploadProcessing$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinishUploadResult$Type extends MessageType {
    constructor() {
        super("FinishUploadResult", [
            { no: 1, name: "missing", kind: "message", oneof: "state", T: () => UploadMissingParts },
            { no: 2, name: "processing", kind: "message", oneof: "state", T: () => UploadProcessing },
            { no: 3, name: "complete", kind: "message", oneof: "state", T: () => UploadComplete },
            { no: 4, name: "failed", kind: "message", oneof: "state", T: () => UploadFailure }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* UploadMissingParts missing */ 1:
                    message.state = {
                        oneofKind: "missing",
                        missing: UploadMissingParts.internalBinaryRead(reader, reader.uint32(), options, message.state.missing)
                    };
                    break;
                case /* UploadProcessing processing */ 2:
                    message.state = {
                        oneofKind: "processing",
                        processing: UploadProcessing.internalBinaryRead(reader, reader.uint32(), options, message.state.processing)
                    };
                    break;
                case /* UploadComplete complete */ 3:
                    message.state = {
                        oneofKind: "complete",
                        complete: UploadComplete.internalBinaryRead(reader, reader.uint32(), options, message.state.complete)
                    };
                    break;
                case /* UploadFailure failed */ 4:
                    message.state = {
                        oneofKind: "failed",
                        failed: UploadFailure.internalBinaryRead(reader, reader.uint32(), options, message.state.failed)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* UploadMissingParts missing = 1; */
        if (message.state.oneofKind === "missing")
            UploadMissingParts.internalBinaryWrite(message.state.missing, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* UploadProcessing processing = 2; */
        if (message.state.oneofKind === "processing")
            UploadProcessing.internalBinaryWrite(message.state.processing, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* UploadComplete complete = 3; */
        if (message.state.oneofKind === "complete")
            UploadComplete.internalBinaryWrite(message.state.complete, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* UploadFailure failed = 4; */
        if (message.state.oneofKind === "failed")
            UploadFailure.internalBinaryWrite(message.state.failed, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FinishUploadResult
 */
export const FinishUploadResult = new FinishUploadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelUploadInput$Type extends MessageType {
    constructor() {
        super("CancelUploadInput", [
            { no: 1, name: "upload_id", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.uploadId = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes upload_id */ 1:
                    message.uploadId = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes upload_id = 1; */
        if (message.uploadId.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.uploadId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelUploadInput
 */
export const CancelUploadInput = new CancelUploadInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelUploadResult$Type extends MessageType {
    constructor() {
        super("CancelUploadResult", [
            { no: 1, name: "canceled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "already_terminal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.canceled = false;
        message.alreadyTerminal = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool canceled */ 1:
                    message.canceled = reader.bool();
                    break;
                case /* bool already_terminal */ 2:
                    message.alreadyTerminal = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool canceled = 1; */
        if (message.canceled !== false)
            writer.tag(1, WireType.Varint).bool(message.canceled);
        /* bool already_terminal = 2; */
        if (message.alreadyTerminal !== false)
            writer.tag(2, WireType.Varint).bool(message.alreadyTerminal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelUploadResult
 */
export const CancelUploadResult = new CancelUploadResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileMessageLocation$Type extends MessageType {
    constructor() {
        super("FileMessageLocation", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.messageId = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 message_id */ 2:
                    message.messageId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* int64 message_id = 2; */
        if (message.messageId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.messageId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FileMessageLocation
 */
export const FileMessageLocation = new FileMessageLocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFilePartInput$Type extends MessageType {
    constructor() {
        super("GetFilePartInput", [
            { no: 1, name: "file_unique_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "offset", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "limit", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "message", kind: "message", T: () => FileMessageLocation }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileUniqueId = "";
        message.offset = 0n;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_unique_id */ 1:
                    message.fileUniqueId = reader.string();
                    break;
                case /* uint64 offset */ 2:
                    message.offset = reader.uint64().toBigInt();
                    break;
                case /* uint32 limit */ 3:
                    message.limit = reader.uint32();
                    break;
                case /* optional FileMessageLocation message */ 4:
                    message.message = FileMessageLocation.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string file_unique_id = 1; */
        if (message.fileUniqueId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUniqueId);
        /* uint64 offset = 2; */
        if (message.offset !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.offset);
        /* uint32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).uint32(message.limit);
        /* optional FileMessageLocation message = 4; */
        if (message.message)
            FileMessageLocation.internalBinaryWrite(message.message, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFilePartInput
 */
export const GetFilePartInput = new GetFilePartInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFilePartResult$Type extends MessageType {
    constructor() {
        super("GetFilePartResult", [
            { no: 1, name: "offset", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "total_size", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "sha256", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.offset = 0n;
        message.totalSize = 0n;
        message.data = new Uint8Array(0);
        message.sha256 = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 offset */ 1:
                    message.offset = reader.uint64().toBigInt();
                    break;
                case /* uint64 total_size */ 2:
                    message.totalSize = reader.uint64().toBigInt();
                    break;
                case /* bytes data */ 3:
                    message.data = reader.bytes();
                    break;
                case /* bytes sha256 */ 4:
                    message.sha256 = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.offset);
        /* uint64 total_size = 2; */
        if (message.totalSize !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.totalSize);
        /* bytes data = 3; */
        if (message.data.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.data);
        /* bytes sha256 = 4; */
        if (message.sha256.length)
            writer.tag(4, WireType.LengthDelimited).bytes(message.sha256);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFilePartResult
 */
export const GetFilePartResult = new GetFilePartResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatAcknowledgement$Type extends MessageType {
    constructor() {
        super("ChatAcknowledgement", [
            { no: 1, name: "chat_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "max_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "user", kind: "message", T: () => User },
            { no: 5, name: "peer_id", kind: "message", T: () => Peer },
            { no: 6, name: "revision", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "cleared", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.chatId = 0n;
        message.userId = 0n;
        message.maxId = 0n;
        message.revision = 0n;
        message.cleared = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 chat_id */ 1:
                    message.chatId = reader.int64().toBigInt();
                    break;
                case /* int64 user_id */ 2:
                    message.userId = reader.int64().toBigInt();
                    break;
                case /* int64 max_id */ 3:
                    message.maxId = reader.int64().toBigInt();
                    break;
                case /* optional User user */ 4:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* optional Peer peer_id */ 5:
                    message.peerId = Peer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 revision */ 6:
                    message.revision = reader.int64().toBigInt();
                    break;
                case /* bool cleared */ 7:
                    message.cleared = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int64 chat_id = 1; */
        if (message.chatId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.chatId);
        /* int64 user_id = 2; */
        if (message.userId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.userId);
        /* int64 max_id = 3; */
        if (message.maxId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.maxId);
        /* optional User user = 4; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional Peer peer_id = 5; */
        if (message.peerId)
            Peer.internalBinaryWrite(message.peerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int64 revision = 6; */
        if (message.revision !== 0n)
            writer.tag(6, WireType.Varint).int64(message.revision);
        /* bool cleared = 7; */
        if (message.cleared !== false)
            writer.tag(7, WireType.Varint).bool(message.cleared);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChatAcknowledgement
 */
export const ChatAcknowledgement = new ChatAcknowledgement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcknowledgeMessagesInput$Type extends MessageType {
    constructor() {
        super("AcknowledgeMessagesInput", [
            { no: 1, name: "peer_id", kind: "message", T: () => InputPeer },
            { no: 2, name: "max_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "clear", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "expected_revision", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.maxId = 0n;
        message.clear = false;
        message.expectedRevision = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* InputPeer peer_id */ 1:
                    message.peerId = InputPeer.internalBinaryRead(reader, reader.uint32(), options, message.peerId);
                    break;
                case /* int64 max_id */ 2:
                    message.maxId = reader.int64().toBigInt();
                    break;
                case /* bool clear */ 3:
                    message.clear = reader.bool();
                    break;
                case /* int64 expected_revision */ 4:
                    message.expectedRevision = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* InputPeer peer_id = 1; */
        if (message.peerId)
            InputPeer.internalBinaryWrite(message.peerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 max_id = 2; */
        if (message.maxId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.maxId);
        /* bool clear = 3; */
        if (message.clear !== false)
            writer.tag(3, WireType.Varint).bool(message.clear);
        /* int64 expected_revision = 4; */
        if (message.expectedRevision !== 0n)
            writer.tag(4, WireType.Varint).int64(message.expectedRevision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AcknowledgeMessagesInput
 */
export const AcknowledgeMessagesInput = new AcknowledgeMessagesInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcknowledgeMessagesResult$Type extends MessageType {
    constructor() {
        super("AcknowledgeMessagesResult", [
            { no: 1, name: "updates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Update }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Update updates */ 1:
                    message.updates.push(Update.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Update updates = 1; */
        for (let i = 0; i < message.updates.length; i++)
            Update.internalBinaryWrite(message.updates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AcknowledgeMessagesResult
 */
export const AcknowledgeMessagesResult = new AcknowledgeMessagesResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatAcknowledgements$Type extends MessageType {
    constructor() {
        super("ChatAcknowledgements", [
            { no: 1, name: "cursors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ChatAcknowledgement }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.cursors = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ChatAcknowledgement cursors */ 1:
                    message.cursors.push(ChatAcknowledgement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ChatAcknowledgement cursors = 1; */
        for (let i = 0; i < message.cursors.length; i++)
            ChatAcknowledgement.internalBinaryWrite(message.cursors[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChatAcknowledgements
 */
export const ChatAcknowledgements = new ChatAcknowledgements$Type();
